(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[480],{

/***/ 34175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PlayIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PlayIcon = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.006 11.0818C16.5418 11.5767 16.5418 12.4233 16.006 12.9182L11.5982 16.99C10.7976 17.7295 9.5 17.1617 9.5 16.0718V7.9282C9.5 6.83829 10.7976 6.27045 11.5982 7.01001L16.006 11.0818Z",
                fill: "#005C29"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "23",
                height: "23",
                rx: "11.5",
                stroke: "#005C29"
            })
        ]
    });
});


/***/ }),

/***/ 31181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var clients_Clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38307);



// MOCK API
var upload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.ctx = ctx, _tmp.url = "/upload", _tmp.mock = true, _tmp.body = body, _tmp))
            ];
        });
    });
    return function upload(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadWithoutAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, body, isAuth, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body, isAuth = param.isAuth;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.ctx = ctx, _tmp.url = "/upload", _tmp.mock = true, _tmp.body = body, _tmp.isAuth = isAuth, _tmp))
            ];
        });
    });
    return function uploadWithoutAuth(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadFeedbackMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.ctx = ctx, _tmp.url = "/upload/feedback", _tmp.mock = true, _tmp.isAuth = false, _tmp.body = body, _tmp))
            ];
        });
    });
    return function uploadFeedbackMock(_) {
        return _ref.apply(this, arguments);
    };
}();
// SERVER API
var genTokenNoAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.ctx = ctx, _tmp.url = "/core/file-manager/v1/access-token/gen", _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function genTokenNoAuth(_) {
        return _ref.apply(this, arguments);
    };
}();
var genToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.ctx = ctx, _tmp.url = "/core/file-manager/v1/access-token/gen", _tmp))
            ];
        });
    });
    return function genToken(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadDocument = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.ctx = ctx, _tmp.url = "/core/file-manager/v1/upload/document", _tmp.body = body, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function uploadDocument(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadFileImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.ctx = ctx, _tmp.url = "/core/file-manager/v1/upload/image", _tmp.body = body, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function uploadFileImage(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = ({
    upload: upload,
    uploadWithoutAuth: uploadWithoutAuth,
    uploadFeedbackMock: uploadFeedbackMock,
    genTokenNoAuth: genTokenNoAuth,
    genToken: genToken,
    uploadDocument: uploadDocument,
    uploadFileImage: uploadFileImage
});


/***/ }),

/***/ 26918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66037);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90512);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13270);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4681);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);








var ReadMoreWrapper = function(param) {
    var className = param.className, _isBlur = param.isBlur, isBlur = _isBlur === void 0 ? true : _isBlur, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 100 : _maxHeight, _text = param.text, text = _text === void 0 ? "Xem tất cả" : _text;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(isOpen), isReadMore = ref[0], setIsReadMore = ref[1];
    var handleReadMore = function() {
        setIsReadMore(!isReadMore);
    };
    if (disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(className, (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().readMoreWrapper), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().isReadMore), isReadMore), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().isBlur), isBlur), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                collapsedSize: maxHeight,
                in: isReadMore,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: "button",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().readMoreAction),
                onClick: handleReadMore,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().textLink),
                        children: !isReadMore ? text : "Hiện \xedt hơn"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .CART_OPEN */ .Ole,
                            width: 16,
                            height: 16,
                            alt: "open icon"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMoreWrapper);


/***/ }),

/***/ 44766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ COMBO_SUGGESTED_BY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19238);
/* harmony import */ var _material_ui_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66735);
/* harmony import */ var clients_MonitorClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70599);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13270);
/* harmony import */ var context_Auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95581);
/* harmony import */ var context_Cart_CartSuggestionContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6496);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43931);
/* harmony import */ var utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31459);
/* harmony import */ var utils_gtag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57059);
/* harmony import */ var _ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19480);
/* harmony import */ var _ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10__);














var COMBO_SUGGESTED_BY = "comboSuggestedBy";
var SLIDE_TIMEOUT = 5000;
function ComboSuggestion(param) {
    var skuProduct = param.skuProduct;
    var handleClick = function handleClick(suggestion) {
        utils_gtag__WEBPACK_IMPORTED_MODULE_9__/* ["default"].clickComboSuggestionMore */ .ZP.clickComboSuggestionMore({
            user: user,
            skuProduct: skuProduct,
            comboSKUCode: suggestion.skuCode
        });
        router.push("".concat(suggestion.url, "?").concat(COMBO_SUGGESTED_BY, "=").concat(skuProduct.slug));
        (0,clients_MonitorClient__WEBPACK_IMPORTED_MODULE_1__/* .collectEvent */ .r3)(utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__/* .MONITORING_COLLECTOR_TYPE.CLICK_BUY_MORE_BUTTON */ .Hq.CLICK_BUY_MORE_BUTTON, {
            combo: suggestion.skuCode,
            sku: skuProduct.skuCode,
            sellerId: skuProduct.sellerId,
            productId: skuProduct.productId || skuProduct.id,
            source: (0,utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__/* .mapSourceToEnum */ .Dw)(),
            screen: (0,utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__/* .mapScreenToEnum */ .lq)(),
            content: "Click n\xfat Săn ngay hoặc Card Combo gợi \xfd"
        });
    };
    var handleMouseOver = function handleMouseOver() {
        if (isGATracked) return;
        utils_gtag__WEBPACK_IMPORTED_MODULE_9__/* ["default"].impressionComboSuggestion */ .ZP.impressionComboSuggestion({
            user: user,
            skuProduct: skuProduct
        });
        setIsGATracked(true);
        (0,clients_MonitorClient__WEBPACK_IMPORTED_MODULE_1__/* .collectEvent */ .r3)(utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__/* .MONITORING_COLLECTOR_TYPE.KEY_SKU_IMPRESSION */ .Hq.KEY_SKU_IMPRESSION, {
            sku: skuProduct.skuCode,
            seller_id: skuProduct.sellerId,
            product_id: skuProduct.productId || skuProduct.id,
            source: (0,utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__/* .mapSourceToEnum */ .Dw)(),
            screen: (0,utils_MonitorUtils__WEBPACK_IMPORTED_MODULE_8__/* .mapScreenToEnum */ .lq)(),
            content: "View SKU được đề xuất Combo gợi \xfd"
        });
    };
    var comboSuggestions = (0,context_Cart_CartSuggestionContext__WEBPACK_IMPORTED_MODULE_4__/* .useCartSuggestions */ .dT)().comboSuggestions;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isGATracked = ref[0], setIsGATracked = ref[1];
    var user = (0,context_Auth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var suggestions = (comboSuggestions === null || comboSuggestions === void 0 ? void 0 : comboSuggestions[skuProduct.skuCode]) || [];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (suggestions.length <= 1) return;
        var interval = setInterval(function() {
            setActiveIndex(function(activeIndex) {
                return (activeIndex + 1) % suggestions.length;
            });
        }, SLIDE_TIMEOUT);
        return function() {
            return clearInterval(interval);
        };
    }, [
        suggestions.length
    ]);
    if (!suggestions.length) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().comboSuggestionContainer),
        children: suggestions.map(function(suggestion, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: 1,
                className: "".concat((_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().comboSuggestion), " ").concat(index === activeIndex ? (_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().active) : ""),
                onClick: function() {
                    return handleClick(suggestion);
                },
                onMouseEnter: handleMouseOver,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        display: "flex",
                        alignItems: "center",
                        minWidth: 32,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_7__/* .ImageFallbackStatic */ .ez, {
                            src: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .SUBSTITUTE_RECOMMEND_ICON */ .VJj,
                            height: 32,
                            width: 32
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().suggestionLabel),
                        children: suggestion.label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SuggestionContent, {
                        suggestion: suggestion
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                        className: (_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().suggestionLink),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Săn ngay"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                className: (_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().suggestionLinkChevron)
                            })
                        ]
                    })
                ]
            }, suggestion.skuCode);
        })
    });
}
function SuggestionContent(param) {
    var suggestion = param.suggestion;
    var content = suggestion.content;
    if (suggestion.param) {
        Object.entries(suggestion.param).forEach(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            content = content.replaceAll("{".concat(key, "}"), '<span class="'.concat((_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default())[key], '">').concat(value, "</span>"));
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ComboSuggestion_module_css__WEBPACK_IMPORTED_MODULE_10___default().suggestionContent),
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_6__.memo)(ComboSuggestion));


/***/ }),

/***/ 52038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NotificationModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66856);
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29525);
/* harmony import */ var _material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66083);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90512);
/* harmony import */ var components_v2_atoms_ActionButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82292);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30795);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);









function NotificationModal(param) {
    var classNames = param.classNames, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? "xs" : _maxWidth, isOpen = param.isOpen, isTitleCenter = param.isTitleCenter, _isDisableSubmit = param.isDisableSubmit, isDisableSubmit = _isDisableSubmit === void 0 ? false : _isDisableSubmit, _isLoadingSubmit = param.isLoadingSubmit, isLoadingSubmit = _isLoadingSubmit === void 0 ? false : _isLoadingSubmit, title = param.title, subTitle = param.subTitle, children = param.children, submitText = param.submitText, cancelText = param.cancelText, renderActions = param.renderActions, onClose = param.onClose, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var renderDefaultActions = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                cancelText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_v2_atoms_ActionButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    variant: "contained",
                    color: "secondary",
                    onClick: onCancel,
                    children: cancelText
                }),
                submitText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_v2_atoms_ActionButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    isLoading: isLoadingSubmit,
                    disabled: isDisableSubmit,
                    variant: "contained",
                    color: "primary",
                    onClick: onSubmit,
                    children: submitText
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        transitionDuration: 0,
        fullWidth: true,
        maxWidth: maxWidth,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classNames, (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().dialog)),
        onClose: onClose,
        open: isOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().headerDialog), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().isTitleCenter), isTitleCenter)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().title)),
                    children: title
                })
            }),
            subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().subTitle),
                children: subTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().content),
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().actions),
                children: renderActions || renderDefaultActions()
            })
        ]
    });
};


/***/ }),

/***/ 53371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BLUR_DATA_URL": function() { return /* binding */ BLUR_DATA_URL; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32692);
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(4024);
/* harmony import */ var _material_ui_core_Fade__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96517);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(18042);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98121);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90512);
/* harmony import */ var components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47448);
/* harmony import */ var constants_data_setting_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34532);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43931);
/* harmony import */ var utils_StringUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52380);
/* harmony import */ var utils_video__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44548);
/* harmony import */ var _SimpleVideoPlayer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61133);
/* harmony import */ var utils_ImageUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81989);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(94328);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_17__);



























var BLUR_DATA_URL = {
    DART_PC: "data:image/svg+xml;base64,".concat((0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_9__/* .toBase64 */ .s3)((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(300, 300, "#bcbcbc1c"))),
    DART_MOBILE: "data:image/svg+xml;base64,".concat((0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_9__/* .toBase64 */ .s3)((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(42, 42, "#bcbcbc1c"))),
    BRIGHT_PC: "data:image/svg+xml;base64,".concat((0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_9__/* .toBase64 */ .s3)((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(545, 545, "#f3f3f3"))),
    BRIGHT_MOBILE: "data:image/svg+xml;base64,".concat((0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_9__/* .toBase64 */ .s3)((0,components_v2_atoms_Shimmer__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(42, 42, "#f3f3f3")))
};
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        modal: {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#FFFFFF",
            width: "940px",
            height: "651px",
            borderRadius: "10px",
            boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.05)"
        },
        mobileModal: {
            position: "absolute",
            display: "flex",
            width: "95%",
            height: "400px",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.05)"
        },
        closeBtn: {
            width: "30px",
            height: "30px",
            color: "#C0C0C0"
        },
        nameBoxText: {
            display: "box",
            lineClamp: 2,
            boxOrient: "vertical",
            overflow: "hidden"
        },
        navigateBtn: {
            width: "40px",
            height: "40px",
            background: "rgba(0, 0, 0, 0.15)",
            position: "absolute",
            color: "#ffffff",
            "&:hover": {
                background: "rgba(0, 0, 0, 0.15)",
                color: "#2CD888"
            }
        },
        navigateIc: {
            width: "40px",
            height: "40px"
        },
        navBtnMobile: {
            background: "rgba(0, 0, 0, 0.15)",
            width: "40px",
            height: "40px"
        }
    });
});
function getModalStyle() {
    return {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}
var PopupMultilImage = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _images = param.images, images = _images === void 0 ? [] : _images, _open = param.open, open = _open === void 0 ? false : _open, handleClose = param.handleClose, _imageName = param.imageName, imageName = _imageName === void 0 ? "" : _imageName, _selectedImage = param.selectedImage, selectedImage = _selectedImage === void 0 ? 0 : _selectedImage, handleClickImage = param.handleClickImage, handlePrevious = param.handlePrevious, handleNext = param.handleNext;
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(getModalStyle), modalStyle = ref[0];
    var ref1;
    var isVideoUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,utils_video__WEBPACK_IMPORTED_MODULE_13__/* .checkVideoUrl */ .P)((ref1 = images === null || images === void 0 ? void 0 : images[selectedImage]) !== null && ref1 !== void 0 ? ref1 : false);
    }, [
        images,
        selectedImage
    ]);
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            open: open,
            onClose: handleClose,
            "aria-labelledby": "image-gallery-title",
            "aria-describedby": "image-gallery-description",
            closeAfterTransition: true,
            BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
            BackdropProps: {
                timeout: 500
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: modalStyle,
                className: classes.mobileModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    container: true,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            item: true,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().wrapperMobileImg),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        onClick: handlePrevious,
                                        "aria-label": "prev",
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(classes.navBtnMobile, (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().leftNavBtn)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            className: classes.navigateIc
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackProductImage */ .nZ, {
                                        width: 300,
                                        height: 300,
                                        layout: "fill",
                                        alt: imageName,
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().imageMainMobile),
                                        src: images[selectedImage],
                                        objectFit: "contain"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        onClick: handleNext,
                                        "aria-label": "next",
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(classes.navBtnMobile, (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().rightNavBtn)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            className: classes.navigateIc
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            item: true,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().wrapper_mobile_thumbnail),
                                children: (images === null || images === void 0 ? void 0 : images.length) === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().flex_center),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_image_wrapper_mobile), (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_selected)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackProductImage */ .nZ, {
                                            width: 42,
                                            height: 42,
                                            alt: imageName,
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_image),
                                            src: images && images[0]
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().slider)
                                }, constants_data_setting_slider__WEBPACK_IMPORTED_MODULE_1__/* .settingsMobileMultiImageBoxV2 */ .As), {
                                    children: images === null || images === void 0 ? void 0 : images.map(function(img, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleClickImage(idx);
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_image_wrapper_mobile), idx === selectedImage && (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_selected)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackProductImage */ .nZ, {
                                                width: 42,
                                                height: 42,
                                                alt: imageName,
                                                size: "thumbnail",
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_image),
                                                src: img
                                            })
                                        }, img);
                                    })
                                }))
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "image-gallery-title",
        "aria-describedby": "image-gallery-description",
        closeAfterTransition: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Fade__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: modalStyle,
                className: classes.modal,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().closeWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            onClick: handleClose,
                            "aria-label": "close",
                            style: {
                                height: "18px",
                                width: "18px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                className: classes.closeBtn
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            container: true,
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().wrapperImg)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                onClick: handlePrevious,
                                                className: classes.navigateBtn,
                                                "aria-label": "prev",
                                                style: {
                                                    left: "40px",
                                                    zIndex: 10
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    className: classes.navigateIc
                                                })
                                            }),
                                            isVideoUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleVideoPlayer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                src: (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_8__/* .getLinkCDNVideo */ .qf)(images[selectedImage]),
                                                width: 545,
                                                height: 545
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                                width: 545,
                                                height: 545,
                                                alt: imageName,
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().imageMain),
                                                src: images[selectedImage]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                onClick: handleNext,
                                                className: classes.navigateBtn,
                                                "aria-label": "next",
                                                style: {
                                                    left: "590px",
                                                    zIndex: 10
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    className: classes.navigateIc
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    item: true,
                                    style: {
                                        width: "250px",
                                        marginLeft: "50px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().imageNameText), classes.nameBoxText),
                                            children: imageName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().wrapper_thumbnail), (images === null || images === void 0 ? void 0 : images.length) > 21 && (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().scroll_vertical)),
                                            children: images === null || images === void 0 ? void 0 : images.map(function(img, idx) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                    onClick: function() {
                                                        return handleClickImage(idx);
                                                    },
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_image_wrapper), idx === selectedImage && (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_selected)),
                                                    children: (0,utils_video__WEBPACK_IMPORTED_MODULE_13__/* .checkVideoUrl */ .P)(img) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleVideoPlayer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        src: (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_8__/* .getLinkCDNVideo */ .qf)(img),
                                                        width: 42,
                                                        height: 42,
                                                        isShowThumbnail: true
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_6__/* .ImageFallbackProductImage */ .nZ, {
                                                        width: 42,
                                                        height: 42,
                                                        alt: imageName,
                                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_17___default().thumbnail_image),
                                                        size: "thumbnail",
                                                        src: img
                                                    })
                                                }, img);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PopupMultilImage);


/***/ }),

/***/ 61133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30520);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




var SimpleVideoPlayer = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? 360 : _width, _height = param.height, height = _height === void 0 ? 360 : _height, _isAutoPlay = param.isAutoPlay, isAutoPlay = _isAutoPlay === void 0 ? false : _isAutoPlay, _isControls = param.isControls, isControls = _isControls === void 0 ? true : _isControls, _isShowThumbnail = param.isShowThumbnail, isShowThumbnail = _isShowThumbnail === void 0 ? false : _isShowThumbnail, _isCenterPlayButton = param.isCenterPlayButton, isCenterPlayButton = _isCenterPlayButton === void 0 ? true : _isCenterPlayButton;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // TODO: check ?size= then remove it
    var formatSrc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (src.includes("?size=")) {
            return src.replace(/\?size=\d+/, "");
        }
        return src;
    }, [
        src
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isAutoPlay) {
            if (videoRef.current) {
                videoRef.current.pause();
            }
        }
    }, [
        isAutoPlay
    ]);
    var handleClick = function(e) {
        if (!isCenterPlayButton) {
            e.preventDefault();
            if (videoRef.current) {
                if (!videoRef.current.paused) {
                    videoRef.current.pause();
                }
            }
        }
    };
    if (isShowThumbnail) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                src: formatSrc,
                width: "50px",
                height: "50px",
                className: "w-[50px] h-[50px]"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative h-[inherit]",
        children: [
            src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "hide-func absolute bottom-[1.75rem] right-0 w-[60px] h-[40px] bg-transparent z-[99] cursor-not-allowed"
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
                ref: videoRef,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().targetVideo), "cursor-pointer z-10 relative hover:shadow-lg h-[inherit]"),
                width: width,
                height: height,
                controls: isControls,
                autoPlay: isAutoPlay,
                controlsList: "nodownload",
                onClick: handleClick,
                "aria-label": "video of product",
                "aria-labelledby": "video of product",
                muted: isAutoPlay,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                        src: formatSrc,
                        type: "video/mp4"
                    }),
                    "Your browser does not support the video tag."
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleVideoPlayer);


/***/ }),

/***/ 96317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96394);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91005);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);






var InfoFormControl = function(param) {
    var xs = param.xs, md = param.md, isRequired = param.isRequired, children = param.children, label = param.label, htmlFor = param.htmlFor, error = param.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "info_form_grid",
        item: true,
        xs: xs,
        md: md,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().form_control),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    shrink: true,
                    htmlFor: htmlFor,
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().input_label),
                    children: [
                        label,
                        " ",
                        isRequired ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().required),
                            children: " * "
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                }),
                children,
                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_FormHelperText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().error),
                    children: error
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoFormControl);


/***/ }),

/***/ 30064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74061);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(186);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0.25rem;\n  font-size: 1rem;\n  background-color: #fff;\n  border-radius: 0.25rem;\n  margin: 1rem 1rem 1rem 0rem;\n  height: 50px;\n  width: 100%;\n  border: none;\n\n  // .MuiOutlinedInput-notchedOutline {\n  //   border: 4px solid #20c997 !important;\n  //   border-radius: 0.25rem !important;\n  // }\n\n  .MuiOutlinedInput-root .Mui-focused .MuiOutlinedInput-notchedOutline {\n    border: 4px solid #20c997 !important;\n    border-radius: 0.25rem !important;\n  }\n\n  &.input__info {\n    height: 2.24em !important;\n    margin-bottom: 0 !important;\n\n    & .MuiInputBase-input {\n      border-radius: 4px;\n      background-color: white;\n      border-color: #ced4da !important;\n      font-size: 16px;\n      padding: 10px 0 10px 12px;\n      height: 100%;\n    }\n\n    & .MuiInputBase-adornedEnd {\n      padding-right: 0 !important;\n    }\n\n    & .Mui-disabled {\n      box-shadow: none !important;\n      border: none !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var InputCustom = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
    var className = props.className, children = props.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: ref,
        className: className
    }, rest), {
        children: children
    }));
}));
var Input = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo((0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(InputCustom).withConfig({
    componentId: "sc-242007b2-0"
})(_templateObject()));
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 42150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30064);




var CustomInput = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "input__info"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(CustomInput));


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ListProductForPCWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var ListProductForPCWrapper = function(param) {
    var children = param.children, _gap = param.gap, gap = _gap === void 0 ? "20px" : _gap;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: gap,
        justifyContent: "center",
        children: children
    });
};


/***/ }),

/***/ 32838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_ListProductWithTitle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/assets/svg/PlayIcon.jsx
var PlayIcon = __webpack_require__(34175);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
;// CONCATENATED MODULE: ./src/constants/Enums/product.ts
var EnumProductGA;
(function(EnumProductGA) {
    EnumProductGA["SAME_MANUFACTURER"] = "SAME_MANUFACTURER";
    EnumProductGA["SAME_INGREDIENT"] = "SAME_INGREDIENT";
})(EnumProductGA || (EnumProductGA = {}));

// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/zustand-lib/useStartGuide.js
var useStartGuide = __webpack_require__(68373);
// EXTERNAL MODULE: ./src/components/mocules/ListProductWithTitle/ListProductForPCWrapper.tsx
var ListProductForPCWrapper = __webpack_require__(1510);
// EXTERNAL MODULE: ./src/components/mocules/ListProductWithTitle/styles.module.css
var styles_module = __webpack_require__(99867);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/ListProductWithTitle/index.js























var MEGA_SALE = "MEGA-SALE";
var ListProductWithTitle = function(param) {
    var children = param.children, _name = param.name, name = _name === void 0 ? "" : _name, redirect = param.redirect, viewMore = param.viewMore, _viewMoreInTitle = param.viewMoreInTitle, viewMoreInTitle = _viewMoreInTitle === void 0 ? true : _viewMoreInTitle, _page = param.page, page = _page === void 0 ? null : _page, icon = param.icon, iconWidth = param.iconWidth, iconHeight = param.iconHeight, _isBestProducts = param.isBestProducts, isBestProducts = _isBestProducts === void 0 ? false : _isBestProducts, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _type = param.type, type = _type === void 0 ? "" : _type, productsType = param.productsType, gap = param.gap, _forceShowButtonAtBottom = param.forceShowButtonAtBottom, forceShowButtonAtBottom = _forceShowButtonAtBottom === void 0 ? false : _forceShowButtonAtBottom, backgroundImage = param.backgroundImage, _config = param.config, config = _config === void 0 ? {} : _config;
    var isGuide = (0,useStartGuide/* default */.Z)(function(state) {
        return state;
    }).isGuide;
    var ref = (0,react.useRef)(null);
    var ctaBottomRef = (0,react.useRef)(null);
    var TITLE_ICON = name === "Sản phẩm c\xf9ng nh\xe0 b\xe1n h\xe0ng" ? Images/* SAME_STORE */.T2Q : Images/* SAME_INGREDIENT */.cau;
    var router = (0,next_router.useRouter)();
    var currentUrl = router.asPath;
    var wrapperRef = (0,react.useRef)(null);
    var isShowBtnAtBottom = viewMore && productsType === MEGA_SALE || forceShowButtonAtBottom;
    var defaultConfigCtaText = (config === null || config === void 0 ? void 0 : config.ctaText) || "Xem tất cả";
    var ctaText = config ? defaultConfigCtaText : data/* MAP_BTN_TITLE_BY_REDIRECT_URL */.Wg[redirect] || "Xem tất cả";
    var backgroundCta = (config === null || config === void 0 ? void 0 : config.backgroundCta) || "linear-gradient(0deg, #078c4e 0%, #29cc80 100%)";
    var ctaTextColor = config === null || config === void 0 ? void 0 : config.ctaTextColor;
    var headerImage = config === null || config === void 0 ? void 0 : config.headerImage;
    var handleGA = function() {
        if (type === EnumProductGA.SAME_MANUFACTURER) {
            gtag/* default.clickViewAllProductSameManufacturer */.ZP.clickViewAllProductSameManufacturer();
        }
        if (type === EnumProductGA.SAME_INGREDIENT) {
            gtag/* default.clickViewAllProductSameIngredient */.ZP.clickViewAllProductSameIngredient();
        }
    };
    (0,react.useEffect)(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            if (isGuide) {
                ref.current.slickPause();
            } else {
                ref.current.slickPlay();
            }
        }
    }, [
        isGuide
    ]);
    // This effect to make ctaTextColorConfig with the highest priority (!important css)
    (0,react.useEffect)(function() {
        if ((ctaBottomRef === null || ctaBottomRef === void 0 ? void 0 : ctaBottomRef.current) && ctaTextColor) {
            ctaBottomRef.current.style.color = ctaTextColor;
        }
    }, []);
    return page === "PRD_DETAIL" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        ref: wrapperRef,
        className: (0,clsx/* default */.Z)((styles_module_default()).wrapper, isBestProducts && (styles_module_default()).bestProductsWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).icon_name, isBestProducts && (styles_module_default()).bestProducts),
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        src: icon,
                        width: iconWidth || 40,
                        height: iconHeight || 40,
                        alt: "icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: (0,clsx/* default */.Z)((styles_module_default()).name, isBestProducts && (styles_module_default()).bestProductsName),
                        children: name
                    }),
                    isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (styles_module_default()).bestProducts_view_more,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "".concat(redirect),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Xem tất cả"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: Images/* DOUBLE_ARROW_ICON */.uVr,
                                    width: 12,
                                    height: 12,
                                    alt: "icon"
                                })
                            ]
                        })
                    })
                ]
            }),
            isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductForPCWrapper/* ListProductForPCWrapper */.r, {
                gap: gap,
                children: children
            }),
            !isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductForPCWrapper/* ListProductForPCWrapper */.r, {
                gap: gap,
                children: children
            }),
            viewMore && !isBestProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).view_more),
                onClick: handleGA,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                    href: "".concat(redirect),
                    color: "#0E1983",
                    name: "Xem tất cả"
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (loading || (children === null || children === void 0 ? void 0 : children.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)((styles_module_default()).wrapper_media, productsType === MEGA_SALE && (styles_module_default()).wrapperMega),
            ref: wrapperRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).wrapper_media_container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)((styles_module_default()).SliderProductWrap, productsType === MEGA_SALE && (styles_module_default()).backgroundMega),
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backgroundImage ? {
                        backgroundImage: "url('" + backgroundImage + "')"
                    } : {}), {
                        backgroundSize: "100% 100%"
                    }),
                    children: [
                        productsType === MEGA_SALE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: headerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                                src: headerImage,
                                width: 1180,
                                height: 74,
                                layout: "intrinsic",
                                alt: "header-image-mega-block"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).wrapperTitle,
                            style: {
                                visibility: name == "" ? "hidden" : "visible"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: (0,clsx/* default */.Z)((styles_module_default()).title, (styles_module_default()).wrapperContentTitle),
                                    children: [
                                        icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (styles_module_default()).contentTitle,
                                            children: name
                                        })
                                    ]
                                }),
                                viewMoreInTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (styles_module_default()).seeAllWrapper,
                                    onClick: function() {
                                        if (productsType === "THUOC_KE_DON_GIA_TOT") {
                                            gtag/* default.clickViewAllThuocKeDonGiaTot */.ZP.clickViewAllThuocKeDonGiaTot({
                                                currentUrl: currentUrl,
                                                redirect: redirect
                                            });
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                        href: "".concat(redirect),
                                        className: (0,clsx/* default */.Z)((styles_module_default()).seeAll),
                                        children: [
                                            data/* MAP_BTN_TITLE_BY_REDIRECT_URL */.Wg[redirect] || "Xem tất cả",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* PlayIcon */.o, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (styles_module_default()).progress,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 50,
                                thickness: 4
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            className: productsType === MEGA_SALE && "px-[6px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductForPCWrapper/* ListProductForPCWrapper */.r, {
                                    gap: gap,
                                    children: children
                                }),
                                isShowBtnAtBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (styles_module_default()).seeAllWrapperMega,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                        href: "".concat(redirect),
                                        className: (0,clsx/* default */.Z)((styles_module_default()).seeAll),
                                        style: {
                                            background: backgroundCta,
                                            color: "".concat(ctaTextColor)
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            ref: ctaBottomRef,
                                            children: ctaText
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var mocules_ListProductWithTitle = (ListProductWithTitle);


/***/ }),

/***/ 2546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58365);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26123);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);






var SliderProductBlock = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var _hiddenTitle = param.hiddenTitle, hiddenTitle = _hiddenTitle === void 0 ? false : _hiddenTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().sliderProductBlockWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                marginTop: hiddenTitle ? 0 : 40,
                marginBottom: hiddenTitle ? 40 : 0
            },
            children: [
                !hiddenTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    width: "100%",
                    height: 70
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().sliderWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "rect",
                            animation: "wave",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().productCardSkeleton)
                        })
                    ]
                })
            ]
        })
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (SliderProductBlock);


/***/ }),

/***/ 94134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductDetailLoading; },
/* harmony export */   "r": function() { return /* binding */ VoucherCollectListSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58365);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1160);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_3__);





function VoucherCollectListSkeleton() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "rect",
        width: "100%",
        height: 50
    });
}
function ProductDetailLoading(param) {
    var _isLogin = param.isLogin, isLogin = _isLogin === void 0 ? false : _isLogin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().containerLoading),
        children: isLogin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    container: true,
                    spacing: 3,
                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            lg: 4,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 330
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "text",
                                    width: "100%",
                                    height: 50
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().rightGrid),
                            xs: 12,
                            lg: 8,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 596,
                                    height: 26
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 500,
                                    height: 26
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "text",
                                    width: 100,
                                    height: 16
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 500,
                                    height: 26
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 500,
                                    height: 26
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 362
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "100%",
                                    height: 362
                                })
                            ]
                        })
                    ]
                }),
                Array.from({
                    length: 2
                }).map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        container: true,
                        spacing: 3,
                        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().sliderSkeleton),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "20%",
                                    height: 400
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "20%",
                                    height: 400
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "20%",
                                    height: 400
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "20%",
                                    height: 400
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: "20%",
                                    height: 400
                                })
                            ]
                        })
                    }, index);
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    container: true,
                    spacing: 3,
                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            lg: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                variant: "rect",
                                width: "100%",
                                height: 330
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().rightGrid),
                            xs: 12,
                            lg: 5,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 480,
                                    height: 26
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "text",
                                    width: 150,
                                    height: 26
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 480,
                                    height: 120
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().rightGrid),
                            xs: 12,
                            lg: 3,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 280,
                                    height: 182
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    width: 280,
                                    height: 50
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    container: true,
                    spacing: 3,
                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            lg: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                variant: "text",
                                width: "100%",
                                height: 26
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().rightGrid),
                            xs: 12,
                            lg: 11,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                variant: "text",
                                width: 80,
                                height: 26
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().rightGrid),
                            xs: 12,
                            lg: 6,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                variant: "rect",
                                width: "100%",
                                height: 320
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            item: true,
                            className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().rightGrid),
                            xs: 12,
                            lg: 6,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                variant: "rect",
                                width: "100%",
                                height: 320
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_3___default().skeleTonWrapper),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        variant: "rect",
                        width: "100%",
                        height: 500
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 64683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ENUM_VOUCHER_ACTION_STATUS; },
/* harmony export */   "ZR": function() { return /* binding */ ENUM_VOUCHER_COLLECTION_STATUS; },
/* harmony export */   "_n": function() { return /* binding */ PromoCodesTabInfo; },
/* harmony export */   "kf": function() { return /* binding */ ENUM_FETCH_MORE_ACTION_TYPE; },
/* harmony export */   "nl": function() { return /* binding */ ENUM_PROMOTION_ORAGANIZER; },
/* harmony export */   "zE": function() { return /* binding */ PromoCodeTabOpts; }
/* harmony export */ });
/* unused harmony exports ENUM_PROMO_CODE_TAB, ENUM_PROMO_TYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var ENUM_PROMO_CODE_TAB;
(function(ENUM_PROMO_CODE_TAB) {
    ENUM_PROMO_CODE_TAB["ALL"] = "ALL";
    ENUM_PROMO_CODE_TAB["USED"] = "USED";
})(ENUM_PROMO_CODE_TAB || (ENUM_PROMO_CODE_TAB = {}));
var ENUM_FETCH_MORE_ACTION_TYPE;
(function(ENUM_FETCH_MORE_ACTION_TYPE) {
    ENUM_FETCH_MORE_ACTION_TYPE["VOUCHER"] = "VOUCHER";
    ENUM_FETCH_MORE_ACTION_TYPE["HISTORY"] = "HISTORY";
    ENUM_FETCH_MORE_ACTION_TYPE["LOYALTY_POINT"] = "LOYALTY_POINT";
    ENUM_FETCH_MORE_ACTION_TYPE["VOUCHER_COLLECTED"] = "VOUCHER_COLLECTED";
    ENUM_FETCH_MORE_ACTION_TYPE["SELLER"] = "SELLER";
    ENUM_FETCH_MORE_ACTION_TYPE["MARKETPLACE"] = "MARKETPLACE";
})(ENUM_FETCH_MORE_ACTION_TYPE || (ENUM_FETCH_MORE_ACTION_TYPE = {}));
var ENUM_PROMOTION_ORAGANIZER;
(function(ENUM_PROMOTION_ORAGANIZER) {
    ENUM_PROMOTION_ORAGANIZER["INTERNAL_SELLER"] = "INTERNAL_SELLER";
    ENUM_PROMOTION_ORAGANIZER["MARKETING"] = "MARKETING";
    ENUM_PROMOTION_ORAGANIZER["SELLER_CENTER"] = "SELLER_CENTER";
})(ENUM_PROMOTION_ORAGANIZER || (ENUM_PROMOTION_ORAGANIZER = {}));
var _obj;
var PromoCodesTabInfo = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ENUM_PROMO_CODE_TAB.ALL, "Tất cả m\xe3"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ENUM_PROMO_CODE_TAB.USED, "M\xe3 đ\xe3 sử dụng"), _obj);
var ENUM_VOUCHER_ACTION_STATUS;
(function(ENUM_VOUCHER_ACTION_STATUS) {
    ENUM_VOUCHER_ACTION_STATUS["INVALID"] = "INVALID";
    ENUM_VOUCHER_ACTION_STATUS["AVAILABLE"] = "AVAILABLE";
    ENUM_VOUCHER_ACTION_STATUS["DISABLED"] = "DISABLED";
    ENUM_VOUCHER_ACTION_STATUS["INUSE"] = "INUSE";
})(ENUM_VOUCHER_ACTION_STATUS || (ENUM_VOUCHER_ACTION_STATUS = {}));
var ENUM_PROMO_TYPE;
(function(ENUM_PROMO_TYPE) {
    ENUM_PROMO_TYPE["DISCOUNT"] = "DISCOUNT";
    ENUM_PROMO_TYPE["COMBO"] = "COMBO";
    ENUM_PROMO_TYPE["GIFT"] = "GIFT";
    ENUM_PROMO_TYPE["VOUCHERCODE"] = "VOUCHERCODE";
    ENUM_PROMO_TYPE["FREESHIP"] = "FREESHIP";
    ENUM_PROMO_TYPE["PERCENTAGE"] = "PERCENTAGE";
    ENUM_PROMO_TYPE["ABSOLUTE"] = "ABSOLUTE";
    ENUM_PROMO_TYPE["POINT"] = "POINT";
})(ENUM_PROMO_TYPE || (ENUM_PROMO_TYPE = {}));
var ENUM_VOUCHER_COLLECTION_STATUS;
(function(ENUM_VOUCHER_COLLECTION_STATUS) {
    ENUM_VOUCHER_COLLECTION_STATUS["AVAILABLE"] = "AVAILABLE";
    ENUM_VOUCHER_COLLECTION_STATUS["COLLECTED"] = "COLLECTED";
    ENUM_VOUCHER_COLLECTION_STATUS["OWNERSHIP"] = "OWNERSHIP";
})(ENUM_VOUCHER_COLLECTION_STATUS || (ENUM_VOUCHER_COLLECTION_STATUS = {}));
var PromoCodeTabOpts = [
    {
        index: 0,
        label: PromoCodesTabInfo.ALL,
        value: ENUM_PROMO_CODE_TAB.ALL
    },
    {
        index: 1,
        label: PromoCodesTabInfo.USED,
        value: ENUM_PROMO_CODE_TAB.USED
    }, 
];


/***/ }),

/***/ 34532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "As": function() { return /* binding */ settingsMobileMultiImageBoxV2; },
/* harmony export */   "GB": function() { return /* binding */ settingDailyCheckin; },
/* harmony export */   "Li": function() { return /* binding */ settingsNewFlashSaleTimes; },
/* harmony export */   "ui": function() { return /* binding */ createSettingsSliderBanner; }
/* harmony export */ });
/* unused harmony exports settingsMultiImageBoxV2, settingsNewProducts, settingsV1WebAppNewFlashSaleTimes, settingsPopupSharing */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18042);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98121);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43931);




function SampleNextArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
}
function SamplePrevArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
}
function DailyCheckinNextArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_1__/* .ImageFallbackStatic */ .ez, {
            src: "".concat("https://cdn-web-next-stg.thuocsi.vn" || 0, "/images/dailyCheckin/arrow_right_icon.svg"),
            width: 20,
            height: 20,
            style: {
                userSelect: "none"
            }
        })
    });
}
function DailyCheckinPrevArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_1__/* .ImageFallbackStatic */ .ez, {
            src: "".concat("https://cdn-web-next-stg.thuocsi.vn" || 0, "/images/dailyCheckin/arrow_left_icon.svg"),
            width: 20,
            height: 20,
            style: {
                userSelect: "none"
            }
        })
    });
}
var settingsMultiImageBoxV2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {})
};
var settingsMobileMultiImageBoxV2 = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    swipeToSlide: true,
    rows: 1,
    speed: 500,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {})
};
var settingsNewProducts = {
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1000,
    lazyLoad: true,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
    responsive: [
        {
            breakpoint: 564,
            settings: {
                arrow: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true
            }
        },
        {
            breakpoint: 640,
            settings: {
                arrow: false,
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: "15px"
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1140,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, 
    ]
};
var settingsNewFlashSaleTimes = {
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    lazyLoad: false,
    swipeToSlide: true,
    speed: 500,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                transform: "matrix(-1 0 0 1 32 0)",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                style: {
                    userSelect: "none",
                    pointerEvents: "none"
                },
                d: "M21.5019 14.8991L14.7203 8.44037C14.4138 8.14679 14.0307 8 13.5709 8C13.1367 8 12.7663 8.14679 12.4598 8.44037C12.1533 8.73394 12 9.08868 12 9.50459C12 9.92049 12.1533 10.2752 12.4598 10.5688L18.1303 16L12.4598 21.3945C12.1533 21.6881 12 22.055 12 22.4954C12 22.9113 12.1533 23.2661 12.4598 23.5596C12.7663 23.8532 13.1367 24 13.5709 24C14.0307 24 14.4138 23.8532 14.7203 23.5596L21.5019 17.1009C21.834 16.8073 22 16.4404 22 16C22 15.5596 21.834 15.1927 21.5019 14.8991Z",
                fill: "white"
            })
        ]
    }),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                transform: "matrix(-1 0 0 1 32 0)",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                style: {
                    userSelect: "none",
                    pointerEvents: "none"
                },
                d: "M13.8697 15.9635L19.5402 10.5571C19.8467 10.2648 20 9.91172 20 9.49772C20 9.08371 19.8467 8.73059 19.5402 8.43835C19.2337 8.14612 18.8506 8 18.3908 8C17.9566 8 17.5862 8.14612 17.2797 8.43835L10.4981 14.8676C10.166 15.1598 10 15.5251 10 15.9635C10 16.4018 10.166 16.7671 10.4981 17.0594L17.2797 23.5616C17.5862 23.8539 17.9566 24 18.3908 24C18.8506 24 19.2337 23.8539 19.5402 23.5616C19.8467 23.2694 20 22.9163 20 22.5023C20 22.0883 19.8467 21.7352 19.5402 21.4429L13.8697 15.9635Z",
                fill: "white"
            })
        ]
    }),
    responsive: [
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, 
    ]
};
var settingsV1WebAppNewFlashSaleTimes = {
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 1000,
    lazyLoad: false,
    focusOnSelect: false,
    focusOnChange: false,
    swipeToSlide: true,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {})
};
var settingsPopupSharing = {
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    rows: 1,
    arrows: false,
    infinite: false,
    autoplay: false,
    speed: 1000,
    focusOnSelect: false,
    focusOnChange: false,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
    responsive: [
        {
            breakpoint: 564,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, 
    ]
};
var createSettingsSliderBanner = function(setCurrentIndex, setPercentTime, isMobile) {
    return {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        rows: 1,
        swipeToSlide: true,
        arrows: !isMobile,
        nextArrow: !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}) : null,
        prevArrow: !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}) : null,
        beforeChange: function(_, next) {
            setCurrentIndex(next);
            setPercentTime(0);
        }
    };
};
var settingDailyCheckin = {
    slidesToShow: 7,
    slidesToScroll: 7,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 1000,
    swipe: false,
    draggable: false,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DailyCheckinNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DailyCheckinPrevArrow, {})
};


/***/ }),

/***/ 6496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Np": function() { return /* binding */ CartSuggestionsProvider; },
/* harmony export */   "dT": function() { return /* binding */ useCartSuggestions; }
/* harmony export */ });
/* unused harmony export CartSuggestionsContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clients_WebServiceClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var CartSuggestionsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)();
var CartSuggestionsProvider = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), comboSuggestions = ref[0], setComboSuggestions = ref[1];
    function fetchCartItemHelper() {
        return _fetchCartItemHelper.apply(this, arguments);
    }
    function _fetchCartItemHelper() {
        _fetchCartItemHelper = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var res, comboSuggestions, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,clients_WebServiceClient__WEBPACK_IMPORTED_MODULE_1__/* .getScreenCartItemHelper */ .zt)()
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status !== "OK") {
                            console.error("[Error] load combo suggestion", res);
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        comboSuggestions = _tmp;
                        (res.data || []).forEach(function(suggestion) {
                            comboSuggestions[suggestion.sku] = suggestion.helpers;
                        });
                        setComboSuggestions(comboSuggestions);
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchCartItemHelper.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        fetchCartItemHelper();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartSuggestionsContext.Provider, {
        value: {
            comboSuggestions: comboSuggestions
        },
        children: props.children
    });
};
var useCartSuggestions = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(CartSuggestionsContext);
};


/***/ }),

/***/ 56856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useGetProductsDisplayedFromAppSettings; }
/* harmony export */ });
/* harmony import */ var constants_Enums_app_settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73796);
/* harmony import */ var zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31439);


var DEFAULT_PRODUCTS_DISPLAYED = 10;
var useGetProductsDisplayedFromAppSettings = function(key) {
    var appSetting = (0,zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_1__/* .useStore */ .oR)(function(state) {
        return state.appSetting;
    });
    var productsDisplayed = appSetting[constants_Enums_app_settings__WEBPACK_IMPORTED_MODULE_0__/* .EnumAppSettings.PRODUCTS_DISPLAYED */ .nv.PRODUCTS_DISPLAYED] || null;
    return (productsDisplayed === null || productsDisplayed === void 0 ? void 0 : productsDisplayed[key]) || DEFAULT_PRODUCTS_DISPLAYED;
};


/***/ }),

/***/ 28727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useModalV2 = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, defValue = arguments.length > 1 ? arguments[1] : void 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(data), isShowing = ref[0], setIsShowing = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defValue), value = ref1[0], setValue = ref1[1];
    var toggle = function(val, callback) {
        if (val) setValue(val);
        setIsShowing(!isShowing);
        if (callback && typeof callback === "function") {
            callback();
        }
    };
    var getVal = function() {
        return value;
    };
    return [
        isShowing,
        toggle,
        getVal
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useModalV2);


/***/ }),

/***/ 34297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useUploadSingleFile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var clients_Clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38307);
/* harmony import */ var clients_UploadFileClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31181);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25872);







var useUploadSingleFile = function(param) {
    var _maxFileSize = param.maxFileSize, maxFileSize = _maxFileSize === void 0 ? 5 : _maxFileSize, callback = param.callback;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), url = ref[0], setUrl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var onChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(e) {
            var file, reader;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                if (e.target.files && e.target.files[0]) {
                    file = e.target.files[0];
                    if (file.size > maxFileSize * 1024 * 1024) {
                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error("K\xedch thước tối đa ".concat(maxFileSize, "MB"));
                        return [
                            2
                        ];
                    }
                    reader = new FileReader();
                    reader.onloadend = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        var base64String, body, _tmp, result, _tmp1, uploadedUrl, result1;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    base64String = reader.result;
                                    _tmp = {};
                                    body = (_tmp.file = base64String, _tmp.type = file.type, _tmp);
                                    setIsLoading(true);
                                    _tmp1 = {};
                                    return [
                                        4,
                                        clients_UploadFileClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upload */ .Z.upload((_tmp1.body = body, _tmp1.ctx = undefined, _tmp1))
                                    ];
                                case 1:
                                    result = _state.sent();
                                    if ((result === null || result === void 0 ? void 0 : result.status) === "ERROR") {
                                        setIsLoading(false);
                                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error("Tải file kh\xf4ng th\xe0nh c\xf4ng. Vui l\xf2ng thử lại sau.");
                                        return [
                                            2
                                        ];
                                    }
                                    if (!clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValidWithoutData */ .Wk) {
                                        setIsLoading(false);
                                        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error((result === null || result === void 0 ? void 0 : result.message) || "Tải file kh\xf4ng th\xe0nh c\xf4ng");
                                        return [
                                            2
                                        ];
                                    }
                                    uploadedUrl = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(result);
                                    if (!callback) return [
                                        3,
                                        5
                                    ];
                                    if (!(typeof callback === "function")) return [
                                        3,
                                        4
                                    ];
                                    result1 = callback(uploadedUrl);
                                    if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(result1, Promise)) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        result1.then(function(res) {
                                            if (res) {
                                                setUrl(uploadedUrl);
                                            }
                                        }).finally(function() {
                                            setIsLoading(false);
                                        })
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                                case 3:
                                    callback(uploadedUrl);
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    console.error("Callback is not a function");
                                    _state.label = 5;
                                case 5:
                                    setUrl(uploadedUrl);
                                    setIsLoading(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    // You can now use the base64String as needed
                    });
                    reader.readAsDataURL(file);
                }
                return [
                    2
                ];
            });
        });
        return function onChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        url: url,
        isLoading: isLoading,
        setUrl: setUrl,
        setIsLoading: setIsLoading,
        onChange: onChange
    };
};


/***/ }),

/***/ 86269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90512);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ 15803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ProductDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
// EXTERNAL MODULE: ./src/clients/SupplierClient.js
var SupplierClient = __webpack_require__(78369);
// EXTERNAL MODULE: ./src/clients/WebServiceClient.js
var WebServiceClient = __webpack_require__(91952);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AttachMoney.js
var AttachMoney = __webpack_require__(46857);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ThumbDownOffAlt.js
var ThumbDownOffAlt = __webpack_require__(58025);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ThumbUpOffAlt.js
var ThumbUpOffAlt = __webpack_require__(77834);
// EXTERNAL MODULE: ./src/clients/CustomerClient.js
var CustomerClient = __webpack_require__(59261);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/components/mocules/ProductLimitMessage/index.js
var ProductLimitMessage = __webpack_require__(68556);
// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/constants/SVG/index.ts
var SVG = __webpack_require__(69448);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/SellerService.js
var SellerService = __webpack_require__(62510);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlTable/index.js + 1 modules
var QuantityControlTable = __webpack_require__(60547);
// EXTERNAL MODULE: ./src/components-v2/mocules/AnotherSeller/styles.module.css
var styles_module = __webpack_require__(18165);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/AnotherSeller/index.js
















function DiscountInfo(param) {
    var displayPriceFormated = param.displayPriceFormated, priceSave = param.priceSave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).priceInfo,
        children: [
            priceSave > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: (styles_module_default()).save,
                children: [
                    "Tiết kiệm ",
                    (0,FormatNumber/* formatCurrency */.xG)(priceSave)
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: (styles_module_default()).price,
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                        displayPriceFormated: displayPriceFormated
                    }) || 0
                ]
            })
        ]
    });
}
function RowHeader() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        className: (styles_module_default()).gridContainer,
        container: true,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).column),
                item: true,
                lg: 5,
                sm: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (styles_module_default()).header,
                    children: "Nh\xe0 b\xe1n h\xe0ng"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).column, (styles_module_default()).right),
                item: true,
                lg: 3,
                sm: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (styles_module_default()).headerRight,
                    children: "Gi\xe1 b\xe1n"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).column),
                item: true,
                lg: 4,
                sm: 5
            })
        ]
    });
}
function RowBody(param) {
    var product = param.product, priceCompare = param.priceCompare;
    var ref;
    var _tags = product.tags, tags = _tags === void 0 ? [] : _tags, displayPriceFormated = product.displayPriceFormated, displayPrice = product.displayPrice, sku = product.sku, slug = product.slug;
    var ref1 = (0,SellerService/* getSellerData */.Kz)({
        seller: product.sellerInfo,
        tags: tags
    }), sellerName = ref1.sellerName, _individualNonVatSellerName = ref1.individualNonVatSellerName, individualNonVatSellerName = _individualNonVatSellerName === void 0 ? "" : _individualNonVatSellerName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        className: (styles_module_default()).gridContainer,
        container: true,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).column),
                item: true,
                lg: 5,
                sm: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                    href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat(slug || ""),
                    children: individualNonVatSellerName || sellerName || (product === null || product === void 0 ? void 0 : product.vendorInfo) && Object.keys(product.vendorInfo).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (styles_module_default()).row,
                        children: (product === null || product === void 0 ? void 0 : (ref = product.vendorInfo) === null || ref === void 0 ? void 0 : ref.name) || individualNonVatSellerName || sellerName || ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        width: "16",
                        height: "16",
                        src: Icons/* COLOR_STORE */.bV2,
                        alt: "thuocsi store",
                        className: (styles_module_default()).image_logo
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).column, (styles_module_default()).right),
                item: true,
                lg: 3,
                sm: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountInfo, {
                    priceSave: priceCompare - displayPrice,
                    displayPriceFormated: displayPriceFormated
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).column),
                item: true,
                lg: 4,
                sm: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).wrapQuantity,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLimitMessage/* default */.Z, {
                            consumedMaxQuantity: product.consumedMaxQuantity,
                            unit: product.unit,
                            page: "product"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlTable/* default */.Z, {
                            product: product
                        })
                    ]
                })
            })
        ]
    }, "".concat(sku));
}
var AnotherSeller = /*#__PURE__*/ (0,react.forwardRef)(function AnotherSeller(param, ref) {
    var products = param.products, _title = param.title, title = _title === void 0 ? "" : _title, toggleOpenModal = param.toggleOpenModal, isModal = param.isModal, sellerTypeNoViewMore = param.sellerTypeNoViewMore, productCompare = param.productCompare;
    var displayPrice = productCompare.displayPrice;
    var updatedProducts = products;
    var checkConditionRender = function() {
        var listProduct = (0,_to_consumable_array/* default */.Z)(updatedProducts);
        if (isModal) return listProduct;
        if (listProduct.length > 2) return listProduct.slice(0, 3);
        return listProduct;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (styles_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).table,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowHeader, {}),
                    checkConditionRender().map(function(product) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(RowBody, {
                            product: product,
                            sellerTypeNoViewMore: sellerTypeNoViewMore,
                            priceCompare: displayPrice
                        }, "".concat(product === null || product === void 0 ? void 0 : product.sku));
                    })
                ]
            }),
            toggleOpenModal && updatedProducts.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (styles_module_default()).showAll,
                onClick: function() {
                    return toggleOpenModal();
                },
                children: "Xem tất cả"
            }) : null
        ]
    });
});
/* harmony default export */ var mocules_AnotherSeller = (AnotherSeller);

// EXTERNAL MODULE: ./src/components/mocules/TagComponent/index.js + 1 modules
var TagComponent = __webpack_require__(19862);
// EXTERNAL MODULE: ./src/hooks/useConfigHangDiem.ts
var useConfigHangDiem = __webpack_require__(53069);
// EXTERNAL MODULE: ./src/utils/ProductLabelUtils.ts
var ProductLabelUtils = __webpack_require__(21038);
// EXTERNAL MODULE: ./src/components-v2/mocules/BuyWithDeal/styles.module.css
var BuyWithDeal_styles_module = __webpack_require__(56209);
var BuyWithDeal_styles_module_default = /*#__PURE__*/__webpack_require__.n(BuyWithDeal_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/BuyWithDeal/index.js















function ProductItemDeal(param) {
    var product = param.product, tags = param.tags, statusData = param.statusData, expiredDate = param.expiredDate, imgUrl = param.imgUrl, link = param.link;
    var ref, ref1, ref2, ref3, ref4;
    var sellerName = (0,SellerService/* getSellerData */.Kz)({
        seller: product.sellerInfo,
        tags: tags
    }).sellerName;
    var ref5 = (0,useConfigHangDiem/* useConfigHangDiem */.x)({
        vendorInfoSellerCode: product === null || product === void 0 ? void 0 : (ref = product.vendorInfo) === null || ref === void 0 ? void 0 : ref.sellerCode
    }), isHangDiem = ref5.isHangDiem, iconHangDiem = ref5.iconHangDiem, linkRedirect = ref5.linkRedirect;
    // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
    var medicineTypeLabels = (0,ProductLabelUtils/* getMedicineTypeLabels */.RG)(product);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BuyWithDeal_styles_module_default()).wrapperDeal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BuyWithDeal_styles_module_default()).itemDeal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BuyWithDeal_styles_module_default()).groupInfoDealTop,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                className: (BuyWithDeal_styles_module_default()).image,
                                href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat((product === null || product === void 0 ? void 0 : product.slug) || ""),
                                padding: "0px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                    size: "thumbnail",
                                    width: 112,
                                    height: 112,
                                    src: imgUrl,
                                    quality: 100,
                                    objectFit: "contain"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BuyWithDeal_styles_module_default()).nameTag,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                        href: "/seller-products/".concat((product === null || product === void 0 ? void 0 : (ref1 = product.sellerInfo) === null || ref1 === void 0 ? void 0 : ref1.code) || (product === null || product === void 0 ? void 0 : (ref2 = product.sellerInfo) === null || ref2 === void 0 ? void 0 : ref2.sellerCode), "/").concat((product === null || product === void 0 ? void 0 : (ref3 = product.sellerInfo) === null || ref3 === void 0 ? void 0 : ref3.sellerType) == "ENTERPRISE" ? product === null || product === void 0 ? void 0 : (ref4 = product.sellerInfo) === null || ref4 === void 0 ? void 0 : ref4.slug : ""),
                                        padding: "0px",
                                        children: [
                                            sellerName === "MEDX" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                width: "12",
                                                height: "12",
                                                src: Icons/* COLOR_STORE */.bV2,
                                                alt: "thuocsi store",
                                                className: (BuyWithDeal_styles_module_default()).image_logo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (BuyWithDeal_styles_module_default()).score,
                                                children: sellerName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                        href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat((product === null || product === void 0 ? void 0 : product.slug) || ""),
                                        padding: "0px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: (BuyWithDeal_styles_module_default()).nameXs,
                                            children: product === null || product === void 0 ? void 0 : product.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (BuyWithDeal_styles_module_default()).hightLightTag,
                                        children: [
                                            medicineTypeLabels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (BuyWithDeal_styles_module_default()).medicineType,
                                                children: medicineTypeLabels.map(function(info) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                        src: info.icon.src,
                                                        height: 20,
                                                        width: Math.round(info.icon.width / info.icon.height * 20),
                                                        alt: info.label
                                                    }, info.variant);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                                product: {
                                                    tags: tags,
                                                    statusData: statusData,
                                                    expiredDate: expiredDate,
                                                    isHangDiemStore: isHangDiem,
                                                    iconHangDiem: iconHangDiem
                                                },
                                                isMobile: true,
                                                isSellerList: false,
                                                isPageDetail: true,
                                                link: isHangDiem ? linkRedirect : link
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (BuyWithDeal_styles_module_default()).volume,
                                        children: product === null || product === void 0 ? void 0 : product.volume
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BuyWithDeal_styles_module_default()).groupQuantity,
                        children: [
                            product.retalPriceDifferencePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (BuyWithDeal_styles_module_default()).amountSaved,
                                children: [
                                    "Rẻ hơn ",
                                    product.retalPriceDifferencePrice,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "tr\xean mỗi sản phẩm"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BuyWithDeal_styles_module_default()).groupInfoDeal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (BuyWithDeal_styles_module_default()).price,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                        displayPriceFormated: (product === null || product === void 0 ? void 0 : product.displayPriceFormated) || 0,
                                        fillPath: "black",
                                        size: "md"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BuyWithDeal_styles_module_default()).flexContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlTable/* default */.Z, {
                                product: product,
                                className: (BuyWithDeal_styles_module_default()).quantityControlWithDeal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLimitMessage/* default */.Z, {
                                consumedMaxQuantity: product.consumedMaxQuantity,
                                unit: product.unit,
                                page: "product"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BuyWithDeal_styles_module_default()).topPosition,
                children: (product === null || product === void 0 ? void 0 : product.discountPercent) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (BuyWithDeal_styles_module_default()).discountDeal,
                    children: [
                        " -",
                        product === null || product === void 0 ? void 0 : product.discountPercent,
                        "%"
                    ]
                })
            })
        ]
    });
}
var BuyWithDeal = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var products = param.products, link = param.link;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (products === null || products === void 0 ? void 0 : products.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (BuyWithDeal_styles_module_default()).buyWithDeal,
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (BuyWithDeal_styles_module_default()).title,
                    children: "Mua k\xe8m deal sốc"
                }),
                products.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductItemDeal, {
                        product: item,
                        tags: item === null || item === void 0 ? void 0 : item.tags,
                        imgUrl: item === null || item === void 0 ? void 0 : item.imagesProxy[0],
                        statusData: item === null || item === void 0 ? void 0 : item.statusData,
                        expiredDate: item === null || item === void 0 ? void 0 : item.expiredDate,
                        link: link
                    }, item.productId);
                })
            ]
        }) : null
    });
});
BuyWithDeal.displayName = "BuyWithDeal";
/* harmony default export */ var mocules_BuyWithDeal = (BuyWithDeal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(11476);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/components-v2/mocules/ComboList/styles.module.css
var ComboList_styles_module = __webpack_require__(39573);
var ComboList_styles_module_default = /*#__PURE__*/__webpack_require__.n(ComboList_styles_module);
// EXTERNAL MODULE: ./src/services/ProductServiceV2.js
var ProductServiceV2 = __webpack_require__(5108);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ComboList/index.js

















var LightTooltip = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "#A2A0A0"
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#A2A0A0",
        color: "#fff",
        fontSize: 12,
        top: "-2px"
    }), _obj;
});
function ComboList(param) {
    var skus = param.skus;
    var ref = (0,react.useState)([]), comboList = ref[0], setComboList = ref[1];
    (0,react.useEffect)(function() {
        if ((skus === null || skus === void 0 ? void 0 : skus.length) > 0) {
            var comboList = skus === null || skus === void 0 ? void 0 : skus.map(function(item) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item, ProductServiceV2/* default.convertProductV2 */.ZP.convertProductV2(item.productData)), {
                    quantity: item.quantity
                });
            });
            setComboList(comboList);
        }
    }, []);
    if ((comboList === null || comboList === void 0 ? void 0 : comboList.length) === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (ComboList_styles_module_default()).titleCombo,
                children: "Combo bao gồm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ComboList_styles_module_default()).comboContainer,
                children: comboList.map(function(item, index) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
                    var isLinkActive = (item === null || item === void 0 ? void 0 : item.sellerClass) === "INTERNAL" && (item === null || item === void 0 ? void 0 : item.isActive);
                    var tagExpired = (item === null || item === void 0 ? void 0 : (ref = item.productData) === null || ref === void 0 ? void 0 : (ref1 = ref.sku) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.lotDates) === null || ref2 === void 0 ? void 0 : ref2.find(function(ele) {
                        return (ele === null || ele === void 0 ? void 0 : ele.isNearExpired) === true;
                    })) || {};
                    var _expiredDate = tagExpired.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ComboList_styles_module_default()).comboItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                style: {
                                    pointerEvents: isLinkActive || !(item === null || item === void 0 ? void 0 : item.isGift) ? "" : "none"
                                },
                                removeStyles: true,
                                href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat((item === null || item === void 0 ? void 0 : (ref3 = item.productData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sku) === null || ref4 === void 0 ? void 0 : ref4.slug) || ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ComboList_styles_module_default()).imageContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        src: (item === null || item === void 0 ? void 0 : (ref5 = item.productData) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.imageUrls) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && (item === null || item === void 0 ? void 0 : (ref8 = item.productData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.product) === null || ref9 === void 0 ? void 0 : ref9.imageUrls[0]),
                                        size: "thumbnail",
                                        width: 38,
                                        height: 38,
                                        alt: item === null || item === void 0 ? void 0 : (ref10 = item.productData) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.product) === null || ref11 === void 0 ? void 0 : ref11.name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ComboList_styles_module_default()).groupInfoProduct,
                                children: [
                                    isLinkActive || !(item === null || item === void 0 ? void 0 : item.isGift) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                        removeStyles: true,
                                        href: "".concat(sysconfig/* DOMAIN_WEB_HOST */.WL, "/product/").concat((item === null || item === void 0 ? void 0 : (ref12 = item.productData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sku) === null || ref13 === void 0 ? void 0 : ref13.slug) || ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                            title: item === null || item === void 0 ? void 0 : (ref14 = item.productData) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.product) === null || ref15 === void 0 ? void 0 : ref15.name,
                                            arrow: true,
                                            placement: "top",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: (ComboList_styles_module_default()).nameCombo,
                                                children: item === null || item === void 0 ? void 0 : (ref16 = item.productData) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.product) === null || ref17 === void 0 ? void 0 : ref17.name
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                        title: item === null || item === void 0 ? void 0 : (ref18 = item.productData) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.product) === null || ref19 === void 0 ? void 0 : ref19.name,
                                        arrow: true,
                                        placement: "top",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: (ComboList_styles_module_default()).nameCombo,
                                            children: item === null || item === void 0 ? void 0 : (ref20 = item.productData) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.product) === null || ref21 === void 0 ? void 0 : ref21.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ComboList_styles_module_default()).hightLightTag,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                            product: {
                                                tags: item === null || item === void 0 ? void 0 : (ref22 = item.productData) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.sku) === null || ref23 === void 0 ? void 0 : ref23.tags,
                                                statusData: item === null || item === void 0 ? void 0 : (ref24 = item.productData) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.sku) === null || ref25 === void 0 ? void 0 : ref25.status,
                                                expiredDate: expiredDate
                                            },
                                            isMobile: true,
                                            isSellerList: false,
                                            isPageDetail: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        className: (ComboList_styles_module_default()).priceCombo,
                                        children: [
                                            item.salePriceFormated || 0,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (ComboList_styles_module_default()).quantity,
                                                children: [
                                                    "x ",
                                                    item === null || item === void 0 ? void 0 : item.quantity,
                                                    " sản phẩm"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            index === comboList.length - 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ComboList_styles_module_default()).addContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ComboList_styles_module_default()).addIcon
                                })
                            })
                        ]
                    }, "".concat(item.sku + index));
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components-v2/mocules/SuggestProductBlock/index.tsx + 1 modules
var SuggestProductBlock = __webpack_require__(97563);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
;// CONCATENATED MODULE: ./src/components-v2/mocules/FlagshipLabel/index.js






function FlagshipLabel(param) {
    var isVip = param.isVip, isStore = param.isStore, productTags = param.productTags, _color = param.color, color = _color === void 0 ? "#B98F0F" : _color, _isHangDiem = param.isHangDiem, isHangDiem = _isHangDiem === void 0 ? false : _isHangDiem, _hangdiemConfig = param.hangdiemConfig, hangdiemConfig = _hangdiemConfig === void 0 ? {} : _hangdiemConfig;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = isVip && isStore;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,SellerService/* hasFlagshipStoreTag */.Po)(productTags)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        setShow.apply(void 0, [
                            _tmp
                        ]);
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    if (isHangDiem && hangdiemConfig) {
        var ref1, ref2;
        //TODO: only display internal config label for HangDiem store
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: hangdiemConfig === null || hangdiemConfig === void 0 ? void 0 : (ref1 = hangdiemConfig.label) === null || ref1 === void 0 ? void 0 : ref1.styles,
                    children: hangdiemConfig === null || hangdiemConfig === void 0 ? void 0 : (ref2 = hangdiemConfig.label) === null || ref2 === void 0 ? void 0 : ref2.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: " - "
                })
            ]
        });
    }
    return !!show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    color: color
                },
                children: Enums/* FLAGSHIP_LABEL */.Yo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " - "
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(46203);
// EXTERNAL MODULE: ./src/components-v2/mocules/BorderLinearProgress/index.js
var BorderLinearProgress = __webpack_require__(22731);
// EXTERNAL MODULE: ./src/utils/calculateTimeLeft.js
var calculateTimeLeft = __webpack_require__(66661);
// EXTERNAL MODULE: ./src/components-v2/mocules/CountdownNew/styles.module.css
var CountdownNew_styles_module = __webpack_require__(45823);
var CountdownNew_styles_module_default = /*#__PURE__*/__webpack_require__.n(CountdownNew_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CountdownNew/index.js




var CountdownNew = function(param) {
    var targetDate = param.targetDate, _hasMoreText = param.hasMoreText, hasMoreText = _hasMoreText === void 0 ? false : _hasMoreText;
    var ref = (0,react.useState)(0), timeRemaining = ref[0], setTimeRemaining = ref[1];
    var memoizedTimeRemaining = (0,react.useMemo)(function() {
        return (0,calculateTimeLeft/* default */.ZP)(targetDate);
    }, [
        timeRemaining
    ]);
    (0,react.useEffect)(function() {
        setTimeRemaining(function(data) {
            return data + 1;
        });
    }, []);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setTimeRemaining(function(data) {
                return data + 1;
            });
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        targetDate
    ]);
    if (!targetDate) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.seconds) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                (memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.days) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        hasMoreText ? "C\xf2n" : "",
                        " ",
                        memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.days,
                        " Ng\xe0y,",
                        " "
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "C\xf2n "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CountdownNew_styles_module_default()).minWidth,
                    children: memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.hours
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CountdownNew_styles_module_default()).minWidth,
                    children: memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.minutes
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CountdownNew_styles_module_default()).minWidth,
                    children: memoizedTimeRemaining === null || memoizedTimeRemaining === void 0 ? void 0 : memoizedTimeRemaining.seconds
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "Khuyến m\xe3i đ\xe3 kết th\xfac"
        })
    });
};
/* harmony default export */ var mocules_CountdownNew = (CountdownNew);

// EXTERNAL MODULE: ./src/components-v2/mocules/HotInfo/styles.module.css
var HotInfo_styles_module = __webpack_require__(32956);
var HotInfo_styles_module_default = /*#__PURE__*/__webpack_require__.n(HotInfo_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/HotInfo/index.js





var BG = "#E9E9E9";
var LINER = "#FBC9BE";
var HEIGHT_BAR = "8px !important";
var WIDTH_BAR = 140;
var HotInfo = function(param) {
    var _title = param.title, title = _title === void 0 ? "Flash sale" : _title, productType = param.productType, campaign = param.campaign, deal = param.deal;
    var ref, ref1, ref2;
    var curTime = new Date();
    var dealEndCampaign = productType === "MEGA_DAY" ? campaign === null || campaign === void 0 ? void 0 : (ref = campaign.campaign) === null || ref === void 0 ? void 0 : ref.endTime : (ref2 = campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.flashSaleTime) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
        return new Date(item.startTime) < curTime && new Date(item.endTime) > curTime;
    })) === null || ref2 === void 0 ? void 0 : ref2.endTime;
    var percentLine = Math.round((campaign === null || campaign === void 0 ? void 0 : campaign.totalSoldQuantity) / (campaign === null || campaign === void 0 ? void 0 : campaign.totalQuantity) * 100);
    var percentLineDeal = Math.round((deal === null || deal === void 0 ? void 0 : deal.totalCurrentQuantity) / (deal === null || deal === void 0 ? void 0 : deal.totalDealQuantity) * 100);
    var totalSold = (campaign === null || campaign === void 0 ? void 0 : campaign.totalSoldQuantity) || (deal === null || deal === void 0 ? void 0 : deal.quantity);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HotInfo_styles_module_default()).hotInfo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HotInfo_styles_module_default()).textContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (HotInfo_styles_module_default()).text,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HotInfo_styles_module_default()).rightInfo,
                children: [
                    percentLineDeal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (HotInfo_styles_module_default()).countBuy,
                        children: (0,helper/* conditionRender */.Yl)(percentLineDeal) ? (0,helper/* checkRule */.Tq)(percentLineDeal) : "Đ\xe3 b\xe1n ".concat(deal === null || deal === void 0 ? void 0 : deal.totalCurrentQuantity)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (HotInfo_styles_module_default()).countBuy,
                        children: (0,helper/* conditionRender */.Yl)(percentLine) ? (0,helper/* checkRule */.Tq)(percentLine) : "Đ\xe3 b\xe1n ".concat(totalSold)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLinearProgress/* default */.Z, {
                        variant: "determinate",
                        value: percentLine || percentLineDeal || 5,
                        width: WIDTH_BAR,
                        height: HEIGHT_BAR,
                        bgcolor: BG,
                        bgliner: LINER,
                        linerradius: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HotInfo_styles_module_default()).timeDiscount,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CountdownNew, {
                            targetDate: dealEndCampaign || (deal === null || deal === void 0 ? void 0 : deal.endTime),
                            hasMoreText: true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_HotInfo = (HotInfo);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./src/components-v2/mocules/IconButtonCustom/styles.module.css
var IconButtonCustom_styles_module = __webpack_require__(37657);
var IconButtonCustom_styles_module_default = /*#__PURE__*/__webpack_require__.n(IconButtonCustom_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/IconButtonCustom/index.js












var IconButtonCustom_LightTooltip = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "#A2A0A0"
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#A2A0A0",
        color: "#fff",
        fontSize: 12,
        top: "-2px"
    }), _obj;
});
var IconButtonCustom = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Ok" : _title, icon = _param.icon, tooltipTitle = _param.tooltipTitle, isDisabled = _param.isDisabled, isHightLight = _param.isHightLight, isMobile = _param.isMobile, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "icon",
        "tooltipTitle",
        "isDisabled",
        "isHightLight",
        "isMobile"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: (IconButtonCustom_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonCustom_LightTooltip, {
                title: tooltipTitle,
                arrow: true,
                placement: "top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        classes: {
                            root: (0,clsx/* default */.Z)((IconButtonCustom_styles_module_default()).root)
                        }
                    }, rest), {
                        disabled: isDisabled,
                        disableRipple: isDisabled,
                        className: (0,clsx/* default */.Z)(!isDisabled && ((IconButtonCustom_styles_module_default()) === null || (IconButtonCustom_styles_module_default()) === void 0 ? void 0 : (IconButtonCustom_styles_module_default())["default"]), isHightLight && (IconButtonCustom_styles_module_default()).hightLight, isMobile && (IconButtonCustom_styles_module_default()).mobile),
                        children: icon
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: (IconButtonCustom_styles_module_default()).typography,
                children: [
                    " ",
                    title
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_IconButtonCustom = (IconButtonCustom);

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(96517);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./src/components-v2/mocules/ModalTour/styles.module.css
var ModalTour_styles_module = __webpack_require__(51166);
var ModalTour_styles_module_default = /*#__PURE__*/__webpack_require__.n(ModalTour_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ModalTour/index.js












function ModalTour(param) {
    var open = param.open, handleCloseModal = param.handleCloseModal, handleConfirmModal = param.handleConfirmModal, _mobile = param.mobile, mobile = _mobile === void 0 ? false : _mobile, _defaultSteps = param.defaultSteps, defaultSteps = _defaultSteps === void 0 ? [] : _defaultSteps, stepsFinish = param.stepsFinish;
    var checkIsShow = function(key) {
        if (stepsFinish && (stepsFinish === null || stepsFinish === void 0 ? void 0 : stepsFinish.length) > 0) {
            var filterArr = defaultSteps === null || defaultSteps === void 0 ? void 0 : defaultSteps.filter(function(item) {
                return !stepsFinish.includes(item);
            });
            return (filterArr === null || filterArr === void 0 ? void 0 : filterArr.some(function(item) {
                return item === key;
            })) || false;
        }
        return defaultSteps.some(function(item) {
            return item === key;
        });
    };
    var handleClose = function() {
        handleCloseModal();
    };
    var handleConfirm = function() {
        handleConfirmModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            open: open,
            "aria-labelledby": "modal-modal-title",
            "aria-describedby": "modal-modal-description",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)(mobile ? (ModalTour_styles_module_default()).styleMobile : (ModalTour_styles_module_default()).styleDesktop),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModalTour_styles_module_default()).banner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                "aria-label": "close",
                                className: (ModalTour_styles_module_default()).closeButton,
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                src: mobile ? Images/* TOUR_BANNER_MOBILE */.fwc : Images/* TOUR_BANNER */.LI5,
                                alt: "Thuocsi Logo New",
                                objectFit: "contain",
                                width: mobile ? 150 : 700,
                                height: mobile ? 150 : 234,
                                layout: "fixed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModalTour_styles_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ModalTour_styles_module_default()).titleContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ModalTour_styles_module_default()).title,
                                        children: "Giao diện"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ModalTour_styles_module_default()).title,
                                        children: "Chi tiết sản phẩm mới"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ModalTour_styles_module_default()).groupContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (ModalTour_styles_module_default())["new"],
                                        children: "Mới:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            checkIsShow("productsSame") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "C\xe1c nh\xe0 b\xe1n h\xe0ng kh\xe1c cũng b\xe1n sản phẩm n\xe0y"
                                            }),
                                            checkIsShow("productsDeal") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Mua k\xe8m deal sốc"
                                            }),
                                            checkIsShow("addToCart") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "N\xfat mua h\xe0ng"
                                            }),
                                            checkIsShow("infoProduct") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Th\xf4ng tin sản phẩm"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModalTour_styles_module_default()).groupButton,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                className: (ModalTour_styles_module_default()).understand,
                                onClick: handleClose,
                                children: "T\xf4i đ\xe3 hiểu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                className: (ModalTour_styles_module_default())["try"],
                                onClick: handleConfirm,
                                children: "Trải nghiệm ngay"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./src/constants/Images/default.js
var Images_default = __webpack_require__(44776);
// EXTERNAL MODULE: ./src/utils/ImageUtils.tsx
var ImageUtils = __webpack_require__(81989);
// EXTERNAL MODULE: ./src/components-v2/mocules/OtherInfoSeller/styles.module.css
var OtherInfoSeller_styles_module = __webpack_require__(26273);
var OtherInfoSeller_styles_module_default = /*#__PURE__*/__webpack_require__.n(OtherInfoSeller_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/OtherInfoSeller/index.js





















var OtherInfoSeller = function(param) {
    var product = param.product, fullName = param.fullName, seller = param.seller, avatar = param.avatar, isStore = param.isStore, isInternal = param.isInternal, isDisplayStore = param.isDisplayStore, linkSeller = param.linkSeller, linkStore = param.linkStore, isVip = param.isVip;
    var ref, ref1;
    var code = seller.code, vendorSellerCode = seller.vendorSellerCode;
    var isShowBtnChat = isStore && !isInternal;
    var ref2 = (0,react.useState)({}), conversationSellerInfo = ref2[0], setConversationSellerInfo = ref2[1];
    var ref3 = (0,useConfigHangDiem/* useConfigHangDiem */.x)({
        vendorInfoSellerCode: vendorSellerCode
    }), _isHangDiem = ref3.isHangDiem, isHangDiem = _isHangDiem === void 0 ? false : _isHangDiem, configHangDiem = ref3.config;
    (0,react.useEffect)(function() {
        var checkValidSeller = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var resp, _tmp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,Clients/* POST */.a4)((_tmp.url = "/integration/chat/v1/proxy/seller/detail", _tmp.body = {
                                    code: code
                                }, _tmp))
                            ];
                        case 1:
                            resp = _state.sent();
                            if ((resp === null || resp === void 0 ? void 0 : resp.status) === "OK") {
                                setConversationSellerInfo((0,Clients/* getFirst */.Xi)(resp));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkValidSeller() {
                return _ref.apply(this, arguments);
            };
        }();
        checkValidSeller();
    }, []);
    var renderTitle = function() {
        if (isVip) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (OtherInfoSeller_styles_module_default()).typography,
                children: "Gian h\xe0ng h\xe3ng"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (OtherInfoSeller_styles_module_default()).storeTag,
            children: Enums/* THUOCSI_LABEL */.w8
        });
    };
    if ((product === null || product === void 0 ? void 0 : product.vendorInfo) && Object.keys(product.vendorInfo).length > 0) {
        var ref4, ref5, ref6, ref7, ref8;
        var primaryColor = product.vendorInfo.primaryColor;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).gridContainer, (product === null || product === void 0 ? void 0 : (ref4 = product.sellerInfo) === null || ref4 === void 0 ? void 0 : ref4.description) && (OtherInfoSeller_styles_module_default()).haveDescription),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: isHangDiem ? 4 : 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OtherInfoSeller_styles_module_default()).wrapperLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (0,ImageUtils/* getLinkProxyFile */.GD)(product.vendorInfo.logo[0]),
                                className: (OtherInfoSeller_styles_module_default()).avatar,
                                style: {
                                    border: "1px solid ".concat(primaryColor)
                                }
                            }),
                            (product.vendorInfo || isStore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: isHangDiem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).typography, "!left-1/2  -translate-x-1/2"),
                                    style: configHangDiem === null || configHangDiem === void 0 ? void 0 : (ref5 = configHangDiem.badge) === null || ref5 === void 0 ? void 0 : ref5.styles,
                                    children: configHangDiem === null || configHangDiem === void 0 ? void 0 : (ref6 = configHangDiem.badge) === null || ref6 === void 0 ? void 0 : ref6.text
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (OtherInfoSeller_styles_module_default()).typography,
                                    style: {
                                        backgroundColor: primaryColor
                                    },
                                    children: "Gian h\xe0ng h\xe3ng"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: isHangDiem ? 8 : 9,
                    className: (OtherInfoSeller_styles_module_default()).rightContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (OtherInfoSeller_styles_module_default()).nameSeller,
                            children: [
                                " ",
                                product.vendorInfo.name || ""
                            ]
                        }),
                        (product === null || product === void 0 ? void 0 : (ref7 = product.vendorInfo) === null || ref7 === void 0 ? void 0 : ref7.numberProducts) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (OtherInfoSeller_styles_module_default()).countProduct,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (OtherInfoSeller_styles_module_default()).nameSeller,
                                    children: product === null || product === void 0 ? void 0 : (ref8 = product.vendorInfo) === null || ref8 === void 0 ? void 0 : ref8.numberProducts
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (OtherInfoSeller_styles_module_default()).productTitle,
                                    children: "sản phẩm"
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (OtherInfoSeller_styles_module_default()).groupButton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).viewStore, (OtherInfoSeller_styles_module_default()).button),
                                    variant: "contained",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                        href: product.vendorInfo.url,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStoreImage */.cE, {
                                                src: Icons/* ICON_STORE */.avo,
                                                width: 14,
                                                height: 14,
                                                alt: fullName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).text, (OtherInfoSeller_styles_module_default()).gotoStore),
                                                children: "Xem Store"
                                            })
                                        ]
                                    })
                                }),
                                isShowBtnChat && (conversationSellerInfo === null || conversationSellerInfo === void 0 ? void 0 : conversationSellerInfo._allowUseBuymedChat) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).quickChat, (OtherInfoSeller_styles_module_default()).button),
                                    onClick: function() {
                                        if (window === null || window === void 0 ? void 0 : window.openBuyerChat) window === null || window === void 0 ? void 0 : window.openBuyerChat({
                                            sellerCode: code
                                        });
                                    },
                                    variant: "contained",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                            src: "".concat(Icons/* ICON_CHAT_NGAY */.PmG, "?size=origin"),
                                            width: 14,
                                            height: 14,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (OtherInfoSeller_styles_module_default()).text,
                                            children: "Chat ngay"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: code && fullName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).gridContainer, !isStore && (OtherInfoSeller_styles_module_default()).notGap, fullName === "MEDX" && (OtherInfoSeller_styles_module_default()).medX),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    className: (OtherInfoSeller_styles_module_default()).store,
                    children: fullName === "MEDX" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OtherInfoSeller_styles_module_default()).wrapperLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (OtherInfoSeller_styles_module_default()).sellerIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStoreImage */.cE, {
                                    src: Images_default/* LOGO_MEDX */.Ac,
                                    fallbackSrc: Images_default/* LOGO_MEDX */.Ac,
                                    width: 65,
                                    height: 65,
                                    q: 100,
                                    objectFit: "contain",
                                    alt: "logo thuocsi"
                                })
                            }),
                            (product.vendorInfo || isStore) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).typography),
                                children: "Gian h\xe0ng h\xe3ng"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).wrapperLeft),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).avatar),
                                alt: fullName,
                                src: (0,ImageUtils/* getLinkProxyFile */.GD)(avatar[0]) || Images/* STORE_IMAGE_DEFAULT */.XDS
                            }),
                            (product.vendorInfo || isStore) && renderTitle()
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 9,
                    className: (OtherInfoSeller_styles_module_default()).rightContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (OtherInfoSeller_styles_module_default()).nameSeller,
                            children: [
                                " ",
                                fullName || ""
                            ]
                        }),
                        (product === null || product === void 0 ? void 0 : (ref = product.sellerInfo) === null || ref === void 0 ? void 0 : ref.numberProducts) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (OtherInfoSeller_styles_module_default()).countProduct,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (OtherInfoSeller_styles_module_default()).nameSeller,
                                    children: product === null || product === void 0 ? void 0 : (ref1 = product.sellerInfo) === null || ref1 === void 0 ? void 0 : ref1.numberProducts
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (OtherInfoSeller_styles_module_default()).productTitle,
                                    children: "sản phẩm"
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (OtherInfoSeller_styles_module_default()).groupButton,
                            children: [
                                isStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).viewStore, (OtherInfoSeller_styles_module_default()).button),
                                    variant: "contained",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                        href: linkStore,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStoreImage */.cE, {
                                                src: Icons/* ICON_STORE */.avo,
                                                width: 14,
                                                height: 14,
                                                alt: fullName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).text, (OtherInfoSeller_styles_module_default()).gotoStore),
                                                children: "Xem Store"
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: isDisplayStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).viewStore, (OtherInfoSeller_styles_module_default()).button),
                                        variant: "contained",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                            href: linkSeller,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStoreImage */.cE, {
                                                    src: Icons/* ICON_STORE */.avo,
                                                    width: 14,
                                                    height: 14,
                                                    alt: fullName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).text, (OtherInfoSeller_styles_module_default()).gotoStore),
                                                    children: "Xem Store"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                isShowBtnChat && (conversationSellerInfo === null || conversationSellerInfo === void 0 ? void 0 : conversationSellerInfo._allowUseBuymedChat) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((OtherInfoSeller_styles_module_default()).quickChat, (OtherInfoSeller_styles_module_default()).button),
                                    onClick: function() {
                                        if (window === null || window === void 0 ? void 0 : window.openBuyerChat) window === null || window === void 0 ? void 0 : window.openBuyerChat({
                                            sellerCode: code
                                        });
                                    },
                                    variant: "contained",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                            src: "".concat(Icons/* ICON_CHAT_NGAY */.PmG, "?size=origin"),
                                            width: 14,
                                            height: 14,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (OtherInfoSeller_styles_module_default()).text,
                                            children: "Chat ngay"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (OtherInfoSeller_styles_module_default()).bottom1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h4",
                    children: "Đăng k\xfd b\xe1n h\xe0ng c\xf9ng thuocsi.vn."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: sysconfig/* DOMAIN_SELLER_CENTER */.Ri,
                    children: "Đăng k\xfd"
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_OtherInfoSeller = (OtherInfoSeller);

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 1 modules
var styles_styled = __webpack_require__(14745);
// EXTERNAL MODULE: ./src/components-v2/mocules/PriceAfterDiscount/styles.module.css
var PriceAfterDiscount_styles_module = __webpack_require__(91028);
var PriceAfterDiscount_styles_module_default = /*#__PURE__*/__webpack_require__.n(PriceAfterDiscount_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/PriceAfterDiscount/index.js











var DiscountIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6866_58618)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22.8965 12.5008L23.9494 9.75453C24.0649 9.45155 23.9749 9.10807 23.7214 8.90259L21.4386 7.05171L20.9766 4.14641C20.9256 3.82543 20.6736 3.57495 20.3527 3.52396L17.4474 3.06199L15.598 0.777643C15.394 0.52416 15.043 0.434166 14.7475 0.549658L11.9997 1.60409L9.25342 0.551158C8.94894 0.434166 8.60846 0.52716 8.40298 0.779143L6.5521 3.06349L3.6468 3.52545C3.32732 3.57645 3.07534 3.82843 3.02434 4.14791L2.56238 7.05322L0.278033 8.90409C0.0260501 9.10807 -0.0654437 9.45155 0.0500484 9.75453L1.10298 12.5008L0.0500484 15.2472C-0.0669436 15.5501 0.0260501 15.8936 0.278033 16.0976L2.56238 17.947L3.02434 20.8523C3.07534 21.1733 3.32582 21.4252 3.6468 21.4762L6.5521 21.9382L8.40298 24.221C8.60846 24.476 8.95194 24.566 9.25492 24.449L11.9997 23.3976L14.746 24.4505C14.833 24.4835 14.923 24.5 15.0145 24.5C15.235 24.5 15.4525 24.4025 15.598 24.221L17.4474 21.9382L20.3527 21.4762C20.6736 21.4252 20.9256 21.1733 20.9766 20.8523L21.4386 17.947L23.7214 16.0976C23.9749 15.8921 24.0649 15.5501 23.9494 15.2472L22.8965 12.5008Z",
                        fill: "#D4323B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.74985 11.0008C8.50943 11.0008 7.5 9.99136 7.5 8.75095C7.5 7.51053 8.50943 6.5011 9.74985 6.5011C10.9903 6.5011 11.9997 7.51053 11.9997 8.75095C11.9997 9.99136 10.9903 11.0008 9.74985 11.0008ZM9.74985 8.001C9.33587 8.001 8.9999 8.33697 8.9999 8.75095C8.9999 9.16492 9.33587 9.50089 9.74985 9.50089C10.1638 9.50089 10.4998 9.16492 10.4998 8.75095C10.4998 8.33697 10.1638 8.001 9.74985 8.001Z",
                        fill: "#FAFAFA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.2498 18.5004C13.0094 18.5004 12 17.491 12 16.2506C12 15.0102 13.0094 14.0007 14.2498 14.0007C15.4903 14.0007 16.4997 15.0102 16.4997 16.2506C16.4997 17.491 15.4903 18.5004 14.2498 18.5004ZM14.2498 15.5006C13.8374 15.5006 13.4999 15.8381 13.4999 16.2506C13.4999 16.6631 13.8374 17.0005 14.2498 17.0005C14.6623 17.0005 14.9998 16.6631 14.9998 16.2506C14.9998 15.8381 14.6623 15.5006 14.2498 15.5006Z",
                        fill: "#FAFAFA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.24928 18.5004C8.09779 18.5004 7.9463 18.4554 7.81431 18.3609C7.47683 18.1194 7.39884 17.6514 7.64032 17.314L15.1398 6.81468C15.3813 6.4772 15.8493 6.3992 16.1867 6.64069C16.5242 6.88067 16.6007 7.35014 16.3607 7.68612L8.86124 18.1854C8.71275 18.3909 8.48326 18.5004 8.24928 18.5004Z",
                        fill: "#FAFAFA"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_6866_58618",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var InfoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5ZM13.1429 7.92857C13.1429 8.55975 12.6312 9.07143 12 9.07143C11.3688 9.07143 10.8571 8.55975 10.8571 7.92857C10.8571 7.29739 11.3688 6.78571 12 6.78571C12.6312 6.78571 13.1429 7.29739 13.1429 7.92857ZM12 11.0714C12.4734 11.0714 12.8571 11.4552 12.8571 11.9286V17.6429C12.8571 18.1162 12.4734 18.5 12 18.5C11.5266 18.5 11.1429 18.1162 11.1429 17.6429V11.9286C11.1429 11.4552 11.5266 11.0714 12 11.0714Z",
            fill: "#0E1983"
        })
    });
};
var CustomTooltip = (0,styles_styled/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "#EBEFFA",
        filter: "drop-shadow(0px 1px 1px rgba(25, 43, 79, 0.20))"
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#EBEFFA",
        color: "#353FA5",
        fontSize: 14,
        top: "4px",
        padding: "12px",
        maxWidth: "380px",
        boxShadow: "0px 2px 10px 0px rgba(25, 43, 79, 0.20)"
    }), _obj;
});
var PriceAfterDiscount = function(param) {
    var retailPriceApplyVoucher = param.retailPriceApplyVoucher, _isCart = param.isCart, isCart = _isCart === void 0 ? false : _isCart;
    if (isCart) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTooltip, {
            arrow: true,
            placement: "top",
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "Đ\xe2y l\xe0 gi\xe1 đ\xe3 giảm sau khi \xe1p dụng c\xe1c chương tr\xecnh khuyến m\xe3i như ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).boldColor,
                        children: " Chiết khấu chuyển khoản"
                    }),
                    " v\xe0",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).boldColor,
                        children: "M\xe3 giảm gi\xe1"
                    })
                ]
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).cartPriceContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).cartPriceDiscount,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).cartLabelDiscountPrice,
                            children: "Gi\xe1 sau chiết khấu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                            displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(retailPriceApplyVoucher),
                            fillPath: "#D4323B",
                            size: "mdx"
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).priceContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).priceDiscount,
                children: [
                    "Gi\xe1 sau chiết khấu",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                        displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(retailPriceApplyVoucher),
                        fillPath: "#D4323B",
                        size: "mdn"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTooltip, {
                arrow: true,
                placement: "top",
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Bạn c\xf3 thể mua được gi\xe1 n\xe0y khi thanh to\xe1n bằng h\xecnh thức ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).boldColor,
                            children: "Chuyển khoản"
                        }),
                        " v\xe0 sử dụng",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).boldColor,
                            children: "M\xe3 giảm gi\xe1"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PriceAfterDiscount_styles_module_default()) === null || (PriceAfterDiscount_styles_module_default()) === void 0 ? void 0 : (PriceAfterDiscount_styles_module_default()).wrapperIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {})
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_PriceAfterDiscount = (PriceAfterDiscount);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(43861);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
;// CONCATENATED MODULE: ./src/hooks/useMultiImageBox.js

var useMultiImageBox = function(param) {
    var _images = param.images, images = _images === void 0 ? [] : _images;
    var ref = (0,react.useState)(0), selectedImage = ref[0], setSelectedImage = ref[1];
    var handleDecrement = (0,react.useCallback)(function() {
        if (selectedImage === 0) {
            setSelectedImage(images.length - 1);
            return;
        }
        setSelectedImage(function(current) {
            return current - 1;
        });
    }, [
        selectedImage,
        images
    ]);
    var handleIncrement = (0,react.useCallback)(function() {
        if (selectedImage === images.length - 1) {
            setSelectedImage(0);
            return;
        }
        setSelectedImage(function(current) {
            return current + 1;
        });
    }, [
        selectedImage,
        images
    ]);
    var handlePrevious = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        handleDecrement();
    }, [
        handleDecrement
    ]);
    var handleKeyDown = (0,react.useCallback)(function(e) {
        if (e.key === "ArrowRight") {
            handleDecrement();
            return;
        }
        if (e.key === "ArrowLeft") {
            handleIncrement();
        }
    }, [
        handleIncrement,
        handleDecrement
    ]);
    var handleNext = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        handleIncrement();
    }, [
        handleIncrement
    ]);
    var handleImageSelection = function(index) {
        setSelectedImage(index);
    };
    var handleHoverImage = function(index) {
        handleImageSelection(index);
    };
    return {
        selectedImage: selectedImage,
        handlePrevious: handlePrevious,
        handleNext: handleNext,
        handleKeyDown: handleKeyDown,
        handleImageSelection: handleImageSelection,
        handleHoverImage: handleHoverImage
    };
};
/* harmony default export */ var hooks_useMultiImageBox = (useMultiImageBox);

;// CONCATENATED MODULE: ./src/hooks/useToggle.js

var useToggle = function() {
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var handleOpen = (0,react.useCallback)(function() {
        setOpen(true);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setOpen(false);
    }, []);
    var handleToggle = (0,react.useCallback)(function() {
        setOpen(function(current) {
            return !current;
        });
    }, []);
    return {
        open: open,
        handleOpen: handleOpen,
        handleClose: handleClose,
        handleToggle: handleToggle
    };
};
/* harmony default export */ var hooks_useToggle = (useToggle);

// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/components-v2/mocules/PopupMultilImage/index.tsx
var PopupMultilImage = __webpack_require__(53371);
// EXTERNAL MODULE: ./src/components-v2/mocules/ListPromoGift/styles.module.css
var ListPromoGift_styles_module = __webpack_require__(83587);
var ListPromoGift_styles_module_default = /*#__PURE__*/__webpack_require__.n(ListPromoGift_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ListPromoGift/index.js











function ListPromoGift(param) {
    var srcImagesProxy = param.srcImagesProxy, width = param.width, height = param.height, imageName = param.imageName, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _name = param.name, name = _name === void 0 ? "" : _name, lengthList = param.lengthList;
    var ref = hooks_useToggle(), open = ref.open, handleClose = ref.handleClose, handleOpen = ref.handleOpen;
    var ref1 = hooks_useMultiImageBox({
        images: srcImagesProxy
    }), selectedImage = ref1.selectedImage, handleImageSelection = ref1.handleImageSelection, handlePrevious = ref1.handlePrevious, handleNext = ref1.handleNext;
    var handleOpenPopup = function() {
        handleOpen();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        className: (0,clsx/* default */.Z)((ListPromoGift_styles_module_default()).wrapPromoImg, isMobile && (ListPromoGift_styles_module_default()).wrapPromoImgMobile, lengthList > 3 && (ListPromoGift_styles_module_default()).wrapPromoResize),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: name,
                arrow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    onClick: handleOpenPopup,
                    role: "presentation",
                    style: {
                        cursor: "pointer"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                        src: !(0,ValidateUtils/* isEmpty */.xb)(srcImagesProxy) && "".concat(srcImagesProxy[0]),
                        width: width,
                        height: height,
                        objectFit: "contain"
                    })
                })
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultilImage["default"], {
                isMobile: isMobile,
                handleNext: handleNext,
                handlePrevious: handlePrevious,
                handleClickImage: handleImageSelection,
                selectedImage: selectedImage,
                open: open,
                handleClose: handleClose,
                images: srcImagesProxy,
                imageName: imageName
            })
        ]
    });
}
/* harmony default export */ var mocules_ListPromoGift = (/*#__PURE__*/(0,react.memo)(ListPromoGift));

// EXTERNAL MODULE: ./src/components-v2/mocules/PromotionProduct/styles.module.css
var PromotionProduct_styles_module = __webpack_require__(28947);
var PromotionProduct_styles_module_default = /*#__PURE__*/__webpack_require__.n(PromotionProduct_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/PromotionProduct/PromotionPC.js

















function PromotionPC(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, _listsPromo = param.listsPromo, listsPromo = _listsPromo === void 0 ? [] : _listsPromo, handleOpen = param.handleOpen, _listPromoProduct = param.listPromoProduct, listPromoProduct = _listPromoProduct === void 0 ? [] : _listPromoProduct;
    var ref = (0,react.useState)(null), setSwiperRef = ref[1];
    return (listsPromo === null || listsPromo === void 0 ? void 0 : listsPromo.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (PromotionProduct_styles_module_default()).gift,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* VOUCHER_TITLE_TS_DETAIL */.I2, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (PromotionProduct_styles_module_default()).titleGift,
                        children: "Qu\xe0 Tặng"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: (PromotionProduct_styles_module_default()).titleDetail,
                        onClick: handleOpen,
                        children: [
                            "Xem chi tiết ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {
                                style: {
                                    color: "#0E1983",
                                    fontSize: "18px",
                                    fontWeight: "bold"
                                }
                            })
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 300,
                height: 64
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                direction: "row",
                className: (0,clsx/* default */.Z)((PromotionProduct_styles_module_default()).wrapPromoList, (listPromoProduct === null || listPromoProduct === void 0 ? void 0 : listPromoProduct.length) > 3 && (PromotionProduct_styles_module_default()).listSwipperPromo),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        onSwiper: setSwiperRef,
                        slidesPerView: 3,
                        navigation: true,
                        modules: [
                            swiper_esm/* Pagination */.tl,
                            swiper_esm/* Navigation */.W_,
                            swiper_esm/* Virtual */.oM
                        ],
                        children: listPromoProduct === null || listPromoProduct === void 0 ? void 0 : listPromoProduct.map(function(item) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_ListPromoGift, {
                                        slugProduct: item === null || item === void 0 ? void 0 : (ref = item.productData) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.slug,
                                        link: "/product/".concat((item === null || item === void 0 ? void 0 : item.slug) || ""),
                                        srcImagesProxy: (0,ImageUtils/* getLinkCDNImageList */.rD)(item === null || item === void 0 ? void 0 : (ref2 = item.productData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.imageUrls) || ((ref4 = item.productData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.product) === null || ref5 === void 0 ? void 0 : ref5.imageUrls),
                                        width: 48,
                                        height: 48,
                                        imageName: item === null || item === void 0 ? void 0 : (ref6 = item.productData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.product) === null || ref7 === void 0 ? void 0 : ref7.name,
                                        lengthList: listPromoProduct.length,
                                        name: item === null || item === void 0 ? void 0 : (ref8 = item.productData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.product) === null || ref9 === void 0 ? void 0 : ref9.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        slot: "wrapper-end",
                                        className: (0,clsx/* default */.Z)((PromotionProduct_styles_module_default()).plus, (listPromoProduct === null || listPromoProduct === void 0 ? void 0 : listPromoProduct.length) <= 3 && (PromotionProduct_styles_module_default()).listResize),
                                        children: "+"
                                    })
                                ]
                            }, item === null || item === void 0 ? void 0 : (ref10 = item.productData) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.product) === null || ref11 === void 0 ? void 0 : ref11.slug);
                        })
                    })
                })
            })
        ]
    }) : "";
}
/* harmony default export */ var PromotionProduct_PromotionPC = (PromotionPC);

// EXTERNAL MODULE: ./src/components-v2/mocules/TypePromo/styles.module.css
var TypePromo_styles_module = __webpack_require__(32572);
var TypePromo_styles_module_default = /*#__PURE__*/__webpack_require__.n(TypePromo_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/TypePromo/index.js


var SpecialChar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            "Thu",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TypePromo_styles_module_default()).specialChar
            }),
            "c Tốt - Gi\xe1 Sỉ"
        ]
    });
};
var ThunderTitle = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (TypePromo_styles_module_default()).thunderBolt,
        children: [
            "F",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TypePromo_styles_module_default()).shape
            }),
            "ash Sale"
        ]
    });
};
var MegaDay = function(param) {
    var monthYear = param.monthYear;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TypePromo_styles_module_default()).bold,
                children: "Mega"
            }),
            " day ",
            monthYear
        ]
    });
};
var DEAL = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (TypePromo_styles_module_default()).bold,
            children: "Ưu đ\xe3i mới"
        })
    });
};
/* harmony default export */ var TypePromo = ({
    SpecialChar: SpecialChar,
    ThunderTitle: ThunderTitle,
    MegaDay: MegaDay,
    DEAL: DEAL
});

;// CONCATENATED MODULE: ./src/components-v2/mocules/PromoType/index.js


var PromoType = function(param) {
    var productType = param.productType;
    if (!productType) return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypePromo.DEAL, {});
    var campaignName = productType.campaignName, campaignType = productType.campaignType, shortName = productType.shortName;
    var displayName = campaignName === null || campaignName === void 0 ? void 0 : campaignName.toLowerCase().includes("thuốc tốt - gi\xe1 sỉ");
    switch(campaignType){
        case "FLASH_SALE":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypePromo.ThunderTitle, {});
        case "NORMAL":
            if (displayName) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypePromo.SpecialChar, {});
            }
            return shortName || campaignName;
        default:
            return displayName || null;
    }
};
/* harmony default export */ var mocules_PromoType = (PromoType);

;// CONCATENATED MODULE: ./src/components-v2/mocules/TagGiftComp/index.js


var TagGiftComp = function(param) {
    var _color = param.color, color = _color === void 0 ? "#D55D2A" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    color: color
                },
                children: Enums/* LABEL_GIFT_TAG_PROMOTION */.xs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " - "
            })
        ]
    });
};
/* harmony default export */ var mocules_TagGiftComp = (TagGiftComp);

// EXTERNAL MODULE: ./src/components-v2/mocules/TourIntro/index.js + 1 modules
var TourIntro = __webpack_require__(95863);
// EXTERNAL MODULE: ./src/clients/MonitorClient.js
var MonitorClient = __webpack_require__(70599);
// EXTERNAL MODULE: ./src/clients/WishlistClient.js
var WishlistClient = __webpack_require__(56639);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Favorite.js
var Favorite = __webpack_require__(76324);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(28106);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/HelpOutline.js
var HelpOutline = __webpack_require__(82369);
// EXTERNAL MODULE: ./src/utils/video.ts
var video = __webpack_require__(44548);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
;// CONCATENATED MODULE: ./src/zustand-lib/useProductDetailPrices.ts




var INITIAL_STATE = {
    targetVoucherCode: "",
    isOpenDialog: false,
    isOpenTooltip: false,
    isFirstTimeAccessPDP: true
};
var useDetailPriceStates = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, INITIAL_STATE), {
        actions: {
            setTargetVoucher: function(payload) {
                set({
                    targetVoucherCode: payload
                });
            },
            clearTargetVoucher: function() {
                set({
                    targetVoucherCode: ""
                });
            },
            toggleDialog: function(payload) {
                set({
                    isOpenDialog: payload
                });
            },
            toggleTooltip: function(payload) {
                set({
                    isOpenTooltip: payload
                });
            },
            updateFirstTimeAccessPDP: function() {
                set({
                    isFirstTimeAccessPDP: false
                });
            }
        }
    });
}));
var useDetailPriceActions = function() {
    return useDetailPriceStates(function(state) {
        return state.actions;
    });
};
/* harmony default export */ var useProductDetailPrices = (useDetailPriceStates);

// EXTERNAL MODULE: ./src/components-v2/mocules/SimpleVideoPlayer/index.tsx
var SimpleVideoPlayer = __webpack_require__(61133);
// EXTERNAL MODULE: ./src/components-v2/mocules/CardImage/styles.module.css
var CardImage_styles_module = __webpack_require__(63179);
var CardImage_styles_module_default = /*#__PURE__*/__webpack_require__.n(CardImage_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CardImage/index.js




















var TITLE_REMOVE_WISHLIST = "Bỏ đ\xe1nh dấu sản phẩm";
var TITLE_ADD_WISHLIST = "Đ\xe1nh dấu sản phẩm quan t\xe2m";
var CardImage_LightTooltip = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "#A2A0A0"
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#A2A0A0",
        color: "#fff",
        fontSize: 12,
        top: "-2px"
    }), _obj;
});
var CardImage = function(param) {
    var img = param.img, onClickQuestion = param.onClickQuestion, onClickWhistList = param.onClickWhistList, isWish = param.isWish, onClickImage = param.onClickImage, _hiddenIconAndText = param.hiddenIconAndText, hiddenIconAndText = _hiddenIconAndText === void 0 ? false : _hiddenIconAndText, isNotAuth = param.isNotAuth, _hasModal = param.hasModal, hasModal = _hasModal === void 0 ? false : _hasModal, _alt = param.alt, alt = _alt === void 0 ? "" : _alt;
    var ref = useProductDetailPrices(), _isFirstTimeAccessPDP = ref.isFirstTimeAccessPDP, isFirstTimeAccessPDP = _isFirstTimeAccessPDP === void 0 ? false : _isFirstTimeAccessPDP;
    var isVideoUrl = (0,react.useMemo)(function() {
        var ref;
        return (ref = (0,video/* checkVideoUrl */.P)(img)) !== null && ref !== void 0 ? ref : false;
    }, [
        img
    ]);
    var handleClickQuestion = function(e) {
        onClickQuestion(e);
    };
    var handleClickWhistList = function(e) {
        onClickWhistList(e);
    };
    var handleOpenModal = function() {
        if (hiddenIconAndText && isNotAuth) return null;
        return onClickImage();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)((CardImage_styles_module_default()).container, hasModal && (CardImage_styles_module_default()).containerModal),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((CardImage_styles_module_default()).image, isVideoUrl ? "flex items-center" : ""),
            children: [
                hiddenIconAndText ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CardImage_styles_module_default()).tooltipLeft,
                            onClick: handleClickQuestion,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage_LightTooltip, {
                                title: "Thắc mắc về sản phẩm ",
                                arrow: true,
                                placement: "top",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CardImage_styles_module_default()) === null || (CardImage_styles_module_default()) === void 0 ? void 0 : (CardImage_styles_module_default()).customButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpOutline/* default */.Z, {
                                        className: (CardImage_styles_module_default()).icon,
                                        style: {
                                            fontSize: 24,
                                            color: "#00000033"
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CardImage_styles_module_default()).tooltipRight,
                            onClick: handleClickWhistList,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage_LightTooltip, {
                                title: isWish ? TITLE_REMOVE_WISHLIST : TITLE_ADD_WISHLIST,
                                arrow: true,
                                placement: "top",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CardImage_styles_module_default()) === null || (CardImage_styles_module_default()) === void 0 ? void 0 : (CardImage_styles_module_default()).customButton,
                                    children: isWish ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                                        style: {
                                            fontSize: 24,
                                            color: "var(--primary-color)"
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {
                                        className: (CardImage_styles_module_default()).icon,
                                        style: {
                                            fontSize: 24,
                                            color: "#00000033"
                                        }
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                    onClick: handleOpenModal,
                    className: "openImg",
                    children: isVideoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleVideoPlayer/* default */.Z, {
                        src: (0,ImageUtils/* getLinkCDNVideo */.qf)(img),
                        width: 360,
                        height: 360,
                        isCenterPlayButton: false,
                        isAutoPlay: isFirstTimeAccessPDP
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                        width: 360,
                        height: 360,
                        src: img,
                        quality: 100,
                        objectFit: "contain",
                        alt: alt
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_CardImage = (CardImage);

// EXTERNAL MODULE: ./src/components-v2/mocules/Cart/CartItem/ComboSuggestion.jsx
var ComboSuggestion = __webpack_require__(44766);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./src/components-v2/mocules/ImageSlider/styles.module.css
var ImageSlider_styles_module = __webpack_require__(85142);
var ImageSlider_styles_module_default = /*#__PURE__*/__webpack_require__.n(ImageSlider_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ImageSlider/index.js














var ImageSlider = function(param) {
    var images = param.images, imageActive = param.imageActive, setImageActive = param.setImageActive, onClickImage = param.onClickImage, isOpenModal = param.isOpenModal, className = param.className, _alt = param.alt, alt = _alt === void 0 ? "" : _alt;
    var updateFirstTimeAccessPDP = useDetailPriceActions().updateFirstTimeAccessPDP;
    var ref = useProductDetailPrices(), _isFirstTimeAccessPDP = ref.isFirstTimeAccessPDP, isFirstTimeAccessPDP = _isFirstTimeAccessPDP === void 0 ? false : _isFirstTimeAccessPDP;
    var refInstance = (0,react.useRef)(null);
    var handleActiveImage = function(index) {
        setImageActive(index);
        if (isFirstTimeAccessPDP) updateFirstTimeAccessPDP();
    };
    var handleOpenModal = function(index) {
        onClickImage(index);
        if (isFirstTimeAccessPDP) updateFirstTimeAccessPDP();
    };
    var ImageItem = function(param) {
        var url = param.url, index = param.index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)((ImageSlider_styles_module_default()).imageItem, index === imageActive && (ImageSlider_styles_module_default()).active),
            onClick: function() {
                return handleOpenModal(index);
            },
            onMouseEnter: function() {
                return handleActiveImage(index);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                size: "thumbnail",
                width: 60,
                height: 60,
                src: url,
                alt: alt
            })
        });
    };
    var VideoItem = function(param) {
        var url = param.url, index = param.index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)((ImageSlider_styles_module_default()).imageItem, index === imageActive && (ImageSlider_styles_module_default()).active),
            onClick: function() {
                return handleOpenModal(index);
            },
            onMouseEnter: function() {
                return handleActiveImage(index);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                src: (0,ImageUtils/* getLinkCDNVideo */.qf)(url),
                width: "50px",
                height: "50px",
                objectfit: "contain",
                className: "h-[50px]"
            })
        });
    };
    var settings = {
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    // useEffect(() => {
    //   if (isOpenModal && images.length > 2) {
    //     if (imageActive === 0) {
    //       refInstance?.slickGoTo(0);
    //     } else if (imageActive > 2) {
    //       refInstance?.slickGoTo(imageActive - 2);
    //     }
    //   }
    // }, [isOpenModal, imageActive]);
    var next = function() {
        return refInstance.slickNext();
    };
    var previous = function() {
        return refInstance.slickPrev();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)((ImageSlider_styles_module_default()).sliderContainer, images.length <= 3 && (ImageSlider_styles_module_default()).lessThenThree, className),
        children: images.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ImageSlider_styles_module_default()).wrapperSlider,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageSlider_styles_module_default()).wrapperRight,
                    onClick: next,
                    role: "button",
                    "aria-label": "next image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "".concat((ImageSlider_styles_module_default()).arrow, " ").concat((ImageSlider_styles_module_default()).right)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    // eslint-disable-next-line no-return-assign
                    ref: function(c) {
                        return refInstance = c;
                    }
                }, settings), {
                    className: (ImageSlider_styles_module_default()).slider,
                    children: images.map(function(url, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                            onClick: function() {
                                return handleOpenModal(index);
                            },
                            className: "openImg",
                            children: (0,video/* checkVideoUrl */.P)(url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoItem, {
                                url: url,
                                index: index
                            }, url) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageItem, {
                                url: url,
                                index: index
                            }, url)
                        }, url);
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImageSlider_styles_module_default()).wrapperLeft,
                    onClick: previous,
                    role: "button",
                    "aria-label": "prev image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "".concat((ImageSlider_styles_module_default()).arrow, " ").concat((ImageSlider_styles_module_default()).left),
                        onClick: previous
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: images.map(function(url, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: (0,video/* checkVideoUrl */.P)(url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoItem, {
                        url: url,
                        index: index
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageItem, {
                        url: url,
                        index: index
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var mocules_ImageSlider = (/*#__PURE__*/(0,react.memo)(ImageSlider));

// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./src/components-v2/ui/ConsultSpecialProductBtn/index.js + 4 modules
var ConsultSpecialProductBtn = __webpack_require__(40420);
// EXTERNAL MODULE: ./src/context/Cart/CartContext.js + 2 modules
var CartContext = __webpack_require__(15012);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
;// CONCATENATED MODULE: ./src/zustand-lib/useCartQuantity.js




var useCartQuantity_INITIAL_STATE = {
    score: 0,
    count: 0
};
var useCartQuantity = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useCartQuantity_INITIAL_STATE), {
        setScore: function(payload) {
            set((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get()), {
                score: payload
            }));
        },
        setCount: function(payload) {
            set((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get()), {
                count: payload
            }));
        }
    });
}, {
    name: "cart_quantity"
}));
/* harmony default export */ var zustand_lib_useCartQuantity = (useCartQuantity);

;// CONCATENATED MODULE: ./src/hooks/useCartControl.js







var UPDATE = "update";
var REMOVE = "remove";
var REGEX_NUMBER = new RegExp("^[0-9]+$");
var useCartControl = function(product) {
    var sku = product.sku, consumedMaxQuantity = product.consumedMaxQuantity;
    var ref = (0,react.useState)(), currentValue = ref[0], setCurrentValue = ref[1];
    var ref1 = zustand_lib_useCartQuantity(function(state) {
        return state;
    }), setCount = ref1.setCount, count = ref1.count;
    var ref2 = (0,CartContext/* useCart */.jD)(), _cartItems = ref2.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems, removeCartItem = ref2.removeCartItem, updateCartItem = ref2.updateCartItem;
    var updateCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(q) {
            var isReload, response, _tmp;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        _tmp = {};
                        return [
                            4,
                            updateCartItem((_tmp.product = product, _tmp.q = parseFloat(q), _tmp), isReload)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(response)) {
                            setCount(product.quantity);
                            setCurrentValue(product.quantity);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateCart(q) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCart = function(val, updateType) {
        switch(updateType){
            case UPDATE:
                updateCart(val);
                break;
            case REMOVE:
                removeCartItem(product, true);
                break;
            default:
                break;
        }
    };
    var handler = (0,react.useCallback)((0,debounce/* default */.ZP)(function(val, updateType) {
        return handleCart(val, updateType);
    }, 300), [
        product
    ]);
    var handleDecrease = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newValue;
            return (0,tslib_es6.__generator)(this, function(_state) {
                newValue = count - 1;
                if (newValue < 0) {
                    return [
                        2,
                        null
                    ];
                }
                if (newValue === 0) {
                    handler(0, REMOVE);
                    return [
                        2,
                        setCount(0)
                    ];
                }
                handler(newValue, UPDATE);
                return [
                    2,
                    setCount(newValue)
                ];
            });
        });
        return function handleDecrease() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleIncrease = function() {
        var newValue = count + 1;
        if (newValue > (consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed)) {
            handler(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed, UPDATE);
            setCount(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed);
        } else {
            handler(newValue, UPDATE);
            setCount(newValue);
        }
    };
    var handleBlurInput = function() {
        if (count === currentValue) {
            return null;
        }
        if (count > 0) {
            return handler(count, UPDATE);
        }
        setCurrentValue(0);
        return handler(0, REMOVE);
    };
    var handleChangeInput = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var value, convertValue;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = e.target.value;
                        if (!(value && REGEX_NUMBER.test(value))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Number(value.replace(/^0+/, ""))
                        ];
                    case 1:
                        convertValue = _state.sent();
                        if (convertValue < 0) setCount(0);
                        else if (convertValue < (consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed)) {
                            setCount(convertValue);
                        } else {
                            setCount(consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setCount(0);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeInput(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadScore = function(cartItemQuantity) {
        var productQuantity = product.quantity || 0;
        if (cartItemQuantity !== undefined && cartItemQuantity !== productQuantity) {
            setCurrentValue(cartItemQuantity);
            return cartItemQuantity;
        }
        setCurrentValue(productQuantity);
        return productQuantity;
    };
    (0,react.useEffect)(function() {
        var ref;
        var cartItemQuantity = (ref = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(item) {
            return item.sku === sku;
        })) === null || ref === void 0 ? void 0 : ref.quantity;
        var value = loadScore(cartItemQuantity);
        setCount(value);
    }, [
        sku
    ]);
    return [
        handleIncrease,
        handleBlurInput,
        handleChangeInput,
        handleDecrease,
        currentValue
    ];
};
/* harmony default export */ var hooks_useCartControl = (useCartControl);

// EXTERNAL MODULE: ./src/hooks/useProductConsultation.js
var useProductConsultation = __webpack_require__(48699);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControl/styles.module.css
var QuantityControl_styles_module = __webpack_require__(72503);
var QuantityControl_styles_module_default = /*#__PURE__*/__webpack_require__.n(QuantityControl_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/QuantityControl/index.js










function QuantityControl(param) {
    var product = param.product, _className = param.className, className = _className === void 0 ? "" : _className, onMinus = param.onMinus, onChange = param.onChange, onAdd = param.onAdd;
    var ref;
    var displayPrice = product.displayPrice, pointMultiplier = product.pointMultiplier, point = product.point, isPointDisabled = product.isPointDisabled;
    var ref1 = zustand_lib_useCartQuantity(function(state) {
        return state;
    }), setScore = ref1.setScore, count = ref1.count;
    var ref2 = (0,react.useState)(0), valueCount = ref2[0], setValueCount = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(hooks_useCartControl(product), 4), handleIncrease = ref3[0], handleBlurInput = ref3[1], handleChangeInput = ref3[2], handleDecrease = ref3[3];
    var shouldShowConsultButton = (0,useProductConsultation/* useProductConsultation */.O)().shouldShowConsultButton;
    var calculatedScore = function(number) {
        // sku bi tat tich diem: khong ap dung ca quy tac mac dinh theo gia.
        // Tra ve '0' vi day la gia tri cac man dung de an han diem (score !== '0'),
        // tra ve '' hay 0 se lam UI hien " diem" / "0 diem".
        if (isPointDisabled) {
            return "0";
        }
        if (point) {
            return number * point * (pointMultiplier || 1);
        }
        if (pointMultiplier) {
            var price = number * displayPrice * pointMultiplier / 100000;
            return price > 0 ? price.toFixed(2).toString().replace(".", ",") : "0";
        }
        var price1 = number * displayPrice / 100000;
        return price1 > 0 ? price1.toFixed(2).toString().replace(".", ",") : "0";
    };
    (0,react.useEffect)(function() {
        var score = calculatedScore(count);
        setValueCount(count);
        setScore(score);
    }, [
        count
    ]);
    if (shouldShowConsultButton(product)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultSpecialProductBtn/* default */.Z, {
            className: "qty-control-consult-btn",
            product: product,
            variant: ConsultSpecialProductBtn/* VARIANT_LIST.DETAIL */.C.DETAIL
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)((QuantityControl_styles_module_default()).container, className, "qty-control-wrapper"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function(e) {
                    handleDecrease(e);
                    onMinus === null || onMinus === void 0 ? void 0 : onMinus(e);
                },
                className: (0,clsx/* default */.Z)((QuantityControl_styles_module_default()).minusContainer, "qty-control-minus"),
                role: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (QuantityControl_styles_module_default()).minus
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                className: "qty-control-input",
                name: "inputNumber",
                value: valueCount,
                onBlur: handleBlurInput,
                onChange: function(e) {
                    handleChangeInput(e);
                    onChange === null || onChange === void 0 ? void 0 : onChange(e);
                },
                type: "number",
                disableUnderline: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function(e) {
                    handleIncrease(e);
                    onAdd === null || onAdd === void 0 ? void 0 : onAdd(e);
                },
                className: (0,clsx/* default */.Z)((QuantityControl_styles_module_default()).addContainer, count >= (product === null || product === void 0 ? void 0 : (ref = product.consumedMaxQuantity) === null || ref === void 0 ? void 0 : ref.maxQuantityConsumed) && (QuantityControl_styles_module_default()).disabled, "qty-control-plus"),
                role: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (QuantityControl_styles_module_default()).addIcon
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/Enums/http.js
var http = __webpack_require__(53208);
// EXTERNAL MODULE: ./src/hooks/useTrackingMonitorSubstituteProduct.ts
var useTrackingMonitorSubstituteProduct = __webpack_require__(9358);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/WebService.js + 1 modules
var WebService = __webpack_require__(98682);
// EXTERNAL MODULE: ./src/services/convertNewAPIProduct.js
var convertNewAPIProduct = __webpack_require__(20402);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js
var MonitorUtils = __webpack_require__(31459);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/detail-product-new/LeftContent/styles.module.css
var LeftContent_styles_module = __webpack_require__(58471);
var LeftContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(LeftContent_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/LeftContent/index.js































var PopupCreateTicket = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6116), __webpack_require__.e(2512), __webpack_require__.e(3443), __webpack_require__.e(129), __webpack_require__.e(8655), __webpack_require__.e(8674), __webpack_require__.e(5017)]).then(__webpack_require__.bind(__webpack_require__, 58674));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58674)
            ];
        }
    },
    ssr: false
});
var LeftContent_PopupMultilImage = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53371));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53371)
            ];
        }
    },
    ssr: false
});
function InfoBuy(param) {
    var orderedCount = param.orderedCount;
    var score = zustand_lib_useCartQuantity(function(state) {
        return state;
    }).score;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LeftContent_styles_module_default()).buyInfo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LeftContent_styles_module_default()).countBuy,
                children: orderedCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            src: Images/* SHOPPING_CART_ICON */.hjz,
                            width: 16,
                            height: 16,
                            alt: "cart_icon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (LeftContent_styles_module_default()).numberBuy,
                            children: orderedCount
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (LeftContent_styles_module_default()).typography,
                            children: " Lượt mua trong 24 giờ"
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: (LeftContent_styles_module_default()).score,
                children: [
                    " ",
                    +score !== 0 ? "".concat(score, " điểm") : ""
                ]
            })
        ]
    });
}
function LeftContent(param) {
    var imagesProxy = param.imagesProxy, orderedCount = param.orderedCount, user = param.user, product = param.product;
    var ref = (0,react.useState)(0), imageActive = ref[0], setImageActive = ref[1];
    var ref1 = (0,react.useState)(false), openModal = ref1[0], setIsOpenModal = ref1[1];
    var ref2 = (0,react.useState)(product === null || product === void 0 ? void 0 : product.isWishList), isWish = ref2[0], setIsWish = ref2[1];
    var ref3 = hooks_useMultiImageBox({
        images: imagesProxy
    }), selectedImage = ref3.selectedImage, handleImageSelection = ref3.handleImageSelection, handlePrevious = ref3.handlePrevious, handleNext = ref3.handleNext;
    var ref4 = hooks_useToggle(), open = ref4.open, handleOpen = ref4.handleOpen, handleClose = ref4.handleClose;
    var cart = (0,CartContext/* useCart */.jD)();
    var router = (0,next_router.useRouter)();
    var trackingMonitorSubstituteAddToCart = (0,useTrackingMonitorSubstituteProduct/* default */.Z)().trackingMonitorSubstituteAddToCart;
    var ref5 = router.query || {}, _isSKUReplace = ref5.isSKUReplace, isSKUReplace = _isSKUReplace === void 0 ? false : _isSKUReplace, sellerIdMainSKU = ref5.sellerIdMainSKU, productIdMainSKU = ref5.productIdMainSKU, mainSKU = ref5.mainSKU, mainType = ref5.mainType;
    // Keep the initial qty and update the qty when changing the QuantityControl
    // onCleanup, send addToCart GA event
    var initialQty = (0,react.useRef)(0);
    var qty = (0,react.useRef)(0);
    var skuProductSuggestFrom = (0,react.useRef)();
    var comboSKUCode = (0,react.useRef)("");
    // TODO: should detect if product is buyable or not, instead of using errorMessageProduct to return product is buyable or not
    var appSetting = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.appSetting;
    });
    var errorMessageProduct = (0,convertNewAPIProduct/* getSKUErrorMessage */.V9)(product, appSetting);
    (0,react.useEffect)(function() {
        var ref;
        if (cart.loading) return;
        var comboProduct = (ref = cart.cartItems) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.sku === product.sku;
        });
        initialQty.current = comboProduct === null || comboProduct === void 0 ? void 0 : comboProduct.quantity;
    }, [
        cart.loading
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (cart.loading) return;
        if (!skuProductSuggestFrom.current) return;
        var comboProduct = (ref = cart.cartItems) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.sku === product.sku;
        });
        qty.current = comboProduct === null || comboProduct === void 0 ? void 0 : comboProduct.quantity;
    }, [
        cart
    ]);
    (0,react.useEffect)(function() {
        if (product.sku) comboSKUCode.current = product.sku;
    }, [
        product.sku
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, searchParams, slug, productRes, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        searchParams = new URLSearchParams(window.location.search);
                        slug = searchParams.get(ComboSuggestion/* COMBO_SUGGESTED_BY */.E);
                        if (!slug) return [
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            WebService/* default.getDataProductDetail */.ZP.getDataProductDetail((_tmp.slug = slug, _tmp))
                        ];
                    case 1:
                        productRes = _state.sent();
                        skuProductSuggestFrom.current = (ref = productRes.data) === null || ref === void 0 ? void 0 : ref[0];
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            if (skuProductSuggestFrom.current && qty.current !== initialQty.current) {
                gtag/* default.addToCartComboSuggestion */.ZP.addToCartComboSuggestion({
                    user: user,
                    skuProduct: skuProductSuggestFrom.current,
                    quantity: qty.current,
                    comboSKUCode: comboSKUCode.current || product.sku
                });
                (0,MonitorClient/* collectEvent */.r3)(MonitorUtils/* MONITORING_COLLECTOR_TYPE.ADD_SUGGESTED_COMBO_TO_CART */.Hq.ADD_SUGGESTED_COMBO_TO_CART, {
                    quantity: qty.current,
                    combo: comboSKUCode.current || product.sku,
                    sku: skuProductSuggestFrom.current.sku,
                    seller_id: skuProductSuggestFrom.current.sellerID,
                    product_id: skuProductSuggestFrom.current.productId,
                    source: (0,MonitorUtils/* mapSourceToEnum */.Dw)(),
                    screen: (0,MonitorUtils/* mapScreenToEnum */.lq)(),
                    content: "Add Combo gợi \xfd v\xe0o Giỏ h\xe0ng"
                }, {
                    quantity: qty.current
                });
            }
        };
    }, []);
    var handleOpenImageModal = function(index) {
        setImageActive(function(indexActive) {
            if (index) return index;
            return indexActive;
        });
        handleOpen();
    };
    (0,react.useEffect)(function() {
        setImageActive(selectedImage);
    }, [
        selectedImage
    ]);
    var handleSetImageActive = function(callback) {
        handleImageSelection(callback);
        setImageActive(callback);
    };
    var handleClickQuestion = function() {
        setIsOpenModal(true);
    };
    var handleDeleteProductWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,WishlistClient/* deleteItemWishlist */.xb)(product === null || product === void 0 ? void 0 : product.sku)
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,Clients/* isValidWithoutData */.Wk)(res)) {
                            setIsWish(function() {
                                return false;
                            });
                            return [
                                2,
                                NotifyUtils/* default.success */.Z.success("Đ\xe3 x\xf3a ".concat(product === null || product === void 0 ? void 0 : product.name, " khỏi danh s\xe1ch quan t\xe2m"))
                            ];
                        }
                        return [
                            2,
                            NotifyUtils/* default.error */.Z.error("X\xf3a sản phẩm ".concat(product === null || product === void 0 ? void 0 : product.name, " khỏi danh s\xe1ch quan t\xe2m thất bại"))
                        ];
                }
            });
        });
        return function handleDeleteProductWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdateWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,WishlistClient/* updateWishlist */.jV)(product === null || product === void 0 ? void 0 : product.sku)
                        ];
                    case 1:
                        res = _state.sent();
                        if ((0,Clients/* isValid */.JY)(res) || (res === null || res === void 0 ? void 0 : res.status) === http/* HTTP_STATUS.Existed */.M.Existed) {
                            setIsWish(function() {
                                return true;
                            });
                            return [
                                2,
                                NotifyUtils/* default.success */.Z.success("Đ\xe3 th\xeam ".concat(product === null || product === void 0 ? void 0 : product.name, " v\xe0o danh s\xe1ch quan t\xe2m"))
                            ];
                        }
                        return [
                            2,
                            NotifyUtils/* default.error */.Z.error("Th\xeam ".concat(product === null || product === void 0 ? void 0 : product.name, " v\xe0o danh s\xe1ch sản phẩm quan t\xe2m thất bại"))
                        ];
                }
            });
        });
        return function handleUpdateWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickWhistList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (isWish) {
                    handleDeleteProductWishlist(product);
                } else {
                    handleUpdateWishlist(product);
                }
                return [
                    2
                ];
            });
        });
        return function handleClickWhistList() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEventTracking = function(product) {
        if (isSKUReplace) {
            trackingMonitorSubstituteAddToCart({
                sku: product === null || product === void 0 ? void 0 : product.sku,
                sellerId: product === null || product === void 0 ? void 0 : product.sellerID,
                productId: product === null || product === void 0 ? void 0 : product.productId,
                type: (product === null || product === void 0 ? void 0 : product.status) === "NORMAL" ? "Instock" : product === null || product === void 0 ? void 0 : product.status,
                pathname: router.pathname,
                sellerIdMainSKU: sellerIdMainSKU,
                productIdMainSKU: productIdMainSKU,
                mainSKU: mainSKU,
                mainType: mainType || "NORMAL"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                className: (LeftContent_styles_module_default()).imageShow,
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LeftContent_styles_module_default()).wrapperImage,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CardImage, {
                                img: imagesProxy[imageActive || 0],
                                onClickQuestion: handleClickQuestion,
                                onClickWhistList: handleClickWhistList,
                                onClickImage: handleOpenImageModal,
                                isOpenModal: open,
                                isWish: isWish,
                                hiddenIconAndText: !user,
                                isNotAuth: !!user,
                                alt: product === null || product === void 0 ? void 0 : product.name
                            }),
                            (imagesProxy === null || imagesProxy === void 0 ? void 0 : imagesProxy.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_ImageSlider, {
                                className: (LeftContent_styles_module_default()).imageSlider,
                                images: imagesProxy,
                                imageActive: imageActive,
                                isOpenModal: open,
                                setImageActive: handleSetImageActive,
                                onClickImage: handleOpenImageModal,
                                alt: product === null || product === void 0 ? void 0 : product.name
                            })
                        ]
                    }),
                    !errorMessageProduct && user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBuy, {
                                orderedCount: orderedCount,
                                displayPrice: product === null || product === void 0 ? void 0 : product.displayPrice
                            }),
                            (product === null || product === void 0 ? void 0 : product.status) !== "OUT_OF_STOCK" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControl, {
                                product: product,
                                onChange: function() {
                                    handleEventTracking(product);
                                },
                                onAdd: function() {
                                    handleEventTracking(product);
                                }
                            }, product === null || product === void 0 ? void 0 : product.sku),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LeftContent_styles_module_default()).typography,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLimitMessage/* default */.Z, {
                                    consumedMaxQuantity: product.consumedMaxQuantity,
                                    unit: product.unit,
                                    page: "product"
                                })
                            })
                        ]
                    })
                ]
            }),
            openModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupCreateTicket, {
                user: user,
                product: product,
                productName: product.name,
                productId: product.productId,
                sku: product.sku,
                visible: true,
                onClose: function() {
                    return setIsOpenModal(false);
                },
                ticketType: "PRODUCT"
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContent_PopupMultilImage, {
                images: imagesProxy,
                open: true,
                handleClose: handleClose,
                imageName: product === null || product === void 0 ? void 0 : product.name,
                selectedImage: imageActive,
                handleClickImage: handleImageSelection,
                handlePrevious: handlePrevious,
                handleNext: handleNext
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorOutline.js
var ErrorOutline = __webpack_require__(32141);
// EXTERNAL MODULE: ./src/context/PopupVoucher/index.tsx + 2 modules
var PopupVoucher = __webpack_require__(89472);
;// CONCATENATED MODULE: ./src/components-v2/organisms/ProductDetailPrices/index.tsx












var tooltipStyles = (0,makeStyles/* default */.Z)({
    container: {
        backgroundColor: "#fff",
        padding: 16,
        minWidth: 384,
        boxShadow: "0px 0px 30px 0px #0000001F",
        borderRadius: 10,
        margin: 0,
        zIndex: 1300
    },
    poper: {
        pointerEvents: "auto"
    }
});
var tooltipHeader = "Chi tiết gi\xe1";
var ProductDetailPrices = function(props) {
    var classes = tooltipStyles();
    var children = props.children, originPrice = props.originPrice, discountInfos = props.discountInfos, tempPrice = props.tempPrice, _isOnlyDiscountWithoutValue = props.isOnlyDiscountWithoutValue, isOnlyDiscountWithoutValue = _isOnlyDiscountWithoutValue === void 0 ? false : _isOnlyDiscountWithoutValue;
    var isOpenTooltip = useProductDetailPrices().isOpenTooltip;
    var ref = useDetailPriceActions(), toggleDialog = ref.toggleDialog, toggleTooltip = ref.toggleTooltip;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        // clear toggle after route change
        router.events.on("routeChangeStart", function() {
            toggleDialog(false);
            toggleTooltip(false);
        });
        return function() {
            router.events.off("routeChangeStart", function() {
                toggleDialog(false);
                toggleTooltip(false);
            });
        };
    }, [
        router.events
    ]);
    // If don't have discountInfo, just render children
    if (!(discountInfos === null || discountInfos === void 0 ? void 0 : discountInfos.length) || isOnlyDiscountWithoutValue) {
        return children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            open: isOpenTooltip,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailTooltip, {
                originPrice: originPrice,
                discountInfos: discountInfos,
                tempPrice: tempPrice
            }),
            classes: {
                tooltip: classes.container,
                popper: classes.poper
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cursor-pointer",
                onMouseOver: function() {
                    return toggleTooltip(true);
                },
                onFocus: function() {
                    return toggleTooltip(true);
                },
                onMouseOut: function() {
                    return toggleTooltip(false);
                },
                onBlur: function() {
                    return toggleTooltip(false);
                },
                children: children
            })
        })
    });
};
/* harmony default export */ var organisms_ProductDetailPrices = (ProductDetailPrices);
var DetailTooltip = function(props) {
    var ref;
    var _originPrice = props.originPrice, originPrice = _originPrice === void 0 ? 0 : _originPrice, _tempPrice = props.tempPrice, tempPrice = _tempPrice === void 0 ? "" : _tempPrice, discountInfos = props.discountInfos;
    var toggleTooltip = useDetailPriceActions().toggleTooltip;
    // Find DEAL discount to calculate VAT invoice price
    var dealDiscount = (ref = discountInfos || []) === null || ref === void 0 ? void 0 : ref.find(function(discount) {
        return (discount === null || discount === void 0 ? void 0 : discount.key) === "DEAL";
    });
    // If DEAL exists: vatInvoicePrice = originPrice - deal
    // If no DEAL: vatInvoicePrice = originPrice
    var vatInvoicePrice = dealDiscount ? originPrice - (dealDiscount === null || dealDiscount === void 0 ? void 0 : dealDiscount.discount) : originPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-black flex flex-col gap-[12px] z-50",
        onMouseEnter: function() {
            return toggleTooltip(true);
        },
        onMouseLeave: function() {
            return toggleTooltip(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[16px] font-ggsm",
                children: tooltipHeader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherWithDiscount, {
                label: "Gi\xe1 gốc",
                discount: (0,FormatNumber/* formatCurrency */.xG)(originPrice),
                discountClasses: "font-ggsm !text-black"
            }),
            dealDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherWithDiscount, {
                label: dealDiscount.title,
                discount: "-".concat((0,FormatNumber/* formatCurrency */.xG)(dealDiscount.discount)),
                subLabel: dealDiscount.subTitle,
                labelClasses: "font-ggsm",
                link: dealDiscount === null || dealDiscount === void 0 ? void 0 : dealDiscount.link,
                voucherCode: dealDiscount === null || dealDiscount === void 0 ? void 0 : dealDiscount.voucherCode
            }),
            vatInvoicePrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherWithDiscount, {
                        label: "Gi\xe1 sau giảm gi\xe1 trực tiếp",
                        discount: (0,FormatNumber/* formatCurrency */.xG)(vatInvoicePrice),
                        labelClasses: "font-ggsm",
                        discountClasses: "font-ggsm !text-black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                ]
            }),
            (discountInfos || []).filter(function(discount) {
                return (discount === null || discount === void 0 ? void 0 : discount.key) !== "DEAL";
            }).map(function(discount, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(VoucherWithDiscount, {
                    label: discount.title,
                    discount: "-".concat((0,FormatNumber/* formatCurrency */.xG)(discount.discount)),
                    subLabel: discount.subTitle,
                    labelClasses: "font-ggsm",
                    link: discount === null || discount === void 0 ? void 0 : discount.link,
                    voucherCode: discount === null || discount === void 0 ? void 0 : discount.voucherCode
                }, discount.key || index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherWithDiscount, {
                label: "Gi\xe1 tạm t\xednh <br/> (khi \xe1p dụng c\xe1c m\xe3 giảm gi\xe1 tr\xean)",
                discount: tempPrice,
                discountClasses: "!text-[#15A959] font-ggsm !my-0"
            })
        ]
    });
};
var VoucherWithDiscount = function(props) {
    var label = props.label, discount = props.discount, subLabel = props.subLabel, _voucherCode = props.voucherCode, voucherCode = _voucherCode === void 0 ? "" : _voucherCode, labelClasses = props.labelClasses, discountClasses = props.discountClasses, _link = props.link, link = _link === void 0 ? "" : _link;
    var ref = useDetailPriceActions(), setTargetVoucher = ref.setTargetVoucher, toggleTooltip = ref.toggleTooltip;
    var handleOpen = (0,PopupVoucher/* usePopupVoucherContext */.lj)().handleOpen;
    var handleClick = function() {
        toggleTooltip(false);
        setTargetVoucher(voucherCode);
        handleOpen(voucherCode);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-2 flex flex-col gap-[4px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)("text-[14px] leading-5", labelClasses),
                        children: label === null || label === void 0 ? void 0 : label.split("<br/>").map(function(line, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    line,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }, index);
                        })
                    }),
                    subLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[12px] text-[#8C8C8C]",
                        children: subLabel
                    }) : null,
                    voucherCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "max-w-max p-0",
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-sm flex items-center text-[#1D39C4] ",
                            children: [
                                "Xem chi tiết\xa0\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutline/* default */.Z, {
                                    className: "text-[#1D39C4] !w-[12px] !h-[12px]"
                                })
                            ]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("col-span-1 text-right text-[#F5222D] text-[14px] my-auto leading-[20px]", discountClasses),
                children: discount
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(52541);
// EXTERNAL MODULE: ./src/components-v2/atoms/ActionButton/index.tsx
var ActionButton = __webpack_require__(82292);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components-v2/atoms/LoadMoreWrapper/styles.module.css
var LoadMoreWrapper_styles_module = __webpack_require__(23772);
var LoadMoreWrapper_styles_module_default = /*#__PURE__*/__webpack_require__.n(LoadMoreWrapper_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/LoadMoreWrapper/index.tsx








var LoadMoreWrapper = function(param) {
    var className = param.className, _isBlur = param.isBlur, isBlur = _isBlur === void 0 ? true : _isBlur, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children, text = param.text, _limit = param.limit, limit = _limit === void 0 ? 5 : _limit, totalVisible = param.totalVisible, total = param.total, onLoadMoreComment = param.onLoadMoreComment;
    var commentRemaining = total - totalVisible;
    var hasMore = totalVisible < total;
    var showText = text || "Xem th\xeam ".concat(commentRemaining > limit ? limit : commentRemaining, " \xfd kiến");
    if (disabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, (LoadMoreWrapper_styles_module_default()).readMoreWrapper, (0,_define_property/* default */.Z)({}, (LoadMoreWrapper_styles_module_default()).isBlur, totalVisible < total ? isBlur : false)),
        children: [
            children,
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                role: "button",
                className: (LoadMoreWrapper_styles_module_default()).readMoreAction,
                onClick: function() {
                    return onLoadMoreComment(commentRemaining);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LoadMoreWrapper_styles_module_default()).textLink,
                        children: showText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LoadMoreWrapper_styles_module_default()).icon,
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            style: {
                                color: "#1B4BE5"
                            },
                            size: 14,
                            thickness: 4
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: Images/* CART_OPEN */.Ole,
                            width: 16,
                            height: 16,
                            alt: "open icon"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var atoms_LoadMoreWrapper = (LoadMoreWrapper);

// EXTERNAL MODULE: ./src/components-v2/atoms/ReadMoreWrapper/index.tsx
var ReadMoreWrapper = __webpack_require__(26918);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NavigateBefore.js
var NavigateBefore = __webpack_require__(61659);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NavigateNext.js
var NavigateNext = __webpack_require__(37958);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/utils/DateTimeUtils.js
var DateTimeUtils = __webpack_require__(33213);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextareaAutosize/TextareaAutosize.js
var TextareaAutosize = __webpack_require__(87343);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CameraAltOutlined.js
var CameraAltOutlined = __webpack_require__(90615);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var icons_Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./src/utils/regUtils.js
var regUtils = __webpack_require__(94024);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components-v2/organisms/QuestionAndAnswer/constants.ts


var PHONE_REGEX = regUtils/* default.PHONE_REGEX */.Z.PHONE_REGEX;
var defaultValues = {
    fullName: "",
    numberPhone: "",
    businessType: {
        key: "",
        value: ""
    },
    province: {
        label: "",
        regionCode: "",
        value: ""
    },
    question: ""
};
var schema = es/* object */.Ry({
    question: es/* string */.Z_().trim().min(3, "Tối thiểu 3 k\xfd tự").required("Th\xf4ng tin bắt buộc")
});
var schemaReply = es/* object */.Ry({
    reply: es/* string */.Z_().trim().min(3, "Tối thiểu 3 k\xfd tự").required("Th\xf4ng tin bắt buộc")
});
var schemaNotLogin = es/* object */.Ry({
    fullName: es/* string */.Z_().trim().required("Vui l\xf2ng nhập họ t\xean").min(2, "T\xean phải d\xe0i hơn 2 k\xed tự"),
    numberPhone: es/* string */.Z_().test({
        name: "is-valid-numberPhone",
        test: function test(value, ctx) {
            if (!value) {
                return ctx.createError({
                    message: "Vui l\xf2ng nhập số điện thoại"
                });
            }
            if (value.length < 10) return ctx.createError({
                message: "Số điện thoại sai định dạng"
            });
            if (value.length > 11 && /^(02)/.test(value)) {
                return ctx.createError({
                    message: "Số điện thoại kh\xf4ng được vượt qu\xe1 11 k\xfd tự"
                });
            }
            if (value.length > 10 && /^(09|07|08|05|03)/.test(value)) {
                return ctx.createError({
                    message: "Số điện thoại kh\xf4ng được vượt qu\xe1 10 k\xfd tự"
                });
            }
            if (value.length === 10) {
                if (!PHONE_REGEX.test(value)) {
                    return ctx.createError({
                        message: "Số điện thoại sai định dạng"
                    });
                }
            }
            if (!/^(09|07|08|05|03|02)/.test(value)) {
                return ctx.createError({
                    message: "Số điện thoại sai định dạng"
                });
            }
            return true;
        }
    }),
    businessType: es/* object */.Ry({
        key: es/* string */.Z_(),
        value: es/* string */.Z_()
    }),
    province: es/* object */.Ry({
        label: es/* string */.Z_(),
        regionCode: es/* string */.Z_(),
        value: es/* string */.Z_()
    }),
    question: es/* string */.Z_().trim().min(3, "Tối thiểu 3 k\xfd tự").required("Th\xf4ng tin bắt buộc")
});
var defaultData = {
    comments: [],
    totalComment: 0,
    totalCommentVisible: 0
};
var LIMIT_HEIGHT_COMMENTS = 840;
var LIMIT_ITEMS = 5;

// EXTERNAL MODULE: ./src/hooks/useUploadSingleFile.ts
var useUploadSingleFile = __webpack_require__(34297);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/components-v2/mocules/CommentList/styles.module.css
var CommentList_styles_module = __webpack_require__(8221);
var CommentList_styles_module_default = /*#__PURE__*/__webpack_require__.n(CommentList_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CommentList/CommentForm.tsx























var MAX_IMAGES = 3;
var MAX_SIZE_MB = 4;
var ACCEPTED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp"
];
var ACCEPTED_EXTENSIONS = [
    "jpg",
    "jpeg",
    "png",
    "webp"
];
var CommentForm = function(props) {
    var className = props.className, type = props.type, image = props.image, replyName = props.replyName, style = props.style, onSubmit = props.onSubmit;
    var ref = (0,react.useState)([]), images = ref[0], setImages = ref[1];
    var fileInputRef = (0,react.useRef)(null);
    var ref1 = (0,useUploadSingleFile/* useUploadSingleFile */.w)({
        maxFileSize: MAX_SIZE_MB,
        callback: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (url) {
                        setImages(function(prev) {
                            return prev.length < MAX_IMAGES ? (0,_to_consumable_array/* default */.Z)(prev).concat([
                                url
                            ]) : prev;
                        });
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }()
    }), uploadOnChange = ref1.onChange, isUploading = ref1.isLoading;
    var ref2 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(schemaReply)
    }), control = ref2.control, handleSubmit = ref2.handleSubmit, formState = ref2.formState;
    var handleOpenFilePicker = function() {
        var ref;
        if (images.length >= MAX_IMAGES || isUploading) return;
        (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    var handleSelectFile = function(e) {
        var ref;
        var file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file) {
            var ref1;
            var extension = ((ref1 = file.name.split(".").pop()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "";
            if (!ACCEPTED_TYPES.includes(file.type) || !ACCEPTED_EXTENSIONS.includes(extension)) {
                NotifyUtils/* default.error */.Z.error("Chỉ hỗ trợ JPG, JPEG, PNG, WEBP");
                e.target.value = "";
                return;
            }
        }
        uploadOnChange(e);
        e.target.value = "";
    };
    var handleRemoveImage = function(url) {
        setImages(function(prev) {
            return prev.filter(function(img) {
                return img !== url;
            });
        });
    };
    var handleFormSubmit = handleSubmit(function(data) {
        onSubmit({
            reply: data.reply,
            images: images
        });
        setImages([]);
    });
    var canAddMore = images.length < MAX_IMAGES && !isUploading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (0,clsx/* default */.Z)(className && className, (CommentList_styles_module_default()).replyInput, (0,_define_property/* default */.Z)({}, (CommentList_styles_module_default())["replyInput-type-".concat(type)], !!type)),
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (CommentList_styles_module_default()).replyAvatar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (CommentList_styles_module_default()).replyAvatarImg,
                    src: image,
                    width: 24,
                    height: 24,
                    loading: "lazy",
                    alt: "avatar reply"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (CommentList_styles_module_default()).replyInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h4",
                        className: (CommentList_styles_module_default()).replyName,
                        children: [
                            "Đang phản hồi: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: replyName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (CommentList_styles_module_default()).replyForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (CommentList_styles_module_default()).replyFormInput,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    name: "reply",
                                    control: control,
                                    render: function(param) {
                                        var field = param.field;
                                        var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            className: (CommentList_styles_module_default()).formTextarea,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                className: (0,clsx/* default */.Z)((CommentList_styles_module_default()).commentBox, (0,_define_property/* default */.Z)({}, (CommentList_styles_module_default()).commentBoxError, !!error)),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaAutosize/* default */.Z, (0,_object_spread/* default */.Z)({
                                                        className: (CommentList_styles_module_default()).input,
                                                        minRows: 2,
                                                        maxRows: 2,
                                                        maxLength: 200,
                                                        placeholder: "* Vui l\xf2ng nhập nội dung phản hồi bằng tiếng Việt c\xf3 dấu, tối thiểu 3 k\xfd tự (Bắt buộc)"
                                                    }, field)),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        className: (CommentList_styles_module_default()).commentBoxToolbar,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                role: "button",
                                                                className: (0,clsx/* default */.Z)((CommentList_styles_module_default()).replyUploadBtn, (0,_define_property/* default */.Z)({}, (CommentList_styles_module_default()).replyUploadBtnDisabled, !canAddMore)),
                                                                onClick: canAddMore ? handleOpenFilePicker : undefined,
                                                                children: [
                                                                    isUploading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                        color: "inherit",
                                                                        size: 16,
                                                                        thickness: 4,
                                                                        style: {
                                                                            color: "var(--primary-color)"
                                                                        }
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraAltOutlined/* default */.Z, {
                                                                        fontSize: "small"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: isUploading ? "Đang tải ảnh l\xean..." : "Th\xeam ảnh (".concat(images.length, "/").concat(MAX_IMAGES, ")")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                ref: fileInputRef,
                                                                type: "file",
                                                                accept: ACCEPTED_TYPES.join(","),
                                                                hidden: true,
                                                                onChange: handleSelectFile
                                                            }),
                                                            error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (CommentList_styles_module_default()).commentBoxError,
                                                                children: error.message
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (CommentList_styles_module_default()).textareaCount,
                                                                children: [
                                                                    field.value ? field.value.length : 0,
                                                                    "/ 200"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        className: (CommentList_styles_module_default()).thumbnails,
                                                        children: images.map(function(url) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                className: (CommentList_styles_module_default()).thumbnailItem,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: (0,ImageUtils/* getLinkCDNImage */.wr)(url),
                                                                        width: 56,
                                                                        height: 56,
                                                                        className: (CommentList_styles_module_default()).thumbnailImage
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        className: (CommentList_styles_module_default()).thumbnailRemove,
                                                                        onClick: function(e) {
                                                                            e.stopPropagation();
                                                                            handleRemoveImage(url);
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close/* default */.Z, {
                                                                            fontSize: "small"
                                                                        })
                                                                    })
                                                                ]
                                                            }, url);
                                                        })
                                                    })
                                                ]
                                            })
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (CommentList_styles_module_default()).submit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                                    variant: "contained",
                                    color: "secondary",
                                    disabled: isUploading,
                                    onClick: handleFormSubmit,
                                    children: "Gửi phản hồi"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CommentList_CommentForm = (CommentForm);

;// CONCATENATED MODULE: ./src/components-v2/mocules/CommentList/CommentItem.tsx




















var PHOTO_ERROR_SRC = "/images/photo_error.svg";
var SWIPE_THRESHOLD = 50;
var CommentImage = function(param) {
    var url = param.url, onClick = param.onClick;
    var ref = (0,react.useState)(false), errored = ref[0], setErrored = ref[1];
    var src = errored ? PHOTO_ERROR_SRC : (0,ImageUtils/* getLinkCDNImage */.wr)(url);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (CommentList_styles_module_default()).commentImageItem,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: src,
            width: 100,
            height: 100,
            loading: "lazy",
            alt: "",
            onError: function() {
                return setErrored(true);
            }
        })
    });
};
var CommentImagesLightbox = function(param) {
    var images = param.images, initialIndex = param.initialIndex, onClose = param.onClose;
    var ref = (0,react.useState)(initialIndex), index = ref[0], setIndex = ref[1];
    var ref1 = (0,react.useState)({}), errored = ref1[0], setErrored = ref1[1];
    var touchStartX = (0,react.useRef)(null);
    var hasMultiple = images.length > 1;
    var showPrev = (0,react.useCallback)(function() {
        setIndex(function(i) {
            return (i - 1 + images.length) % images.length;
        });
    }, [
        images.length
    ]);
    var showNext = (0,react.useCallback)(function() {
        setIndex(function(i) {
            return (i + 1) % images.length;
        });
    }, [
        images.length
    ]);
    (0,react.useEffect)(function() {
        var handleKey = function(e) {
            if (e.key === "Escape") onClose();
            else if (hasMultiple && e.key === "ArrowLeft") showPrev();
            else if (hasMultiple && e.key === "ArrowRight") showNext();
        };
        document.addEventListener("keydown", handleKey);
        return function() {
            return document.removeEventListener("keydown", handleKey);
        };
    }, [
        hasMultiple,
        showPrev,
        showNext,
        onClose
    ]);
    (0,react.useEffect)(function() {
        var prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = prevOverflow;
        };
    }, []);
    var handleTouchStart = function(e) {
        touchStartX.current = e.touches[0].clientX;
    };
    var handleTouchEnd = function(e) {
        if (touchStartX.current === null || !hasMultiple) return;
        var dx = e.changedTouches[0].clientX - touchStartX.current;
        if (Math.abs(dx) > SWIPE_THRESHOLD) {
            if (dx > 0) showPrev();
            else showNext();
        }
        touchStartX.current = null;
    };
    if (typeof document === "undefined") return null;
    var currentSrc = errored[index] ? PHOTO_ERROR_SRC : (0,ImageUtils/* getLinkCDNImage */.wr)(images[index]);
    var overlay = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CommentList_styles_module_default()).lightboxOverlay,
        role: "dialog",
        "aria-modal": "true",
        onClick: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (CommentList_styles_module_default()).lightboxClose,
                onClick: onClose,
                "aria-label": "Đ\xf3ng",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {})
            }),
            hasMultiple && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (0,clsx/* default */.Z)((CommentList_styles_module_default()).lightboxNav, (CommentList_styles_module_default()).lightboxNavPrev),
                onClick: function(e) {
                    e.stopPropagation();
                    showPrev();
                },
                "aria-label": "Ảnh trước",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateBefore["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CommentList_styles_module_default()).lightboxContent,
                onClick: function(e) {
                    return e.stopPropagation();
                },
                onTouchStart: handleTouchStart,
                onTouchEnd: handleTouchEnd,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: currentSrc,
                    alt: "",
                    className: (CommentList_styles_module_default()).lightboxImage,
                    onError: function() {
                        return setErrored(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, index, true));
                        });
                    }
                })
            }),
            hasMultiple && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,clsx/* default */.Z)((CommentList_styles_module_default()).lightboxNav, (CommentList_styles_module_default()).lightboxNavNext),
                        onClick: function(e) {
                            e.stopPropagation();
                            showNext();
                        },
                        "aria-label": "Ảnh kế",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateNext/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CommentList_styles_module_default()).lightboxCounter,
                        children: [
                            index + 1,
                            " / ",
                            images.length
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,react_dom.createPortal)(overlay, document.body);
};
var CommentItem = function(props) {
    var id = props.id, _parentCommentID = props.parentCommentID, parentCommentID = _parentCommentID === void 0 ? null : _parentCommentID, activeComment = props.activeComment, setActiveComment = props.setActiveComment, commenter = props.commenter, content = props.content, _images = props.images, images = _images === void 0 ? [] : _images, createdTime = props.createdTime, _replies = props.replies, replies = _replies === void 0 ? [] : _replies, _isChild = props.isChild, isChild = _isChild === void 0 ? false : _isChild, _type = props.type, type = _type === void 0 ? "COMMENT" : _type, _depth = props.depth, depth = _depth === void 0 ? 0 : _depth, _depthStep = props.depthStep, depthStep = _depthStep === void 0 ? 10 : _depthStep, _totalReply = props.totalReply, totalReply = _totalReply === void 0 ? 0 : _totalReply, onLike = props.onLike, onReply = props.onReply, onLoadMoreReply = props.onLoadMoreReply;
    var canReply = Boolean(id);
    var isReplying = activeComment && activeComment.id === id && activeComment.type === "replying";
    var commentPaddingLeft = type === "COMMENT" ? 4 : 0;
    var ref = (0,react.useState)(null), lightboxIndex = ref[0], setLightboxIndex = ref[1];
    var info = {
        COMMENT: {
            name: commenter.fullname,
            image: Images/* QA_CUSTOMER_AVATAR_ICON */.qJA
        },
        REPLY: {
            name: commenter.fullname,
            image: commenter.isModerator ? Images/* QA_EMPLOYEE_AVATAR_ICON */.ixW : Images/* QA_CUSTOMER_AVATAR_ICON */.qJA
        }
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
        id: "".concat(type, "-").concat(id),
        disableGutters: true,
        className: (0,clsx/* default */.Z)((CommentList_styles_module_default()).commentItem, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (CommentList_styles_module_default()).subCommentItem, isChild), (0,_define_property/* default */.Z)(_obj, (CommentList_styles_module_default()).hasReply, isReplying), _obj)),
        style: {
            paddingLeft: depth * depthStep
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (CommentList_styles_module_default()).commentInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (0,clsx/* default */.Z)((CommentList_styles_module_default()).commentAvatar, (0,_define_property/* default */.Z)({}, (CommentList_styles_module_default()).hasChildBranch, replies.length > 0)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: (CommentList_styles_module_default()).commentAvatarImg,
                            src: info[type].image,
                            width: 24,
                            height: 24,
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (CommentList_styles_module_default()).commentInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "h4",
                                className: (CommentList_styles_module_default()).commentName,
                                children: [
                                    info[type].name,
                                    type === "REPLY" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Images/* QA_AUTHEN_ICON */.JtP,
                                        width: 12,
                                        height: 12,
                                        loading: "lazy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CommentList_styles_module_default()).commentContent,
                                dangerouslySetInnerHTML: {
                                    __html: content
                                }
                            }),
                            (images === null || images === void 0 ? void 0 : images.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (CommentList_styles_module_default()).commentImages,
                                children: images.map(function(url, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentImage, {
                                        url: url,
                                        onClick: function() {
                                            return setLightboxIndex(idx);
                                        }
                                    }, url);
                                })
                            }),
                            lightboxIndex !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentImagesLightbox, {
                                images: images,
                                initialIndex: lightboxIndex,
                                onClose: function() {
                                    return setLightboxIndex(null);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CommentList_styles_module_default()).commentUtils,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (CommentList_styles_module_default()).commentTime,
                                        children: DateTimeUtils/* default.getTimeAgo */.ZP.getTimeAgo(createdTime)
                                    }),
                                    onLike && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "button",
                                        className: (CommentList_styles_module_default()).commentLike,
                                        onClick: function() {
                                            return onLike(info[type].name);
                                        },
                                        children: "Hữu \xedch"
                                    }),
                                    canReply && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "button",
                                        className: (CommentList_styles_module_default()).commentReply,
                                        onClick: function() {
                                            return setActiveComment({
                                                id: id,
                                                type: "replying"
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: Images/* QA_REPLY_ICON */.NDw,
                                                width: 20,
                                                height: 20,
                                                loading: "lazy",
                                                alt: "reply icon"
                                            }),
                                            "Trả lời"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isReplying && onReply && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList_CommentForm, {
                className: (0,clsx/* default */.Z)((0,_define_property/* default */.Z)({}, (CommentList_styles_module_default()).hasReplies, replies.length > 0)),
                type: type,
                style: {
                    paddingLeft: commentPaddingLeft * depthStep
                },
                image: info.COMMENT.image,
                replyName: info[type].name,
                onSubmit: function(data) {
                    return onReply(data, parentCommentID || +id);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_LoadMoreWrapper, {
                className: (CommentList_styles_module_default()).loadMoreReply,
                isBlur: false,
                total: totalReply,
                totalVisible: replies.length,
                onLoadMoreComment: function(num) {
                    // eslint-disable-next-line no-unused-expressions
                    onLoadMoreReply && onLoadMoreReply({
                        restNumber: num,
                        parentCommentID: parentCommentID,
                        totalReply: totalReply
                    });
                },
                children: replies.length > 0 && replies.map(function(comment) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentItem, {
                        id: comment.commentID,
                        activeComment: activeComment,
                        setActiveComment: setActiveComment,
                        parentCommentID: comment.parentCommentID,
                        commenter: comment.commenter,
                        content: comment.content,
                        images: comment.images,
                        createdTime: comment.createdTime,
                        replies: comment.replies,
                        onReply: onReply,
                        depth: 4,
                        type: "REPLY",
                        isChild: true
                    }, comment.commentID);
                })
            })
        ]
    });
};
/* harmony default export */ var CommentList_CommentItem = (CommentItem);

// EXTERNAL MODULE: ./src/hooks/useIsInViewportOnce.js
var useIsInViewportOnce = __webpack_require__(92803);
// EXTERNAL MODULE: ./src/hooks/useModalV2.ts
var useModalV2 = __webpack_require__(28727);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(70148);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Add.js
var Add = __webpack_require__(63957);
// EXTERNAL MODULE: ./src/components-v2/mocules/NotificationModal/index.tsx
var NotificationModal = __webpack_require__(52038);
// EXTERNAL MODULE: ./src/components-v2/organisms/QuestionAndAnswer/RegisteredQuestionForm/styles.module.css
var RegisteredQuestionForm_styles_module = __webpack_require__(29354);
var RegisteredQuestionForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(RegisteredQuestionForm_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/QuestionAndAnswer/RegisteredQuestionForm/index.tsx


























var RegisteredQuestionForm_MAX_IMAGES = 3;
var RegisteredQuestionForm_MAX_SIZE_MB = 4;
var RegisteredQuestionForm_ACCEPTED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png"
];
var RegisteredQuestionForm_ACCEPTED_EXTENSIONS = [
    "jpg",
    "jpeg",
    "png"
];
var RegisteredQuestionForm = function(props) {
    var isOpen = props.isOpen, targetCode = props.targetCode, onClose = props.onClose;
    var ref = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(schema)
    }), control = ref.control, handleSubmit = ref.handleSubmit, formState = ref.formState, reset = ref.reset;
    var ref1 = (0,react.useState)([]), images = ref1[0], setImages = ref1[1];
    var fileInputRef = (0,react.useRef)(null);
    var ref2 = (0,useUploadSingleFile/* useUploadSingleFile */.w)({
        maxFileSize: RegisteredQuestionForm_MAX_SIZE_MB,
        callback: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (url) {
                        setImages(function(prev) {
                            return prev.length < RegisteredQuestionForm_MAX_IMAGES ? (0,_to_consumable_array/* default */.Z)(prev).concat([
                                url
                            ]) : prev;
                        });
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }()
    }), uploadOnChange = ref2.onChange, isUploading = ref2.isLoading;
    var handleClose = function() {
        reset();
        setImages([]);
        onClose();
    };
    var handleOpenFilePicker = function() {
        var ref;
        if (images.length >= RegisteredQuestionForm_MAX_IMAGES || isUploading) return;
        (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    var handleSelectFile = function(e) {
        var ref;
        var file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0];
        if (file) {
            var ref1;
            var extension = ((ref1 = file.name.split(".").pop()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "";
            if (!RegisteredQuestionForm_ACCEPTED_TYPES.includes(file.type) || !RegisteredQuestionForm_ACCEPTED_EXTENSIONS.includes(extension)) {
                NotifyUtils/* default.error */.Z.error("Chỉ hỗ trợ JPG, JPEG, PNG");
                e.target.value = "";
                return;
            }
        }
        uploadOnChange(e);
        e.target.value = "";
    };
    var handleRemoveImage = function(url) {
        setImages(function(prev) {
            return prev.filter(function(img) {
                return img !== url;
            });
        });
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var question, params, _tmp, rs, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        question = data.question;
                        _tmp = {};
                        params = (_tmp.content = question, _tmp.targetCode = targetCode, _tmp.images = images, _tmp);
                        return [
                            4,
                            (0,WebServiceClient/* createComment */.Yr)(params)
                        ];
                    case 1:
                        rs = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(rs)) {
                            react_toastify_esm/* toast.error */.Am.error(rs.message || "C\xf3 lỗi xảy ra, vui l\xf2ng thử lại");
                            return [
                                2
                            ];
                        }
                        reset();
                        setImages([]);
                        onClose();
                        _tmp1 = {};
                        react_toastify_esm/* toast.success */.Am.success("Cảm ơn bạn đ\xe3 gửi \xfd kiến cho thuocsi.vn. \xdd kiến của bạn đang chờ duyệt.", (_tmp1.autoClose = 3000, _tmp1));
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationModal/* default */.Z, {
        classNames: (RegisteredQuestionForm_styles_module_default()).loggedFormModal,
        title: "\xdd kiến về sản phẩm",
        maxWidth: "sm",
        cancelText: "Hủy",
        submitText: "Gửi",
        isOpen: isOpen,
        isDisableSubmit: formState.isSubmitting || isUploading,
        onClose: handleClose,
        onCancel: handleClose,
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: (RegisteredQuestionForm_styles_module_default()).loggedForm,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (RegisteredQuestionForm_styles_module_default()).loggedFormGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        name: "question",
                        control: control,
                        render: function(param) {
                            var field = param.field;
                            var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (RegisteredQuestionForm_styles_module_default()).formTextarea,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaAutosize/* default */.Z, (0,_object_spread/* default */.Z)({
                                        className: (0,clsx/* default */.Z)((RegisteredQuestionForm_styles_module_default()).input, (0,_define_property/* default */.Z)({}, (RegisteredQuestionForm_styles_module_default()).error, !!error)),
                                        minRows: 3,
                                        maxRows: 3,
                                        maxLength: 200,
                                        placeholder: "* Vui l\xf2ng nhập nội dung c\xe2u hỏi bằng tiếng Việt c\xf3 dấu, tối thiểu 3 k\xfd tự (Bắt buộc)"
                                    }, field)),
                                    error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: error.message
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (RegisteredQuestionForm_styles_module_default()).textareaCount,
                                        children: [
                                            field.value ? field.value.length : 0,
                                            "/ 200"
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (0,clsx/* default */.Z)((RegisteredQuestionForm_styles_module_default()).uploadBox, (0,_define_property/* default */.Z)({}, (RegisteredQuestionForm_styles_module_default()).uploadBoxDisabled, images.length >= RegisteredQuestionForm_MAX_IMAGES || isUploading)),
                        onClick: handleOpenFilePicker,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (RegisteredQuestionForm_styles_module_default()).uploadIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraAltOutlined/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (RegisteredQuestionForm_styles_module_default()).uploadText,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (RegisteredQuestionForm_styles_module_default()).uploadTitle,
                                        children: isUploading ? "Đang tải ảnh l\xean..." : "Th\xeam ảnh (t\xf9y chọn)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (RegisteredQuestionForm_styles_module_default()).uploadSubtitle,
                                        children: [
                                            "Tối đa ",
                                            RegisteredQuestionForm_MAX_IMAGES,
                                            " ảnh • JPG, PNG, JPEG • Mỗi ảnh ≤ ",
                                            RegisteredQuestionForm_MAX_SIZE_MB,
                                            "MB"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (RegisteredQuestionForm_styles_module_default()).uploadAddBtn,
                                children: isUploading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    color: "inherit",
                                    size: 18,
                                    thickness: 4,
                                    style: {
                                        color: "var(--primary-color)"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                ref: fileInputRef,
                                type: "file",
                                accept: RegisteredQuestionForm_ACCEPTED_TYPES.join(","),
                                hidden: true,
                                onChange: handleSelectFile
                            })
                        ]
                    }),
                    images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (RegisteredQuestionForm_styles_module_default()).thumbnails,
                        children: images.map(function(url) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (RegisteredQuestionForm_styles_module_default()).thumbnailItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (0,ImageUtils/* getLinkCDNImage */.wr)(url),
                                        width: 80,
                                        height: 80,
                                        className: (RegisteredQuestionForm_styles_module_default()).thumbnailImage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (RegisteredQuestionForm_styles_module_default()).thumbnailRemove,
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            handleRemoveImage(url);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }, url);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var QuestionAndAnswer_RegisteredQuestionForm = (RegisteredQuestionForm);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 1 modules
var Select = __webpack_require__(55296);
// EXTERNAL MODULE: ./src/components-v2/atoms/SelectBase/styles.module.css
var SelectBase_styles_module = __webpack_require__(95628);
var SelectBase_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectBase_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/SelectBase/index.tsx








var MenuProps = {
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    getContentAnchorEl: null,
    PaperProps: {
        style: {
            boxShadow: " 0px 5px 15px 0px rgba(0, 0, 0, 0.20)"
        }
    },
    MenuListProps: {
        style: {
            padding: "20px 20px 0 20px"
        }
    }
};
var SelectBase = function(_param) {
    var className = _param.className, error = _param.error, errorMessage = _param.errorMessage, iconStart = _param.iconStart, iconEnd = _param.iconEnd, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "error",
        "errorMessage",
        "iconStart",
        "iconEnd",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                error: error,
                className: (SelectBase_styles_module_default()).select,
                fullWidth: true,
                displayEmpty: true,
                variant: "outlined",
                MenuProps: (0,_object_spread/* default */.Z)({}, MenuProps)
            }, iconStart && {
                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                    position: "start",
                    className: (SelectBase_styles_module_default()).input_icon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SelectBase_styles_module_default()).inputIcon,
                        children: iconStart
                    })
                })
            }, iconEnd && {
                IconComponent: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SelectBase_styles_module_default()).icon,
                        children: iconEnd
                    });
                }
            }, restProps), {
                children: children
            })),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                className: (SelectBase_styles_module_default()).textError,
                children: errorMessage
            })
        ]
    });
};
/* harmony default export */ var atoms_SelectBase = (SelectBase);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./src/components-v2/atoms/TextFieldBase/styles.module.css
var TextFieldBase_styles_module = __webpack_require__(61604);
var TextFieldBase_styles_module_default = /*#__PURE__*/__webpack_require__.n(TextFieldBase_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/TextFieldBase/index.tsx






var TextFieldBase = function(_param) {
    var className = _param.className, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, error = _param.error, errorMessage = _param.errorMessage, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "placeholder",
        "error",
        "errorMessage"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        className: (0,clsx/* default */.Z)((TextFieldBase_styles_module_default()).input, className && className),
        variant: "outlined",
        fullWidth: true,
        placeholder: placeholder,
        error: error,
        helperText: errorMessage
    }, restProps));
};
/* harmony default export */ var atoms_TextFieldBase = (TextFieldBase);

// EXTERNAL MODULE: ./src/hooks/useProvinces.js
var useProvinces = __webpack_require__(86853);
// EXTERNAL MODULE: ./src/components-v2/organisms/QuestionAndAnswer/UnregisteredQuestionForm/styles.module.css
var UnregisteredQuestionForm_styles_module = __webpack_require__(20153);
var UnregisteredQuestionForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(UnregisteredQuestionForm_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/QuestionAndAnswer/UnregisteredQuestionForm/index.tsx






























var UnregisteredQuestionForm = function(props) {
    var targetCode = props.targetCode, isOpen = props.isOpen, onClose = props.onClose;
    var ref = (0,react.useState)([]), provinces = ref[0], setProvinces = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(schemaNotLogin)
    }), controlNotLogin = ref1.control, handleSubmit = ref1.handleSubmit, formState = ref1.formState, reset = ref1.reset;
    var getProvinceOptions = (0,useProvinces/* useProvinces */.L)().getProvinceOptions;
    var fetchProvinces = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var provincesRs, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            getProvinceOptions()
                        ];
                    case 1:
                        provincesRs = _state.sent();
                        setProvinces(provincesRs);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        NotifyUtils/* default.error */.Z.error("Lấy danh s\xe1ch tỉnh th\xe0nh kh\xf4ng th\xe0nh c\xf4ng");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchProvinces() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        reset();
        onClose();
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var businessType, question, numberPhone, fullName, province, params, _tmp, rs, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        businessType = data.businessType, question = data.question, numberPhone = data.numberPhone, fullName = data.fullName, province = data.province;
                        _tmp = {};
                        params = (_tmp.content = question, _tmp.targetCode = targetCode, _tmp.isBasic = true, _tmp.fullname = fullName, _tmp.provinceCode = province.value, _tmp.scope = businessType === null || businessType === void 0 ? void 0 : businessType.key, _tmp.phone = numberPhone, _tmp);
                        return [
                            4,
                            (0,WebServiceClient/* createCommentNotLogin */.mB)(params)
                        ];
                    case 1:
                        rs = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(rs)) {
                            react_toastify_esm/* toast.error */.Am.error(rs.message || "C\xf3 lỗi xảy ra, vui l\xf2ng thử lại");
                            return [
                                2
                            ];
                        }
                        reset();
                        onClose();
                        _tmp1 = {};
                        react_toastify_esm/* toast.success */.Am.success("Cảm ơn bạn đ\xe3 gửi \xfd kiến cho thuocsi.vn. \xdd kiến của bạn đang chờ duyệt.", (_tmp1.autoClose = 3000, _tmp1));
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!isOpen) return;
        if (provinces.length > 0) return;
        fetchProvinces();
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationModal/* default */.Z, {
        classNames: (UnregisteredQuestionForm_styles_module_default()).loginFormModal,
        title: "\xdd kiến về sản phẩm",
        maxWidth: "sm",
        cancelText: "Hủy",
        submitText: "Gửi",
        isOpen: isOpen,
        isDisableSubmit: formState.isSubmitting,
        onClose: handleClose,
        onCancel: handleClose,
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: (UnregisteredQuestionForm_styles_module_default()).loginForm,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "fullName",
                            control: controlNotLogin,
                            render: function(param) {
                                var field = param.field;
                                var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_TextFieldBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    placeholder: "* Họ v\xe0 t\xean (Bắt buộc)",
                                    error: !!(error === null || error === void 0 ? void 0 : error.message),
                                    helperText: error === null || error === void 0 ? void 0 : error.message
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "numberPhone",
                            control: controlNotLogin,
                            render: function(param) {
                                var field = param.field;
                                var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_TextFieldBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    placeholder: "* Số điện thoại (Bắt buộc)",
                                    error: !!(error === null || error === void 0 ? void 0 : error.message),
                                    helperText: error === null || error === void 0 ? void 0 : error.message
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "businessType",
                            control: controlNotLogin,
                            render: function(param) {
                                var field = param.field;
                                var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_SelectBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    renderValue: function(selected) {
                                        if (!(selected === null || selected === void 0 ? void 0 : selected.value)) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (UnregisteredQuestionForm_styles_module_default()).placeholder,
                                                children: "Bạn l\xe0"
                                            });
                                        }
                                        return selected === null || selected === void 0 ? void 0 : selected.value;
                                    },
                                    error: error,
                                    iconStart: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Images/* QA_STORE_ICON */.LUp,
                                        width: 24,
                                        height: 24,
                                        loading: "lazy",
                                        alt: "select icon"
                                    }),
                                    iconEnd: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_REGISTER_DROPDOWN */.jjP, {}),
                                    children: Object.entries(Enums/* ENUM_SCOPE_LABEL */.xZ).map(function(arr) {
                                        var ref;
                                        var key = arr[0];
                                        var value = arr[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                            className: (UnregisteredQuestionForm_styles_module_default()).menuItem,
                                            value: {
                                                key: key,
                                                value: value
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                    checked: (field === null || field === void 0 ? void 0 : (ref = field.value) === null || ref === void 0 ? void 0 : ref.key) === key
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                    primary: value
                                                })
                                            ]
                                        }, key);
                                    })
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "province",
                            control: controlNotLogin,
                            render: function(param) {
                                var field = param.field;
                                var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_SelectBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    renderValue: function(selected) {
                                        if (!(selected === null || selected === void 0 ? void 0 : selected.label)) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (UnregisteredQuestionForm_styles_module_default()).placeholder,
                                                children: "Tỉnh/Th\xe0nh phố *"
                                            });
                                        }
                                        return selected === null || selected === void 0 ? void 0 : selected.label;
                                    },
                                    placeholder: "Tỉnh/Th\xe0nh phố",
                                    error: error,
                                    iconStart: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Images/* QA_LOCATION_ICON */.PY9,
                                        width: 24,
                                        height: 24,
                                        loading: "lazy",
                                        alt: "select icon"
                                    }),
                                    iconEnd: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_REGISTER_DROPDOWN */.jjP, {}),
                                    children: provinces.map(function(province) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                            value: province,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                primary: province.label
                                            })
                                        }, province.value);
                                    })
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "question",
                            control: controlNotLogin,
                            render: function(param) {
                                var field = param.field;
                                var error = (0,index_esm/* get */.U2)(formState.errors, field.name);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: (UnregisteredQuestionForm_styles_module_default()).formTextarea,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaAutosize/* default */.Z, (0,_object_spread/* default */.Z)({
                                            className: (0,clsx/* default */.Z)((UnregisteredQuestionForm_styles_module_default()).input, (0,_define_property/* default */.Z)({}, (UnregisteredQuestionForm_styles_module_default()).error, !!error)),
                                            minRows: 3,
                                            maxRows: 3,
                                            maxLength: 200,
                                            placeholder: "* Vui l\xf2ng nhập nội dung c\xe2u hỏi bằng tiếng Việt c\xf3 dấu, tối thiểu 3 k\xfd tự (Bắt buộc)"
                                        }, field)),
                                        error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: error.message
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (UnregisteredQuestionForm_styles_module_default()).textareaCount,
                                            children: [
                                                field.value ? field.value.length : 0,
                                                "/ 200"
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var QuestionAndAnswer_UnregisteredQuestionForm = (UnregisteredQuestionForm);

// EXTERNAL MODULE: ./src/components-v2/organisms/QuestionAndAnswer/styles.module.css
var QuestionAndAnswer_styles_module = __webpack_require__(70561);
var QuestionAndAnswer_styles_module_default = /*#__PURE__*/__webpack_require__.n(QuestionAndAnswer_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/QuestionAndAnswer/index.jsx






























var defaultActiveComment = {
    id: null,
    type: "idle"
};
var QuestionAndAnswer = function(param) {
    var user = param.user, targetCode = param.targetCode, priceFeedback = param.priceFeedback;
    var handleSort = function handleSort(event) {
        var queryParams = (0,_object_spread/* default */.Z)({}, router.query);
        if (router.query.commentID) delete queryParams.commentID;
        var value = event.target.value;
        setSort(value);
        setOffset(0);
        router.push({
            pathname: router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryParams), {
                sort: value
            })
        }, undefined, {
            shallow: true,
            scroll: false
        });
        fetchComments({
            sort: value,
            offset: 0,
            commentID: 0
        });
    };
    var handleLoadMoreComment = function handleLoadMoreComment(num) {
        setIsMoreLoading(true);
        var newOffset = offset + LIMIT_ITEMS;
        setOffset(newOffset);
        fetchComments({
            sort: sort,
            offset: newOffset,
            commentID: +String(router.query.commentID)
        });
    };
    var handleLoadMoreReply = function handleLoadMoreReply(data) {
        var restNumber = data.restNumber, parentCommentID = data.parentCommentID, totalReply = data.totalReply;
        var offsetCalc = totalReply - restNumber;
        fetchReply({
            offset: offsetCalc,
            parentCommentID: parentCommentID
        });
    };
    var ref;
    var commentRef = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(router.query.sort || "NEWEST"), sort = ref1[0], setSort = ref1[1];
    var ref2 = (0,react.useState)(0), offset = ref2[0], setOffset = ref2[1];
    var ref3 = (0,react.useState)(false), isMoreLoading = ref3[0], setIsMoreLoading = ref3[1];
    var ref4 = (0,react.useState)(defaultActiveComment), activeComment = ref4[0], setActiveComment = ref4[1];
    var ref5 = (0,react.useState)(defaultData), data = ref5[0], setData = ref5[1];
    var hasComments = data.totalCommentVisible > 0;
    var hasMoreCommentsToLoad = data.totalCommentVisible < data.totalComment;
    var isCommentListBelowHeightLimit = (((ref = commentRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0) < LIMIT_HEIGHT_COMMENTS;
    var elementRef = (0,useIsInViewportOnce/* useIsInViewportOnce */.z)({
        callback: function() {
            var _initComments = (0,_async_to_generator/* default */.Z)(function() {
                var _tmp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _tmp = {};
                    fetchComments((_tmp.sort = sort, _tmp.offset = offset, _tmp.commentID = +String(router.query.commentID), _tmp));
                    return [
                        2
                    ];
                });
            });
            function initComments() {
                return _initComments.apply(this, arguments);
            }
            return initComments;
        }()
    }).elementRef;
    (0,react.useEffect)(function() {
        if (router.query.commentID) {
            // CHEAT: use setTimeout to delay after the DOM is rendered, and scroll.
            // Without it, it will scroll to the comment section and jump back to top.
            setTimeout(function() {
                elementRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }, 0);
        }
    }, []);
    function fetchComments(_) {
        return _fetchComments.apply(this, arguments);
    }
    function _fetchComments() {
        _fetchComments = (0,_async_to_generator/* default */.Z)(function(param) {
            var _limit, limit, _offset, offset, _sort, sort, _commentID, commentID, mergedComments, rs, _tmp, _tmp1, getComment, _tmp2, ref, commentData, _tmp3, _tmp4, comments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _limit = param.limit, limit = _limit === void 0 ? LIMIT_ITEMS : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _sort = param.sort, sort = _sort === void 0 ? "NEWEST" : _sort, _commentID = param.commentID, commentID = _commentID === void 0 ? 0 : _commentID;
                        mergedComments = [];
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            (0,WebServiceClient/* getCommentsBySkuCode */.Ge)((0,_object_spread/* default */.Z)((_tmp.isAuth = false, _tmp.skuCode = targetCode, _tmp.sort = sort, _tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp), commentID && (_tmp1.excludeID = String(commentID), _tmp1)))
                        ];
                    case 1:
                        rs = _state.sent();
                        if (!commentID) return [
                            3,
                            3
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            (0,WebServiceClient/* getCommentsBySkuCode */.Ge)((_tmp2.isAuth = false, _tmp2.skuCode = targetCode, _tmp2.sort = sort, _tmp2.offset = offset, _tmp2.limit = limit, _tmp2.q = {
                                commentID: +commentID
                            }, _tmp2))
                        ];
                    case 2:
                        getComment = _state.sent();
                        _tmp3 = {};
                        _tmp4 = {};
                        if ((0,Clients/* isValid */.JY)(getComment)) {
                            ref = (0,_sliced_to_array/* default */.Z)((0,Clients/* getData */.Yu)(getComment), 1), commentData = ref[0];
                            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, data), (_tmp4.totalComment = 1, _tmp4)));
                            mergedComments.push(commentData);
                        }
                        _state.label = 3;
                    case 3:
                        if (!(0,Clients/* isValid */.JY)(rs) && !commentID) {
                            setData(defaultData);
                            setIsMoreLoading(false);
                            return [
                                2
                            ];
                        }
                        comments = (0,Clients/* getData */.Yu)(rs);
                        setData(function(prevData) {
                            mergedComments = offset === 0 && !commentID ? comments : (0,_to_consumable_array/* default */.Z)(mergedComments).concat((0,_to_consumable_array/* default */.Z)(prevData.comments), (0,_to_consumable_array/* default */.Z)(comments));
                            return {
                                comments: mergedComments,
                                totalComment: rs.total || mergedComments.length,
                                totalCommentVisible: mergedComments.length
                            };
                        });
                        setIsMoreLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchComments.apply(this, arguments);
    }
    function fetchReply(_) {
        return _fetchReply.apply(this, arguments);
    }
    function _fetchReply() {
        _fetchReply = (0,_async_to_generator/* default */.Z)(function(param) {
            var _offset, offset, _limit, limit, _parentCommentID, parentCommentID, rs, _tmp, result, cloneComments, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _limit = param.limit, limit = _limit === void 0 ? 5 : _limit, _parentCommentID = param.parentCommentID, parentCommentID = _parentCommentID === void 0 ? null : _parentCommentID;
                        _tmp = {};
                        return [
                            4,
                            (0,WebServiceClient/* getReply */.HU)((_tmp.isAuth = true, _tmp.parentCommentID = parentCommentID, _tmp.offset = offset, _tmp.limit = limit, _tmp))
                        ];
                    case 1:
                        rs = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(rs)) {
                            return [
                                2
                            ];
                        }
                        result = (0,Clients/* getData */.Yu)(rs);
                        cloneComments = data.comments;
                        cloneComments.forEach(function(comment) {
                            if (comment.commentID === parentCommentID) {
                                var _replies;
                                (_replies = comment.replies).push.apply(_replies, (0,_to_consumable_array/* default */.Z)(result));
                            }
                        });
                        _tmp1 = {};
                        _tmp2 = {};
                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, data), (_tmp2.comments = cloneComments, _tmp2)));
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchReply.apply(this, arguments);
    }
    function handleReply(data, parentCommentID) {
        return _handleReply.apply(this, arguments);
    }
    function _handleReply() {
        _handleReply = (0,_async_to_generator/* default */.Z)(function(data, parentCommentID) {
            var rs, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,WebServiceClient/* createReply */.PP)((_tmp.content = data.reply, _tmp.parentCommentID = parentCommentID, _tmp.images = data.images, _tmp))
                        ];
                    case 1:
                        rs = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(rs)) {
                            react_toastify_esm/* toast.error */.Am.error(rs.message || "C\xf3 lỗi xảy ra, vui l\xf2ng thử lại");
                            return [
                                2
                            ];
                        }
                        _tmp1 = {};
                        react_toastify_esm/* toast.success */.Am.success("Cảm ơn bạn đ\xe3 gửi \xfd kiến cho thuocsi.vn. \xdd kiến của bạn đang chờ duyệt.", (_tmp1.autoClose = 3000, _tmp1));
                        setActiveComment(defaultActiveComment);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleReply.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: elementRef,
        className: (QuestionAndAnswer_styles_module_default()).comment,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (QuestionAndAnswer_styles_module_default()).actionComment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (QuestionAndAnswer_styles_module_default()).titleComment,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (QuestionAndAnswer_styles_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: Images/* QA_TITLE_ICON */.qGW,
                                    width: 32,
                                    height: 32,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: (QuestionAndAnswer_styles_module_default()).headingComment,
                                children: [
                                    "\xdd kiến về sản phẩm ",
                                    hasComments && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "(",
                                            data.totalComment || data.totalCommentVisible,
                                            " \xfd kiến)"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasComments && /*#__PURE__*/ (0,jsx_runtime.jsx)(SendCommentBtn, {
                        user: user,
                        targetCode: targetCode
                    })
                ]
            }),
            priceFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (QuestionAndAnswer_styles_module_default()).priceFeedback,
                children: priceFeedback
            }),
            (hasComments || sort === "IS_HAVE_IMAGE") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (QuestionAndAnswer_styles_module_default()).filterComment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (QuestionAndAnswer_styles_module_default()).filterHeading,
                        children: "Lọc theo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                        className: (QuestionAndAnswer_styles_module_default()).btnGroup,
                        row: true,
                        value: sort,
                        onChange: handleSort,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: "NEWEST",
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: "Mới nhất"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: "OLDEST",
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: "Cũ nhất"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: "IS_HAVE_IMAGE",
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: "C\xf3 ảnh"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (QuestionAndAnswer_styles_module_default()).mainComment,
                children: hasComments ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreWrapper/* default */.Z, {
                    disabled: hasMoreCommentsToLoad || isCommentListBelowHeightLimit,
                    isOpen: hasMoreCommentsToLoad,
                    maxHeight: LIMIT_HEIGHT_COMMENTS,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_LoadMoreWrapper, {
                        isLoading: isMoreLoading,
                        total: data.totalComment,
                        totalVisible: data.totalCommentVisible,
                        onLoadMoreComment: handleLoadMoreComment,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            innerRef: commentRef,
                            className: (QuestionAndAnswer_styles_module_default()).commentList,
                            children: data.comments.map(function(comment) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList_CommentItem, {
                                    id: comment.commentID,
                                    parentCommentID: comment.commentID,
                                    activeComment: activeComment,
                                    setActiveComment: setActiveComment,
                                    commenter: comment.commenter,
                                    content: comment.content,
                                    images: comment.images,
                                    createdTime: comment.createdTime,
                                    replies: comment.replies,
                                    totalReply: comment.totalReplies || 0,
                                    onReply: handleReply,
                                    onLoadMoreReply: handleLoadMoreReply
                                }, comment.commentID);
                            })
                        })
                    })
                }) : sort === "IS_HAVE_IMAGE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (QuestionAndAnswer_styles_module_default()).emptyComment,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (QuestionAndAnswer_styles_module_default()).textEmptyComment,
                        children: "Chưa c\xf3 \xfd kiến n\xe0o c\xf3 h\xecnh ảnh."
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: (QuestionAndAnswer_styles_module_default()).emptyComment,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SendCommentBtn, {
                            user: user,
                            targetCode: targetCode
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (QuestionAndAnswer_styles_module_default()).textEmptyComment,
                            children: "Bạn c\xf3 thắc mắc về sản phẩm? Gửi c\xe2u hỏi để được giải đ\xe1p ngay!"
                        })
                    ]
                })
            })
        ]
    });
};
function SendCommentBtn(param) {
    var user = param.user, targetCode = param.targetCode;
    var handleToggleModal = function handleToggleModal() {
        if (user) {
            toggleQuestionModal();
            return;
        }
        toggleNotLoginModal();
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModalV2/* default */.Z)(false), 2), isOpenQuestionModal = ref[0], toggleQuestionModal = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModalV2/* default */.Z)(false), 2), isNotLoginModal = ref1[0], toggleNotLoginModal = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: Images/* QA_BTN_ICON */.c7S,
                    width: 24,
                    height: 24,
                    loading: "lazy"
                }),
                size: "small",
                variant: "contained",
                color: "greenish",
                onClick: handleToggleModal,
                children: "Gửi \xfd kiến"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAndAnswer_RegisteredQuestionForm, {
                targetCode: targetCode,
                isOpen: isOpenQuestionModal,
                onClose: toggleQuestionModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAndAnswer_UnregisteredQuestionForm, {
                targetCode: targetCode,
                isOpen: isNotLoginModal,
                onClose: toggleNotLoginModal
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/mocules/Breadcrumbs/index.tsx
var Breadcrumbs = __webpack_require__(61828);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.js
var atoms_Button = __webpack_require__(23600);
// EXTERNAL MODULE: ./src/components/atoms/InfoFormControl/index.js
var InfoFormControl = __webpack_require__(96317);
// EXTERNAL MODULE: ./src/components/atoms/Modal/index.js
var atoms_Modal = __webpack_require__(57925);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./src/context/Ticket/index.js
var Ticket = __webpack_require__(23801);
// EXTERNAL MODULE: ./src/components/mocules/InfoInput/index.js
var InfoInput = __webpack_require__(42150);
// EXTERNAL MODULE: ./src/components/mocules/FeedbackPriceFormModal/style.module.css
var style_module = __webpack_require__(20768);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/mocules/FeedbackPriceFormModal/index.js




















var FeedbackPriceFormModal = function(props) {
    var visible = props.visible, onClose = props.onClose, productId = props.productId, sku = props.sku;
    var customerInfo = (0,Auth/* useAuth */.aC)().customerInfo;
    var sendDislikeFeedback = (0,Ticket/* useTicket */.Q)().sendDislikeFeedback;
    var ref = (0,react.useState)({
        price: "",
        src: ""
    }), val = ref[0], setVal = ref[1];
    var handleChangeValue = function(key, value) {
        setVal((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, val), (0,_define_property/* default */.Z)({}, key, value)));
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isSendFeedback, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(val === null || val === void 0 ? void 0 : val.price)) {
                            NotifyUtils/* default.error */.Z.error("Bạn chưa nhập gi\xe1 tiền");
                            return [
                                2
                            ];
                        }
                        if (val.price <= 0) {
                            NotifyUtils/* default.error */.Z.error("Gi\xe1 tiền phải lớn hơn 0");
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            sendDislikeFeedback((_tmp.productId = productId, _tmp.sku = sku, _tmp.feedbackContent = "Gi\xe1: ".concat((0,FormatNumber/* formatCurrency */.xG)(val.price), " \n Nguồn: ").concat(val.src || "kh\xf4ng đề cập"), _tmp))
                        ];
                    case 1:
                        isSendFeedback = _state.sent();
                        if (isSendFeedback) {
                            onClose();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Modal/* default */.Z, {
        open: visible,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).feedback_order,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).title,
                    children: "Gửi \xfd kiến đ\xf3ng g\xf3p"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    className: (style_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (style_module_default()).info_group,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                className: (style_module_default()).text_body,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h6",
                                    children: [
                                        "Xin ch\xe0o ",
                                        customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.name,
                                        "! Ch\xfang t\xf4i muốn lắng nghe g\xf3p \xfd từ bạn"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "space-evenly",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoFormControl/* default */.Z, {
                                    xs: 12,
                                    label: "Gi\xe1 thấp hơn s\xe0n thuocsi.vn",
                                    htmlFor: "price",
                                    isRequired: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoInput/* default */.Z, {
                                        id: "price",
                                        placeholder: "Nhập gi\xe1 (vnđ)",
                                        type: "number",
                                        value: val.price,
                                        onChange: function(e) {
                                            var ref;
                                            return handleChangeValue("price", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoFormControl/* default */.Z, {
                                    xs: 12,
                                    label: "Nguồn mua (nơi cung cấp hoặc đường dẫn sản phẩm)",
                                    htmlFor: "src",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoInput/* default */.Z, {
                                        id: "src",
                                        placeholder: "Nhập nguồn mua",
                                        value: val.src || "",
                                        onChange: function(e) {
                                            var ref;
                                            return handleChangeValue("src", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            className: (style_module_default()).textarea,
                            item: true,
                            container: true,
                            justifyContent: "center",
                            xs: 12,
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button/* default */.ZP, {
                                className: (0,clsx/* default */.Z)("payment_button", (style_module_default()).button),
                                onClick: handleSubmit,
                                children: "Gửi y\xeau cầu"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_FeedbackPriceFormModal = (FeedbackPriceFormModal);

;// CONCATENATED MODULE: ./src/components/mocules/ProductDetailAlertPriceAfterApplyVoucher/index.tsx


function ProductDetailAlertPriceAfterApplyVoucher(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text, _condition = param.condition, condition = _condition === void 0 ? false : _condition, _isProductDetail = param.isProductDetail, isProductDetail = _isProductDetail === void 0 ? false : _isProductDetail, style = param.style;
    if (!condition) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: (0,_object_spread/* default */.Z)({
            margin: !isProductDetail ? "8px 0" : 0,
            fontStyle: "italic",
            color: "#f5222d"
        }, style),
        children: text || ""
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./src/components-v2/atoms/LoadingBM/index.js
var LoadingBM = __webpack_require__(30274);
// EXTERNAL MODULE: ./src/components/mocules/PromotionDetailModal/styles.module.css
var PromotionDetailModal_styles_module = __webpack_require__(57770);
var PromotionDetailModal_styles_module_default = /*#__PURE__*/__webpack_require__.n(PromotionDetailModal_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/PromotionDetailModal/index.js













var PromotionDetailModal = /*#__PURE__*/ (0,react.memo)(function(param) {
    var onClose = param.onClose, visible = param.visible, className = param.className, restProps = param.restProps, title = param.title, _listsPromo = param.listsPromo, listsPromo = _listsPromo === void 0 ? [] : _listsPromo, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    // max 5 list promo
    // const maxPromoLists = listsPromo.slice(0, 5);
    var renderDescriptionPromo = function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: data
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        open: visible
    }, restProps), {
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: Backdrop/* default */.Z,
        BackdropProps: {
            timeout: 300
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
            in: visible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                className: (PromotionDetailModal_styles_module_default()).confirm_modal_wrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        className: (PromotionDetailModal_styles_module_default()).header,
                        style: {
                            background: "var(--primary-color)",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 0px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                style: {
                                    display: "flex",
                                    marginLeft: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        className: (PromotionDetailModal_styles_module_default()).wrapImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* VOUCHER_TITLE_BOX */.Uex, {})
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (PromotionDetailModal_styles_module_default()).modal_title,
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close/* default */.Z, {
                                className: (PromotionDetailModal_styles_module_default()).closeIcon,
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        className: (PromotionDetailModal_styles_module_default()).containerPromoDiablog,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            className: (PromotionDetailModal_styles_module_default()).wrapLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBM/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            className: (PromotionDetailModal_styles_module_default()).children,
                            children: listsPromo === null || listsPromo === void 0 ? void 0 : listsPromo.map(function(param) {
                                var _conditionDescription = param.conditionDescription, conditionDescription = _conditionDescription === void 0 ? "" : _conditionDescription, voucherId = param.voucherId;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: renderDescriptionPromo(conditionDescription)
                                }, voucherId);
                            })
                        })
                    })
                ]
            })
        })
    }));
});
/* harmony default export */ var mocules_PromotionDetailModal = (/*#__PURE__*/react.memo(PromotionDetailModal));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js
var Drawer = __webpack_require__(39636);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ErrorOutline.js
var icons_ErrorOutline = __webpack_require__(38740);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PlayCircleOutlineOutlined.js
var PlayCircleOutlineOutlined = __webpack_require__(51841);
// EXTERNAL MODULE: ./src/components/organisms/PromoCodesContainerV2/interface.ts
var PromoCodesContainerV2_interface = __webpack_require__(64683);
// EXTERNAL MODULE: ./src/constants/data/guideline/index.tsx + 2 modules
var guideline = __webpack_require__(87225);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(58769);
;// CONCATENATED MODULE: ./src/components/mocules/CountdownTimerVoucher/index.js







// thuannc
// TODO:
// MUST FIX
function CountdownTimerVoucher(_param) {
    var prefix = _param.prefix, dealEndDay = _param.dealEndDay, _typeSpace = _param.typeSpace, typeSpace = _typeSpace === void 0 ? " " : _typeSpace, _textExpired = _param.textExpired, textExpired = _textExpired === void 0 ? "Đ\xe3 hết hạn" : _textExpired, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "prefix",
        "dealEndDay",
        "typeSpace",
        "textExpired"
    ]);
    var ref = (0,react.useState)((0,calculateTimeLeft/* default */.ZP)(dealEndDay)), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setTimeLeft((0,calculateTimeLeft/* default */.ZP)(dealEndDay));
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    var timerComponents = [];
    Object.keys(timeLeft).forEach(function(interval) {
        var val = timeLeft[interval];
        if (!val) {
            return;
        }
        // 05Jan2022 -> nếu > 30 ngày thì set lại 30 ngày, dài quá bể UI
        timerComponents.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                val,
                interval === "days" ? " ng\xe0y".concat(typeSpace) : null
            ]
        }, "timer-".concat(Math.random())));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
            children: [
                prefix,
                (timerComponents === null || timerComponents === void 0 ? void 0 : timerComponents.length) ? "C\xf2n " : "",
                timerComponents.length ? timerComponents : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: textExpired
                })
            ]
        }))
    });
}
/* harmony default export */ var mocules_CountdownTimerVoucher = (CountdownTimerVoucher);

;// CONCATENATED MODULE: ./src/components/mocules/SlideCoupon/interface.ts
var ENUM_SECTION_PROMO;
(function(ENUM_SECTION_PROMO) {
    ENUM_SECTION_PROMO["MARKETPLACE"] = "MARKETPLACE";
    ENUM_SECTION_PROMO["SELLER"] = "SELLER";
})(ENUM_SECTION_PROMO || (ENUM_SECTION_PROMO = {}));

// EXTERNAL MODULE: ./src/components/mocules/SlideCoupon/styles.module.css
var SlideCoupon_styles_module = __webpack_require__(22957);
var SlideCoupon_styles_module_default = /*#__PURE__*/__webpack_require__.n(SlideCoupon_styles_module);
;// CONCATENATED MODULE: ./src/components/mocules/SlideCoupon/index.tsx












































var timerOut = 15000; // 15s
var SlideCoupon = function(param) {
    var coupons = param.coupons, _headLabel = param.headLabel, headLabel = _headLabel === void 0 ? "M\xe3 giảm gi\xe1 c\xf3 thể sử dụng" : _headLabel, _actionLabel = param.actionLabel, actionLabel = _actionLabel === void 0 ? "Xem tất cả" : _actionLabel, _actionIcon = param.actionIcon, actionIcon = _actionIcon === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutlineOutlined/* default */.Z, {}) : _actionIcon, sellerCode = param.sellerCode, sellerName = param.sellerName, sku = param.sku, skuName = param.skuName, vendorInfo = param.vendorInfo;
    var router = (0,next_router.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref = (0,react.useState)(false), isOpenDrawer = ref[0], setOpenDrawer = ref[1];
    var ref1 = (0,react.useState)(null), couponCollecting = ref1[0], setCouponCollecting = ref1[1];
    var ref2 = (0,react.useState)(0), triggerRefetchVouchers = ref2[0], setTriggerRefetchVouchers = ref2[1];
    var ref3 = (0,react.useState)(false), isDragging = ref3[0], setDragging = ref3[1];
    var ref4 = (0,react.useState)(false), isGuideTooltip = ref4[0], toggleGuidedTooltip = ref4[1]; // indicator check guide tooltip
    var ref5 = (0,react.useState)(true), isFirstLoading = ref5[0], setFirstLoading = ref5[1]; // indicator for first loading
    var ref6 = (0,react.useState)(null), firstEleOfAll = ref6[0], setFirstEleOfAll = ref6[1]; // first element of array
    // slider settings
    var settingCollectPromoCode = {
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: false,
        infinite: false,
        autoplay: false,
        beforeChange: function() {
            return setDragging(true);
        },
        afterChange: function() {
            return setDragging(false);
        }
    };
    var toggleDrawer = function() {
        // handle on Dragging make clicking to child
        if (!isDragging) {
            setOpenDrawer(!isOpenDrawer);
            if (!isOpenDrawer) {
                trackingClickCollectionVoucherSection();
            }
        }
    };
    var handleCollectVoucher = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var voucherCode, _isPopupCondition, isPopupCondition, respCollected, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        voucherCode = param.voucherCode, _isPopupCondition = param.isPopupCondition, isPopupCondition = _isPopupCondition === void 0 ? false : _isPopupCondition;
                        setCouponCollecting(voucherCode);
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* postCollectVoucher */.ky)((_tmp.voucherCode = voucherCode, _tmp.currentPage = router.asPath, _tmp.fullLink = window.location.host, _tmp.screen = (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname), _tmp.sku = sku, _tmp))
                        ];
                    case 1:
                        respCollected = _state.sent();
                        if (respCollected.status === "OK") {
                            setTriggerRefetchVouchers(function(prev) {
                                return prev + 1;
                            });
                            NotifyUtils/* default.success */.Z.success("Thu thập m\xe3 giảm gi\xe1 th\xe0nh c\xf4ng");
                            if (isPopupCondition) {
                                trackingClickCollectionVoucherButtonInDetailPopup(voucherCode);
                            } else {
                                trackingClickCollectionButton(voucherCode);
                            }
                        } else {
                            NotifyUtils/* default.error */.Z.error("Thu thập m\xe3 giảm gi\xe1 kh\xf4ng th\xe0nh c\xf4ng");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCollectVoucher(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseGuideTooltip = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, feature, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        feature = guideline/* GUIDE_FEATURE.COLLECTION_VOUCHER_GUIDE */.Z.COLLECTION_VOUCHER_GUIDE;
                        _tmp = {};
                        return [
                            4,
                            (0,CustomerClient/* postUserLogGuide */.n)((_tmp.feature = feature, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        toggleGuidedTooltip(false);
                        setFirstEleOfAll(null); // clear state first element when close guide
                        (ref = document.getElementById("marketPromoSection")) === null || ref === void 0 ? void 0 : ref.style.setProperty("overflow-y", "auto");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCloseGuideTooltip() {
            return _ref.apply(this, arguments);
        };
    }();
    // tracking click voucher ticket or button show full voucher collect list
    var trackingClickCollectionVoucherSection = function() {
        var metaData = {
            customerId: String(user === null || user === void 0 ? void 0 : user.customerID),
            skuCode: sku,
            skuName: skuName,
            sellerCode: sellerCode,
            sellerName: sellerName,
            source: "web-desktop",
            screen: (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname),
            description: "Click v\xe0o bất kỳ đ\xe2u của section voucher ở trang chi tiết sản phẩm"
        };
        MonitorUtils/* default.collectVoucherClickEvent */.ZP.collectVoucherClickEvent(MonitorUtils/* MONITORING_COLLECTOR_TYPE.CLICK_COLLECTION_VOUCHER_SECTION */.Hq.CLICK_COLLECTION_VOUCHER_SECTION, metaData);
    };
    // tracking button collect
    var trackingClickCollectionButton = function(voucherCode) {
        var metaData = {
            customerId: String(user === null || user === void 0 ? void 0 : user.customerID),
            voucherId: voucherCode,
            skuCode: sku,
            skuName: skuName,
            sellerCode: sellerCode,
            sellerName: sellerName,
            source: "web-desktop",
            screen: (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname),
            description: "Click v\xe0o n\xfat “Thu thập”"
        };
        MonitorUtils/* default.collectVoucherClickEvent */.ZP.collectVoucherClickEvent(MonitorUtils/* MONITORING_COLLECTOR_TYPE.CLICK_COLLECTION_BUTTON */.Hq.CLICK_COLLECTION_BUTTON, metaData);
    };
    // tracking button condition
    var trackingClickCollectionVoucherDetail = function(voucherCode) {
        var metaData = {
            customerId: String(user === null || user === void 0 ? void 0 : user.customerID),
            voucherId: voucherCode,
            skuCode: sku,
            skuName: skuName,
            sellerCode: sellerCode,
            sellerName: sellerName,
            source: "web-desktop",
            screen: (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname),
            description: "Click n\xfat “Điều kiện” của card voucher"
        };
        MonitorUtils/* default.collectVoucherClickEvent */.ZP.collectVoucherClickEvent(MonitorUtils/* MONITORING_COLLECTOR_TYPE.CLICK_COLLECTION_VOUCHER_DETAIL */.Hq.CLICK_COLLECTION_VOUCHER_DETAIL, metaData);
    };
    // tracking button collect in condition popup
    var trackingClickCollectionVoucherButtonInDetailPopup = function(voucherCode) {
        var metaData = {
            customerId: String(user === null || user === void 0 ? void 0 : user.customerID),
            voucherId: voucherCode,
            skuCode: sku,
            skuName: skuName,
            sellerCode: sellerCode,
            sellerName: sellerName,
            source: "web-desktop",
            screen: (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname),
            description: "Click n\xfat “Thu thập” trong popup điều kiện"
        };
        MonitorUtils/* default.collectVoucherClickEvent */.ZP.collectVoucherClickEvent(MonitorUtils/* MONITORING_COLLECTOR_TYPE.CLICK_COLLECTION_VOUCHER_BUTTON_IN_DETAIL_POPUP */.Hq.CLICK_COLLECTION_VOUCHER_BUTTON_IN_DETAIL_POPUP, metaData);
    };
    (0,react.useEffect)(function() {
        // TODO: check and show guide by tooltip
        var checkGuideVoucherCollection = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var respCheckGuideCollectVoucher, _tmp, dataCheckGuide, ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,CustomerClient/* getUserLogGuide */.Xd)((_tmp.q = {
                                    feature: guideline/* GUIDE_FEATURE.COLLECTION_VOUCHER_GUIDE */.Z.COLLECTION_VOUCHER_GUIDE
                                }, _tmp))
                            ];
                        case 1:
                            respCheckGuideCollectVoucher = _state.sent();
                            if ((respCheckGuideCollectVoucher === null || respCheckGuideCollectVoucher === void 0 ? void 0 : respCheckGuideCollectVoucher.status) === "OK") {
                                dataCheckGuide = (0,Clients/* getFirst */.Xi)(respCheckGuideCollectVoucher);
                                if ((dataCheckGuide === null || dataCheckGuide === void 0 ? void 0 : dataCheckGuide.isActive) && !(dataCheckGuide === null || dataCheckGuide === void 0 ? void 0 : dataCheckGuide.isGuided)) {
                                    ;
                                    toggleGuidedTooltip(true);
                                    (ref = document.getElementById("marketPromoSection")) === null || ref === void 0 ? void 0 : ref.style.setProperty("overflow-y", "hidden");
                                } else {
                                    toggleGuidedTooltip(false);
                                }
                            } else {
                                toggleGuidedTooltip(false);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkGuideVoucherCollection() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isOpenDrawer && !isFirstLoading) {
            setTimeout(function() {
                // handle asynchronous
                checkGuideVoucherCollection();
            }, 300);
        }
        if (!isOpenDrawer) {
            setFirstEleOfAll(null); // clear state first element when close drawer
        }
    }, [
        isOpenDrawer,
        isFirstLoading
    ]);
    (0,react.useEffect)(function() {
        // auto close guide tooltip after 3s
        if (isGuideTooltip) {
            setTimeout(function() {
                handleCloseGuideTooltip();
            }, timerOut);
        }
    }, [
        isGuideTooltip
    ]);
    if ((coupons === null || coupons === void 0 ? void 0 : coupons.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                minWidth: "28%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SlideCoupon_styles_module_default()).headLabel,
                    children: headLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                minWidth: "55%",
                className: (SlideCoupon_styles_module_default()).listCouponWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: (SlideCoupon_styles_module_default()).slider
                }, settingCollectPromoCode), {
                    children: coupons === null || coupons === void 0 ? void 0 : coupons.map(function(coupon, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponWithText, {
                            text: coupon.shortName,
                            toggleDrawer: toggleDrawer
                        }, coupon.code);
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                minWidth: "17%",
                marginLeft: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    className: (0,clsx/* default */.Z)((SlideCoupon_styles_module_default()).dFlex_spacing_4, (SlideCoupon_styles_module_default()).buttonAction),
                    onClick: toggleDrawer,
                    children: [
                        actionLabel,
                        " ",
                        actionIcon
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightDrawerListVoucher, {
                isOpen: isOpenDrawer,
                toggleDrawer: toggleDrawer,
                sellerCode: sellerCode,
                handleCollectVoucher: handleCollectVoucher,
                couponCollecting: couponCollecting,
                setCouponCollecting: setCouponCollecting,
                triggerRefetchVouchers: triggerRefetchVouchers,
                trackingClickCollectionVoucherDetail: trackingClickCollectionVoucherDetail,
                sku: sku,
                // guide tooltip
                isGuideTooltip: isGuideTooltip,
                handleCloseGuideTooltip: handleCloseGuideTooltip,
                isFirstLoading: isFirstLoading,
                setFirstLoading: setFirstLoading,
                firstEleOfAll: firstEleOfAll,
                setFirstEleOfAll: setFirstEleOfAll,
                vendorInfo: vendorInfo
            })
        ]
    });
};
/* harmony default export */ var mocules_SlideCoupon = (SlideCoupon);
var CouponWithText = function(param) {
    var text = param.text, toggleDrawer = param.toggleDrawer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
        disableRipple: true,
        onDragStart: function(e) {
            return e.preventDefault();
        },
        className: (SlideCoupon_styles_module_default()).couponWrapper,
        onClick: toggleDrawer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SlideCoupon_styles_module_default()).coupounPart_container,
            children: text
        })
    });
};
var RightDrawerListVoucher = function(param) {
    var isOpen = param.isOpen, toggleDrawer = param.toggleDrawer, sellerCode = param.sellerCode, handleCollectVoucher = param.handleCollectVoucher, couponCollecting = param.couponCollecting, setCouponCollecting = param.setCouponCollecting, triggerRefetchVouchers = param.triggerRefetchVouchers, trackingClickCollectionVoucherDetail = param.trackingClickCollectionVoucherDetail, sku = param.sku, _isGuideTooltip = param.isGuideTooltip, isGuideTooltip = _isGuideTooltip === void 0 ? false : _isGuideTooltip, handleCloseGuideTooltip = param.handleCloseGuideTooltip, isFirstLoading = param.isFirstLoading, setFirstLoading = param.setFirstLoading, firstEleOfAll = param.firstEleOfAll, setFirstEleOfAll = param.setFirstEleOfAll, vendorInfo = param.vendorInfo;
    var headerTitle = "M\xe3 giảm gi\xe1 c\xf3 thể sử dụng";
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var user = (0,Auth/* useAuth */.aC)().user;
    var isInitialMount = (0,react.useRef)(true);
    var mountRef = (0,react.useRef)(false);
    // seller promo
    var ref = (0,react.useState)(false), isSellerFetching = ref[0], setSellerFetching = ref[1]; // indicator for see more button
    var ref1 = (0,react.useState)([]), sellerPromoList = ref1[0], setSellerPromoList = ref1[1];
    var ref2 = (0,react.useState)([]), sellerPromoShowMore = ref2[0], setSellerPromoShowMore = ref2[1];
    var ref3 = (0,react.useState)(3), limitSellerPromo = ref3[0], setLimitSellerPromo = ref3[1];
    var ref4 = (0,react.useState)(0), totalSellerPromo = ref4[0], setTotalSellerPromo = ref4[1];
    // market promo
    var ref5 = (0,react.useState)(false), isMarketplaceFetching = ref5[0], setMarketFetching = ref5[1]; // indicator for see more button
    var ref6 = (0,react.useState)([]), marketplacePromoList = ref6[0], setMarketplacePromoList = ref6[1];
    var ref7 = (0,react.useState)([]), marketplacePromoShowMore = ref7[0], setMarketplacePromoShowMore = ref7[1];
    var ref8 = (0,react.useState)(3), limitMarketPromo = ref8[0], setLimitMarketPromo = ref8[1];
    var ref9 = (0,react.useState)(0), totalMarketPromo = ref9[0], setTotalMarketPromo = ref9[1];
    var ref10 = (0,PopupVoucher/* usePopupVoucherContext */.lj)(), isOpenCondition = ref10.open;
    // handle button see more voucher
    var handleFetchMore = function(type) {
        if (type === ENUM_SECTION_PROMO.SELLER) {
            setSellerFetching(true);
            // button hide
            if (limitSellerPromo >= totalSellerPromo) {
                var prevSellerPromo = sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.map(function(item) {
                    return item;
                }).splice(0, 3);
                setSellerPromoShowMore(prevSellerPromo);
                setLimitSellerPromo(3);
            // button show more
            } else {
                setSellerPromoShowMore(sellerPromoList);
                setLimitSellerPromo(sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length);
            }
            setSellerFetching(false);
        }
        if (type === ENUM_SECTION_PROMO.MARKETPLACE) {
            setMarketFetching(true);
            // button hide
            if (limitMarketPromo >= totalMarketPromo) {
                var prevSellerPromo1 = marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.map(function(item) {
                    return item;
                }).splice(0, 3);
                setMarketplacePromoShowMore(prevSellerPromo1);
                setLimitMarketPromo(3);
            // button show more
            } else {
                setMarketplacePromoShowMore(marketplacePromoList);
                setLimitMarketPromo(marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length);
            }
            setMarketFetching(false);
        }
    };
    (0,react.useEffect)(function() {
        function getVoucherList() {
            return _getVoucherList.apply(this, arguments);
        }
        function _getVoucherList() {
            _getVoucherList = (0,_async_to_generator/* default */.Z)(function() {
                var querySellerPromos, _tmp, ref, respMarketplacePromos, respSellerPromos, _tmp1, sellerPromos, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!mountRef.current) {
                                mountRef.current = true;
                            }
                            _tmp = {};
                            querySellerPromos = (_tmp.ctx = "", _tmp.accountID = user === null || user === void 0 ? void 0 : user.accountId, _tmp.scope = "seller", _tmp.sellerCode = sellerCode, _tmp.getVoucherToCollect = true, _tmp.skipVoucherCollected = false, _tmp.storeCode = "", _tmp.getMedxVoucherOnly = false, _tmp.getTotal = true, _tmp);
                            if (sellerCode === "MEDX" && (vendorInfo === null || vendorInfo === void 0 ? void 0 : vendorInfo.storeType) === "FLAGSHIP") {
                                querySellerPromos.sellerCode = "";
                                querySellerPromos.storeCode = vendorInfo.code;
                            } else if (sellerCode === "MEDX") {
                                querySellerPromos.getMedxVoucherOnly = true;
                            }
                            _tmp1 = {};
                            return [
                                4,
                                Promise.all([
                                    (0,PromoClient/* postVoucherList */.QC)((_tmp1.ctx = "", _tmp1.accountID = user === null || user === void 0 ? void 0 : user.accountId, _tmp1.scope = "marketplace", _tmp1.sellerCode = sellerCode, _tmp1.getVoucherToCollect = true, _tmp1.skipVoucherCollected = false, _tmp1.getTotal = true, _tmp1)),
                                    (0,PromoClient/* postVoucherList */.QC)(querySellerPromos)
                                ])
                            ];
                        case 1:
                            ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), respMarketplacePromos = ref[0], respSellerPromos = ref[1];
                            // check valid seller Promos
                            if ((0,Clients/* isValid */.JY)(respSellerPromos)) {
                                sellerPromos = (0,Clients/* getData */.Yu)(respSellerPromos);
                                setSellerPromoList(sellerPromos);
                                // TODO: if limitSellerPromo > 3, meaning list have expand, dont clear state
                                if (limitSellerPromo > 3) {
                                    ;
                                    setSellerPromoShowMore((ref1 = sellerPromos === null || sellerPromos === void 0 ? void 0 : sellerPromos.map(function(item) {
                                        return item;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.splice(0, limitSellerPromo));
                                } else {
                                    ;
                                    setSellerPromoShowMore((ref2 = sellerPromos === null || sellerPromos === void 0 ? void 0 : sellerPromos.map(function(item) {
                                        return item;
                                    })) === null || ref2 === void 0 ? void 0 : ref2.splice(0, 3));
                                }
                                setTotalSellerPromo((respSellerPromos === null || respSellerPromos === void 0 ? void 0 : respSellerPromos.total) || 0);
                                if (!firstEleOfAll) {
                                    ;
                                    setFirstEleOfAll(((ref3 = (0,Clients/* getData */.Yu)(respSellerPromos)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.code) || null);
                                }
                            } else {
                                setSellerPromoList([]);
                                setSellerPromoShowMore([]);
                                setTotalSellerPromo(0);
                            }
                            // check valid marketplace Promos
                            if ((0,Clients/* isValid */.JY)(respMarketplacePromos)) {
                                ;
                                setMarketplacePromoList((0,Clients/* getData */.Yu)(respMarketplacePromos));
                                // TODO: if limitMarketplacePromo > 3, meaning list have expand, dont clear state
                                if (limitMarketPromo > 3) {
                                    ;
                                    setMarketplacePromoShowMore((ref7 = (ref6 = (0,Clients/* getData */.Yu)(respMarketplacePromos)) === null || ref6 === void 0 ? void 0 : ref6.map(function(item) {
                                        return item;
                                    })) === null || ref7 === void 0 ? void 0 : ref7.splice(0, limitMarketPromo));
                                } else {
                                    ;
                                    setMarketplacePromoShowMore((ref9 = (ref8 = (0,Clients/* getData */.Yu)(respMarketplacePromos)) === null || ref8 === void 0 ? void 0 : ref8.map(function(item) {
                                        return item;
                                    })) === null || ref9 === void 0 ? void 0 : ref9.splice(0, 3));
                                }
                                setTotalMarketPromo((respMarketplacePromos === null || respMarketplacePromos === void 0 ? void 0 : respMarketplacePromos.total) || 0);
                                if (((ref5 = (0,Clients/* getData */.Yu)(respSellerPromos)) === null || ref5 === void 0 ? void 0 : ref5.length) === 0) {
                                    ;
                                    setFirstEleOfAll(((ref10 = (0,Clients/* getData */.Yu)(respMarketplacePromos)) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.code) || null);
                                }
                            } else {
                                setMarketplacePromoList([]);
                                setMarketplacePromoShowMore([]);
                                setTotalMarketPromo(0);
                            }
                            setFirstLoading(false);
                            // clear coupon collecting state
                            setCouponCollecting(null);
                            return [
                                2
                            ];
                    }
                });
            });
            return _getVoucherList.apply(this, arguments);
        }
        if (!isInitialMount.current && isOpen) {
            getVoucherList();
        } else {
            isInitialMount.current = false;
        }
    }, [
        isOpen,
        triggerRefetchVouchers
    ]);
    (0,react.useEffect)(function() {
        if (!isOpen) {
            // clear state show more
            setLimitSellerPromo(3);
            setTotalSellerPromo(0);
            setLimitMarketPromo(3);
            setTotalMarketPromo(0);
            // check if on Guiding, guided tooltip when close drawer
            if (isGuideTooltip) {
                handleCloseGuideTooltip();
            }
        }
    }, [
        isOpen,
        isGuideTooltip
    ]);
    // TODO: if one of both section not available, will expand all another section
    var isMarketplaceExpandAll = (sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length) === 0;
    var marketplaceVoucherList = isMarketplaceExpandAll ? marketplacePromoList : marketplacePromoShowMore;
    var isSellerExpandAll = (marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length) === 0;
    var sellerVoucherList = isSellerExpandAll ? sellerPromoList : sellerPromoShowMore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        anchor: "right",
        open: isOpen,
        onClose: toggleDrawer,
        PaperProps: {
            style: {
                width: "30%",
                minWidth: 436,
                display: isOpenCondition ? "none" : "flex"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDrawer, {
                title: headerTitle,
                toggleDrawer: toggleDrawer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SlideCoupon_styles_module_default()).couponListWrapper,
                id: "marketPromoSection",
                children: isFirstLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    className: (SlideCoupon_styles_module_default()).loadLogo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBM/* default */.Z, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)((SlideCoupon_styles_module_default()).couponList, (marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length) <= 0 && (sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length) <= 0 ? (SlideCoupon_styles_module_default()).unScrollY : null),
                    id: "sellerSectionPromoList",
                    children: [
                        (sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length) === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SlideCoupon_styles_module_default()).sectionVoucher_sticky,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (SlideCoupon_styles_module_default()).sectionVoucher_title,
                                children: "M\xe3 giảm gi\xe1 từ nh\xe0 b\xe1n h\xe0ng"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            className: (0,clsx/* default */.Z)((SlideCoupon_styles_module_default()).voucherList_container, (sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length) === 0 ? (SlideCoupon_styles_module_default()).displayNone : null),
                            children: sellerVoucherList === null || sellerVoucherList === void 0 ? void 0 : sellerVoucherList.map(function(coupon, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    className: (SlideCoupon_styles_module_default()).coupon_card_grid,
                                    item: true,
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerVoucherTicket, {
                                        coupon: coupon,
                                        voucherSource: ENUM_SECTION_PROMO.SELLER,
                                        handleCollectVoucher: handleCollectVoucher,
                                        couponCollecting: couponCollecting,
                                        trackingClickCollectionVoucherDetail: trackingClickCollectionVoucherDetail,
                                        isGuideTooltip: isGuideTooltip,
                                        firstEleOfAll: firstEleOfAll,
                                        handleCloseGuideTooltip: handleCloseGuideTooltip
                                    }, coupon === null || coupon === void 0 ? void 0 : coupon.code)
                                }, coupon === null || coupon === void 0 ? void 0 : coupon.code);
                            })
                        }),
                        !isSellerExpandAll && (sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length) > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SlideCoupon_styles_module_default()).buttonCollapse,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeeMoreBtn, {
                                type: ENUM_SECTION_PROMO.SELLER,
                                handleFetchMore: function() {
                                    return handleFetchMore(ENUM_SECTION_PROMO.SELLER);
                                },
                                isFetching: isSellerFetching,
                                isReverse: limitSellerPromo >= totalSellerPromo
                            })
                        }) : null,
                        (marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length) > 0 && (sellerPromoList === null || sellerPromoList === void 0 ? void 0 : sellerPromoList.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SlideCoupon_styles_module_default()).newDivider
                        }) : null,
                        (marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx/* default */.Z)((SlideCoupon_styles_module_default()).counpon_list),
                            id: "marketSectionPromoList",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SlideCoupon_styles_module_default()).sectionVoucher_sticky,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (SlideCoupon_styles_module_default()).sectionVoucher_title,
                                        children: "M\xe3 giảm gi\xe1 từ Buymed"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    container: true,
                                    className: (0,clsx/* default */.Z)((SlideCoupon_styles_module_default()).voucherList_container, (marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length) === 0 ? (SlideCoupon_styles_module_default()).displayNone : null),
                                    children: marketplaceVoucherList === null || marketplaceVoucherList === void 0 ? void 0 : marketplaceVoucherList.map(function(coupon) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: "100%",
                                            marginBottom: "12px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                className: (SlideCoupon_styles_module_default()).coupon_card_grid,
                                                item: true,
                                                style: {
                                                    width: "100%"
                                                },
                                                "data-test": "modal-item-promo",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerVoucherTicket, {
                                                    coupon: coupon,
                                                    voucherSource: ENUM_SECTION_PROMO.MARKETPLACE,
                                                    handleCollectVoucher: handleCollectVoucher,
                                                    couponCollecting: couponCollecting,
                                                    trackingClickCollectionVoucherDetail: trackingClickCollectionVoucherDetail,
                                                    isGuideTooltip: isGuideTooltip,
                                                    firstEleOfAll: firstEleOfAll,
                                                    handleCloseGuideTooltip: handleCloseGuideTooltip
                                                }, coupon === null || coupon === void 0 ? void 0 : coupon.code)
                                            }, coupon === null || coupon === void 0 ? void 0 : coupon.code)
                                        }, coupon === null || coupon === void 0 ? void 0 : coupon.code);
                                    })
                                }),
                                !isMarketplaceExpandAll && (marketplacePromoList === null || marketplacePromoList === void 0 ? void 0 : marketplacePromoList.length) > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SlideCoupon_styles_module_default()).buttonCollapse,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeeMoreBtn, {
                                        type: ENUM_SECTION_PROMO.MARKETPLACE,
                                        handleFetchMore: function() {
                                            return handleFetchMore(ENUM_SECTION_PROMO.MARKETPLACE);
                                        },
                                        isFetching: isMarketplaceFetching,
                                        isReverse: limitMarketPromo >= totalMarketPromo
                                    })
                                }) : null
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
};
// voucher ticket inside drawer
var DrawerVoucherTicket = function(param) {
    var coupon = param.coupon, voucherSource = param.voucherSource, handleCollectVoucher = param.handleCollectVoucher, couponCollecting = param.couponCollecting, trackingClickCollectionVoucherDetail = param.trackingClickCollectionVoucherDetail, _isGuideTooltip = param.isGuideTooltip, isGuideTooltip = _isGuideTooltip === void 0 ? false : _isGuideTooltip, firstEleOfAll = param.firstEleOfAll, handleCloseGuideTooltip = param.handleCloseGuideTooltip;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ref = coupon || {}, endTime = ref.endTime, _code = ref.code, code = _code === void 0 ? "" : _code, collectStatus = ref.collectStatus;
    var handleOpen = (0,PopupVoucher/* usePopupVoucherContext */.lj)().handleOpen;
    var checkTimeCountDown = function() {
        var threeDay = new Date().getTime() + 3 * 24 * 60 * 60 * 1000;
        var endTimeVoucher = new Date(endTime).getTime();
        return endTime && threeDay > endTimeVoucher ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            style: {
                color: "#D4323B"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CountdownTimerVoucher, {
                prefix: "",
                dealEndDay: endTime,
                style: {
                    display: "inline-block"
                },
                typeSpace: ", "
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "HSD: ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: DateTimeUtils/* default.getFormattedWithDate */.ZP.getFormattedWithDate(new Date(endTime), "DD/MM/YYYY")
                })
            ]
        });
    };
    var handleOpenVoucher = function() {
        handleOpen(coupon.code);
        trackingClickCollectionVoucherDetail(code);
    };
    if (voucherSource === ENUM_SECTION_PROMO.MARKETPLACE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (SlideCoupon_styles_module_default()).voucherTicket_container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SlideCoupon_styles_module_default()).voucherTicketMissingPart_topMarketplace
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    className: (SlideCoupon_styles_module_default()).voucherTicket_childContainerMarketplace,
                    style: {
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            md: 8,
                            className: (SlideCoupon_styles_module_default()).voucherTicket_leftContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SlideCoupon_styles_module_default()).voucherTicket_nameMarketplace,
                                            children: coupon.shortName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SlideCoupon_styles_module_default()).content_2Line,
                                            dangerouslySetInnerHTML: {
                                                __html: coupon === null || coupon === void 0 ? void 0 : coupon.description
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: (SlideCoupon_styles_module_default()).labelExpiredDate,
                                            children: checkTimeCountDown()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                            className: (SlideCoupon_styles_module_default()).buttonCondition,
                                            onClick: handleOpenVoucher,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ErrorOutline/* default */.Z, {
                                                    style: {
                                                        width: "20px",
                                                        height: "20px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    className: (SlideCoupon_styles_module_default()).labelCondition,
                                                    children: "Điều kiện"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SlideCoupon_styles_module_default()).verticalDivider
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            md: 4,
                            className: (SlideCoupon_styles_module_default()).buttonCollectWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCollect, {
                                couponCode: coupon === null || coupon === void 0 ? void 0 : coupon.code,
                                couponCollecting: couponCollecting,
                                handleCollectVoucher: handleCollectVoucher,
                                collectStatus: collectStatus,
                                voucherSource: ENUM_SECTION_PROMO.MARKETPLACE,
                                isGuideTooltip: isGuideTooltip,
                                firstEleOfAll: firstEleOfAll,
                                handleCloseGuideTooltip: handleCloseGuideTooltip
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SlideCoupon_styles_module_default()).voucherTicketMissingPart_bottomMarketplace
                })
            ]
        });
    }
    // voucher Seller
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (SlideCoupon_styles_module_default()).voucherTicket_container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SlideCoupon_styles_module_default()).voucherTicketMissingPart_top
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                className: (SlideCoupon_styles_module_default()).voucherTicket_childContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        md: 8,
                        className: (SlideCoupon_styles_module_default()).voucherTicket_leftContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SlideCoupon_styles_module_default()).voucherTicket_name,
                                        children: coupon.shortName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SlideCoupon_styles_module_default()).content_2Line,
                                        dangerouslySetInnerHTML: {
                                            __html: coupon === null || coupon === void 0 ? void 0 : coupon.description
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (SlideCoupon_styles_module_default()).labelExpiredDate,
                                        children: checkTimeCountDown()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        className: (SlideCoupon_styles_module_default()).buttonCondition,
                                        onClick: handleOpenVoucher,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ErrorOutline/* default */.Z, {
                                                style: {
                                                    width: "20px",
                                                    height: "20px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                className: (SlideCoupon_styles_module_default()).labelCondition,
                                                children: "Điều kiện"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SlideCoupon_styles_module_default()).verticalDivider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 4,
                        className: (SlideCoupon_styles_module_default()).buttonCollectWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCollect, {
                            couponCode: coupon === null || coupon === void 0 ? void 0 : coupon.code,
                            couponCollecting: couponCollecting,
                            handleCollectVoucher: handleCollectVoucher,
                            collectStatus: collectStatus,
                            voucherSource: ENUM_SECTION_PROMO.SELLER,
                            isGuideTooltip: isGuideTooltip,
                            firstEleOfAll: firstEleOfAll,
                            handleCloseGuideTooltip: handleCloseGuideTooltip
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SlideCoupon_styles_module_default()).voucherTicketMissingPart_bottom
            })
        ]
    });
};
// Button expand/collapse voucher list
var SeeMoreBtn = function(param) {
    var isFetching = param.isFetching, handleFetchMore = param.handleFetchMore, type = param.type, _isReverse = param.isReverse, isReverse = _isReverse === void 0 ? false : _isReverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: (SlideCoupon_styles_module_default()).btnSeeMoreItem,
        onClick: function() {
            return handleFetchMore(type);
        },
        children: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
            color: "primary",
            size: 24
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isReverse ? "Ẩn" : "Xem th\xeam",
                " ",
                isReverse ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {
                    style: {
                        width: 24,
                        height: 24
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                    style: {
                        width: 24,
                        height: 24
                    }
                })
            ]
        })
    });
};
// Drawer Head title
var HeaderDrawer = function(param) {
    var title = param.title, toggleDrawer = param.toggleDrawer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        minWidth: 436,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SlideCoupon_styles_module_default()).drawerHeadTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: toggleDrawer,
                        style: {
                            padding: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close/* default */.Z, {
                            style: {
                                width: 20,
                                height: 20,
                                strokeWidth: 1,
                                stroke: "#797979"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};
var ButtonCollect = function(param) {
    var voucherSource = param.voucherSource, collectStatus = param.collectStatus, handleCollectVoucher = param.handleCollectVoucher, couponCollecting = param.couponCollecting, couponCode = param.couponCode, _isGuideTooltip = param.isGuideTooltip, isGuideTooltip = _isGuideTooltip === void 0 ? false : _isGuideTooltip, handleCloseGuideTooltip = param.handleCloseGuideTooltip, firstEleOfAll = param.firstEleOfAll;
    var contentGuideTooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        fontSize: "14px",
        gridGap: "8px",
        lineHeight: "18px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Bấm Thu thập để lấy m\xe3 giảm gi\xe1 n\xe0y. "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Sau khi thu thập, m\xe3 sẽ được lưu tại trang m\xe3 giảm gi\xe1 để bạn tiện theo d\xf5i v\xe0 sử dụng."
            })
        ]
    });
    if (isGuideTooltip) {
        if (firstEleOfAll === couponCode && voucherSource === ENUM_SECTION_PROMO.SELLER) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                onClickAway: handleCloseGuideTooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                    open: isGuideTooltip,
                    title: contentGuideTooltip,
                    arrow: true,
                    classes: {
                        tooltip: (SlideCoupon_styles_module_default()).tooltipGuide
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: collectStatus === PromoCodesContainerV2_interface/* ENUM_VOUCHER_COLLECTION_STATUS.COLLECTED */.ZR.COLLECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            gap: "4px",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: Images/* COLLECT_VOUCHER_COLLECTED_BLUE */.UBK,
                                    width: 14,
                                    height: 14,
                                    alt: "voucher seller collected"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SlideCoupon_styles_module_default()).textCollectedSeller,
                                    children: "Đ\xe3 thu thập"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: (SlideCoupon_styles_module_default()).sellerButtonCollect,
                            onClick: function() {
                                return handleCollectVoucher({
                                    voucherCode: couponCode,
                                    isPopupCondition: false
                                });
                            },
                            disabled: couponCollecting !== null,
                            children: couponCollecting === couponCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 16,
                                className: (SlideCoupon_styles_module_default()).whiteProgressColor
                            }) : "Thu thập"
                        })
                    })
                })
            });
        }
        if (firstEleOfAll === couponCode && voucherSource === ENUM_SECTION_PROMO.MARKETPLACE) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                onClickAway: handleCloseGuideTooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                    open: isGuideTooltip,
                    title: contentGuideTooltip,
                    arrow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: collectStatus === PromoCodesContainerV2_interface/* ENUM_VOUCHER_COLLECTION_STATUS.COLLECTED */.ZR.COLLECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            gap: "4px",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: Images/* COLLECT_VOUCHER_COLLECTED_GREEN */.KDU,
                                    width: 14,
                                    height: 14,
                                    alt: "voucher market collected"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SlideCoupon_styles_module_default()).textCollectedMarketplace,
                                    children: "Đ\xe3 thu thập"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: (SlideCoupon_styles_module_default()).marketplaceButtonCollect,
                            onClick: function() {
                                return handleCollectVoucher({
                                    voucherCode: couponCode,
                                    isPopupCondition: false
                                });
                            },
                            disabled: couponCollecting !== null,
                            children: couponCollecting === couponCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 16,
                                className: (SlideCoupon_styles_module_default()).whiteProgressColor
                            }) : "Thu thập"
                        })
                    })
                })
            });
        }
    }
    if (collectStatus === PromoCodesContainerV2_interface/* ENUM_VOUCHER_COLLECTION_STATUS.OWNERSHIP */.ZR.OWNERSHIP) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        src: Images/* COLLECT_VOUCHER_COLLECTED_GREY */.Woz,
                        width: 14,
                        height: 14,
                        alt: "voucher owner"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SlideCoupon_styles_module_default()).textOwnerVoucher,
                        children: "Đ\xe3 sở hữu"
                    })
                ]
            })
        });
    }
    if (voucherSource === ENUM_SECTION_PROMO.MARKETPLACE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: collectStatus === PromoCodesContainerV2_interface/* ENUM_VOUCHER_COLLECTION_STATUS.COLLECTED */.ZR.COLLECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        src: Images/* COLLECT_VOUCHER_COLLECTED_GREEN */.KDU,
                        width: 14,
                        height: 14,
                        alt: "voucher market collected"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SlideCoupon_styles_module_default()).textCollectedMarketplace,
                        children: "Đ\xe3 thu thập"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (SlideCoupon_styles_module_default()).marketplaceButtonCollect,
                onClick: function() {
                    return handleCollectVoucher({
                        voucherCode: couponCode,
                        isPopupCondition: false
                    });
                },
                disabled: couponCollecting !== null,
                children: couponCollecting === couponCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    size: 16,
                    className: (SlideCoupon_styles_module_default()).whiteProgressColor
                }) : "Thu thập"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: collectStatus === PromoCodesContainerV2_interface/* ENUM_VOUCHER_COLLECTION_STATUS.COLLECTED */.ZR.COLLECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            gap: "4px",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                    src: Images/* COLLECT_VOUCHER_COLLECTED_BLUE */.UBK,
                    width: 14,
                    height: 14,
                    alt: "voucher seller collected"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SlideCoupon_styles_module_default()).textCollectedSeller,
                    children: "Đ\xe3 thu thập"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (SlideCoupon_styles_module_default()).sellerButtonCollect,
            onClick: function() {
                return handleCollectVoucher({
                    voucherCode: couponCode,
                    isPopupCondition: false
                });
            },
            disabled: couponCollecting !== null,
            children: couponCollecting === couponCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 16,
                className: (SlideCoupon_styles_module_default()).whiteProgressColor
            }) : "Thu thập"
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/ProductDetailLoading/index.js
var ProductDetailLoading = __webpack_require__(94134);
// EXTERNAL MODULE: ./src/constants/tracking/index.ts + 1 modules
var tracking = __webpack_require__(27429);
// EXTERNAL MODULE: ./src/context/Settings/index.js
var Settings = __webpack_require__(48854);
// EXTERNAL MODULE: ./src/hooks/useCategories.js
var useCategories = __webpack_require__(95102);
// EXTERNAL MODULE: ./src/hooks/useManufacturers.js + 1 modules
var useManufacturers = __webpack_require__(61533);
// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./src/services/CustomerService.js
var CustomerService = __webpack_require__(29455);
// EXTERNAL MODULE: ./src/services/ProductService.js
var ProductService = __webpack_require__(82681);
// EXTERNAL MODULE: ./src/hooks/useIsKcbVerified.js
var useIsKcbVerified = __webpack_require__(7501);
// EXTERNAL MODULE: ./src/zustand-lib/useCategoryFilterTree.js
var useCategoryFilterTree = __webpack_require__(34831);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/detail-product-new/ModalViewMore/styles.module.css
var ModalViewMore_styles_module = __webpack_require__(36178);
var ModalViewMore_styles_module_default = /*#__PURE__*/__webpack_require__.n(ModalViewMore_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/ModalViewMore/index.js


















var ModalViewMore = function(param) {
    var product = param.product, imagesProxy = param.imagesProxy, messageLimitOrder = param.messageLimitOrder, openModal = param.openModal, closeModal = param.closeModal, productType = param.productType, monthYear = param.monthYear, name = param.name, volume = param.volume, displayPriceFormated = param.displayPriceFormated, salePriceFormated = param.salePriceFormated, discountPercent = param.discountPercent, productsSame = param.productsSame, sellerInfo = param.sellerInfo, campaign = param.campaign, deal = param.deal;
    var score = zustand_lib_useCartQuantity(function(state) {
        return state;
    }).score;
    if (!openModal) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: openModal,
        onClose: closeModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((ModalViewMore_styles_module_default()).modalContainer, openModal && (ModalViewMore_styles_module_default()).show),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                    onClick: function() {
                        return closeModal();
                    },
                    className: (ModalViewMore_styles_module_default()) === null || (ModalViewMore_styles_module_default()) === void 0 ? void 0 : (ModalViewMore_styles_module_default()).buttonModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {}),
                        " Đ\xf3ng"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    className: (ModalViewMore_styles_module_default()).modalWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CardImage, {
                                img: imagesProxy[0],
                                hiddenIconAndText: true,
                                hasModal: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            xs: 8,
                            className: (ModalViewMore_styles_module_default()).rightContent,
                            children: [
                                productType !== "NORMAL" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_HotInfo, {
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_PromoType, {
                                        productType: campaign === null || campaign === void 0 ? void 0 : campaign.campaign,
                                        monthYear: monthYear
                                    }),
                                    productType: productType,
                                    campaign: campaign,
                                    deal: deal
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: (ModalViewMore_styles_module_default()).typographyTitle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagshipLabel, {
                                                    isVip: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isVip,
                                                    isStore: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isStore,
                                                    productTags: product === null || product === void 0 ? void 0 : product.tags
                                                }),
                                                (product === null || product === void 0 ? void 0 : product.isTagGift) && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_TagGiftComp, {}),
                                                " ",
                                                name || "",
                                                name || ""
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: (ModalViewMore_styles_module_default()).typographyRight,
                                            children: [
                                                " ",
                                                volume || ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ModalViewMore_styles_module_default()).rowPrice,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ModalViewMore_styles_module_default()).priceInfo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: (ModalViewMore_styles_module_default()).price,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                    displayPriceFormated: displayPriceFormated,
                                                    fillPath: "#0C884E"
                                                }) || 0
                                            }),
                                            discountPercent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (ModalViewMore_styles_module_default()).originalPrice,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                            displayPriceFormated: salePriceFormated || 0,
                                                            size: "sm",
                                                            fillPath: "#8D8D8D",
                                                            line: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (ModalViewMore_styles_module_default()).discountPercent,
                                                        children: [
                                                            " -",
                                                            discountPercent,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ModalViewMore_styles_module_default()).hightLightTag,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                        product: {
                                            tags: product.tags,
                                            statusData: product.statusData,
                                            expiredDate: product.expiredDate
                                        },
                                        isProductCard: false,
                                        isSellerList: false,
                                        isPageDetail: true,
                                        isLinkTagDeal: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ModalViewMore_styles_module_default()).quantityModal,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ModalViewMore_styles_module_default()).canBuyAndScore,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    className: (ModalViewMore_styles_module_default()).typography,
                                                    children: [
                                                        " ",
                                                        messageLimitOrder || ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    className: (ModalViewMore_styles_module_default()).score,
                                                    children: [
                                                        " ",
                                                        score !== "0" ? "".concat(score, " điểm") : "",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControl, {
                                            product: product
                                        })
                                    ]
                                })
                            ]
                        }),
                        (productsSame === null || productsSame === void 0 ? void 0 : productsSame.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        className: (ModalViewMore_styles_module_default()).sameSeller,
                                        children: [
                                            " ",
                                            productsSame === null || productsSame === void 0 ? void 0 : productsSame.length,
                                            " nh\xe0 b\xe1n h\xe0ng c\xf9ng sản phẩm"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AnotherSeller, {
                                        products: productsSame,
                                        productCompare: product,
                                        isModal: true
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var detail_product_new_ModalViewMore = (ModalViewMore);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/hooks/useOnceInViewport.js
var useOnceInViewport = __webpack_require__(29720);
// EXTERNAL MODULE: ./src/utils/TrackingHelpers.js
var TrackingHelpers = __webpack_require__(2288);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/detail-product-new/ReplaceProduct/styles.module.css
var ReplaceProduct_styles_module = __webpack_require__(2328);
var ReplaceProduct_styles_module_default = /*#__PURE__*/__webpack_require__.n(ReplaceProduct_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/ReplaceProduct/index.js
























var ItemProduct = function(param) {
    var product = param.product, slug = param.slug, imageUrl = param.imageUrl, name = param.name, displayPriceFormated = param.displayPriceFormated, volume = param.volume, sku = param.sku, sellerId = param.sellerId, productId = param.productId, status = param.status, productParent = param.productParent;
    var ref = product || {}, _salePriceFormated = ref.salePriceFormated, salePriceFormated = _salePriceFormated === void 0 ? "" : _salePriceFormated, _discountPercent = ref.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, consumedMaxQuantity = ref.consumedMaxQuantity, unit = ref.unit, sellerName = ref.sellerName, sellerUrl = ref.sellerUrl;
    var isMaxBuy = (consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityConsumed) === 0 && (consumedMaxQuantity === null || consumedMaxQuantity === void 0 ? void 0 : consumedMaxQuantity.maxQuantityType) === "PER_DAY";
    var ref1 = (0,useTrackingMonitorSubstituteProduct/* default */.Z)(), trackingMonitorSubstituteClickDetail = ref1.trackingMonitorSubstituteClickDetail, trackingMonitorSubstituteAddToCart = ref1.trackingMonitorSubstituteAddToCart, trackingMonitorSubstituteMainSKUImpression = ref1.trackingMonitorSubstituteMainSKUImpression;
    var router = (0,next_router.useRouter)();
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref2 = router.query || {}, sellerIdMainSKU = ref2.sellerIdMainSKU, productIdMainSKU = ref2.productIdMainSKU, mainSKU = ref2.mainSKU, mainType = ref2.mainType;
    var handleClickDetailTracking = function() {
        gtag/* default.substituteClickDetail */.ZP.substituteClickDetail({
            screen: "Product Detail",
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            sku: sku,
            sellerId: sellerId,
            productId: productId,
            mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)((productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType)
        });
        trackingMonitorSubstituteClickDetail({
            sku: sku,
            sellerId: sellerId,
            productId: productId,
            type: status === "NORMAL" ? "Instock" : status,
            pathname: router.pathname,
            sellerIdMainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sellerID) || sellerIdMainSKU,
            productIdMainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.productId) || productIdMainSKU,
            mainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sku) || mainSKU,
            mainType: (productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType
        });
    };
    // Event "Add substitute product to cart": bấm Add to Cart / nhập số lượng trên card
    var handleAddToCartTracking = function() {
        gtag/* default.substituteClickAddToCart */.ZP.substituteClickAddToCart({
            screen: "Product Detail",
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            sku: sku,
            sellerId: sellerId,
            productId: productId,
            mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)((productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType)
        });
        trackingMonitorSubstituteAddToCart({
            sku: sku,
            sellerId: sellerId,
            productId: productId,
            type: status === "NORMAL" ? "Instock" : status,
            pathname: router.pathname,
            sellerIdMainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sellerID) || sellerIdMainSKU,
            productIdMainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.productId) || productIdMainSKU,
            mainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sku) || mainSKU,
            mainType: (productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType
        });
    };
    // Event "Search result having substitute product impression": card hiện >= 50% viewport (spec MKT)
    var impressionRef = (0,useOnceInViewport/* default */.Z)(function() {
        var ref, ref1;
        gtag/* default.substituteSearchResult */.ZP.substituteSearchResult({
            screen: "Product Detail",
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)((productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType),
            sku: sku,
            sellerId: sellerId,
            productId: productId
        });
        trackingMonitorSubstituteMainSKUImpression({
            sku: sku,
            sellerCode: "",
            productId: (productId === null || productId === void 0 ? void 0 : productId.toString()) || "",
            type: status === "NORMAL" ? "Instock" : status,
            pathname: router.pathname,
            sellerIdMainSKU: ((ref = (productParent === null || productParent === void 0 ? void 0 : productParent.sellerID) || sellerIdMainSKU) === null || ref === void 0 ? void 0 : ref.toString()) || "",
            productIdMainSKU: ((ref1 = (productParent === null || productParent === void 0 ? void 0 : productParent.productId) || productIdMainSKU) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "",
            mainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sku) || mainSKU || "",
            mainType: (productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType || "NORMAL"
        });
    });
    var linkHref = "".concat((0,Paths/* getPathProductBySlug */.hq)(slug), "?isSKUReplace=true&sellerIdMainSKU=").concat((productParent === null || productParent === void 0 ? void 0 : productParent.sellerID) || sellerIdMainSKU, "&productIdMainSKU=").concat((productParent === null || productParent === void 0 ? void 0 : productParent.productId) || productIdMainSKU, "&mainSKU=").concat((productParent === null || productParent === void 0 ? void 0 : productParent.sku) || mainSKU, "&mainType=").concat((productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType || "NORMAL");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ReplaceProduct_styles_module_default()).cardContainer,
        ref: impressionRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReplaceProduct_styles_module_default()).itemFlex,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        href: linkHref,
                        prefetch: false,
                        padding: "0px",
                        className: null,
                        name: null,
                        onMouseOver: null,
                        target: null,
                        onClick: handleClickDetailTracking,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                            src: imageUrl,
                            alt: name,
                            width: 100,
                            height: 100,
                            title: name && name,
                            className: (ReplaceProduct_styles_module_default()).image,
                            size: "thumbnail",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReplaceProduct_styles_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                href: linkHref,
                                prefetch: false,
                                padding: "0px",
                                className: null,
                                name: null,
                                onMouseOver: null,
                                target: null,
                                onClick: handleClickDetailTracking,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (ReplaceProduct_styles_module_default()).name,
                                    children: name !== null && name !== void 0 ? name : ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ReplaceProduct_styles_module_default()).volume,
                                children: volume
                            }),
                            sellerName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (ReplaceProduct_styles_module_default()).sellerName,
                                href: sellerUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                children: sellerName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ReplaceProduct_styles_module_default()).priceRow,
                                children: [
                                    displayPriceFormated && /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                        displayPriceFormated: displayPriceFormated,
                                        size: "lg",
                                        textLeft: true
                                    }),
                                    discountPercent > 0 && !!salePriceFormated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                displayPriceFormated: salePriceFormated,
                                                fillPath: "#333",
                                                size: "xs",
                                                line: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                className: (ReplaceProduct_styles_module_default()).cardChip,
                                                label: "-".concat(discountPercent, "%"),
                                                size: "small"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReplaceProduct_styles_module_default()).actionCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLimitMessage/* default */.Z, {
                        consumedMaxQuantity: consumedMaxQuantity,
                        unit: unit,
                        page: "products",
                        className: (ReplaceProduct_styles_module_default()).limitMessage,
                        isNewCard: true
                    }),
                    !isMaxBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlTable/* default */.Z, {
                        product: product,
                        newCard: true,
                        consultVariant: ConsultSpecialProductBtn/* VARIANT_LIST.LIST_HORIZONTAL */.C.LIST_HORIZONTAL,
                        onAdd: handleAddToCartTracking,
                        onChange: handleAddToCartTracking
                    })
                ]
            })
        ]
    });
};
var ReplaceProduct = function(param) {
    var _productReplace = param.productReplace, productReplace = _productReplace === void 0 ? {} : _productReplace, _isShowViewMore = param.isShowViewMore, isShowViewMore = _isShowViewMore === void 0 ? false : _isShowViewMore, slugCurrent = param.slugCurrent, _showGuide = param.showGuide, showGuide = _showGuide === void 0 ? false : _showGuide, _productParent = param.productParent, productParent = _productParent === void 0 ? {} : _productParent;
    var _slug = productReplace.slug, slug = _slug === void 0 ? "" : _slug, _defaultImage = productReplace.defaultImage, defaultImage = _defaultImage === void 0 ? "" : _defaultImage, _name = productReplace.name, name = _name === void 0 ? "" : _name, _displayPriceFormated = productReplace.displayPriceFormated, displayPriceFormated = _displayPriceFormated === void 0 ? "" : _displayPriceFormated, _volume = productReplace.volume, volume = _volume === void 0 ? "" : _volume, sellerInfo = productReplace.sellerInfo, productId = productReplace.productId, sku = productReplace.sku, status = productReplace.status;
    var router = (0,next_router.useRouter)();
    var ref = router.query || {}, sellerIdMainSKU = ref.sellerIdMainSKU, productIdMainSKU = ref.productIdMainSKU, mainSKU = ref.mainSKU, mainType = ref.mainType;
    var trackingMonitorSubstituteClickMore = (0,useTrackingMonitorSubstituteProduct/* default */.Z)().trackingMonitorSubstituteClickMore;
    if (Object.keys(productReplace).length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReplaceProduct_styles_module_default()).container,
                id: "product__replace",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReplaceProduct_styles_module_default()).leftPlace,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (ReplaceProduct_styles_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                        src: Images/* SUBSTITUTE_RECOMMEND_ICON */.VJj,
                                        height: 24,
                                        width: 24
                                    }),
                                    "Gợi \xfd"
                                ]
                            }),
                            isShowViewMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                href: "/substitutes?slug=".concat(encodeURIComponent(slugCurrent)),
                                prefetch: false,
                                padding: "0px",
                                className: null,
                                name: null,
                                onMouseOver: null,
                                target: null,
                                onClick: function() {
                                    gtag/* default.substituteClickMore */.ZP.substituteClickMore({
                                        product: productReplace,
                                        screen: "Product Listing",
                                        sku: sku,
                                        sellerId: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerID,
                                        productId: productId,
                                        mainSkuStatus: (0,TrackingHelpers/* mapMainSkuStatus */.xl)((productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType)
                                    });
                                    trackingMonitorSubstituteClickMore({
                                        sku: sku,
                                        sellerId: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerID,
                                        productId: productId,
                                        type: status === "NORMAL" ? "Instock" : status,
                                        pathname: router.pathname,
                                        sellerIdMainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sellerID) || sellerIdMainSKU,
                                        productIdMainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.productId) || productIdMainSKU,
                                        mainSKU: (productParent === null || productParent === void 0 ? void 0 : productParent.sku) || mainSKU,
                                        mainType: (productParent === null || productParent === void 0 ? void 0 : productParent.errorCode) || mainType
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    className: (ReplaceProduct_styles_module_default()).viewMore,
                                    children: "Xem th\xeam"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReplaceProduct_styles_module_default()).rightPlace,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemProduct, {
                                product: productReplace,
                                slug: slug,
                                imageUrl: defaultImage,
                                name: name,
                                displayPriceFormated: displayPriceFormated,
                                volume: volume,
                                sku: sku,
                                sellerId: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerID,
                                productId: productId,
                                status: status,
                                productParent: productParent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (ReplaceProduct_styles_module_default()).replaceSticker,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                        src: Images/* SUBSTITUDE_REPLACE_ICON */.m8e,
                                        height: 16,
                                        width: 16
                                    }),
                                    " Sản phẩm thay thế"
                                ]
                            })
                        ]
                    })
                ]
            }),
            showGuide && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourSubstituteSKU, {})
        ]
    });
};
function TourSubstituteSKU() {
    var onFinish = function onFinish() {
        handleFinishGuide();
        turnOnScrollBody();
    };
    var turnOnScrollBody = function turnOnScrollBody() {
        document.body.style.overflow = "auto";
        document.body.style.paddingRight = "0px";
    };
    var ref = (0,react.useState)(false), isOpenGuideReplace = ref[0], setIsOpenGuideReplace = ref[1];
    var substituteCardRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        substituteCardRef.current = document.getElementById("product__replace");
        var timeout;
        if (substituteCardRef === null || substituteCardRef === void 0 ? void 0 : substituteCardRef.current) {
            // Check if already guided, no need to show the guide
            (0,_async_to_generator/* default */.Z)(function() {
                var ref, res, _tmp, guideInfo;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,CustomerClient/* getUserLogGuide */.Xd)((_tmp.q = {
                                    feature: guideline/* GUIDE_FEATURE.SUBSTITUTE_SKU_OTHERS */.Z.SUBSTITUTE_SKU_OTHERS
                                }, _tmp))
                            ];
                        case 1:
                            res = _state.sent();
                            if (res.status !== "OK") {
                                console.error("[ERROR] Get guide substitute cart", res);
                                return [
                                    2
                                ];
                            }
                            guideInfo = (ref = res.data) === null || ref === void 0 ? void 0 : ref[0];
                            if (guideInfo.isActive && !guideInfo.isGuided) {
                                timeout = setTimeout(function() {
                                    setIsOpenGuideReplace(true);
                                }, 1000);
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        return function() {
            clearTimeout(timeout);
        };
    }, []);
    if (!isOpenGuideReplace) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    function handleFinishGuide() {
        return _handleFinishGuide.apply(this, arguments);
    }
    function _handleFinishGuide() {
        _handleFinishGuide = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsOpenGuideReplace(false);
                        _tmp = {};
                        return [
                            4,
                            (0,CustomerClient/* postUserLogGuide */.n)((_tmp.feature = guideline/* GUIDE_FEATURE.SUBSTITUTE_SKU_OTHERS */.Z.SUBSTITUTE_SKU_OTHERS, _tmp.isViewAll = true, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFinishGuide.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TourIntro/* default */.Z, {
        steps: [
            {
                context: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "Thuốc sỉ gợi \xfd bạn sản phẩm thay thế c\xf9ng hoạt chất, h\xe0m lượng hoặc c\xf9ng c\xf4ng dụng để c\xf3 th\xeam sự lựa chọn đặt h\xe0ng bạn nh\xe9."
                }),
                position: "bottom",
                name: "infoProduct",
                refCurrent: {
                    current: document.getElementById("product__replace")
                },
                styles: {
                    width: "480px",
                    fontSize: "16px"
                }
            }, 
        ],
        isHiddenScroll: false,
        isReady: true,
        onFinish: onFinish
    });
}
/* harmony default export */ var detail_product_new_ReplaceProduct = (ReplaceProduct);

// EXTERNAL MODULE: ./src/components-v2/mocules/ProductCardNewList/index.js + 2 modules
var ProductCardNewList = __webpack_require__(34117);
// EXTERNAL MODULE: ./src/components/mocules/ListProductWithTitle/index.js + 1 modules
var ListProductWithTitle = __webpack_require__(32838);
// EXTERNAL MODULE: ./src/components/mocules/Skeleton/SliderProductBlock.js
var SliderProductBlock = __webpack_require__(2546);
// EXTERNAL MODULE: ./src/constants/Enums/app-settings.ts
var app_settings = __webpack_require__(73796);
// EXTERNAL MODULE: ./src/hooks/useGetProductsDisplayedFromAppSettings.ts
var useGetProductsDisplayedFromAppSettings = __webpack_require__(56856);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/styles.module.css
var PcScreen_styles_module = __webpack_require__(25399);
var PcScreen_styles_module_default = /*#__PURE__*/__webpack_require__.n(PcScreen_styles_module);
// EXTERNAL MODULE: ./src/utils/StoreUtils.js
var StoreUtils = __webpack_require__(16226);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/ProductsRecommendation.js























function ProductsRecommendation(param) {
    var product = param.product, _blockCodeTracking = param.blockCodeTracking, blockCodeTracking = _blockCodeTracking === void 0 ? tracking/* EnumBlockCodeTracking.PRODUCT_DETAIL_RCM */.x.PRODUCT_DETAIL_RCM : _blockCodeTracking;
    var isKcbVerified = (0,useIsKcbVerified/* default */.Z)();
    var mapDataProduct = (0,CartContext/* useCart */.jD)().mapDataProduct;
    var ref = (0,react.useState)([]), productRecommend = ref[0], setProductRecommend = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var MAXIMUM_PRODUCTS_RECOMMENDATION = (0,useGetProductsDisplayedFromAppSettings/* useGetProductsDisplayedFromAppSettings */.m)(app_settings/* EnumProductsDisplayedMobile.PRD_DETAIL_RECOMMENDATION_PRODUCTS */.ds.PRD_DETAIL_RECOMMENDATION_PRODUCTS);
    var elementRef = (0,useIsInViewportOnce/* useIsInViewportOnce */.z)({
        callback: function() {
            var _fetchProductDetailRecommendation = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, recommendations, _tmp, productsData, dataWithTracking, sellerCodes, sellers, sellersMap, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            setLoading(true);
                            _tmp = {};
                            return [
                                4,
                                ProductServiceV2/* default.getSearchRecommend */.ZP.getSearchRecommend((_tmp.q = {
                                    categories: product === null || product === void 0 ? void 0 : product.categoryCodes,
                                    skuCode: product === null || product === void 0 ? void 0 : product.sku
                                }, _tmp))
                            ];
                        case 1:
                            recommendations = _state.sent();
                            setLoading(false);
                            productsData = (0,ProductService/* moveKcbPriorityFirst */.tP)((0,ProductService/* getSortedProducts */.LB)((ref1 = mapDataProduct((ref = (0,Clients/* getData */.Yu)(recommendations)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                                return item.isAvailable;
                            }))) === null || ref1 === void 0 ? void 0 : ref1.map(function(prd) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                                    isRecommendedByTS: true
                                });
                            })), isKcbVerified) || [];
                            dataWithTracking = productsData.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    blockCode: blockCodeTracking
                                });
                            });
                            sellerCodes = [];
                            dataWithTracking === null || dataWithTracking === void 0 ? void 0 : dataWithTracking.forEach(function(item) {
                                if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
                            });
                            if (!sellerCodes.length) return [
                                3,
                                3
                            ];
                            sellerCodes = (0,_to_consumable_array/* default */.Z)(new Set(sellerCodes));
                            return [
                                4,
                                SupplierClient/* default.getSellersV2 */.ZP.getSellersV2(sellerCodes).then(Clients/* getData */.Yu)
                            ];
                        case 2:
                            sellers = _state.sent();
                            sellersMap = new Map(sellers.map(function(seller) {
                                return [
                                    seller.code,
                                    seller
                                ];
                            }));
                            dataWithTracking === null || dataWithTracking === void 0 ? void 0 : dataWithTracking.forEach(function(item) {
                                item.sellerInfo = (0,StoreUtils/* sellerForStore */.M)(sellersMap.get(item.seller.code), item.storeCode);
                            });
                            _state.label = 3;
                        case 3:
                            setProductRecommend(dataWithTracking);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            console.error("[Error] fetchProductDetailRecommendation:", error);
                            setLoading(false);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            function fetchProductDetailRecommendation() {
                return _fetchProductDetailRecommendation.apply(this, arguments);
            }
            return fetchProductDetailRecommendation;
        }()
    }).elementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "products-recommendation",
        ref: elementRef,
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (PcScreen_styles_module_default()).containerPage,
            style: {
                marginTop: "20px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductWithTitle/* default */.Z, {
                iconWidth: "40px",
                iconHeight: "41px",
                name: "Sản phẩm gợi \xfd",
                viewMore: true,
                redirect: "/products",
                children: productRecommend.slice(0, MAXIMUM_PRODUCTS_RECOMMENDATION).map(function(product, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardNewList/* default */.Z, {
                        product: product,
                        index: index
                    }, "item-product-".concat(product.slug));
                })
            }, "flagship-suggestion")
        })
    });
};

// EXTERNAL MODULE: ./src/clients/ProductClientV2.js
var ProductClientV2 = __webpack_require__(22997);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/ProductsSameIngredient.js























function ProductsSameIngredient(param) {
    var product = param.product, _blockCodeTracking = param.blockCodeTracking, blockCodeTracking = _blockCodeTracking === void 0 ? tracking/* EnumBlockCodeTracking.PRODUCT_DETAIL_SAME_INGREDIENT */.x.PRODUCT_DETAIL_SAME_INGREDIENT : _blockCodeTracking;
    var isKcbVerified = (0,useIsKcbVerified/* default */.Z)();
    var ref = (0,react.useState)([]), productsIngredient = ref[0], setProductsIngredient = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var MAXIMUM_PRODUCTS_INGREDIENT = (0,useGetProductsDisplayedFromAppSettings/* useGetProductsDisplayedFromAppSettings */.m)(app_settings/* EnumProductsDisplayedMobile.PRD_DETAIL_INGREDIENT_PRODUCTS */.ds.PRD_DETAIL_INGREDIENT_PRODUCTS);
    var elementRef = (0,useIsInViewportOnce/* useIsInViewportOnce */.z)({
        callback: function() {
            var _fetchSameIngredient = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ingredientCodes, ref2, ref3, promises, listDataIngredientRes, listProductRelative, mapDataResult, _tmp, filteredProducts, dataWithTracking, sellerCodes, sellers, sellersMap;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ingredientCodes = (ref1 = (ref = product.ingredients) === null || ref === void 0 ? void 0 : ref.map(function(ele) {
                                return ele.ingredientCode;
                            })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2);
                            if (!(ingredientCodes && ingredientCodes.length > 0)) return [
                                3,
                                5
                            ];
                            setLoading(true);
                            promises = ingredientCodes.map(function(code) {
                                return (0,ProductClientV2/* getFuzzySearchClient */.Qm)({
                                    body: {
                                        filter: {
                                            ingredient: code
                                        },
                                        limit: 15
                                    }
                                });
                            });
                            return [
                                4,
                                Promise.all(promises)
                            ];
                        case 1:
                            listDataIngredientRes = _state.sent();
                            listProductRelative = listDataIngredientRes.map(function(dataIngredientRes) {
                                return (0,Clients/* getData */.Yu)(dataIngredientRes);
                            }).flat();
                            _tmp = {};
                            return [
                                4,
                                ProductServiceV2/* default.mapDataProduct */.ZP.mapDataProduct((_tmp.result = {
                                    status: "OK",
                                    data: listProductRelative
                                }, _tmp))
                            ];
                        case 2:
                            mapDataResult = _state.sent();
                            filteredProducts = (0,ProductService/* moveKcbPriorityFirst */.tP)((0,ProductService/* getSortedProducts */.LB)(((ref3 = (ref2 = (0,Clients/* getData */.Yu)(mapDataResult)) === null || ref2 === void 0 ? void 0 : ref2.filter(function(prd) {
                                return prd.sku !== product.sku;
                            }).reduce(function(unique, o) {
                                if (!unique.some(function(prd) {
                                    return prd.sku === o.sku;
                                })) {
                                    unique.push(o);
                                }
                                return unique;
                            }, [])) === null || ref3 === void 0 ? void 0 : ref3.map(function(prd) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                                    isSameIngredient: true
                                });
                            }).slice(0, MAXIMUM_PRODUCTS_INGREDIENT)) || []), isKcbVerified);
                            dataWithTracking = filteredProducts.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    blockCode: blockCodeTracking
                                });
                            });
                            sellerCodes = [];
                            dataWithTracking === null || dataWithTracking === void 0 ? void 0 : dataWithTracking.forEach(function(item) {
                                if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
                            });
                            if (!sellerCodes.length) return [
                                3,
                                4
                            ];
                            sellerCodes = (0,_to_consumable_array/* default */.Z)(new Set(sellerCodes));
                            return [
                                4,
                                SupplierClient/* default.getSellersV2 */.ZP.getSellersV2(sellerCodes).then(Clients/* getData */.Yu)
                            ];
                        case 3:
                            sellers = _state.sent();
                            sellersMap = new Map(sellers.map(function(seller) {
                                return [
                                    seller.code,
                                    seller
                                ];
                            }));
                            dataWithTracking === null || dataWithTracking === void 0 ? void 0 : dataWithTracking.forEach(function(item) {
                                item.sellerInfo = (0,StoreUtils/* sellerForStore */.M)(sellersMap.get(item.seller.code), item.storeCode);
                            });
                            _state.label = 4;
                        case 4:
                            setProductsIngredient(dataWithTracking);
                            _state.label = 5;
                        case 5:
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            function fetchSameIngredient() {
                return _fetchSameIngredient.apply(this, arguments);
            }
            return fetchSameIngredient;
        }()
    }).elementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "products-same-ingredients",
        ref: elementRef,
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (PcScreen_styles_module_default()).containerPage,
            style: {
                marginTop: "20px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductWithTitle/* default */.Z, {
                iconWidth: "40px",
                iconHeight: "41px",
                name: "Sản phẩm c\xf9ng hoạt chất",
                viewMore: true,
                redirect: "/products",
                children: productsIngredient.map(function(product, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardNewList/* default */.Z, {
                        product: product,
                        index: index
                    }, "item-product-".concat(product.slug));
                })
            }, "flagship-same-ingredients")
        })
    });
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/ProductsSameSeller.js






















var NO_VIEW_MORE_SELLER_TYPES = [
    "INDIVIDUAL",
    "MARKET"
];
function getSellerURL(seller) {
    var sellerCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (seller === null || seller === void 0 ? void 0 : seller.isStore) {
        return "/seller/".concat(seller === null || seller === void 0 ? void 0 : seller.slug, "/list-product");
    }
    if ((seller === null || seller === void 0 ? void 0 : seller.isInternal) || !NO_VIEW_MORE_SELLER_TYPES.includes(seller === null || seller === void 0 ? void 0 : seller.sellerType)) {
        return "/seller-products/".concat(seller === null || seller === void 0 ? void 0 : seller.code, "/").concat((seller === null || seller === void 0 ? void 0 : seller.sellerType) == "ENTERPRISE" ? seller === null || seller === void 0 ? void 0 : seller.slug : "");
    }
    return "/doitac/".concat(sellerCode);
}
function ProductsSameSeller(param) {
    var product = param.product, sellerInfo = param.sellerInfo, _blockCodeTracking = param.blockCodeTracking, blockCodeTracking = _blockCodeTracking === void 0 ? tracking/* EnumBlockCodeTracking.PRODUCT_DETAIL_SAME_SELLER */.x.PRODUCT_DETAIL_SAME_SELLER : _blockCodeTracking;
    var isKcbVerified = (0,useIsKcbVerified/* default */.Z)();
    var ref = (0,react.useState)([]), productsBySeller = ref[0], setProductsBySeller = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var MAXIMUM_PRODUCTS_SELLER = (0,useGetProductsDisplayedFromAppSettings/* useGetProductsDisplayedFromAppSettings */.m)(app_settings/* EnumProductsDisplayedMobile.PRD_DETAIL_SELLER_PRODUCTS */.ds.PRD_DETAIL_SELLER_PRODUCTS);
    var elementRef = (0,useIsInViewportOnce/* useIsInViewportOnce */.z)({
        callback: function() {
            var _fetchProductDetailRecommendation = (0,_async_to_generator/* default */.Z)(function() {
                var listProductBySellerRes, _tmp, _tmp1, ref, ref1, listProductBySeller, dataWithTracking, sellerCodes, sellers, sellersMap;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            if (!(product === null || product === void 0 ? void 0 : product.vendorProductTag)) return [
                                3,
                                2
                            ];
                            _tmp = {};
                            return [
                                4,
                                ProductServiceV2/* default.loadProductWithTag */.ZP.loadProductWithTag((_tmp.slug = product === null || product === void 0 ? void 0 : product.vendorProductTag, _tmp.offset = 0, _tmp.limit = 15, _tmp.v2 = true, _tmp))
                            ];
                        case 1:
                            listProductBySellerRes = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            _tmp1 = {};
                            return [
                                4,
                                ProductServiceV2/* default.loadProductWithSeller */.ZP.loadProductWithSeller((_tmp1.code = sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.code, _tmp1.// SP cùng gian với SKU đang xem (BV-2164): productFilter của gian, seller-core trả sẵn
                                storeFilter = sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.productFilter, _tmp1.offset = 0, _tmp1.limit = 15, _tmp1.v2 = true, _tmp1))
                            ];
                        case 3:
                            listProductBySellerRes = _state.sent();
                            _state.label = 4;
                        case 4:
                            setLoading(false);
                            if (!(0,Clients/* isValid */.JY)(listProductBySellerRes)) return [
                                3,
                                7
                            ];
                            listProductBySeller = (0,ProductService/* moveKcbPriorityFirst */.tP)((0,ProductService/* getSortedProducts */.LB)(((ref1 = (ref = (0,Clients/* getData */.Yu)(listProductBySellerRes)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                                return (item === null || item === void 0 ? void 0 : item.sku) !== (product === null || product === void 0 ? void 0 : product.sku);
                            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(prd) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                                    isSameSeller: true
                                });
                            })) || []), isKcbVerified);
                            dataWithTracking = listProductBySeller.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    blockCode: blockCodeTracking
                                });
                            });
                            sellerCodes = [];
                            dataWithTracking === null || dataWithTracking === void 0 ? void 0 : dataWithTracking.forEach(function(item) {
                                if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
                            });
                            if (!sellerCodes.length) return [
                                3,
                                6
                            ];
                            sellerCodes = (0,_to_consumable_array/* default */.Z)(new Set(sellerCodes));
                            return [
                                4,
                                SupplierClient/* default.getSellersV2 */.ZP.getSellersV2(sellerCodes).then(Clients/* getData */.Yu)
                            ];
                        case 5:
                            sellers = _state.sent();
                            sellersMap = new Map(sellers.map(function(seller) {
                                return [
                                    seller.code,
                                    seller
                                ];
                            }));
                            dataWithTracking === null || dataWithTracking === void 0 ? void 0 : dataWithTracking.forEach(function(item) {
                                item.sellerInfo = (0,StoreUtils/* sellerForStore */.M)(sellersMap.get(item.seller.code), item.storeCode);
                            });
                            _state.label = 6;
                        case 6:
                            setProductsBySeller(dataWithTracking);
                            _state.label = 7;
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            function fetchProductDetailRecommendation() {
                return _fetchProductDetailRecommendation.apply(this, arguments);
            }
            return fetchProductDetailRecommendation;
        }()
    }).elementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "products-same-seller",
        ref: elementRef,
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProductBlock/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (PcScreen_styles_module_default()).containerPage,
            style: {
                marginTop: "20px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListProductWithTitle/* default */.Z, {
                iconWidth: "40px",
                iconHeight: "41px",
                name: "Sản phẩm c\xf9ng nh\xe0 b\xe1n h\xe0ng",
                viewMore: true,
                redirect: getSellerURL(sellerInfo, product.sellerCode),
                children: productsBySeller.slice(0, MAXIMUM_PRODUCTS_SELLER).map(function(product, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardNewList/* default */.Z, {
                        product: product,
                        index: index
                    }, "item-product-".concat(product.slug));
                })
            }, "flagship-same-seller")
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/SectionInformation.constant.ts
var PRODUCT_INFO_CATEGORIES = [
    {
        id: "description",
        label: "Th\xf4ng tin chung"
    },
    {
        id: "ingredients",
        label: "Th\xe0nh phần"
    },
    {
        id: "indication",
        label: "Chỉ định"
    },
    {
        id: "contraindication",
        label: "Chống chỉ định"
    },
    {
        id: "dosage",
        label: "Liều lượng - c\xe1ch d\xf9ng"
    },
    {
        id: "drugInteraction",
        label: "Tương t\xe1c thuốc"
    },
    {
        id: "storage",
        label: "Bảo quản"
    },
    {
        id: "drugOverdose",
        label: "Qu\xe1 liều"
    }, 
];

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/hooks/useScrollActive.ts


var getOffetTop = function(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    // Adjust this value to set the space from the top
    var bodyRect = document.body.getBoundingClientRect().top;
    var elementRect = element.getBoundingClientRect().top;
    var elementPosition = elementRect - bodyRect;
    var offsetPosition = elementPosition - offset;
    return offsetPosition;
};
var useScrollActive = function() {
    var ref = (0,react.useState)(PRODUCT_INFO_CATEGORIES[0].id), activeId = ref[0], setActiveId = ref[1];
    var onCategoryClick = function(id) {
        var element = document.getElementById(id);
        if (element) {
            var offsetTop = getOffetTop(element, 130);
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            PRODUCT_INFO_CATEGORIES.forEach(function(section) {
                var element = document.getElementById(section.id);
                if (element) {
                    var offsetTop = getOffetTop(element, 150);
                    if (window.scrollY >= offsetTop && window.scrollY < offsetTop + element.offsetHeight) {
                        setActiveId(section.id);
                    }
                }
            });
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return {
        activeId: activeId,
        onCategoryClick: onCategoryClick,
        setActiveId: setActiveId
    };
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/hooks/useToggleLessMore.ts

var useToggleLessMore_getOffetTop = function(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    // Adjust this value to set the space from the top
    var bodyRect = document.body.getBoundingClientRect().top;
    var elementRect = element.getBoundingClientRect().top;
    var elementPosition = elementRect - bodyRect;
    var offsetPosition = elementPosition - offset;
    return offsetPosition;
};
var useToggleLessMore = function() {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isExpanded = ref2[0], setIsExpanded = ref2[1];
    var categoryRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    var categoryHeight = (ref = categoryRef.current) === null || ref === void 0 ? void 0 : ref.scrollHeight;
    var contentHeight = (ref1 = contentRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight;
    // Content > Category and Content > 500px
    var shouldHaveExpand = (0,react.useMemo)(function() {
        return contentHeight && categoryHeight && contentHeight > categoryHeight && contentHeight > 500;
    }, [
        contentHeight,
        categoryHeight
    ]);
    var scrollToTop = function() {
        var element = document.getElementById("section-information");
        if (element) {
            window.scrollTo({
                top: useToggleLessMore_getOffetTop(element, 150)
            });
        }
    };
    var toggle = function() {
        setIsExpanded(!isExpanded);
        if (isExpanded) scrollToTop();
    };
    return {
        isExpanded: isExpanded || !shouldHaveExpand,
        categoryRef: categoryRef,
        contentRef: contentRef,
        categoryHeight: categoryHeight,
        contentHeight: contentHeight,
        shouldHaveExpand: shouldHaveExpand,
        toggle: toggle,
        setIsExpanded: setIsExpanded
    };
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/SectionInformation.util.ts





var isEmptyContent = function(content) {
    var ref;
    var div = document.createElement("div");
    div.innerHTML = content;
    return ((ref = div.textContent) === null || ref === void 0 ? void 0 : ref.trim()) === "" && !div.querySelector("img");
};
var filterEmptyHtml = function(content) {
    return isEmptyContent(content) ? "" : content;
};
/**
 * Replace all <img> src attributes in the HTML string using getLinkCDNImage.
 * @param html The HTML string to process.
 * @returns The HTML string with updated img src attributes.
 */ function replaceImgSrc(html) {
    if (!html) return html;
    return html.replace(/<img([^>]+?)src=["']([^"']+)["']/gi, function(match, before, src) {
        return "<img".concat(before, 'src="').concat((0,ImageUtils/* getLinkCDNImage */.wr)(src, "large"), '"');
    });
}
var adaptProductInformation = function(product) {
    try {
        var ref, ref1, ref2, ref3, ref4;
        var contraindication = filterEmptyHtml(product.description.contraindication);
        var description = filterEmptyHtml(replaceImgSrc(product.description.description));
        var dosage = filterEmptyHtml(product.description.dosage);
        var drugInteraction = filterEmptyHtml(product.description.drugInteraction);
        var drugOverdose = filterEmptyHtml(product.description.drugOverdose);
        var indication = filterEmptyHtml(product.description.indication);
        var storage = filterEmptyHtml(product.description.storage);
        var registrationNumber = product.registrationNumber;
        var ingredients = ((ref = product.ingredients) === null || ref === void 0 ? void 0 : ref.length) ? product.ingredients.map(function(ingredient) {
            return {
                quantity: ingredient.volume,
                name: ingredient.name,
                url: "".concat(Paths/* INGREDIENT */.gL, "/").concat(ingredient.slug)
            };
        }) : undefined;
        var expiredDate = product.expiredDate ? product.expiredDate.split("-").reverse().join("-") : "";
        var categories = !!((ref1 = product.categories) === null || ref1 === void 0 ? void 0 : ref1.length) ? product.categories.map(function(item) {
            return {
                href: "".concat(Paths/* CATEGORIES */.aA, "/").concat(item === null || item === void 0 ? void 0 : item.slug),
                label: item.name
            };
        }) : undefined;
        var manufacturer = product.manufacturer ? {
            label: (ref2 = product.manufacturer) === null || ref2 === void 0 ? void 0 : ref2.name,
            href: "".concat(Paths/* MANUFACTURERS */.LS, "/").concat((ref3 = product.manufacturer) === null || ref3 === void 0 ? void 0 : ref3.slug)
        } : undefined;
        var country = product === null || product === void 0 ? void 0 : product.originName;
        var documents = !!((ref4 = product.documents) === null || ref4 === void 0 ? void 0 : ref4.length) ? product.documents.map(function(item) {
            return {
                href: item.link,
                label: item.fileName
            };
        }) : undefined;
        var brand = product.brandInfo ? {
            label: product.brandInfo.name,
            href: "".concat(Paths/* PRODUCTS_URL */.NL, "?brand=").concat(product.brandInfo.slug)
        } : undefined;
        var adaptedCategories = {
            contraindication: contraindication,
            description: description,
            dosage: dosage,
            drugInteraction: drugInteraction,
            drugOverdose: drugOverdose,
            indication: indication,
            storage: storage,
            ingredients: ingredients
        };
        var infoCategories = PRODUCT_INFO_CATEGORIES;
        // .filter((item) => {
        //   if (item.id === 'description') {
        //     return adaptedCategories[item.id] || !!categories || !!expiredDate || !!manufacturer || !!country || !!documents;
        //   } else {
        //     return !!adaptedCategories[item.id];
        //   }
        // });
        var isEmpty = infoCategories.length === 0;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, adaptedCategories), {
            infoCategories: infoCategories,
            categories: categories,
            expiredDate: expiredDate,
            manufacturer: manufacturer,
            country: country,
            documents: documents,
            isEmpty: isEmpty,
            registrationNumber: registrationNumber,
            brand: brand
        });
    } catch (e) {
        return {
            isEmpty: true,
            infoCategories: [],
            contraindication: "",
            description: "",
            dosage: "",
            drugInteraction: "",
            drugOverdose: "",
            indication: "",
            storage: "",
            ingredients: undefined,
            categories: undefined,
            expiredDate: "",
            manufacturer: undefined,
            country: "",
            documents: undefined,
            registrationNumber: "",
            brand: undefined
        };
    }
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/ui/ButtonLessMore.tsx




var ButtonLessMore = function(param) {
    var onClick = param.onClick, isExpanded = param.isExpanded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: onClick,
        className: "w-full mx-auto mt-2 text-[var(--primary-color)] flex items-center justify-center gap-2 py-1",
        children: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Thu gọn ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    className: "rotate-180"
                }),
                " "
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Xem tất cả ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                " "
            ]
        })
    });
};
var Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "8",
        height: "11",
        viewBox: "0 0 8 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.666748 1.5L4.00008 4.83333L7.33341 1.5M0.666748 6.16667L4.00008 9.5L7.33341 6.16667",
            stroke: "#005C29",
            strokeWidth: "1.33",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};

// EXTERNAL MODULE: ./src/lib/utils.ts
var utils = __webpack_require__(86269);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/ui/CategoryItem.tsx


var CategoryItem = function(param) {
    var isActive = param.isActive, label = param.label, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,utils.cn)("w-full rounded-[8px] flex items-center py-5 px-3  font-[ggsm]", "text-[var(--primary-color)]", [
            isActive && "bg-[var(--primary-color)] text-[#fff]"
        ], [
            !isActive && "bg-[#FAFAFA] hover:bg-[#D1E7BF] cursor-pointer"
        ]),
        onClick: onClick,
        children: label
    });
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/ui/FieldInformation.tsx



var FieldInformation = function(param) {
    var title = param.title, children = param.children, className = param.className;
    if (!children) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("flex gap-2 text-[14px]", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: title
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/ui/GeneralInfomation.tsx



var GeneralInfomation = /*#__PURE__*/ (0,react.memo)(function(param) {
    var value = param.value, title = param.title, id = param.id, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-[18px] text-[var(--primary-color)] font-[ggsm]",
                children: title
            }),
            children,
            value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)([
                    "[&_*]:m-[revert] [&_iframe]:!max-w-full",
                    "[&_ul]:[all:revert]",
                    "[&_ol]:[all:revert]",
                    "[&_p]:[all:revert]",
                    "[overflow-wrap:anywhere]",
                    "[&_table]:inline-block",
                    "jodit-wysiwyg", 
                ]),
                // className="[&_iframe]:!max-w-[calc(100vw-24px)] break-words jodit-wysiwyg"
                dangerouslySetInnerHTML: {
                    __html: value
                }
            })
        ]
    });
});
GeneralInfomation.displayName = "GeneralInfomation";

// EXTERNAL MODULE: ./src/components-v2/atoms/LinkNext/LinkNext.tsx
var LinkNext = __webpack_require__(91636);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/ui/Ingredient.tsx



var Ingredient = function(param) {
    var value = param.value, id = param.id, title = param.title;
    var isEmpty = !value || value.length === 0;
    // if (isEmpty) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: "border-[2px] border-[var(--primary-color)] rounded p-4 flex flex-col gap-2 bg-[#F5F5F5]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-[18px] text-[var(--primary-color)] font-[ggsm]",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (0,utils.cn)("list-none p-0 pr-4 m-0 overflow-y-auto max-h-[220px] space-y-2", "scrollbar-primary"),
                children: value === null || value === void 0 ? void 0 : value.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkNext/* LinkNext */.t, {
                                href: item.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[var(--primary-color)]",
                                    children: item.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.quantity
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionInformation/SectionInformation.tsx












var mappingTypeMedicineLabel = {
    "LALT0T": "C\xf3",
    "XT2U1Y": "Kh\xf4ng" // Thuốc không kê đơn
};
var SectionInformation = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var product = param.product;
    var _$ref = useScrollActive(), onCategoryClick = _$ref.onCategoryClick, activeId = _$ref.activeId, setActiveId = _$ref.setActiveId;
    var _$ref1 = useToggleLessMore(), categoryRef = _$ref1.categoryRef, contentRef = _$ref1.contentRef, contentHeight = _$ref1.contentHeight, categoryHeight = _$ref1.categoryHeight, shouldHaveExpand = _$ref1.shouldHaveExpand, toggle = _$ref1.toggle, setIsExpanded = _$ref1.setIsExpanded, isExpanded = _$ref1.isExpanded;
    if (!product) return null;
    var _$ref2 = adaptProductInformation(product), contraindication = _$ref2.contraindication, description = _$ref2.description, dosage = _$ref2.dosage, drugInteraction = _$ref2.drugInteraction, drugOverdose = _$ref2.drugOverdose, indication = _$ref2.indication, storage = _$ref2.storage, ingredients = _$ref2.ingredients, categories = _$ref2.categories, infoCategories = _$ref2.infoCategories, expiredDate = _$ref2.expiredDate, manufacturer = _$ref2.manufacturer, country = _$ref2.country, documents = _$ref2.documents, isEmpty = _$ref2.isEmpty, registrationNumber = _$ref2.registrationNumber, brand = _$ref2.brand;
    if (isEmpty) return null;
    var isMedicine = (product === null || product === void 0 ? void 0 : product.sellerCategoryCode) === "AQFV2U" // when sellerCategoryCode = "AQFV2U" this code is medicine type (Thuốc)
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            id: "section-information",
            className: "grid grid-cols-3 gap-5 p-5 rounded-[20px] bg-white mb-5",
            children: [
                !!(infoCategories === null || infoCategories === void 0 ? void 0 : infoCategories.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        ref: categoryRef,
                        id: "information-categories",
                        className: "flex flex-col gap-3 list-none pl-0 sticky top-[144px]",
                        children: infoCategories.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryItem, {
                                isActive: item.id === activeId,
                                label: item.label,
                                onClick: function() {
                                    setIsExpanded(true);
                                    setTimeout(function() {
                                        onCategoryClick(item.id);
                                    });
                                }
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-2 relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: contentRef,
                            className: (0,clsx/* default */.Z)("flex flex-col gap-2 overflow-hidden"),
                            style: {
                                height: isExpanded ? "auto" : "".concat(categoryHeight, "px")
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GeneralInfomation, {
                                    id: "description",
                                    value: description,
                                    title: "Th\xf4ng tin chung",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Hồ sơ sản phẩm",
                                            className: "flex-col",
                                            children: !!(documents === null || documents === void 0 ? void 0 : documents.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col gap-1",
                                                children: documents.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: item.href,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            className: "text-[var(--primary-color)]",
                                                            children: item.label
                                                        })
                                                    }, index);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Hạn sử dụng:",
                                            children: !!expiredDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: expiredDate
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Danh mục:",
                                            children: !!(categories === null || categories === void 0 ? void 0 : categories.length) && categories.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        className: "text-[var(--primary-color)]",
                                                        children: item.label
                                                    })
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Nh\xe0 sản xuất:",
                                            children: !!manufacturer && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: manufacturer.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    className: "text-[var(--primary-color)]",
                                                    children: manufacturer.label
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Nước sản xuất:",
                                            children: !!country && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: country
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Thương hiệu:",
                                            children: brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: brand === null || brand === void 0 ? void 0 : brand.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    className: "text-[var(--primary-color)]",
                                                    children: brand === null || brand === void 0 ? void 0 : brand.label
                                                })
                                            }) : null
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Số đăng k\xfd:",
                                            children: !!registrationNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: registrationNumber
                                            })
                                        }),
                                        isMedicine && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldInformation, {
                                            title: "Thuốc k\xea đơn:",
                                            children: product.sellerSubCategoryCode && mappingTypeMedicineLabel[product.sellerSubCategoryCode]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Ingredient, {
                                    id: "ingredients",
                                    title: "Chi tiết th\xe0nh phần",
                                    value: ingredients
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInfomation, {
                                    id: "indication",
                                    value: indication,
                                    title: "Chỉ định"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInfomation, {
                                    id: "contraindication",
                                    value: contraindication,
                                    title: "Chống chỉ định"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInfomation, {
                                    id: "dosage",
                                    value: dosage,
                                    title: "Liều lượng - c\xe1ch d\xf9ng"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInfomation, {
                                    id: "drugInteraction",
                                    value: drugInteraction,
                                    title: "Tương t\xe1c thuốc"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInfomation, {
                                    id: "storage",
                                    value: storage,
                                    title: "Bảo quản"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralInfomation, {
                                    id: "drugOverdose",
                                    value: drugOverdose,
                                    title: "Qu\xe1 liều"
                                })
                            ]
                        }),
                        shouldHaveExpand && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx/* default */.Z)("flex justify-end items-end", [
                                !isExpanded && "bg-[linear-gradient(180deg,_rgba(255,255,255,0)_0%,_rgba(255,255,255,0.3660057773109243)_24%,_rgba(255,255,255,1)_100%)]",
                                !isExpanded && "absolute bottom-0 left-0 right-0 h-[60px] cursor-pointer", 
                            ]),
                            onClick: function() {
                                toggle();
                                if (isExpanded) {
                                    setTimeout(function() {
                                        setActiveId(infoCategories[0].id);
                                    });
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLessMore, {
                                isExpanded: isExpanded
                            })
                        })
                    ]
                })
            ]
        })
    });
});
SectionInformation.displayName = "SectionInformation";

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton_IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip_Tooltip = __webpack_require__(21023);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/SectionRetailPrice/SectionRetailPrice.tsx







var SectionRetailPrice = function(param) {
    var price = param.price, profit = param.profit;
    if (!price || !profit || price <= 0 || profit <= 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-fit gap-6 items-center rounded-[30px] bg-[#FDF0DD] h-[25px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)("flex gap-2 items-center justify-center px-3", "bg-[linear-gradient(90deg,_#FF3D28_0%,_#FF9549_100%)]", "rounded-[30px] h-full"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfitIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-white text-[14px]",
                        children: "Lợi nhuận b\xe1n lẻ"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                        displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(profit),
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-2 p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] font-[ggsm] text-[#1F1F1F]",
                                    children: "Đ\xe2y l\xe0 những sản phẩm thuộc nh\xf3m c\xf3 lợi nhuận cao m\xe0 thuocsi gợi \xfd cho bạn"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[14px] text-[#1F1F1F] font-[ggsr]",
                                            children: "Gi\xe1 b\xe1n lẻ gợi \xfd"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                            displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(price),
                                            size: "sm"
                                        })
                                    ]
                                })
                            ]
                        }),
                        classes: {
                            tooltip: (0,clsx/* default */.Z)("!bg-white p-4 min-w-[384px]", "shadow-[0px_0px_30px_0px_#0000001F] rounded-[10px]"),
                            popper: "cursor-pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                className: "text-[#1D39C4] !h-4 !w-4"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var ProfitIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5 6C9.63261 6 9.75979 5.94732 9.85355 5.85355C9.94732 5.75979 10 5.63261 10 5.5C10 5.36739 9.94732 5.24021 9.85355 5.14645C9.75979 5.05268 9.63261 5 9.5 5H8.5V4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V5H7C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6V7C6 7.26522 6.10536 7.51957 6.29289 7.70711C6.48043 7.89464 6.73478 8 7 8H9V9H6.5C6.36739 9 6.24021 9.05268 6.14645 9.14645C6.05268 9.24021 6 9.36739 6 9.5C6 9.63261 6.05268 9.75979 6.14645 9.85355C6.24021 9.94732 6.36739 10 6.5 10H7.5V10.5C7.5 10.6326 7.55268 10.7598 7.64645 10.8536C7.74021 10.9473 7.86739 11 8 11C8.13261 11 8.25979 10.9473 8.35355 10.8536C8.44732 10.7598 8.5 10.6326 8.5 10.5V10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9V8C10 7.73478 9.89464 7.48043 9.70711 7.29289C9.51957 7.10536 9.26522 7 9 7H7V6H9.5Z",
                fill: "white",
                stroke: "white",
                "stroke-width": "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.8551 9.64497C12.8086 9.59811 12.7533 9.56091 12.6924 9.53552C12.6314 9.51014 12.5661 9.49707 12.5001 9.49707C12.4341 9.49707 12.3687 9.51014 12.3078 9.53552C12.2469 9.56091 12.1916 9.59811 12.1451 9.64497L10.1451 11.645C10.0757 11.7153 10.0287 11.8046 10.01 11.9016C9.99132 11.9986 10.0018 12.0989 10.0401 12.19C10.0776 12.2813 10.1413 12.3594 10.2231 12.4146C10.305 12.4698 10.4014 12.4995 10.5001 12.5H11.0001V14C11.0001 14.1326 11.0527 14.2598 11.1465 14.3535C11.2403 14.4473 11.3675 14.5 11.5001 14.5C11.6327 14.5 11.7599 14.4473 11.8536 14.3535C11.9474 14.2598 12.0001 14.1326 12.0001 14V12C12.0004 11.8978 11.9694 11.798 11.9113 11.714C11.8532 11.6299 11.7708 11.5657 11.6751 11.53L12.5001 10.705L13.3251 11.53C13.2294 11.5657 13.1469 11.6299 13.0888 11.714C13.0307 11.798 12.9997 11.8978 13.0001 12V14C13.0001 14.1326 13.0527 14.2598 13.1465 14.3535C13.2403 14.4473 13.3675 14.5 13.5001 14.5C13.6327 14.5 13.7599 14.4473 13.8536 14.3535C13.9474 14.2598 14.0001 14.1326 14.0001 14V12.5H14.5001C14.5988 12.4995 14.6951 12.4698 14.777 12.4146C14.8589 12.3594 14.9226 12.2813 14.9601 12.19C14.9984 12.0989 15.0088 11.9986 14.9901 11.9016C14.9714 11.8046 14.9244 11.7153 14.8551 11.645L12.8551 9.64497Z",
                fill: "white",
                stroke: "white",
                "stroke-width": "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.385 13.34C8.93097 13.4461 8.46627 13.4998 8 13.5C6.81332 13.5 5.65328 13.1481 4.66658 12.4888C3.67989 11.8295 2.91085 10.8925 2.45673 9.7961C2.0026 8.69975 1.88378 7.49335 2.11529 6.32946C2.3468 5.16558 2.91825 4.09648 3.75736 3.25736C4.59648 2.41825 5.66558 1.8468 6.82946 1.61529C7.99335 1.38378 9.19975 1.5026 10.2961 1.95673C11.3925 2.41085 12.3295 3.17989 12.9888 4.16658C13.6481 5.15328 14 6.31332 14 7.5C14.001 8.04622 13.9253 8.58987 13.775 9.115C13.7529 9.17918 13.7441 9.24719 13.7491 9.31488C13.7542 9.38257 13.7729 9.44853 13.8043 9.50874C13.8356 9.56895 13.8789 9.62214 13.9315 9.66508C13.984 9.70801 14.0448 9.7398 14.1101 9.75849C14.1753 9.77718 14.2437 9.78239 14.311 9.7738C14.3784 9.76521 14.4432 9.743 14.5017 9.70853C14.5602 9.67405 14.611 9.62803 14.6511 9.57327C14.6912 9.51851 14.7198 9.45615 14.735 9.39C14.9108 8.77539 15 8.13926 15 7.5C15 6.11553 14.5895 4.76216 13.8203 3.61101C13.0511 2.45987 11.9579 1.56266 10.6788 1.03285C9.3997 0.503033 7.99224 0.36441 6.63437 0.634506C5.2765 0.904603 4.02922 1.57129 3.05026 2.55026C2.07129 3.52922 1.4046 4.7765 1.13451 6.13437C0.86441 7.49224 1.00303 8.8997 1.53285 10.1788C2.06266 11.4579 2.95987 12.5511 4.11101 13.3203C5.26216 14.0895 6.61553 14.5 8 14.5C8.54393 14.5003 9.08599 14.4365 9.615 14.31C9.73474 14.2714 9.83553 14.1891 9.89729 14.0796C9.95905 13.97 9.97723 13.8411 9.94821 13.7187C9.91918 13.5963 9.84509 13.4894 9.7407 13.4192C9.63632 13.349 9.50931 13.3207 9.385 13.34Z",
                fill: "white",
                stroke: "white",
                "stroke-width": "0.4"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreen/index.js














































































var DEFAULT_STEPS = [
    "infoProduct",
    "addToCart"
];
var SellerTypeNoViewMore = [
    "INDIVIDUAL",
    "MARKET"
];
var KEY = "PRODUCT_DETAIL_DISPLAY_PRICE_AFTER_DISCOUNT";
var MoneyIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.27273 5.81818H10.1818C10.3747 5.81818 10.5597 5.74156 10.6961 5.60517C10.8325 5.46878 10.9091 5.28379 10.9091 5.09091C10.9091 4.89802 10.8325 4.71304 10.6961 4.57665C10.5597 4.44026 10.3747 4.36364 10.1818 4.36364H8.72727V3.63636C8.72727 3.44348 8.65065 3.25849 8.51426 3.1221C8.37787 2.98571 8.19289 2.90909 8 2.90909C7.80712 2.90909 7.62213 2.98571 7.48574 3.1221C7.34935 3.25849 7.27273 3.44348 7.27273 3.63636V4.36364C6.69408 4.36364 6.13912 4.59351 5.72995 5.00268C5.32078 5.41185 5.09091 5.9668 5.09091 6.54545C5.09091 7.12411 5.32078 7.67906 5.72995 8.08823C6.13912 8.4974 6.69408 8.72727 7.27273 8.72727H8.72727C8.92016 8.72727 9.10514 8.80389 9.24153 8.94028C9.37792 9.07668 9.45455 9.26166 9.45455 9.45454C9.45455 9.64743 9.37792 9.83241 9.24153 9.9688C9.10514 10.1052 8.92016 10.1818 8.72727 10.1818H5.81818C5.6253 10.1818 5.44032 10.2584 5.30393 10.3948C5.16754 10.5312 5.09091 10.7162 5.09091 10.9091C5.09091 11.102 5.16754 11.287 5.30393 11.4233C5.44032 11.5597 5.6253 11.6364 5.81818 11.6364H7.27273V12.3636C7.27273 12.5565 7.34935 12.7415 7.48574 12.8779C7.62213 13.0143 7.80712 13.0909 8 13.0909C8.19289 13.0909 8.37787 13.0143 8.51426 12.8779C8.65065 12.7415 8.72727 12.5565 8.72727 12.3636V11.6364C9.30593 11.6364 9.86088 11.4065 10.2701 10.9973C10.6792 10.5882 10.9091 10.0332 10.9091 9.45454C10.9091 8.87589 10.6792 8.32094 10.2701 7.91177C9.86088 7.5026 9.30593 7.27273 8.72727 7.27273H7.27273C7.07984 7.27273 6.89486 7.1961 6.75847 7.05971C6.62208 6.92332 6.54546 6.73834 6.54546 6.54545C6.54546 6.35257 6.62208 6.16758 6.75847 6.03119C6.89486 5.8948 7.07984 5.81818 7.27273 5.81818ZM8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.0034663 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.5455C6.70543 14.5455 5.43994 14.1616 4.36354 13.4423C3.28715 12.7231 2.4482 11.7009 1.95279 10.5048C1.45738 9.30881 1.32776 7.99274 1.58032 6.72304C1.83288 5.45335 2.45627 4.28706 3.37167 3.37166C4.28707 2.45627 5.45335 1.83287 6.72305 1.58031C7.99274 1.32776 9.30881 1.45738 10.5048 1.95279C11.7009 2.4482 12.7231 3.28715 13.4423 4.36354C14.1616 5.43993 14.5455 6.70543 14.5455 8C14.5455 9.73596 13.8558 11.4008 12.6283 12.6283C11.4008 13.8558 9.73596 14.5455 8 14.5455Z",
            fill: "#8C8C8C"
        })
    });
};
function DetailProductPcScreenNew(param) {
    var product = param.product, orderedCount = param.orderedCount, sellerInfo = param.sellerInfo, user = param.user, seller = param.seller, link = param.link, tags = param.tags;
    var turnOnScrollBody = function turnOnScrollBody() {
        document.body.style.overflow = "auto";
        document.body.style.paddingRight = "0px";
    };
    var handleClose = function handleClose() {
        setOpen(false);
        handleShowSusbstituteGuide();
        (0,CustomerService/* updateMeGuide */.VB)({
            feature: guideline/* GUIDE_FEATURE.PRODUCT_DETAIL */.Z.PRODUCT_DETAIL,
            isViewAll: true
        });
        // Trick: push this line code to task queue to make sure this code works
        requestIdleCallback(function() {
            turnOnScrollBody();
        });
    };
    var onFinish = function onFinish(hasViewedAllSteps) {
        turnOnScrollBody();
        setIsReady(false);
        handleShowSusbstituteGuide();
        hasViewedAllSteps && (0,CustomerService/* updateMeGuide */.VB)({
            feature: guideline/* GUIDE_FEATURE.PRODUCT_DETAIL */.Z.PRODUCT_DETAIL
        });
    };
    var handleConfirmModal = function handleConfirmModal() {
        setIsReady(true);
        setOpen(false);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var isKcbVerified = (0,useIsKcbVerified/* isKcbVerifiedUser */.Q)(user);
    var name = product.name, imagesProxy = product.imagesProxy, limitPerDay = product.limitPerDay, displayPriceFormated = product.displayPriceFormated, salePriceFormated = product.salePriceFormated, discountPercent = product.discountPercent, productType = product.productType, campaign = product.campaign, messageLimitOrder = product.messageLimitOrder, manufacturerCode = product.manufacturerCode, volume = product.volume, sku = product.sku, productId = product.productId, nextPrice = product.nextPrice, nextLevel = product.nextLevel, vouchers = product.vouchers, deal = product.deal, _sellerCode = product.sellerCode, sellerCode = _sellerCode === void 0 ? "" : _sellerCode, doseUnitName = product.doseUnitName, retailPricePerUnit = product.retailPricePerUnit, vendorInfo = product.vendorInfo, discountPriceInfo = product.discountPriceInfo, originPrice = product.originPrice, highProfitRetailValue = product.highProfitRetailValue, highProfitRetailPrice = product.highProfitRetailPrice, _videoUrls = product.videoUrls, videoUrls = _videoUrls === void 0 ? [] : _videoUrls;
    // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
    var medicineTypeLabels = (0,ProductLabelUtils/* getMedicineTypeLabels */.RG)(product);
    var stepState = JSON.parse(localStorage.getItem("stepProductDetail"));
    var refOne = (0,react.useRef)();
    var refTwo = (0,react.useRef)();
    var refThree = (0,react.useRef)();
    var refFour = (0,react.useRef)();
    var mapDataProduct = (0,CartContext/* useCart */.jD)().mapDataProduct;
    var ref12 = (0,react.useState)(DEFAULT_STEPS), defaultSteps = ref12[0], setDefaultSteps = ref12[1];
    var ref13 = (0,react.useState)([]), productDeals = ref13[0], setProductDeals = ref13[1];
    var ref14 = (0,react.useState)(), productReplace = ref14[0], setProductReplace = ref14[1];
    var ref15 = (0,react.useState)(false), isShowViewMore = ref15[0], setIsShowViewMore = ref15[1];
    var ref16 = (0,react.useState)(false), showGiftModal = ref16[0], setShowGiftModal = ref16[1];
    var ref17 = (0,react.useState)(false), isReady = ref17[0], setIsReady = ref17[1];
    var ref18 = (0,react.useState)([]), productsSame = ref18[0], setProductsSame = ref18[1];
    var ref19 = (0,react.useState)([]), infoGift = ref19[0], setInfoGift = ref19[1];
    var ref20 = (0,react.useState)(false), openModal = ref20[0], setOpenModal = ref20[1];
    var ref21 = (0,react.useState)(false), open = ref21[0], setOpen = ref21[1];
    var ref22 = (0,Ticket/* useTicket */.Q)(), sendLikeFeedback = ref22.sendLikeFeedback, isSkuFeedbackedPrice = ref22.isSkuFeedbackedPrice;
    var feedback = isSkuFeedbackedPrice({
        sku: sku
    });
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(), 2), isShowModalHighPrice = ref23[0], toggleModalHighPrice = ref23[1];
    var ref24 = (0,react.useState)({
        recommendations: false,
        sameProduct: false,
        productDeals: false,
        productBySeller: false,
        sameIngredient: false,
        voucherCollectList: false
    }), loading = ref24[0], setLoading = ref24[1];
    var ref25 = (0,react.useState)([]), listVoucherProduct = ref25[0], setListVoucherProduct = ref25[1];
    var ref26 = (0,react.useState)([]), breadcrumbs = ref26[0], setBreadcrumbs = ref26[1];
    var router = (0,next_router.useRouter)();
    var slug = router.query.slug;
    var getCategoryMapByCode = (0,useCategories/* useCategories */.L)().getCategoryMapByCode;
    var ref27 = (0,useCategoryFilterTree/* default */.Z)(), categoryFilterTree = ref27.categoryFilterTree, fetchCategoryFilterTree = ref27.fetchCategoryFilterTree;
    var getTopManufacturers = (0,useManufacturers/* useManufacturers */.e)().getTopManufacturers;
    var configs = (0,Settings/* useSetting */.y)().configs;
    // Fetch categoryFilterTree on mount (will be cached)
    (0,react.useEffect)(function() {
        fetchCategoryFilterTree();
    }, [
        fetchCategoryFilterTree
    ]);
    var tabs = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.tabs;
    });
    // Build breadcrumbs from URL query params (same logic as ProductListing)
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var defaultBreadcrumbs, _tmp, query, ref, tabName, tabNameValue, item, _tmp1, queryString, params, querySlug, basePath, topManufacturers, manufacture, item1, _tmp2, categoryFromTree, _tmp3, _tmp4, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, categoryFilters, normalCategory, combinedCategory, mapCategories, categoryNames, newCategoryFilters, categoryUrl, _tmp5, _tmp6, efficacyMap, _tmp7, normalEfficacyNames, combinedEfficacyNames, efficacyNames, efficacyUrl, _tmp8, _tmp9;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        defaultBreadcrumbs = [
                            (_tmp.name = "Trang chủ", _tmp.url = "/", _tmp)
                        ];
                        if (!(Object.keys(router.query).length > 0)) return [
                            3,
                            4
                        ];
                        query = router.query;
                        _tmp1 = {};
                        if (query.currentTab) {
                            ;
                            tabName = (tabs === null || tabs === void 0 ? void 0 : tabs.filter(function(item) {
                                return item.slug === query.currentTab;
                            })) || [];
                            tabNameValue = (tabName === null || tabName === void 0 ? void 0 : tabName.length) > 0 ? (ref = tabName[0]) === null || ref === void 0 ? void 0 : ref.name : null;
                            if (tabNameValue) {
                                item = (_tmp1.name = tabNameValue, _tmp1.url = "/products?currentTab=".concat(query.currentTab), _tmp1);
                                defaultBreadcrumbs.push(item);
                            }
                        }
                        queryString = router.asPath.split("?")[1];
                        params = new URLSearchParams(queryString);
                        querySlug = params.get("slug");
                        basePath = querySlug ? "/manufacturers/".concat(querySlug) : "/products";
                        if (!querySlug) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getTopManufacturers()
                        ];
                    case 1:
                        topManufacturers = _state.sent();
                        manufacture = topManufacturers.find(function(item) {
                            return item.slug === querySlug;
                        });
                        _tmp2 = {};
                        if (manufacture) {
                            item1 = (_tmp2.name = manufacture === null || manufacture === void 0 ? void 0 : manufacture.shortName, _tmp2.url = "".concat(basePath, "?").concat(query.tag ? "&tag=".concat(query.tag) : "").concat(query.currentTab ? "&currentTab=".concat(query.currentTab) : ""), _tmp2);
                            defaultBreadcrumbs.push(item1);
                        }
                        _state.label = 2;
                    case 2:
                        _tmp3 = {};
                        _tmp4 = {};
                        // Handle tag breadcrumb (submenu item)
                        if (query.tag) {
                            categoryFromTree = categoryFilterTree === null || categoryFilterTree === void 0 ? void 0 : categoryFilterTree.find(function(item) {
                                var ref;
                                return (item === null || item === void 0 ? void 0 : (ref = item.mapParams) === null || ref === void 0 ? void 0 : ref.tag) === query.tag;
                            });
                            if (categoryFromTree === null || categoryFromTree === void 0 ? void 0 : categoryFromTree.label) {
                                defaultBreadcrumbs.push((_tmp3.name = categoryFromTree.label, _tmp3.url = "".concat(basePath, "?tag=").concat(query.tag), _tmp3));
                            }
                        } else {
                            // Only push "Sản phẩm" if basePath is /products (not manufacturer)
                            if (!querySlug) {
                                defaultBreadcrumbs.push((_tmp4.name = "Sản phẩm", _tmp4.url = basePath, _tmp4));
                            }
                        }
                        if (!query.filter) return [
                            3,
                            4
                        ];
                        categoryFilters = [];
                        try {
                            categoryFilters = JSON.parse(query.filter || "{}").categoryFilters || [];
                        } catch (e) {
                            categoryFilters = [];
                        }
                        normalCategory = categoryFilters.filter(function(item) {
                            return !item.isCombined;
                        });
                        combinedCategory = categoryFilters.filter(function(item) {
                            return item.isCombined;
                        });
                        return [
                            4,
                            getCategoryMapByCode()
                        ];
                    case 3:
                        mapCategories = _state.sent();
                        categoryNames = (ref3 = (ref2 = (ref1 = normalCategory === null || normalCategory === void 0 ? void 0 : normalCategory.filter(function(item) {
                            return !item.isCombined;
                        })) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, category) {
                            var codes = category.categoryCodes || [];
                            var names = codes.map(function(code) {
                                var ref;
                                return (ref = mapCategories.get(code)) === null || ref === void 0 ? void 0 : ref.name;
                            }).filter(Boolean);
                            return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(names));
                        }, [])) === null || ref2 === void 0 ? void 0 : ref2.sort(function(a, b) {
                            return a.localeCompare(b);
                        })) === null || ref3 === void 0 ? void 0 : ref3.join(" | ");
                        newCategoryFilters = (ref4 = categoryFilters === null || categoryFilters === void 0 ? void 0 : categoryFilters.filter(function(item) {
                            return !item.isCombined;
                        })) === null || ref4 === void 0 ? void 0 : ref4.map(function(cat) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cat), {
                                efficacyCodes: []
                            });
                        });
                        _tmp5 = {};
                        _tmp6 = {};
                        if (categoryNames) {
                            categoryUrl = "".concat(basePath, "?filter=").concat(JSON.stringify((_tmp5.categoryFilters = newCategoryFilters, _tmp5))).concat(query.tag ? "&tag=".concat(query.tag) : "").concat(query.currentTab ? "&currentTab=".concat(query.currentTab) : "");
                            defaultBreadcrumbs.push((_tmp6.name = categoryNames, _tmp6.url = categoryUrl, _tmp6));
                        }
                        _tmp7 = {};
                        efficacyMap = _tmp7;
                        mapCategories.forEach(function(value) {
                            var ref;
                            return (ref = value.subEfficacies) === null || ref === void 0 ? void 0 : ref.forEach(function(subEff) {
                                efficacyMap[subEff.code] = subEff;
                            });
                        });
                        normalEfficacyNames = (ref6 = (ref5 = normalCategory === null || normalCategory === void 0 ? void 0 : normalCategory.filter(function(item) {
                            return !item.isCombined;
                        })) === null || ref5 === void 0 ? void 0 : ref5.reduce(function(acc, c) {
                            return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)((c === null || c === void 0 ? void 0 : c.efficacyCodes) || []));
                        }, [])) === null || ref6 === void 0 ? void 0 : ref6.map(function(code) {
                            var ref;
                            return (ref = efficacyMap[code]) === null || ref === void 0 ? void 0 : ref.name;
                        });
                        combinedEfficacyNames = combinedCategory === null || combinedCategory === void 0 ? void 0 : combinedCategory.map(function(item) {
                            var ref;
                            return (ref = efficacyMap[item.code]) === null || ref === void 0 ? void 0 : ref.name;
                        });
                        efficacyNames = (ref8 = (ref7 = (0,_to_consumable_array/* default */.Z)(normalEfficacyNames).concat((0,_to_consumable_array/* default */.Z)(combinedEfficacyNames))) === null || ref7 === void 0 ? void 0 : ref7.sort(function(a, b) {
                            return a.localeCompare(b);
                        })) === null || ref8 === void 0 ? void 0 : ref8.join(" | ");
                        _tmp8 = {};
                        if (efficacyNames) {
                            efficacyUrl = "".concat(basePath, "?filter=").concat(query.filter).concat(query.currentTab ? "&currentTab=".concat(query.currentTab) : "").concat(query.tag ? "&tag=".concat(query.tag) : "");
                            defaultBreadcrumbs.push((_tmp8.name = efficacyNames, _tmp8.url = efficacyUrl, _tmp8));
                        }
                        _state.label = 4;
                    case 4:
                        _tmp9 = {};
                        // Add product name as last breadcrumb
                        if (product === null || product === void 0 ? void 0 : product.name) {
                            defaultBreadcrumbs.push((_tmp9.name = product.name, _tmp9.url = router.asPath, _tmp9));
                        }
                        setBreadcrumbs(defaultBreadcrumbs);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        product === null || product === void 0 ? void 0 : product.name,
        router.asPath,
        router.query,
        getCategoryMapByCode,
        categoryFilterTree,
        tabs
    ]);
    var appSetting = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.appSetting;
    });
    var flexibleWarning = appSetting[KEY];
    var errorMessageProduct = (0,convertNewAPIProduct/* getSKUErrorMessage */.V9)(product, appSetting);
    var combineImageAndVideo = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(videoUrls).concat((0,_to_consumable_array/* default */.Z)(imagesProxy)) || [];
    }, [
        imagesProxy,
        videoUrls
    ]);
    var ref28 = (0,useConfigHangDiem/* useConfigHangDiem */.x)({
        vendorInfoSellerCode: vendorInfo === null || vendorInfo === void 0 ? void 0 : vendorInfo.sellerCode
    }), isHangDiem = ref28.isHangDiem, configHangDiem = ref28.config, iconHangDiem = ref28.iconHangDiem, linkRedirect = ref28.linkRedirect;
    var condDisplayPriceAfterApplyVoucher = function() {
        var ref, ref1;
        var conditionProvince = (user === null || user === void 0 ? void 0 : user.provinceCode) ? flexibleWarning === null || flexibleWarning === void 0 ? void 0 : (ref = flexibleWarning.provinceCodesApplyFormula) === null || ref === void 0 ? void 0 : ref.includes(user === null || user === void 0 ? void 0 : user.provinceCode) : false;
        var conditionSku = (product === null || product === void 0 ? void 0 : product.sku) ? flexibleWarning === null || flexibleWarning === void 0 ? void 0 : (ref1 = flexibleWarning.skipSkus) === null || ref1 === void 0 ? void 0 : ref1.includes(product.sku) : false;
        return conditionProvince && !conditionSku && (flexibleWarning === null || flexibleWarning === void 0 ? void 0 : flexibleWarning.isActive);
    };
    var ref29 = (0,SellerService/* getSellerData */.Kz)({
        seller: product.sellerInfo,
        tags: tags
    }), sellerName = ref29.sellerName, isDisplayStore = ref29.isDisplayStore, linkStore = ref29.linkStore, linkSeller = ref29.linkSeller, _avatar = ref29.avatar, avatar = _avatar === void 0 ? [] : _avatar, _isStore = ref29.isStore, isStore = _isStore === void 0 ? false : _isStore, isInternal = ref29.isInternal, _individualNonVatSellerName = ref29.individualNonVatSellerName, individualNonVatSellerName = _individualNonVatSellerName === void 0 ? "" : _individualNonVatSellerName, fullNameSeller = ref29.fullNameSeller;
    var isOnlyDiscountWithoutValue = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (ref1 = (ref = discountPriceInfo === null || discountPriceInfo === void 0 ? void 0 : discountPriceInfo.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.discount;
        })) === null || ref === void 0 ? void 0 : ref.every(function(item) {
            return item === 0 || !item;
        })) !== null && ref1 !== void 0 ? ref1 : false;
    }, [
        discountPriceInfo
    ]);
    var handleLogical = function() {
        sendLikeFeedback({
            sku: sku,
            productId: productId
        });
    };
    (0,react.useEffect)(function() {
        if (vouchers) {
            var newInfoGift = vouchers.map(function(item) {
                return item === null || item === void 0 ? void 0 : item.gifts;
            }).filter(function(gifts) {
                return gifts;
            }).flat();
            setInfoGift(newInfoGift);
        }
    }, [
        vouchers
    ]);
    var funcRevertListProductDetail = function(productDeal) {
        var ref;
        return (ref = productDeal.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.status) !== "OUT_OF_STOCK";
        })) === null || ref === void 0 ? void 0 : ref.map(function(productInCombo) {
            var ref;
            if ((productInCombo === null || productInCombo === void 0 ? void 0 : (ref = productInCombo.skus) === null || ref === void 0 ? void 0 : ref.length) === 1) {
                var ref1, ref2;
                var retalPriceIndividualProduct = (productInCombo === null || productInCombo === void 0 ? void 0 : productInCombo.displayPrice) / (productInCombo === null || productInCombo === void 0 ? void 0 : (ref1 = productInCombo.skus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.quantity);
                var retalPriceDifferencePrice = Math.ceil(product.displayPrice - retalPriceIndividualProduct);
                if (retalPriceDifferencePrice > 0) {
                    // eslint-disable-next-line no-param-reassign
                    productInCombo.retalPriceDifferencePrice = (0,FormatNumber/* formatCurrency */.xG)(retalPriceDifferencePrice);
                }
            }
            return productInCombo;
        });
    };
    var conditionIsSame = function(stepsShallow) {
        var ref;
        return (0,helper/* isEqual */.Xy)(stepState === null || stepState === void 0 ? void 0 : stepState.stepsFinish, stepsShallow) && (stepsShallow === null || stepsShallow === void 0 ? void 0 : stepsShallow.length) === (stepState === null || stepState === void 0 ? void 0 : (ref = stepState.stepsFinish) === null || ref === void 0 ? void 0 : ref.length);
    };
    var ref30 = (0,react.useState)(false), showSubstituteGuide = ref30[0], setShowSubstituteGuide = ref30[1];
    function handleShowSusbstituteGuide() {
        return _handleShowSusbstituteGuide.apply(this, arguments);
    }
    function _handleShowSusbstituteGuide() {
        _handleShowSusbstituteGuide = (0,_async_to_generator/* default */.Z)(function() {
            var respCheckGuide, _tmp, dataCheckGuide;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,CustomerClient/* getUserLogGuide */.Xd)((_tmp.q = {
                                feature: guideline/* GUIDE_FEATURE.SUBSTITUTE_SKU_OTHERS */.Z.SUBSTITUTE_SKU_OTHERS
                            }, _tmp))
                        ];
                    case 1:
                        respCheckGuide = _state.sent();
                        if (respCheckGuide.status === "OK") {
                            dataCheckGuide = (0,Clients/* getFirst */.Xi)(respCheckGuide);
                            if ((dataCheckGuide === null || dataCheckGuide === void 0 ? void 0 : dataCheckGuide.isActive) && !(dataCheckGuide === null || dataCheckGuide === void 0 ? void 0 : dataCheckGuide.isGuided)) {
                                setShowSubstituteGuide(true);
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleShowSusbstituteGuide.apply(this, arguments);
    }
    function handleShowGuide(stepsShallow) {
        return _handleShowGuide.apply(this, arguments);
    }
    function _handleShowGuide() {
        _handleShowGuide = (0,_async_to_generator/* default */.Z)(function(stepsShallow) {
            var meGuide, ref, isSame, isSameStep;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,CustomerService/* getMeGuide */.iW)(guideline/* GUIDE_FEATURE.PRODUCT_DETAIL */.Z.PRODUCT_DETAIL)
                        ];
                    case 1:
                        meGuide = _state.sent();
                        if (meGuide.isActive && !meGuide.isGuided) {
                            ;
                            isSame = conditionIsSame(stepsShallow);
                            if ((stepState === null || stepState === void 0 ? void 0 : (ref = stepState.stepsFinish) === null || ref === void 0 ? void 0 : ref.length) > (stepsShallow === null || stepsShallow === void 0 ? void 0 : stepsShallow.length)) {
                                isSameStep = stepsShallow.some(function(x) {
                                    var ref;
                                    return stepState === null || stepState === void 0 ? void 0 : (ref = stepState.stepsFinish) === null || ref === void 0 ? void 0 : ref.includes(x);
                                });
                                if (isSameStep) {
                                    setOpen(false);
                                    handleShowSusbstituteGuide();
                                    return [
                                        2
                                    ];
                                }
                            } else if (!(stepState === null || stepState === void 0 ? void 0 : stepState.isFinish) && !isSame) {
                                setOpen(true);
                                return [
                                    2
                                ];
                            }
                        }
                        handleShowSusbstituteGuide();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleShowGuide.apply(this, arguments);
    }
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, sameProduct, productDeals, _tmp, _tmp1, stepsShallow, ref1, productDeal, revertListProductDeal, productDealsWithTracking, ref2, ref3, ref4, listProductSame, revertListProductSame, productSameWithTracking, error, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        setLoading(function(prevLoading) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLoading), {
                                recommendations: true,
                                sameProduct: true,
                                productDeals: true
                            });
                        });
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            Promise.all([
                                ProductServiceV2/* default.getSearchSameProduct */.ZP.getSearchSameProduct((_tmp.productCode = product === null || product === void 0 ? void 0 : product.skuId, _tmp)),
                                !(product === null || product === void 0 ? void 0 : product.isCombo) && ProductServiceV2/* default.getComboContainingProduct */.ZP.getComboContainingProduct((_tmp1.skuCode = product === null || product === void 0 ? void 0 : product.sku, _tmp1))
                            ])
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), sameProduct = ref[0], productDeals = ref[1];
                        setLoading(function(prevLoading) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLoading), {
                                recommendations: false,
                                sameProduct: false,
                                productDeals: false
                            });
                        });
                        stepsShallow = (0,_to_consumable_array/* default */.Z)(defaultSteps);
                        if (!(product === null || product === void 0 ? void 0 : product.isCombo)) {
                            ;
                            productDeal = mapDataProduct((ref1 = (0,Clients/* getData */.Yu)(productDeals)) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
                                return item.isAvailable;
                            }));
                            revertListProductDeal = (0,ProductService/* moveKcbPriorityFirst */.tP)(funcRevertListProductDetail(productDeal), isKcbVerified);
                            if (revertListProductDeal.length > 0) {
                                setDefaultSteps(function(steps) {
                                    return (0,_to_consumable_array/* default */.Z)(steps).concat([
                                        "productsDeal"
                                    ]);
                                });
                                stepsShallow.push("productsDeal");
                            }
                            productDealsWithTracking = revertListProductDeal.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    blockCode: tracking/* EnumBlockCodeTracking.PRODUCT_DETAIL_COMBO_SUGGESTION */.x.PRODUCT_DETAIL_COMBO_SUGGESTION
                                });
                            });
                            setProductDeals(productDealsWithTracking);
                        }
                        if (sameProduct && (0,Clients/* isValid */.JY)(sameProduct)) {
                            ;
                            listProductSame = (0,ProductService/* getSortedProducts */.LB)(((ref3 = (ref2 = (0,Clients/* getData */.Yu)(sameProduct)) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                                return (item === null || item === void 0 ? void 0 : item.sku) !== (product === null || product === void 0 ? void 0 : product.sku);
                            })) === null || ref3 === void 0 ? void 0 : ref3.map(function(prd) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prd), {
                                    isSameProduct: true
                                });
                            })) || []);
                            revertListProductSame = (0,ProductService/* moveKcbPriorityFirst */.tP)((ref4 = listProductSame.filter(function(x) {
                                return (x === null || x === void 0 ? void 0 : x.status) !== "OUT_OF_STOCK";
                            })) === null || ref4 === void 0 ? void 0 : ref4.sort(function(a, b) {
                                return (a === null || a === void 0 ? void 0 : a.displayPrice) - (b === null || b === void 0 ? void 0 : b.displayPrice);
                            }), isKcbVerified);
                            if (revertListProductSame.length > 0) {
                                setDefaultSteps(function(steps) {
                                    return (0,_to_consumable_array/* default */.Z)(steps).concat([
                                        "productsSame"
                                    ]);
                                });
                                stepsShallow.push("productsSame");
                            }
                            productSameWithTracking = revertListProductSame.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    blockCode: tracking/* EnumBlockCodeTracking.PRODUCT_DETAIL_SAME_PRODUCT_ID */.x.PRODUCT_DETAIL_SAME_PRODUCT_ID
                                });
                            });
                            setProductsSame(productSameWithTracking);
                            setLoading(function(prevLoading) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLoading), {
                                    sameIngredient: false
                                });
                            });
                        }
                        return [
                            4,
                            handleShowGuide(stepsShallow)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error fetching data:", error);
                        _tmp2 = {};
                        setLoading((_tmp2.recommendations = false, _tmp2.sameProduct = false, _tmp2.productDeals = false, _tmp2.productBySeller = false, _tmp2.sameIngredient = false, _tmp2.voucherCollectList = false, _tmp2));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchCollectionVoucher = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp, _tmp1, querySellerPromos, _tmp2, ref, respMarketplacePromos, respSellerPromos, _tmp3, vouchersList, _vouchersList, _vouchersList1, _tmp4, _tmp5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        setLoading((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, loading), (_tmp1.voucherCollectList = true, _tmp1)));
                        _tmp2 = {};
                        querySellerPromos = (_tmp2.ctx = "", _tmp2.accountID = user === null || user === void 0 ? void 0 : user.accountId, _tmp2.scope = "seller", _tmp2.sellerCode = sellerCode, _tmp2.getVoucherToCollect = true, _tmp2.skipVoucherCollected = false, _tmp2.storeCode = "", _tmp2.getMedxVoucherOnly = false, _tmp2);
                        if (sellerCode === "MEDX" && (vendorInfo === null || vendorInfo === void 0 ? void 0 : vendorInfo.storeType) === "FLAGSHIP") {
                            querySellerPromos.sellerCode = "";
                            querySellerPromos.storeCode = vendorInfo.code;
                        } else if (sellerCode === "MEDX") {
                            querySellerPromos.getMedxVoucherOnly = true;
                        }
                        _tmp3 = {};
                        return [
                            4,
                            Promise.all([
                                (0,PromoClient/* postVoucherList */.QC)((_tmp3.ctx = "", _tmp3.accountID = user === null || user === void 0 ? void 0 : user.accountId, _tmp3.scope = "marketplace", _tmp3.sellerCode = sellerCode, _tmp3.getVoucherToCollect = true, _tmp3.skipVoucherCollected = false, _tmp3)),
                                (0,PromoClient/* postVoucherList */.QC)(querySellerPromos)
                            ])
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), respMarketplacePromos = ref[0], respSellerPromos = ref[1];
                        vouchersList = [];
                        // handle resp voucher collect list
                        if ((0,Clients/* isValid */.JY)(respSellerPromos)) {
                            ;
                            (_vouchersList = vouchersList).push.apply(_vouchersList, (0,_to_consumable_array/* default */.Z)((0,Clients/* getData */.Yu)(respSellerPromos)));
                        }
                        if ((0,Clients/* isValid */.JY)(respMarketplacePromos)) {
                            ;
                            (_vouchersList1 = vouchersList).push.apply(_vouchersList1, (0,_to_consumable_array/* default */.Z)((0,Clients/* getData */.Yu)(respMarketplacePromos)));
                        }
                        setListVoucherProduct(vouchersList);
                        _tmp4 = {};
                        _tmp5 = {};
                        setLoading((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp4, loading), (_tmp5.voucherCollectList = false, _tmp5)));
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchCollectionVoucher() {
            return _ref.apply(this, arguments);
        };
    }();
    // Attach a popstate event listener
    var handlePopstate = function() {
        // Reload the page
        window.location.reload();
    };
    (0,react.useEffect)(function() {
        fetchData();
        fetchCollectionVoucher();
        window.addEventListener("popstate", handlePopstate);
        return function() {
            window.removeEventListener("popstate", handlePopstate);
        };
    }, [
        product === null || product === void 0 ? void 0 : product.slug
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = product.skuReplace) === null || ref === void 0 ? void 0 : ref.length) {
            var ref1;
            setIsShowViewMore(product.skuReplace.length > 1);
            // seller lấy từ DTO lite (BFF đã dựng tên/link như card SP mua kèm)
            var ref2 = ((ref1 = product.skuReplaceLite) === null || ref1 === void 0 ? void 0 : ref1[0]) || {}, sellerName = ref2.sellerName, sellerUrl = ref2.sellerUrl;
            setProductReplace((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ProductServiceV2/* default.convertProductV2 */.ZP.convertProductV2(product.skuReplace[0])), {
                sellerName: sellerName,
                sellerUrl: sellerUrl
            }));
        }
    }, []);
    var toggleOpenModal = function() {
        setOpenModal(function(isOpen) {
            return !isOpen;
        });
    };
    var closeModal = function() {
        setOpenModal(false);
        turnOnScrollBody();
    };
    var handleOpen = function() {
        setShowGiftModal(true);
    };
    var date = new Date(campaign === null || campaign === void 0 ? void 0 : campaign.campaign.startTime);
    var monthYear = "".concat(date.getMonth() + 1, "/").concat(date.getFullYear());
    var conditionRenderTitle = function(type) {
        return type ? "Bạn đ\xe3 phản hồi cho ".concat(Enums/* BRAND_NAME */.RS, " trong tuần n\xe0y") : "Gi\xe1 hợp l\xfd";
    };
    var conditionRenderTitleFb = function(type) {
        return type ? "Bạn đ\xe3 phản hồi cho ".concat(Enums/* BRAND_NAME */.RS, " trong tuần n\xe0y") : "Gi\xe1 cao";
    };
    var conditionRenderNextLevel = function() {
        return nextPrice > 0 && (product === null || product === void 0 ? void 0 : product.status) !== "OUT_OF_STOCK";
    };
    var conditionRenderIntroduce = function() {
        var ref, ref1;
        return (seller === null || seller === void 0 ? void 0 : seller.code) && sellerName && ((product === null || product === void 0 ? void 0 : (ref = product.sellerInfo) === null || ref === void 0 ? void 0 : ref.description) || (product === null || product === void 0 ? void 0 : (ref1 = product.vendorInfo) === null || ref1 === void 0 ? void 0 : ref1.description));
    };
    var conditionRenderIntroduceHardCode = function() {
        return (product === null || product === void 0 ? void 0 : product.vendorInfo) && Object.keys(product.vendorInfo).length > 0 && (seller === null || seller === void 0 ? void 0 : seller.code) && sellerName;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)((PcScreen_styles_module_default()).wrapperContainer, openModal && (PcScreen_styles_module_default()).showModal),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                disableGutters: true,
                style: {
                    maxWidth: "1180px"
                },
                children: [
                    breadcrumbs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: "10px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            breadcrumbs: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 3,
                        className: (PcScreen_styles_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 4,
                                ref: refOne,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PcScreen_styles_module_default()).bigImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContent, {
                                        product: product,
                                        imagesProxy: (combineImageAndVideo === null || combineImageAndVideo === void 0 ? void 0 : combineImageAndVideo.length) === 0 ? [
                                            Images/* MISSING_IMAGE */.g_W
                                        ] : combineImageAndVideo,
                                        orderedCount: orderedCount,
                                        user: user,
                                        limitPerDay: limitPerDay,
                                        messageLimitOrder: messageLimitOrder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                className: (PcScreen_styles_module_default()).rightGrid,
                                xs: 8,
                                children: [
                                    productType !== "NORMAL" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_HotInfo, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_PromoType, {
                                            productType: campaign === null || campaign === void 0 ? void 0 : campaign.campaign,
                                            monthYear: monthYear
                                        }),
                                        productType: productType,
                                        campaign: campaign,
                                        deal: deal
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                className: (PcScreen_styles_module_default()).typographyTitle,
                                                variant: "h1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagshipLabel, {
                                                        isVip: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isVip,
                                                        isStore: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isStore,
                                                        productTags: product === null || product === void 0 ? void 0 : product.tags,
                                                        isHangDiem: isHangDiem,
                                                        hangdiemConfig: configHangDiem || {}
                                                    }),
                                                    (product === null || product === void 0 ? void 0 : product.isTagGift) && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_TagGiftComp, {}),
                                                    " ",
                                                    name || ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                className: (PcScreen_styles_module_default()).typographyRight,
                                                children: [
                                                    " ",
                                                    volume || ""
                                                ]
                                            })
                                        ]
                                    }),
                                    errorMessageProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "error",
                                        textalign: "center",
                                        children: errorMessageProduct || "Đang cập nhật gi\xe1"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PcScreen_styles_module_default()).rowPrice,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (PcScreen_styles_module_default()).priceInfo,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_ProductDetailPrices, {
                                                    discountInfos: discountPriceInfo,
                                                    originPrice: originPrice,
                                                    tempPrice: displayPriceFormated,
                                                    isOnlyDiscountWithoutValue: isOnlyDiscountWithoutValue,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        className: (0,clsx/* default */.Z)((PcScreen_styles_module_default()).price, "flex items-baseline"),
                                                        children: [
                                                            (product === null || product === void 0 ? void 0 : product.status) !== "OUT_OF_STOCK" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                                displayPriceFormated: displayPriceFormated,
                                                                size: "lg",
                                                                fillPath: "#0C884E"
                                                            }, product.sku),
                                                            (discountPriceInfo === null || discountPriceInfo === void 0 ? void 0 : discountPriceInfo.length) && !isOnlyDiscountWithoutValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: Images/* PRODUCT_DETAIL_VOUCHER_ICON_PATH */.xSH,
                                                                alt: "icon",
                                                                width: 20,
                                                                height: 20
                                                            }) : null
                                                        ]
                                                    })
                                                }),
                                                discountPercent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        gap: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (PcScreen_styles_module_default()).originalPrice,
                                                            children: (product === null || product === void 0 ? void 0 : product.status) !== "OUT_OF_STOCK" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                                displayPriceFormated: salePriceFormated || 0,
                                                                size: "sm",
                                                                fillPath: "#8D8D8D",
                                                                line: true
                                                            }, product.sku)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: (PcScreen_styles_module_default()).discountPercent,
                                                            children: [
                                                                " -",
                                                                discountPercent,
                                                                "%"
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRetailPrice, {
                                        price: highProfitRetailPrice,
                                        profit: highProfitRetailValue
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.status) !== "OUT_OF_STOCK" && !errorMessageProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailAlertPriceAfterApplyVoucher, {
                                        text: (product === null || product === void 0 ? void 0 : product.isHighProfit) ? flexibleWarning === null || flexibleWarning === void 0 ? void 0 : (ref = flexibleWarning.text) === null || ref === void 0 ? void 0 : ref.highProfitText : flexibleWarning === null || flexibleWarning === void 0 ? void 0 : (ref1 = flexibleWarning.text) === null || ref1 === void 0 ? void 0 : ref1.defaultText,
                                        condition: condDisplayPriceAfterApplyVoucher(),
                                        isProductDetail: true,
                                        style: flexibleWarning === null || flexibleWarning === void 0 ? void 0 : flexibleWarning.style
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreen_styles_module_default()).hightLightTag,
                                        children: [
                                            medicineTypeLabels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PcScreen_styles_module_default()).medicineType,
                                                children: medicineTypeLabels.map(function(info) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                        src: info.icon.src,
                                                        height: 20,
                                                        width: Math.round(info.icon.width / info.icon.height * 20),
                                                        alt: info.label
                                                    }, info.variant);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagComponent/* default */.Z, {
                                                product: {
                                                    tags: product.tags,
                                                    statusData: product.statusData,
                                                    expiredDate: product.expiredDate,
                                                    isProductDetailPage: true,
                                                    isHangDiemStore: isHangDiem,
                                                    iconHangDiem: iconHangDiem
                                                },
                                                isProductCard: false,
                                                isSellerList: false,
                                                isPageDetail: true,
                                                link: isHangDiem ? linkRedirect : link,
                                                isLinkTagDeal: true
                                            })
                                        ]
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.retailPriceApplyVoucher) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_PriceAfterDiscount, {
                                        retailPriceApplyVoucher: product === null || product === void 0 ? void 0 : product.retailPriceApplyVoucher
                                    }),
                                    doseUnitName != "" && retailPricePerUnit > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreen_styles_module_default()).referenceRetailPrice,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachMoney/* default */.Z, {
                                                sx: {
                                                    color: "#797979",
                                                    border: "1px solid",
                                                    borderRadius: "100%",
                                                    fontSize: "14px"
                                                },
                                                styles: true
                                            }),
                                            "Gi\xe1 mua lẻ tr\xean từng ",
                                            doseUnitName === null || doseUnitName === void 0 ? void 0 : doseUnitName.toLowerCase(),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                    displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(retailPricePerUnit),
                                                    fillPath: "#0C884E",
                                                    size: "sm"
                                                }, product === null || product === void 0 ? void 0 : product.sku)
                                            })
                                        ]
                                    }) : null,
                                    conditionRenderNextLevel() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        className: (PcScreen_styles_module_default()).promoLevel,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoneyIcon, {}),
                                            "Bạn sẽ mua được gi\xe1",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreen_styles_module_default()).pricePromo,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                    displayPriceFormated: nextPrice,
                                                    size: "sm",
                                                    fillPath: "#0C884E"
                                                }, product === null || product === void 0 ? void 0 : product.sku)
                                            }),
                                            " ",
                                            "khi đạt cấp bậc ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreen_styles_module_default()).level,
                                                children: Enums/* LEVEL_CUSTOMER */.LB[nextLevel]
                                            })
                                        ]
                                    }) : null,
                                    infoGift.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionProduct_PromotionPC, {
                                        handleOpen: handleOpen,
                                        listsPromo: vouchers,
                                        listPromoProduct: infoGift
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComboList, {
                                        skus: product.skus
                                    }),
                                    loading.voucherCollectList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailLoading/* VoucherCollectListSkeleton */.r, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !errorMessageProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SlideCoupon, {
                                            coupons: listVoucherProduct,
                                            sellerCode: sellerCode,
                                            sku: sku,
                                            skuName: name,
                                            sellerName: fullNameSeller,
                                            vendorInfo: vendorInfo
                                        })
                                    }),
                                    !errorMessageProduct && !!(product === null || product === void 0 ? void 0 : (ref2 = product.crossSell) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestProductBlock/* default */.Z, {
                                                id: "product__replace",
                                                flush: true,
                                                substitutes: product.skuReplaceLite,
                                                crossSell: product.crossSell,
                                                quantityVariant: "quickOrder",
                                                mainSKU: sku,
                                                mainSKUProductId: productId === null || productId === void 0 ? void 0 : productId.toString(),
                                                mainSKUSellerId: product === null || product === void 0 ? void 0 : product.sellerID,
                                                mainType: (product === null || product === void 0 ? void 0 : product.errorCode) || "NORMAL"
                                            }),
                                            showSubstituteGuide && !!(product === null || product === void 0 ? void 0 : (ref3 = product.skuReplaceLite) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourSubstituteSKU, {})
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(detail_product_new_ReplaceProduct, {
                                        productReplace: productReplace,
                                        isShowViewMore: isShowViewMore,
                                        slugCurrent: slug,
                                        showGuide: showSubstituteGuide,
                                        productParent: product
                                    }),
                                    loading.sameProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        variant: "rect",
                                        width: "100%",
                                        height: 129
                                    }) : (productsSame === null || productsSame === void 0 ? void 0 : productsSame.length) > 0 && !(configs === null || configs === void 0 ? void 0 : (ref4 = configs["HIDE_SPECIFIED_BLOCKS_IN_PRODUCT_DETAIL_BY_SELLER"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sellerCodes) === null || ref5 === void 0 ? void 0 : ref5.includes(product === null || product === void 0 ? void 0 : product.sellerCode)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_AnotherSeller, {
                                        productCompare: product,
                                        products: productsSame,
                                        title: "C\xe1c nh\xe0 b\xe1n h\xe0ng kh\xe1c cũng b\xe1n sản phẩm n\xe0y",
                                        ref: refTwo,
                                        toggleOpenModal: toggleOpenModal,
                                        sellerTypeNoViewMore: SellerTypeNoViewMore
                                    }, "AnotherSeller-".concat(slug)),
                                    !(configs === null || configs === void 0 ? void 0 : (ref6 = configs["HIDE_SPECIFIED_BLOCKS_IN_PRODUCT_DETAIL_BY_SELLER"]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sellerCodes) === null || ref7 === void 0 ? void 0 : ref7.includes(product === null || product === void 0 ? void 0 : product.sellerCode)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_BuyWithDeal, {
                                        products: productDeals,
                                        ref: refThree,
                                        link: link
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreen_styles_module_default()).groupInfoSeller,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_OtherInfoSeller, {
                                                product: product,
                                                fullName: individualNonVatSellerName || sellerName,
                                                slug: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.slug,
                                                avatar: avatar,
                                                seller: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, seller), {
                                                    vendorSellerCode: vendorInfo === null || vendorInfo === void 0 ? void 0 : vendorInfo.sellerCode
                                                }),
                                                isStore: isStore,
                                                isInternal: isInternal,
                                                isDisplayStore: isDisplayStore,
                                                linkSeller: linkSeller,
                                                linkStore: linkStore,
                                                isVip: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isVip
                                            }, "OtherInfoSeller-".concat(slug)),
                                            conditionRenderIntroduceHardCode() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (product === null || product === void 0 ? void 0 : (ref8 = product.vendorInfo) === null || ref8 === void 0 ? void 0 : ref8.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (PcScreen_styles_module_default()).commonContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            className: (PcScreen_styles_module_default()).titleCommon,
                                                            children: "Giới thiệu chung"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (PcScreen_styles_module_default()).content,
                                                            dangerouslySetInnerHTML: {
                                                                __html: (product === null || product === void 0 ? void 0 : (ref9 = product.vendorInfo) === null || ref9 === void 0 ? void 0 : ref9.description) || ""
                                                            }
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: conditionRenderIntroduce() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (PcScreen_styles_module_default()).commonContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            className: (PcScreen_styles_module_default()).titleCommon,
                                                            children: "Giới thiệu chung"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (PcScreen_styles_module_default()).content,
                                                            dangerouslySetInnerHTML: {
                                                                __html: (product === null || product === void 0 ? void 0 : (ref10 = product.sellerInfo) === null || ref10 === void 0 ? void 0 : ref10.description) || (product === null || product === void 0 ? void 0 : (ref11 = product.vendorInfo) === null || ref11 === void 0 ? void 0 : ref11.description) || ""
                                                            }
                                                        })
                                                    ]
                                                }) : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionInformation, {
                        product: product,
                        ref: refFour
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAndAnswer, {
                        user: user,
                        targetCode: sku,
                        priceFeedback: !errorMessageProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PcScreen_styles_module_default()).assessPrice,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (PcScreen_styles_module_default()).typographyRight,
                                    children: " Bạn thấy gi\xe1 n\xe0y?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_IconButtonCustom, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbUpOffAlt/* default */.Z, {}),
                                    isDisabled: !!(feedback === null || feedback === void 0 ? void 0 : feedback.type) || (feedback === null || feedback === void 0 ? void 0 : feedback.disabledFeedbackPrice),
                                    isHightLight: (feedback === null || feedback === void 0 ? void 0 : feedback.type) === sysconfig/* LIKE_FEEDBACK_CODE */.wN,
                                    onClick: handleLogical,
                                    title: "Hợp l\xed",
                                    tooltipTitle: conditionRenderTitle(feedback === null || feedback === void 0 ? void 0 : feedback.type)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_IconButtonCustom, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbDownOffAlt/* default */.Z, {}),
                                    isDisabled: !!(feedback === null || feedback === void 0 ? void 0 : feedback.type) || (feedback === null || feedback === void 0 ? void 0 : feedback.disabledFeedbackPrice),
                                    isHightLight: (feedback === null || feedback === void 0 ? void 0 : feedback.type) === sysconfig/* DISLIKE_FEEDBACK_CODE */.bO,
                                    onClick: toggleModalHighPrice,
                                    title: "Cao",
                                    tooltipTitle: conditionRenderTitleFb(feedback === null || feedback === void 0 ? void 0 : feedback.type)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsRecommendation, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSameSeller, {
                        product: product,
                        sellerInfo: sellerInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSameIngredient, {
                        product: product
                    }),
                    isShowModalHighPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_FeedbackPriceFormModal, {
                        productId: productId,
                        sku: sku,
                        visible: isShowModalHighPrice,
                        onClose: toggleModalHighPrice
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detail_product_new_ModalViewMore, {
                product: product,
                imagesProxy: imagesProxy,
                orderedCount: orderedCount,
                user: user,
                openModal: openModal,
                limitPerDay: limitPerDay,
                messageLimitOrder: messageLimitOrder,
                closeModal: closeModal,
                monthYear: monthYear,
                productType: productType,
                name: name,
                volume: volume,
                displayPriceFormated: displayPriceFormated,
                salePriceFormated: salePriceFormated,
                discountPercent: discountPercent,
                productsSame: productsSame,
                sellerInfo: sellerInfo,
                campaign: campaign,
                deal: deal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_PromotionDetailModal, {
                className: (PcScreen_styles_module_default()).promoTionWrap,
                visible: showGiftModal,
                onClose: function() {
                    setShowGiftModal(false);
                },
                title: "Khuyến m\xe3i qu\xe0 tặng",
                listsPromo: vouchers
            }),
            (stepState === null || stepState === void 0 ? void 0 : stepState.isFinish) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(TourIntro/* default */.Z, {
                steps: [
                    {
                        context: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "H\xecnh ảnh sản phẩm, n\xfat mua h\xe0ng được thay đổi vị tr\xed để qu\xfd kh\xe1ch h\xe0ng c\xf3 trải nghiệm mua sắm thuận tiện hơn!"
                        }),
                        position: "right",
                        name: "addToCart",
                        refCurrent: refOne,
                        stylesArrow: {
                            transform: "rotate(90deg)",
                            top: "10%",
                            left: "-28px"
                        }
                    },
                    {
                        context: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "Qu\xfd kh\xe1ch c\xf3 thể nhanh ch\xf3ng t\xecm kiếm, so s\xe1nh gi\xe1 b\xe1n của c\xf9ng một sản phẩm đến từ c\xe1c nh\xe0 b\xe1n h\xe0ng kh\xe1c nhau."
                        }),
                        position: "left",
                        name: "productsSame",
                        refCurrent: refTwo,
                        stylesArrow: {
                            transform: "rotate(-90deg)",
                            top: "10%",
                            right: "-28px"
                        }
                    },
                    {
                        context: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Với mục ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (PcScreen_styles_module_default()).dealShock,
                                    children: "Mua K\xe8m Deal Sốc"
                                }),
                                ", qu\xfd kh\xe1ch c\xf3 thể xem c\xe1c combo, ưu đ\xe3i của sản phẩm đang xem."
                            ]
                        }),
                        position: "left",
                        name: "productsDeal",
                        refCurrent: refThree,
                        stylesArrow: {
                            transform: "rotate(-90deg)",
                            top: "10%",
                            right: "-28px"
                        }
                    },
                    {
                        context: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "Th\xf4ng tin sản phẩm giờ đ\xe2y được sắp xếp lại gi\xfap qu\xfd kh\xe1ch theo d\xf5i th\xf4ng tin một c\xe1ch dễ d\xe0ng hơn."
                        }),
                        position: "top",
                        name: "infoProduct",
                        refCurrent: refFour,
                        stylesArrow: {
                            transform: "rotate(-90deg)",
                            top: "10%",
                            right: "-28px"
                        }
                    }, 
                ],
                name: "stepProductDetail",
                isReady: isReady,
                onFinish: onFinish
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTour, {
                open: open,
                handleCloseModal: handleClose,
                handleConfirmModal: handleConfirmModal,
                defaultSteps: defaultSteps,
                stepsFinish: stepState === null || stepState === void 0 ? void 0 : stepState.stepsFinish
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreenNotLogin/styles.module.css
var PcScreenNotLogin_styles_module = __webpack_require__(54747);
var PcScreenNotLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(PcScreenNotLogin_styles_module);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabContext/TabContext.js
var TabContext = __webpack_require__(78207);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabList/TabList.js
var TabList = __webpack_require__(37313);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabPanel/TabPanel.js
var TabPanel = __webpack_require__(64532);
// EXTERNAL MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreenNotLogin/InfoProduct.module.css
var InfoProduct_module = __webpack_require__(23034);
var InfoProduct_module_default = /*#__PURE__*/__webpack_require__.n(InfoProduct_module);
;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreenNotLogin/InfoProduct.tsx















// this is a clone component
// need to refactor, build a new component
var InfoProduct = /*#__PURE__*/ (0,react.forwardRef)(function InfoProduct(param, ref) {
    var className = param.className, product = param.product, onClickBait = param.onClickBait;
    var _$ref;
    var _$ref1 = product === null || product === void 0 ? void 0 : product.description, contraindication = _$ref1.contraindication, dosage = _$ref1.dosage, drugInteraction = _$ref1.drugInteraction, drugOverdose = _$ref1.drugOverdose, indication = _$ref1.indication, storage = _$ref1.storage;
    var parentRef = (0,react.useRef)(null);
    var _$ref2 = (0,react.useState)(false), isDisplaySecondTab = _$ref2[0], setIsDisplaySecondTab = _$ref2[1];
    var _$ref3 = (0,react.useState)([]), ingredientEle = _$ref3[0], setIngredientEle = _$ref3[1];
    var isHtmlStringEmpty = function(htmlString) {
        if (!htmlString) return true;
        // Remove whitespace characters and tags using a regular expression
        var cleanString = htmlString === null || htmlString === void 0 ? void 0 : htmlString.replace(/<[^>]*>/g, "").replace(/\s/g, "");
        // Check if the cleaned string is empty or contains only <br> tags
        return (cleanString === null || cleanString === void 0 ? void 0 : cleanString.length) === 0 || /^<br>+$/.test(cleanString);
    };
    var handleShowHide = function() {
        if (parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) {
            parentRef.current.style.height = "100%";
        }
    };
    var handleChange = function(e, newValue) {
        if (newValue === "2") {
            onClickBait();
        }
    };
    (0,react.useLayoutEffect)(function() {
        handleShowHide();
    }, []);
    (0,react.useEffect)(function() {
        setIsDisplaySecondTab(!isHtmlStringEmpty(indication || drugInteraction || drugOverdose || contraindication || dosage || storage));
        (0,_async_to_generator/* default */.Z)(function() {
            var _$ref, _$ref1, newIngredientEle;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (((_$ref = product.ingredients) === null || _$ref === void 0 ? void 0 : _$ref.length) > 0) {
                    ;
                    newIngredientEle = (_$ref1 = product.ingredients) === null || _$ref1 === void 0 ? void 0 : _$ref1.map(function(param) {
                        var ingredientVolume = param.volume, tmp = param.name, ingredientName = tmp === void 0 ? "" : tmp, slug = param.slug;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between"
                            },
                            className: (0,clsx/* default */.Z)((InfoProduct_module_default()).groupIngredient, (InfoProduct_module_default()) === null || (InfoProduct_module_default()) === void 0 ? void 0 : (InfoProduct_module_default()).groupIngredientIsNotLogin),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "".concat((InfoProduct_module_default()).ingredientLink),
                                    children: ingredientName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (InfoProduct_module_default()).ingredientVolume,
                                    children: ingredientVolume
                                })
                            ]
                        }, slug);
                    });
                    setIngredientEle((0,_to_consumable_array/* default */.Z)(newIngredientEle));
                } else {
                    setIngredientEle([]);
                }
                return [
                    2
                ];
            });
        })();
    }, [
        product.ingredients
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)((InfoProduct_module_default()).container, className),
            ref: parentRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContext/* default */.ZP, {
                value: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            borderBottom: 1,
                            borderColor: "divider"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabList/* default */.Z, {
                            className: (InfoProduct_module_default()).tabList,
                            onChange: handleChange,
                            TabIndicatorProps: {
                                style: {
                                    background: "var(--primary-color)"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    label: "Th\xf4ng tin chung",
                                    value: "1"
                                }),
                                isDisplaySecondTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    label: "Th\xf4ng tin chuy\xean s\xe2u",
                                    value: "2"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                        className: (0,clsx/* default */.Z)((InfoProduct_module_default()).tabPanelCustom),
                        value: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            className: (InfoProduct_module_default()).paddingCustom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    lg: 6,
                                    sm: 12,
                                    className: (0,clsx/* default */.Z)((InfoProduct_module_default()).leftContentNotLogin, (InfoProduct_module_default()).leftSideNotLogin),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (InfoProduct_module_default()).wrapperInfo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: (InfoProduct_module_default()).infoNotLogin,
                                                children: "Th\xf4ng tin"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (InfoProduct_module_default()).contentNotLogin,
                                                dangerouslySetInnerHTML: {
                                                    __html: replaceImgSrc(product === null || product === void 0 ? void 0 : (_$ref = product.description) === null || _$ref === void 0 ? void 0 : _$ref.description)
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    lg: 6,
                                    sm: 12,
                                    className: (0,clsx/* default */.Z)((InfoProduct_module_default()).rightContentNotLogin),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (InfoProduct_module_default()).wrapperInfo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: (InfoProduct_module_default()).infoNotLogin,
                                                children: "Th\xe0nh phần"
                                            }),
                                            (ingredientEle === null || ingredientEle === void 0 ? void 0 : ingredientEle.length) > 0 && (ingredientEle === null || ingredientEle === void 0 ? void 0 : ingredientEle.map(function(item) {
                                                return item;
                                            }))
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
});
/* harmony default export */ var PcScreenNotLogin_InfoProduct = (InfoProduct);

;// CONCATENATED MODULE: ./src/components-v2/organisms/pages/detail-product-new/PcScreenNotLogin/index.js



















var EyeIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.9233 7.16817C15.3861 5.90591 14.7082 4.81281 13.8897 3.88889C13.0711 2.96497 12.1567 2.25576 11.1463 1.76126C10.1359 1.25375 9.08713 1 8 1C6.91287 1 5.86411 1.25375 4.85372 1.76126C3.84333 2.25576 2.92886 2.96497 2.11031 3.88889C1.29177 4.81281 0.613909 5.90591 0.0767386 7.16817C-0.0255795 7.38939 -0.0255795 7.61061 0.0767386 7.83183C0.613909 9.09409 1.29177 10.1872 2.11031 11.1111C2.92886 12.035 3.84333 12.7507 4.85372 13.2583C5.86411 13.7528 6.91287 14 8 14C9.08713 14 10.1359 13.7528 11.1463 13.2583C12.1567 12.7507 13.0711 12.035 13.8897 11.1111C14.7082 10.1872 15.3861 9.09409 15.9233 7.83183C16.0256 7.61061 16.0256 7.38939 15.9233 7.16817ZM8 12.3799C6.73381 12.3799 5.53797 11.9439 4.41247 11.0721C3.28697 10.2002 2.3789 9.00951 1.68825 7.5C2.3789 5.99049 3.28697 4.7998 4.41247 3.92793C5.53797 3.05606 6.73381 2.62012 8 2.62012C9.26619 2.62012 10.462 3.05606 11.5875 3.92793C12.713 4.7998 13.6211 5.99049 14.3118 7.5C13.6211 9.00951 12.713 10.2002 11.5875 11.0721C10.462 11.9439 9.26619 12.3799 8 12.3799ZM8 4.24024C7.42446 4.24024 6.88729 4.38989 6.38849 4.68919C5.90248 4.97548 5.51239 5.37237 5.21823 5.87988C4.93685 6.37437 4.79616 6.91441 4.79616 7.5C4.79616 8.08559 4.93685 8.63213 5.21823 9.13964C5.51239 9.63413 5.90248 10.031 6.38849 10.3303C6.88729 10.6166 7.42446 10.7598 8 10.7598C8.57554 10.7598 9.10631 10.6166 9.59233 10.3303C10.0911 10.031 10.4812 9.63413 10.7626 9.13964C11.0568 8.63213 11.2038 8.08559 11.2038 7.5C11.2038 6.91441 11.0568 6.37437 10.7626 5.87988C10.4812 5.37237 10.0911 4.97548 9.59233 4.68919C9.10631 4.38989 8.57554 4.24024 8 4.24024ZM8 9.12012C7.56515 9.12012 7.18785 8.96396 6.86811 8.65165C6.56115 8.32633 6.40767 7.94244 6.40767 7.5C6.40767 7.05756 6.56115 6.68018 6.86811 6.36787C7.18785 6.04254 7.56515 5.87988 8 5.87988C8.43485 5.87988 8.80576 6.04254 9.11271 6.36787C9.43245 6.68018 9.59233 7.05756 9.59233 7.5C9.59233 7.94244 9.43245 8.32633 9.11271 8.65165C8.80576 8.96396 8.43485 9.12012 8 9.12012Z",
            fill: "white"
        })
    });
};
var ProductDetailNotLogin = function(param) {
    var product = param.product, orderedCount = param.orderedCount, _productWithoutLoginRecommend = param.productWithoutLoginRecommend, productWithoutLoginRecommend = _productWithoutLoginRecommend === void 0 ? [] : _productWithoutLoginRecommend;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(productWithoutLoginRecommend !== null && productWithoutLoginRecommend !== void 0 ? productWithoutLoginRecommend : []), productRecommendData = ref4[0], setProductRecommendData = ref4[1];
    var ref5 = (0,Auth/* useAuth */.aC)(), toggleLogin = ref5.toggleLogin, toggleSignUp = ref5.toggleSignUp;
    var imagesProxy = product.imagesProxy, limitPerDay = product.limitPerDay, messageLimitOrder = product.messageLimitOrder, name = product.name, volume = product.volume;
    // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
    var medicineTypeLabels = (0,ProductLabelUtils/* getMedicineTypeLabels */.RG)(product);
    // Prefer client-side fetched config (useSetting), fallback to SSR Zustand store
    var configs = (0,Settings/* useSetting */.y)().configs;
    var appSettingFromStore = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.appSetting;
    });
    var bannerConfig = (configs === null || configs === void 0 ? void 0 : configs["DISPLAY_BANNER_CONFIG"]) || (appSettingFromStore === null || appSettingFromStore === void 0 ? void 0 : appSettingFromStore["DISPLAY_BANNER_CONFIG"]) || {};
    var banner2 = (bannerConfig === null || bannerConfig === void 0 ? void 0 : bannerConfig.homeBanner2) || Images/* BANNER2 */.pcO;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        style: {
            maxWidth: "1304px"
        },
        className: (PcScreenNotLogin_styles_module_default()).containerNotLogin,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 3,
                className: (PcScreenNotLogin_styles_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContent, {
                            product: product,
                            imagesProxy: imagesProxy.length === 0 ? [
                                Images/* MISSING_IMAGE */.g_W
                            ] : imagesProxy,
                            limitPerDay: limitPerDay,
                            messageLimitOrder: messageLimitOrder
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        className: (PcScreenNotLogin_styles_module_default()).rightGrid,
                        xs: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (PcScreenNotLogin_styles_module_default()).typographyTitle,
                                variant: "h1",
                                children: name || ""
                            }),
                            medicineTypeLabels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PcScreenNotLogin_styles_module_default()).medicineType,
                                children: medicineTypeLabels.map(function(info) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                        src: info.icon.src,
                                        height: 20,
                                        width: Math.round(info.icon.width / info.icon.height * 20),
                                        alt: info.label
                                    }, info.variant);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (PcScreenNotLogin_styles_module_default()).priceHidden,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                                    className: (PcScreenNotLogin_styles_module_default()).viewPrice,
                                    onClick: toggleLogin,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeIcon, {}),
                                        product.isIngredientSpecial ? "Tư vấn" : "Xem gi\xe1"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PcScreenNotLogin_styles_module_default()).infoProduct,
                                children: [
                                    ((ref = product.manufacturer) === null || ref === void 0 ? void 0 : ref.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreenNotLogin_styles_module_default()).flexItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).titleContent,
                                                children: "Nh\xe0 sản xuất"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PcScreenNotLogin_styles_module_default()).infoTitleTop,
                                                onClick: toggleLogin,
                                                role: "button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    className: (PcScreenNotLogin_styles_module_default()).link,
                                                    children: (ref1 = product.manufacturer) === null || ref1 === void 0 ? void 0 : ref1.name
                                                })
                                            })
                                        ]
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.originName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreenNotLogin_styles_module_default()).flexItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).titleContent,
                                                children: "Nước sản xuất"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).infoTitle,
                                                children: product === null || product === void 0 ? void 0 : product.originName
                                            })
                                        ]
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.volume) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreenNotLogin_styles_module_default()).flexItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).titleContent,
                                                children: "Quy c\xe1ch"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).infoTitle,
                                                children: volume
                                            })
                                        ]
                                    }),
                                    (product === null || product === void 0 ? void 0 : (ref2 = product.categories) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreenNotLogin_styles_module_default()).flexItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).titleContent,
                                                children: "Danh mục"
                                            }),
                                            product === null || product === void 0 ? void 0 : (ref3 = product.categories) === null || ref3 === void 0 ? void 0 : ref3.map(function(category) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PcScreenNotLogin_styles_module_default()).infoTitle,
                                                    onClick: toggleLogin,
                                                    role: "button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        className: (PcScreenNotLogin_styles_module_default()).link,
                                                        children: category.name
                                                    })
                                                });
                                            })
                                        ]
                                    }),
                                    orderedCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PcScreenNotLogin_styles_module_default()).flexItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).titleContent,
                                                children: "Lượt mua trong 24h"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (PcScreenNotLogin_styles_module_default()).infoTitle,
                                                children: [
                                                    orderedCount,
                                                    " lượt"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        className: (PcScreenNotLogin_styles_module_default()).rightGrid,
                        xs: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PcScreenNotLogin_styles_module_default()).wrapperImageBanner,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: (0,ImageUtils/* getLinkProxyFile */.GD)(banner2),
                                    width: "298",
                                    height: "167",
                                    size: "large",
                                    alt: "D\xe0nh cho kh\xe1ch h\xe0ng mới giảm 10% cho đơn h\xe0ng đầu ti\xean"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                                className: (PcScreenNotLogin_styles_module_default()).registerNow,
                                onClick: toggleSignUp,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (PcScreenNotLogin_styles_module_default()).registerTitle,
                                        children: "Đăng k\xfd ngay"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (PcScreenNotLogin_styles_module_default()).registerSubTitle,
                                        children: "để nhận ưu đ\xe3i"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                className: (PcScreenNotLogin_styles_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PcScreenNotLogin_InfoProduct, {
                        product: product,
                        className: (PcScreenNotLogin_styles_module_default()).infoContainerNotLogin,
                        onClickBait: toggleLogin
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                className: (PcScreenNotLogin_styles_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAndAnswer, {
                        user: null,
                        targetCode: product.sku
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                className: (PcScreenNotLogin_styles_module_default()).clickBaitContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PcScreenNotLogin_styles_module_default()).titleTop,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    width: 135,
                                    height: 51,
                                    src: Images/* COUNT_PRODUCT */.Ice,
                                    border: "0",
                                    alt: "Hơn 35000 SẢN PHẨM KH\xc1C ĐANG ĐỢI BẠN KH\xc1M PH\xc1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (PcScreenNotLogin_styles_module_default()).textCount,
                                    children: "SẢN PHẨM KH\xc1C ĐANG ĐỢI BẠN KH\xc1M PH\xc1"
                                })
                            ]
                        }),
                        (productRecommendData === null || productRecommendData === void 0 ? void 0 : productRecommendData.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PcScreenNotLogin_styles_module_default()).listProduct,
                            children: productRecommendData === null || productRecommendData === void 0 ? void 0 : productRecommendData.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: (PcScreenNotLogin_styles_module_default()).cardItem,
                                    onClick: toggleLogin,
                                    role: "button",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (PcScreenNotLogin_styles_module_default()).wrapperImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                                src: item === null || item === void 0 ? void 0 : item.defaultImage,
                                                width: "186",
                                                height: "186",
                                                objectFit: "contain",
                                                size: "medium",
                                                alt: (item === null || item === void 0 ? void 0 : item.name) || ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (PcScreenNotLogin_styles_module_default()).wrapperInfoProduct,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    className: (PcScreenNotLogin_styles_module_default()).nameCard,
                                                    children: (item === null || item === void 0 ? void 0 : item.name) || ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    className: (PcScreenNotLogin_styles_module_default()).volume,
                                                    children: (item === null || item === void 0 ? void 0 : item.volume) || ""
                                                })
                                            ]
                                        })
                                    ]
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PcScreenNotLogin_styles_module_default()).wrapperButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                className: (PcScreenNotLogin_styles_module_default()).clickBaitButton,
                                onClick: toggleLogin,
                                children: "Kh\xe1m ph\xe1 ngay"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var PcScreenNotLogin = (ProductDetailNotLogin);

// EXTERNAL MODULE: ./src/components/layout/Template/index.js + 8 modules
var Template = __webpack_require__(97394);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/context/Product/context.js + 4 modules
var context = __webpack_require__(65669);
;// CONCATENATED MODULE: ./src/hooks/useDealTagUrl.js

function useDealTagUrl(datas) {
    var baseURL = "/khuyenmai";
    var ref = (0,react.useState)(""), link = ref[0], setLink = ref[1];
    var ref1 = datas || {}, dataDeal = ref1.campaign;
    var ref2 = (dataDeal === null || dataDeal === void 0 ? void 0 : dataDeal.campaign) || {}, campaignType = ref2.campaignType, slug = ref2.slug;
    (0,react.useEffect)(function() {
        var getLink = function getLink() {
            if (campaignType !== "DAILY_DEAL") {
                setLink("".concat(baseURL, "/").concat(slug));
            }
            // deal
            if (!dataDeal) setLink("/deals");
        };
        getLink();
    }, [
        datas
    ]);
    return [
        link
    ];
};

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/zustand-lib/useSearchResult.js
var useSearchResult = __webpack_require__(80169);
;// CONCATENATED MODULE: ./src/pages/product/[slug]/index.js


























var __N_SSP = true;
function ProductDetail() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)({}), product = ref[0], setProduct = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)([]), recommendProductsNoLogin = ref2[0], setRecommendProductsNoLogin = ref2[1];
    var user = (0,Auth/* useAuth */.aC)().user;
    var getSellerByCode = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.getSellerByCode;
    });
    var getSearchResult = (0,useSearchResult/* default */.Z)(function(state) {
        return state.getSearchResult;
    });
    var sendSearchEvent = (0,useSearchResult/* default */.Z)(function(state) {
        return state.sendSearchEvent;
    });
    (0,react.useEffect)(function() {
        function fetchProduct() {
            return _fetchProduct.apply(this, arguments);
        }
        function _fetchProduct() {
            _fetchProduct = (0,_async_to_generator/* default */.Z)(function() {
                var slug, codeLocationNotLogin, ref, ref1, productWithoutLoginRes, productWithoutLoginRecommend, _tmp, _tmp1, productRawNotLogin, sellerRes, seller, productRes, _tmp2, product, sellerRes1, seller1, productConverted, brandInfo, _tmp3, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            slug = router.query.slug || "";
                            codeLocationNotLogin = js_cookie_default().get("provinceCode") || data/* HCM_PROVINCE_CODE */.Mc;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                11,
                                12,
                                13
                            ]);
                            if (!!user) return [
                                3,
                                4
                            ];
                            _tmp = {};
                            _tmp1 = {};
                            return [
                                4,
                                Promise.all([
                                    (0,ProductServiceV2/* getDetailProductWithoutLogin */.WQ)((_tmp.slug = slug, _tmp)),
                                    ProductServiceV2/* default.getListProductWithoutLogin */.ZP.getListProductWithoutLogin((_tmp1.slug = slug, _tmp1.provinceCode = codeLocationNotLogin, _tmp1))
                                ])
                            ];
                        case 2:
                            ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), productWithoutLoginRes = ref1[0], productWithoutLoginRecommend = ref1[1];
                            if (!(0,Clients/* isValid */.JY)(productWithoutLoginRes)) {
                                return [
                                    2
                                ];
                            }
                            productRawNotLogin = ProductServiceV2/* default.convertProductV2 */.ZP.convertProductV2((0,Clients/* getFirst */.Xi)(productWithoutLoginRes));
                            return [
                                4,
                                SupplierClient/* default.getSellersV2 */.ZP.getSellersV2([
                                    productRawNotLogin.seller.code
                                ])
                            ];
                        case 3:
                            sellerRes = _state.sent();
                            seller = (0,Clients/* getFirst */.Xi)(sellerRes);
                            // thông tin nhà bán theo gian chứa SKU (BV-2164)
                            productRawNotLogin.sellerInfo = (0,StoreUtils/* sellerForStore */.M)((0,_object_spread/* default */.Z)({}, seller, productRawNotLogin.sellerInfo), productRawNotLogin.storeCode);
                            setProduct(productRawNotLogin);
                            setRecommendProductsNoLogin((productWithoutLoginRecommend === null || productWithoutLoginRecommend === void 0 ? void 0 : (ref = productWithoutLoginRecommend.data) === null || ref === void 0 ? void 0 : ref.length) > 0 ? productWithoutLoginRecommend === null || productWithoutLoginRecommend === void 0 ? void 0 : productWithoutLoginRecommend.data : []);
                            return [
                                3,
                                10
                            ];
                        case 4:
                            setLoading(true);
                            _tmp2 = {};
                            return [
                                4,
                                WebService/* default.getDataProductDetail */.ZP.getDataProductDetail((_tmp2.router = router, _tmp2.slug = router.query.slug, _tmp2.isConvertProduct = false, _tmp2.productDetailPage = true, _tmp2.isGetCrossSell = true, _tmp2))
                            ];
                        case 5:
                            productRes = _state.sent();
                            if (!(0,Clients/* isValid */.JY)(productRes)) return [
                                3,
                                9
                            ];
                            product = (0,Clients/* getFirst */.Xi)(productRes);
                            return [
                                4,
                                SupplierClient/* default.getSellersV2 */.ZP.getSellersV2([
                                    product.sellerInfo.sellerCode
                                ])
                            ];
                        case 6:
                            sellerRes1 = _state.sent();
                            seller1 = (0,Clients/* getFirst */.Xi)(sellerRes1);
                            productConverted = ProductServiceV2/* default.convertProductV2 */.ZP.convertProductV2(product);
                            // thông tin nhà bán theo gian chứa SKU (BV-2164)
                            productConverted.sellerInfo = (0,StoreUtils/* sellerForStore */.M)((0,_object_spread/* default */.Z)({}, seller1, productConverted.sellerInfo), productConverted.storeCode);
                            if (!((productConverted === null || productConverted === void 0 ? void 0 : productConverted.productId) && !(productConverted === null || productConverted === void 0 ? void 0 : productConverted.isCombo))) return [
                                3,
                                8
                            ];
                            _tmp3 = {};
                            return [
                                4,
                                (0,WebServiceClient/* getBrandInfo */.Cc)((_tmp3.productID = productConverted.productId, _tmp3))
                            ];
                        case 7:
                            brandInfo = _state.sent();
                            if ((0,Clients/* isValid */.JY)(brandInfo)) productConverted.brandInfo = (0,Clients/* getFirst */.Xi)(brandInfo).brandInfo;
                            _state.label = 8;
                        case 8:
                            setProduct(productConverted);
                            return [
                                3,
                                10
                            ];
                        case 9:
                            return [
                                2
                            ];
                        case 10:
                            return [
                                3,
                                13
                            ];
                        case 11:
                            error = _state.sent();
                            setLoading(false);
                            console.error(error);
                            return [
                                3,
                                13
                            ];
                        case 12:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 13:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchProduct.apply(this, arguments);
        }
        fetchProduct();
    }, [
        router.query.slug
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if (!product.productId) return;
        // Gửi event SEARCH nếu click xem chi tiết một sản phẩm trong kết quả search
        var searchResult = (ref2 = getSearchResult()) === null || ref2 === void 0 ? void 0 : ref2[(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.text) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.q)];
        var isProductInSearchResult = searchResult === null || searchResult === void 0 ? void 0 : (ref3 = searchResult.data) === null || ref3 === void 0 ? void 0 : ref3[product.productId];
        if (isProductInSearchResult) {
            sendSearchEvent(searchResult === null || searchResult === void 0 ? void 0 : searchResult.content);
        }
    }, [
        router,
        product.productId
    ]);
    (0,react.useEffect)(function() {
        if (!(product === null || product === void 0 ? void 0 : product.sellerCode)) return;
        (0,_async_to_generator/* default */.Z)(function() {
            var sellerInfo, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getSellerByCode(product === null || product === void 0 ? void 0 : product.sellerCode)
                        ];
                    case 1:
                        sellerInfo = _state.sent();
                        _tmp = {};
                        gtag/* default.viewContentDetail */.ZP.viewContentDetail((_tmp.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                            sellerInfo: sellerInfo
                        }), _tmp));
                        _tmp1 = {};
                        gtag/* default.viewContent */.ZP.viewContent((_tmp1.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                            sellerInfo: sellerInfo
                        }), _tmp1));
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        product === null || product === void 0 ? void 0 : product.sellerCode
    ]);
    var addProductToListViewed = (0,context/* useProduct */.iB)().addProductToListViewed;
    (0,react.useEffect)(function() {
        if (!(product === null || product === void 0 ? void 0 : product.sku)) return;
        addProductToListViewed((product === null || product === void 0 ? void 0 : product.sku) || "");
    }, [
        product === null || product === void 0 ? void 0 : product.sku
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Template/* default */.Z, {
        overrideMV2Options: {
            title: "Chi tiết sản phẩm"
        },
        pageTitle: product.name,
        title: product.name,
        pageName: "PRD_DETAIL",
        product: product,
        isNewLayout: user === null || user === void 0 ? void 0 : user.isNewLayout,
        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderNewUIDetail, {
            user: user,
            product: product,
            loading: loading
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderNotLogin, {
            product: product,
            productWithoutLoginRecommend: recommendProductsNoLogin
        })
    });
};
function RenderNewUIDetail(param) {
    var loading = param.loading, product = param.product, user = param.user;
    var ref = product || {}, categoryCodes = ref.categoryCodes, tags = ref.tags, seller = ref.seller, _deal = ref.deal, deal = _deal === void 0 ? {} : _deal;
    var link = useDealTagUrl(product);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailLoading/* default */.Z, {
        isLogin: true
    });
    if (Object.keys(product).length <= 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailProductPcScreenNew, {
        product: product,
        user: user,
        deal: deal,
        orderedCount: product.orderedCount,
        sellerInfo: product.sellerInfo,
        seller: seller,
        categoryCodes: categoryCodes,
        link: link,
        tags: tags
    });
}
function RenderNotLogin(param) {
    var product = param.product, productWithoutLoginRecommend = param.productWithoutLoginRecommend;
    if (!Object.keys(product).length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailLoading/* default */.Z, {
        isLogin: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PcScreenNotLogin, {
        product: product,
        orderedCount: product.orderedCount,
        productWithoutLoginRecommend: productWithoutLoginRecommend
    });
}


/***/ }),

/***/ 66661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ remainTime; },
/* harmony export */   "ND": function() { return /* binding */ calculateTimeLeftFlip; },
/* harmony export */   "ZP": function() { return /* binding */ calculateTimeLeft; },
/* harmony export */   "lv": function() { return /* binding */ worldCalculateTimeLeft; },
/* harmony export */   "nw": function() { return /* binding */ calculateTimeLeftWithoutColon; }
/* harmony export */ });
/* unused harmony export calculateTimeLeftFlashSale */
function calculateTimeLeft(time) {
    var remainingTime = +new Date(time) - +new Date();
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24).toString().padStart(2, "0");
        var minutes = ":".concat(Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0"), ":");
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
};
function calculateTimeLeftFlashSale(time) {
    var remainingTime = +new Date(time) - +new Date();
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24).toString().padStart(2, "0");
        var minutes = "".concat(Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0"));
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
}
var ONE_DAY = 86400000;
var remainTime = function(time1, time2) {
    return (time1 - time2) / ONE_DAY;
};
function calculateTimeLeftWithoutColon(time) {
    var remainingTime = +new Date(time) - +new Date();
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24).toString().padStart(2, "0");
        var minutes = Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0");
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
}
function calculateTimeLeftFlip(time) {
    var timeInMilliseconds = new Date(time).getTime();
    var now = new Date().getTime();
    var remainingTime = timeInMilliseconds - now;
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24).toString().padStart(2, "0");
        var minutes = "".concat(Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0"));
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            days: days,
            daysShuffle: true,
            hours: hours,
            hoursShuffle: true,
            minutes: minutes,
            minutesShuffle: true,
            seconds: seconds,
            secondsShuffle: true
        };
    }
    return timeLeft;
}
function worldCalculateTimeLeft(time) {
    var timeInMilliseconds = new Date(time).getTime();
    var now = new Date().getTime();
    var remainingTime = timeInMilliseconds - now;
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24 + days * 24) // hours + daysToHours
        .toString().padStart(2, "0");
        var minutes = ":".concat(Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0"), ":");
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            // days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
}


/***/ }),

/***/ 94024:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var PHONE_REGEX = /^(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})$/;
var EMAIL_REGEX = /^$|^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
/* harmony default export */ __webpack_exports__["Z"] = ({
    PHONE_REGEX: PHONE_REGEX,
    EMAIL_REGEX: EMAIL_REGEX
});


/***/ }),

/***/ 44548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ checkVideoUrl; }
/* harmony export */ });
function checkVideoUrl(url) {
    var videoFileType = [
        "mp4",
        "move",
        "ogg",
        "avi",
        "wmv",
        "flv",
        "webm",
        "m4v"
    ];
    var urlSplit = url.split(".");
    var fileType = urlSplit[urlSplit.length - 1];
    // TODO: check ?size= then remove it
    if (fileType.includes("?size=")) {
        fileType = fileType.replace(/\?size=\d+/, "");
    }
    return videoFileType.includes(fileType);
    return false;
}


/***/ }),

/***/ 68373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36902);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38597);




var INITIAL_STATE = {
    isGuide: 0
};
var useStartGuide = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, INITIAL_STATE), {
        setGuide: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, get()), {
                isGuide: payload
            }));
        }
    });
}, {
    name: "guide_state"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useStartGuide);


/***/ }),

/***/ 23772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readMoreWrapper":"styles_readMoreWrapper__26uhD","isBlur":"styles_isBlur__Nyrzz","isReadMore":"styles_isReadMore__DJKfO","action":"styles_action__tcbFX","icon":"styles_icon__yM41D","readMoreAction":"styles_readMoreAction__OSndJ","textLink":"styles_textLink__95MpV"};

/***/ }),

/***/ 4681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readMoreWrapper":"styles_readMoreWrapper__cQ0iz","isBlur":"styles_isBlur__qYsnd","isReadMore":"styles_isReadMore__uCEoc","action":"styles_action__XDmNF","icon":"styles_icon__h9aEM","readMoreAction":"styles_readMoreAction__XK6Gj","textLink":"styles_textLink__XTo35"};

/***/ }),

/***/ 95628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__PCYRo","placeholder":"styles_placeholder__Brd9x","icon":"styles_icon__u_ZtY","iconSelect":"styles_iconSelect__f1hcB","menuItem":"styles_menuItem__zVOqo"};

/***/ }),

/***/ 61604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__tHIAG","textError":"styles_textError__fdEMw"};

/***/ }),

/***/ 18165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__69g11","priceInfo":"styles_priceInfo__JuAS3","save":"styles_save__sy_bS","price":"styles_price__5VAWV","originalPrice":"styles_originalPrice__A_NaW","discountPercent":"styles_discountPercent__Ij6kq","title":"styles_title__Ux2v3","tableRow":"styles_tableRow__nPBAg","table":"styles_table__eHMwY","gridContainer":"styles_gridContainer___4ekf","column":"styles_column__TA_14","right":"styles_right__f_rT7","header":"styles_header__Iu00O","headerRight":"styles_headerRight__36ePF","showAll":"styles_showAll__7X2yY","wrapQuantity":"styles_wrapQuantity__se49l","countCanBuy":"styles_countCanBuy__YpywJ","row":"styles_row__j9Ol2"};

/***/ }),

/***/ 56209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__RGiY9","itemDeal":"styles_itemDeal__XCSeQ","topPosition":"styles_topPosition__LyGwg","groupInfoDeal":"styles_groupInfoDeal__4asyE","groupInfoDealTop":"styles_groupInfoDealTop__uzKh1","productImage":"styles_productImage__uqHGx","nameXs":"styles_nameXs__r_wZW","groupQuantity":"styles_groupQuantity__XjAhv","buyWithDeal":"styles_buyWithDeal__3lBhm","discountDeal":"styles_discountDeal__jyjjV","score":"styles_score__aAOfl","price":"styles_price__uJPje","priceBig":"styles_priceBig__5rH9t","originalPrice":"styles_originalPrice___Y6uj","quantityControlWithDeal":"styles_quantityControlWithDeal__Objwg","flexContainer":"styles_flexContainer__kruTU","wrapperDeal":"styles_wrapperDeal__v_Hlj","hightLightTag":"styles_hightLightTag__VXHOD","medicineType":"styles_medicineType__1w8pJ","volume":"styles_volume__FNvRU","nameTag":"styles_nameTag__7UyL3","image":"styles_image__fJU5_","amountSaved":"styles_amountSaved__snboG"};

/***/ }),

/***/ 63179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__boKoW","containerModal":"styles_containerModal__9Jqsx","customButton":"styles_customButton__VYlIZ","tooltipLeft":"styles_tooltipLeft__UbYbr","tooltipRight":"styles_tooltipRight__JopJL","icon":"styles_icon__wvMZT","bottomSpan":"styles_bottomSpan__55nIe","image":"styles_image__g98t2"};

/***/ }),

/***/ 19480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"comboSuggestionContainer":"ComboSuggestion_comboSuggestionContainer__igFyj","comboSuggestion":"ComboSuggestion_comboSuggestion__IfC5W","active":"ComboSuggestion_active__SRJXT","suggestionLabel":"ComboSuggestion_suggestionLabel__omAcR","suggestionContent":"ComboSuggestion_suggestionContent__xJra_","suggestionLink":"ComboSuggestion_suggestionLink__eQkQy","suggestionLinkChevron":"ComboSuggestion_suggestionLinkChevron__YnGhG","diffPrice":"ComboSuggestion_diffPrice__dSVQr"};

/***/ }),

/***/ 39573:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"comboContainer":"styles_comboContainer__GFocL","comboItem":"styles_comboItem__v8LNb","nameCombo":"styles_nameCombo__2snSO","hightLightTag":"styles_hightLightTag__lEja_","priceCombo":"styles_priceCombo__BVIIv","groupInfoProduct":"styles_groupInfoProduct__LZfXn","imageContainer":"styles_imageContainer__0KQQ_","addContainer":"styles_addContainer__VYtL8","addIcon":"styles_addIcon__1jUYE","titleCombo":"styles_titleCombo__OCO8B"};

/***/ }),

/***/ 8221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commentList":"styles_commentList__Qbjbb","commentItem":"styles_commentItem__nWOGk","subCommentItem":"styles_subCommentItem___bLrj","commentInner":"styles_commentInner__tt6x7","commentAvatar":"styles_commentAvatar__fa0Mc","hasChildBranch":"styles_hasChildBranch__weVqR","commentAvatarImg":"styles_commentAvatarImg__jlxDQ","commentInfo":"styles_commentInfo__VUjW7","commentName":"styles_commentName__X_cRE","commentContent":"styles_commentContent__jaaOa","commentImages":"styles_commentImages__WrlMq","commentImageItem":"styles_commentImageItem__TEZF5","lightboxOverlay":"styles_lightboxOverlay__3lLha","lightboxContent":"styles_lightboxContent__TsyXu","lightboxImage":"styles_lightboxImage__Xp4Y5","lightboxClose":"styles_lightboxClose__tbnQz","lightboxNav":"styles_lightboxNav__igFLP","lightboxNavPrev":"styles_lightboxNavPrev__IlL1T","lightboxNavNext":"styles_lightboxNavNext__W6wFw","lightboxCounter":"styles_lightboxCounter__dwEJE","commentTime":"styles_commentTime___jR8W","commentChip":"styles_commentChip__vysZX","commentUtils":"styles_commentUtils__pwwsc","commentReply":"styles_commentReply__JftrS","replyInput":"styles_replyInput__9WyqP","replyInfo":"styles_replyInfo__Pyi5E","replyName":"styles_replyName__cFBJi","replyAvatar":"styles_replyAvatar__YJ14U","replyForm":"styles_replyForm__RhKnd","replyFormInput":"styles_replyFormInput__Mekc6","submit":"styles_submit__KDOGl","replyInput-type-REPLY":"styles_replyInput-type-REPLY__MqRB6","hasReplies":"styles_hasReplies__u4ALo","replyInput-type-COMMENT":"styles_replyInput-type-COMMENT__Q_7lM","commentBox":"styles_commentBox__nGINa","commentBoxError":"styles_commentBoxError__6iA7D","commentBoxToolbar":"styles_commentBoxToolbar___mQcb","input":"styles_input__guBXf","textareaCount":"styles_textareaCount__dhFX3","error":"styles_error__EEQ3N","formTextarea":"styles_formTextarea__tEzx5","commentBoxInput":"styles_commentBoxInput__2aG6q","commentBoxCount":"styles_commentBoxCount__FYANJ","commentBoxErrorText":"styles_commentBoxErrorText__fgLs3","textEmptyComment":"styles_textEmptyComment__Fnn60","placeholder":"styles_placeholder__AdF8W","loadMoreReply":"styles_loadMoreReply__0gNh3","replyUploadBtn":"styles_replyUploadBtn__Yipi9","replyUploadBtnDisabled":"styles_replyUploadBtnDisabled__mEAwZ","thumbnails":"styles_thumbnails__RkQMx","thumbnailItem":"styles_thumbnailItem__XzVPI","thumbnailImage":"styles_thumbnailImage__7yLIV","thumbnailRemove":"styles_thumbnailRemove__tMNlS"};

/***/ }),

/***/ 45823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"minWidth":"styles_minWidth__jKcwk"};

/***/ }),

/***/ 32956:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hotInfo":"styles_hotInfo__9A396","textContainer":"styles_textContainer__1QrRo","text":"styles_text__GLibt","rightInfo":"styles_rightInfo__bpgar","countBuy":"styles_countBuy__xCs2l","timeDiscount":"styles_timeDiscount__lsraI"};

/***/ }),

/***/ 37657:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EWHMz","root":"styles_root__h_lXN","typography":"styles_typography__KesV2","hightLight":"styles_hightLight__VAfLn","mobile":"styles_mobile__JGU_e"};

/***/ }),

/***/ 85142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"styles_sliderContainer__FwX5B","lessThenThree":"styles_lessThenThree__9inJ4","wrapperSlider":"styles_wrapperSlider__ChLsw","imageItem":"styles_imageItem__bGCgm","active":"styles_active__wKQN9","arrow":"styles_arrow__BgiX1","right":"styles_right__snSLq","left":"styles_left__nHNaN","wrapperRight":"styles_wrapperRight__ryBSR","wrapperLeft":"styles_wrapperLeft__9oUEY"};

/***/ }),

/***/ 83587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapListPromo":"styles_wrapListPromo__CnTiE","wrapPromoImg":"styles_wrapPromoImg__fkeWP","wrapPromoResize":"styles_wrapPromoResize__XV1C0","plus":"styles_plus__xiUzq","hidePlus":"styles_hidePlus__B_4JH","wrapPromoImgMobile":"styles_wrapPromoImgMobile__Q95Bt"};

/***/ }),

/***/ 51166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__WaQpd","styleDesktop":"styles_styleDesktop__wQyBO","styleMobile":"styles_styleMobile__Qjj9p","content":"styles_content__XwWYY","titleContainer":"styles_titleContainer__tK_d6","title":"styles_title___qmtl","new":"styles_new__YMMMv","groupContent":"styles_groupContent__rWRg7","understand":"styles_understand__4QQn9","try":"styles_try__lB5Ek","groupButton":"styles_groupButton__jRRLg","closeButton":"styles_closeButton__1aVf_"};

/***/ }),

/***/ 30795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__sLwuc","headerDialog":"styles_headerDialog__eP0xR","isTitleCenter":"styles_isTitleCenter__udrAM","iconInner":"styles_iconInner__fpTRA","title":"styles_title__iDbGS","closeText":"styles_closeText__o_q3O","subTitle":"styles_subTitle__JFJmi","content":"styles_content__XFqhI","actions":"styles_actions__TKot9"};

/***/ }),

/***/ 26273:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"styles_gridContainer__vaY_M","avatar":"styles_avatar__v6V2q","typography":"styles_typography__QMz4F","nameSeller":"styles_nameSeller__WGOvw","groupButton":"styles_groupButton__ZCSDy","button":"styles_button__B2nNt","viewStore":"styles_viewStore__6TUng","quickChat":"styles_quickChat__uPyjh","rightContent":"styles_rightContent__jP7Th","text":"styles_text__NABNi","gotoStore":"styles_gotoStore___7DPZ","productTitle":"styles_productTitle__iKJ7T","sellerIcon":"styles_sellerIcon__3OQlt","bottom1":"styles_bottom1__va7FI","wrapperLeft":"styles_wrapperLeft__WA9KX","countProduct":"styles_countProduct__GIfnw","store":"styles_store__3b7Aq","storeTag":"styles_storeTag__2Y3oN"};

/***/ }),

/***/ 94328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper_modal":"styles_wrapper_modal__JD2VD","modalBackdrop":"styles_modalBackdrop__6l882","modalImage":"styles_modalImage__ATIHb","closeWrapper":"styles_closeWrapper__uCKj0","imageMain":"styles_imageMain__spbIb","imageMainMobile":"styles_imageMainMobile__hZnbT","wrapperImg":"styles_wrapperImg__PDDk2","wrapperMobileImg":"styles_wrapperMobileImg__L8TbE","imageNameText":"styles_imageNameText__9IHtY","wrapper_thumbnail":"styles_wrapper_thumbnail__oQiOk","scroll_vertical":"styles_scroll_vertical__l9ELW","wrapper_mobile_thumbnail":"styles_wrapper_mobile_thumbnail__qoNG6","flex_center":"styles_flex_center__p71b_","thumbnail_image_wrapper":"styles_thumbnail_image_wrapper__h4gYD","thumbnail_image_wrapper_mobile":"styles_thumbnail_image_wrapper_mobile__PqCTw","thumbnail_selected":"styles_thumbnail_selected__RBkuM","slider":"styles_slider__7hMX7","leftNavBtn":"styles_leftNavBtn__GOfq4","rightNavBtn":"styles_rightNavBtn__nZUo1"};

/***/ }),

/***/ 91028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"styles_priceContainer__OGS2_","priceDiscount":"styles_priceDiscount__SPZz8","wrapperIcon":"styles_wrapperIcon__oGQJP","boldColor":"styles_boldColor__pzm8a","cartPriceContainer":"styles_cartPriceContainer__Ze2wc","cartLabelDiscountPrice":"styles_cartLabelDiscountPrice__F5nUQ","cartPriceDiscount":"styles_cartPriceDiscount__kPHFP"};

/***/ }),

/***/ 28947:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dividerRoot":"styles_dividerRoot__oP9c4","wrapPromoMobile":"styles_wrapPromoMobile__7hfkb","promoContent":"styles_promoContent__DYdmo","wrapTitlePromo":"styles_wrapTitlePromo__hP_Op","wrapActionPromo":"styles_wrapActionPromo__kgsnS","gift":"styles_gift__yYUmM","wrapPromoList":"styles_wrapPromoList__5HnL1","titleDetail":"styles_titleDetail__UVV_f","titleGift":"styles_titleGift__SZnAD","swiper-slide":"styles_swiper-slide__yKpNM","listSwipperPromo":"styles_listSwipperPromo__7ZjXp","append-buttons":"styles_append-buttons__DrxIz","plus":"styles_plus__Muw6I","listResize":"styles_listResize__OlQiG"};

/***/ }),

/***/ 72503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RJvSq","minusContainer":"styles_minusContainer__61A8K","minus":"styles_minus__BA244","addContainer":"styles_addContainer__07KXb","addIcon":"styles_addIcon__SXVYV","disabled":"styles_disabled__dMV3X"};

/***/ }),

/***/ 30520:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"targetVideo":"styles_targetVideo__Y0nzb"};

/***/ }),

/***/ 32572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"specialChar":"styles_specialChar__dOOA2","thunderBolt":"styles_thunderBolt__2o0bs","shape":"styles_shape__tk7jN","bold":"styles_bold__J7AP_"};

/***/ }),

/***/ 29354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__htKbU","textareaCount":"styles_textareaCount__pYuWE","error":"styles_error__hy1BH","formTextarea":"styles_formTextarea__ng5zd","actionBtn":"styles_actionBtn__Sg7BN","textEmptyComment":"styles_textEmptyComment__eay_M","loggedFormModal":"styles_loggedFormModal__QkhVv","isLoading":"styles_isLoading__yHUJ4","placeholder":"styles_placeholder__t6RfU","uploadBox":"styles_uploadBox__d6LEK","uploadBoxDisabled":"styles_uploadBoxDisabled__kr1Vv","uploadIcon":"styles_uploadIcon__9l0kZ","uploadText":"styles_uploadText__8sRwT","uploadTitle":"styles_uploadTitle__325I8","uploadSubtitle":"styles_uploadSubtitle__EJq8z","uploadAddBtn":"styles_uploadAddBtn__svOlr","thumbnails":"styles_thumbnails__PCcCG","thumbnailItem":"styles_thumbnailItem__W4ANT","thumbnailImage":"styles_thumbnailImage__mp4S0","thumbnailRemove":"styles_thumbnailRemove__APY9W"};

/***/ }),

/***/ 20153:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__Uiwx8","textareaCount":"styles_textareaCount__sKoiK","error":"styles_error__C4q4K","formTextarea":"styles_formTextarea__Nhrc9","actionBtn":"styles_actionBtn__ns_nF","textEmptyComment":"styles_textEmptyComment___b82t","loginFormModal":"styles_loginFormModal__CAfgk","isLoading":"styles_isLoading__0BaTb","placeholder":"styles_placeholder__soT27"};

/***/ }),

/***/ 70561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"comment":"styles_comment__tvkRA","titleComment":"styles_titleComment__MnezQ","logo":"styles_logo__ONLCd","headingComment":"styles_headingComment__Rzl_3","actionComment":"styles_actionComment__s5JCB","priceFeedback":"styles_priceFeedback__17lZD","filterComment":"styles_filterComment__UDHOg","filterHeading":"styles_filterHeading__Wceo0","btnGroup":"styles_btnGroup__s4AYh","mainComment":"styles_mainComment__7SwfO","commentList":"styles_commentList__byBaU","emptyComment":"styles_emptyComment__SuUnK"};

/***/ }),

/***/ 58471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___m5M6","wrapper":"styles_wrapper__TtmRi","stickyContainer":"styles_stickyContainer__ByBKM","imageShow":"styles_imageShow__0_WTL","bigImage":"styles_bigImage__8LWEO","numberBuy":"styles_numberBuy__3nhbg","typography":"styles_typography__yL4Xa","buyInfo":"styles_buyInfo__7dnyO","countBuy":"styles_countBuy__Ev3_S","score":"styles_score__sUEVW","typographyTitle":"styles_typographyTitle__YpUGR","typographyRight":"styles_typographyRight__UsiZM","rightGrid":"styles_rightGrid__ffv5P","rowPrice":"styles_rowPrice__8goJz","priceInfo":"styles_priceInfo__JmtxW","assessPrice":"styles_assessPrice__PRTid","price":"styles_price__7na5l","originalPrice":"styles_originalPrice__xzIli","discountPercent":"styles_discountPercent__AteQV","hightLightTag":"styles_hightLightTag__UnbK_","promoLevel":"styles_promoLevel__KUBsg","pricePromo":"styles_pricePromo__SnM7G","level":"styles_level__zhlQn","groupInfoSeller":"styles_groupInfoSeller__kUgYs","maybeLike":"styles_maybeLike__LvQnj","wrapperImage":"styles_wrapperImage__Sngdw","imageSlider":"styles_imageSlider__FV2Sv"};

/***/ }),

/***/ 36178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"styles_modalContainer__d2rwh","modalWrapper":"styles_modalWrapper__wzdyY","numberBuy":"styles_numberBuy__fvyPQ","typography":"styles_typography__W_XV9","buyInfo":"styles_buyInfo__eoko0","countBuy":"styles_countBuy__INYs9","score":"styles_score__cbZrl","typographyTitle":"styles_typographyTitle__SmOKg","typographyRight":"styles_typographyRight__nDm_H","rightGrid":"styles_rightGrid__b1WjE","rowPrice":"styles_rowPrice__9wz_a","priceInfo":"styles_priceInfo__QUQ4x","assessPrice":"styles_assessPrice__6f6fG","price":"styles_price__Ke_a8","originalPrice":"styles_originalPrice__8_Ddu","discountPercent":"styles_discountPercent__aXIZp","hightLightTag":"styles_hightLightTag__r9Mnu","show":"styles_show__TZY9j","buttonModal":"styles_buttonModal__esb7P","quantityModal":"styles_quantityModal__Yly6k","rightContent":"styles_rightContent__Wt1HZ","sameSeller":"styles_sameSeller__gPtEm","canBuyAndScore":"styles_canBuyAndScore__U_r3D"};

/***/ }),

/***/ 25399:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapperContainer":"styles_wrapperContainer__zxrSf","showModal":"styles_showModal__yUNbE","backgroundEffect":"styles_backgroundEffect__6ajcf","wrapper":"styles_wrapper__Xa5hm","stickyContainer":"styles_stickyContainer__wgIWp","bigImage":"styles_bigImage__9eFTb","numberBuy":"styles_numberBuy__UT2cN","typography":"styles_typography__9hV93","buyInfo":"styles_buyInfo__oK_sW","countBuy":"styles_countBuy__T7dbf","score":"styles_score__XS_Xx","typographyTitle":"styles_typographyTitle__RTV69","typographyRight":"styles_typographyRight__0cmji","rightGrid":"styles_rightGrid__PGQ7R","rowPrice":"styles_rowPrice__giLxB","priceInfo":"styles_priceInfo__66bgZ","assessPrice":"styles_assessPrice__0YRCt","price":"styles_price__uDwZz","originalPrice":"styles_originalPrice__5lefU","discountPercent":"styles_discountPercent__SrLu1","hightLightTag":"styles_hightLightTag__Wk7k7","promoLevel":"styles_promoLevel__94K1w","referenceRetailPrice":"styles_referenceRetailPrice__yb15C","pricePromo":"styles_pricePromo__4vwpM","level":"styles_level__Zg7Zh","groupInfoSeller":"styles_groupInfoSeller__oSepT","maybeLike":"styles_maybeLike__aRbcK","hightLight":"styles_hightLight__JL4ku","modalContainer":"styles_modalContainer__s8equ","show":"styles_show__psNZF","buttonModal":"styles_buttonModal__2qU3o","quantityModal":"styles_quantityModal__rimtS","rightContent":"styles_rightContent__MT5UB","sameSeller":"styles_sameSeller__XnAia","canBuyAndScore":"styles_canBuyAndScore__TpbDK","dealShock":"styles_dealShock__WyGWD","productDeal":"styles_productDeal__FRNY0","titleSlider":"styles_titleSlider__0_4WJ","titleCommon":"styles_titleCommon__fuvmR","commonContainer":"styles_commonContainer__4S6TZ","description":"styles_description__Gyjcg","content":"styles_content__uVYH_","containerPage":"styles_containerPage__eKW1A","medicineType":"styles_medicineType__9QIen"};

/***/ }),

/***/ 23034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoProduct_container__jT3vh","mobile":"InfoProduct_mobile__A1mUq","paddingCustom":"InfoProduct_paddingCustom__blgZW","info":"InfoProduct_info__q7gX7","infoNotLogin":"InfoProduct_infoNotLogin__i71BR","infoDetail":"InfoProduct_infoDetail__28d2g","text":"InfoProduct_text__hQzVw","leftContent":"InfoProduct_leftContent___oZwt","leftSide":"InfoProduct_leftSide__sRv4n","category":"InfoProduct_category__M7OAn","prefix":"InfoProduct_prefix__efmxX","ingredientLink":"InfoProduct_ingredientLink__9IIJr","link":"InfoProduct_link__gpsMp","rightContent":"InfoProduct_rightContent__P6erW","rightContentNotLogin":"InfoProduct_rightContentNotLogin__vtmiv","rightContentMobile":"InfoProduct_rightContentMobile__swPUk","groupIngredient":"InfoProduct_groupIngredient__JDCnp","groupIngredientIsNotLogin":"InfoProduct_groupIngredientIsNotLogin__wDOSV","ingredient":"InfoProduct_ingredient__G3bbI","textIngredient":"InfoProduct_textIngredient__4DsAf","tabList":"InfoProduct_tabList__P7q9c","showMore":"InfoProduct_showMore__PH3hD","hiddenState":"InfoProduct_hiddenState__hOTpo","leftContentTabTwo":"InfoProduct_leftContentTabTwo__agzT3","leftContentTabTwoCenter":"InfoProduct_leftContentTabTwoCenter__aPs0Z","leftContentTabTwoRight":"InfoProduct_leftContentTabTwoRight___jNc0","tabMobile":"InfoProduct_tabMobile__cYyie","content":"InfoProduct_content__ESXeI","contentNotLogin":"InfoProduct_contentNotLogin___Bak8","mobileGroup":"InfoProduct_mobileGroup___iLmG","ingredientVolume":"InfoProduct_ingredientVolume__DqQQY","marginBottom":"InfoProduct_marginBottom__U9qUJ","wrapperInfo":"InfoProduct_wrapperInfo__v0AiW"};

/***/ }),

/***/ 54747:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerNotLogin":"styles_containerNotLogin__UIvTM","wrapper":"styles_wrapper__gxfQH","typographyTitle":"styles_typographyTitle__O1Kne","priceHidden":"styles_priceHidden__NXH0O","infoProduct":"styles_infoProduct__KWWEt","flexItem":"styles_flexItem__CnwTR","titleContent":"styles_titleContent__g_aZU","infoTitle":"styles_infoTitle__XyJd3","infoTitleTop":"styles_infoTitleTop__YZFeo","noneBorder":"styles_noneBorder__DzoFt","viewPrice":"styles_viewPrice__DszZZ","registerNow":"styles_registerNow__S0vij","registerTitle":"styles_registerTitle__34bJj","registerSubTitle":"styles_registerSubTitle__hX2m9","infoContainerNotLogin":"styles_infoContainerNotLogin__hr6YH","clickBaitContainer":"styles_clickBaitContainer__I__eS","titleTop":"styles_titleTop__nSRxP","countProduct":"styles_countProduct___rHg4","textCount":"styles_textCount__Fdj5G","listProduct":"styles_listProduct__Zzm1E","cardItem":"styles_cardItem__zbiI8","wrapperInfoProduct":"styles_wrapperInfoProduct__mFA1e","wrapperImage":"styles_wrapperImage__WSQNK","wrapperImageBanner":"styles_wrapperImageBanner__o2fXh","rightGrid":"styles_rightGrid__HsToy","nameCard":"styles_nameCard__MaYHd","volume":"styles_volume__RIikA","wrapperButton":"styles_wrapperButton__N9n2f","clickBaitButton":"styles_clickBaitButton__RdGfL","link":"styles_link__e2o3w","medicineType":"styles_medicineType__nEs3_"};

/***/ }),

/***/ 2328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4niLh","leftPlace":"styles_leftPlace__n_wAL","title":"styles_title__FekYv","viewMore":"styles_viewMore__RZ0Yd","rightPlace":"styles_rightPlace__FHKhc","name":"styles_name__21nBf","cardContainer":"styles_cardContainer__LLIwq","replaceSticker":"styles_replaceSticker__VghHx","priceRow":"styles_priceRow___99YH","cardChip":"styles_cardChip__C_J82","actionCard":"styles_actionCard__VvEz7","limitMessage":"styles_limitMessage__2Qfr_","content":"styles_content__pEN8B","volume":"styles_volume__Mrt3R","itemFlex":"styles_itemFlex__qQLH5","sellerName":"styles_sellerName__HUW84"};

/***/ }),

/***/ 91005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__odMpk","account_form_input":"styles_account_form_input__mkT1d","form_control":"styles_form_control__oozI7","required":"styles_required__olRBx","input_label":"styles_input_label__MVezz","title":"styles_title__ISKl_","input_adornment":"styles_input_adornment__aJgfm","padding_none":"styles_padding_none__6Pj19","MuiOutlinedInput-adornedEnd":"styles_MuiOutlinedInput-adornedEnd____eDl","error":"styles_error__ZoNYm"};

/***/ }),

/***/ 20768:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feedback_order":"style_feedback_order__mVSi3","container":"style_container__fE1Ui","title":"style_title__Pc5yG","label":"style_label__BD_Al","text_body":"style_text_body__lc48m","button_find":"style_button_find__VCXTC","text_red":"style_text_red__w91nN","button":"style_button__SF5UP","info_group":"style_info_group__eqYSY"};

/***/ }),

/***/ 99867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__MGuNV","bestProducts":"styles_bestProducts__0ZKaG","title":"styles_title__W7HFl","root":"styles_root__Ko_37","media":"styles_media__RMmSH","large":"styles_large__tQqRx","card_header":"styles_card_header__M6wzK","header_customer":"styles_header_customer__sPI7u","header_title":"styles_header_title__kAY7K","wrapper_media":"styles_wrapper_media__8E69V","wrapper_media_container":"styles_wrapper_media_container__mzr38","card_content":"styles_card_content__n_NFr","comment_style":"styles_comment_style__GopNa","rotate":"styles_rotate__ssmGf","quote":"styles_quote__bZeC9","seeAllWrapper":"styles_seeAllWrapper__LVbbZ","seeAll":"styles_seeAll__R2mnW","seeAllWrapperMega":"styles_seeAllWrapperMega__AU7jy","SliderProductWrap":"styles_SliderProductWrap__FM9kz","SliderProductWrapV2":"styles_SliderProductWrapV2__RpSUD","header":"styles_header__LQMML","name":"styles_name__PAY0o","bestProductsName":"styles_bestProductsName__VOjDx","seeAllMobile":"styles_seeAllMobile___Q7i7","view_more":"styles_view_more__oP_PL","wrapper":"styles_wrapper__Be83M","bestProductsWrapper":"styles_bestProductsWrapper__p8dax","bestProducts_view_more":"styles_bestProducts_view_more__W5FqA","icon_name":"styles_icon_name__GN52V","wrapper_mv2":"styles_wrapper_mv2__ulLGw","view_more_mv2":"styles_view_more_mv2__UVFkx","icon_name_mv2":"styles_icon_name_mv2__xYYvS","name_mv2":"styles_name_mv2__oWnUQ","megaSale_name":"styles_megaSale_name__hNJNF","megaSaleSlider":"styles_megaSaleSlider__l3M54","wrapper_media_mobile":"styles_wrapper_media_mobile__OCWC8","wrapper_media_mobile_container":"styles_wrapper_media_mobile_container__pDaaq","wrapperContentTitle":"styles_wrapperContentTitle__AGJR6","contentTitle":"styles_contentTitle__y8kvU","contentTitleTop":"styles_contentTitleTop__YJVee","backgroundMega":"styles_backgroundMega__aCiLv","wrapperMega":"styles_wrapperMega__BIzkZ","wrapperTitle":"styles_wrapperTitle__DaSRf","backgroundTitle":"styles_backgroundTitle__0oI4D","sliderContainer":"styles_sliderContainer__IjY4Y","removeAddingSpace":"styles_removeAddingSpace__tys5e"};

/***/ }),

/***/ 57770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirm_modal_wrap":"styles_confirm_modal_wrap__uTxNL","header":"styles_header__lEBHn","closeIcon":"styles_closeIcon__8jfJQ","fixed_width_wrapper":"styles_fixed_width_wrapper__G_sjn","modal_title":"styles_modal_title__2q_64","children":"styles_children__W0hg0","gift_icon":"styles_gift_icon__TNl3o","wrapLoading":"styles_wrapLoading__tiTSv","containerPromoDiablog":"styles_containerPromoDiablog__tgs8S","wrapImg":"styles_wrapImg__iDCCh","btn_container":"styles_btn_container__7SXzj"};

/***/ }),

/***/ 26123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleSliderProduct":"styles_titleSliderProduct__T2fWl","productCardSkeleton":"styles_productCardSkeleton__rrHkJ","buttonSliderProductSkeleton":"styles_buttonSliderProductSkeleton__Q8a4a","sliderProductBlockWrapper":"styles_sliderProductBlockWrapper__nMGrY","sliderWrapper":"styles_sliderWrapper__UuWW0"};

/***/ }),

/***/ 22957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dFlex_spacing_4":"styles_dFlex_spacing_4__JOtSp","dFlex":"styles_dFlex__9j05d","slideCouponContainer":"styles_slideCouponContainer__QJ0h1","headLabel":"styles_headLabel__tKC70","listCouponWrapper":"styles_listCouponWrapper__yPH5B","couponWrapper":"styles_couponWrapper__ZKKgG","coupounPart_container":"styles_coupounPart_container__9BabF","couponMissingPart_left":"styles_couponMissingPart_left__BemKr","couponMissingPart_right":"styles_couponMissingPart_right__x7gHQ","buttonAction":"styles_buttonAction__dEObZ","slider":"styles_slider__yU6vN","drawerHeadTitle":"styles_drawerHeadTitle__TZ1RV","voucherTicket_container":"styles_voucherTicket_container__ZVNbH","voucherTicket_childContainer":"styles_voucherTicket_childContainer__W4em_","voucherTicket_childContainerMarketplace":"styles_voucherTicket_childContainerMarketplace__Qt15d","voucherTicket_action":"styles_voucherTicket_action__gcA0_","voucherTicketMissingPart_top":"styles_voucherTicketMissingPart_top__HQKl5","voucherTicketMissingPart_topMarketplace":"styles_voucherTicketMissingPart_topMarketplace__3x8Nx","voucherTicketMissingPart_bottom":"styles_voucherTicketMissingPart_bottom__2ocE1","voucherTicketMissingPart_bottomMarketplace":"styles_voucherTicketMissingPart_bottomMarketplace__Lat34","couponListWrapper":"styles_couponListWrapper__6AD6m","sectionVoucher_title":"styles_sectionVoucher_title__7Cux6","coupon_card_grid":"styles_coupon_card_grid__WyglQ","sectionVoucher_sticky":"styles_sectionVoucher_sticky__DlbAS","voucherList_container":"styles_voucherList_container__wcJki","verticalDivider":"styles_verticalDivider__mkts8","voucherTicket_name":"styles_voucherTicket_name__Ho2DZ","voucherTicket_nameMarketplace":"styles_voucherTicket_nameMarketplace__KhCA_","voucherTicket_leftContainer":"styles_voucherTicket_leftContainer__HSp4p","content_2Line":"styles_content_2Line__6fSIC","btnSeeMoreItem":"styles_btnSeeMoreItem__8fQxp","newDivider":"styles_newDivider__vn2GG","buttonCondition":"styles_buttonCondition__mNNBY","textCenter":"styles_textCenter__X57ZP","guildlinePopup_container":"styles_guildlinePopup_container__A3ggs","guildlinePopup_titleContainer":"styles_guildlinePopup_titleContainer__Hj60p","guildlineStep_container":"styles_guildlineStep_container__DVUAs","btnClosePopup":"styles_btnClosePopup__z7cPc","contentPopupCondition_wrapper":"styles_contentPopupCondition_wrapper__tCdvy","contentPopupCondition_title":"styles_contentPopupCondition_title__A8Ur_","contentPopupCondition_value":"styles_contentPopupCondition_value__YMvFi","popupCondition_divider":"styles_popupCondition_divider__x5SLu","voucherContent_title":"styles_voucherContent_title__ft4Bt","popupCondition_btn":"styles_popupCondition_btn__u48ba","iconCopy":"styles_iconCopy__QtMFF","iconCopyDone":"styles_iconCopyDone__XGAVc","popupCondition_groupCodeBtn":"styles_popupCondition_groupCodeBtn__0L9Wh","popupCondition_btnClose":"styles_popupCondition_btnClose__q8ebp","popupCondition_btnCollect":"styles_popupCondition_btnCollect__AHeF6","textCollectedSeller":"styles_textCollectedSeller__wm9WS","textCollectedMarketplace":"styles_textCollectedMarketplace___zjML","textOwnerVoucher":"styles_textOwnerVoucher__Sn3os","sellerButtonCollect":"styles_sellerButtonCollect___Jm_l","marketplaceButtonCollect":"styles_marketplaceButtonCollect__XWDy_","buttonCollectWrapper":"styles_buttonCollectWrapper__AOAJI","unScrollY":"styles_unScrollY__GTgdp","loadLogo":"styles_loadLogo__gFCSW","labelExpiredDate":"styles_labelExpiredDate__qXiTb","labelCondition":"styles_labelCondition__d_tJv","textCountDownTime":"styles_textCountDownTime__33jqx","whiteProgressColor":"styles_whiteProgressColor__xdRwY"};

/***/ }),

/***/ 1160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerLoading":"style_containerLoading__uSjRW","wrapper":"style_wrapper__cy4Xf","rightGrid":"style_rightGrid__5faRt","sliderSkeleton":"style_sliderSkeleton__eezxh","skeleTonWrapper":"style_skeleTonWrapper__P2fp_"};

/***/ })

}]);